import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110, _templateObject111, _templateObject112, _templateObject113, _templateObject114, _templateObject115, _templateObject116, _templateObject117, _templateObject118, _templateObject119, _templateObject120, _templateObject121, _templateObject122, _templateObject123, _templateObject124, _templateObject125, _templateObject126, _templateObject127, _templateObject128, _templateObject129, _templateObject130, _templateObject131, _templateObject132, _templateObject133, _templateObject134, _templateObject135, _templateObject136, _templateObject137, _templateObject138, _templateObject139, _templateObject140, _templateObject141, _templateObject142, _templateObject143, _templateObject144, _templateObject145, _templateObject146, _templateObject147, _templateObject148, _templateObject149, _templateObject150, _templateObject151, _templateObject152, _templateObject153, _templateObject154, _templateObject155, _templateObject156, _templateObject157, _templateObject158, _templateObject159, _templateObject160, _templateObject161, _templateObject162, _templateObject163, _templateObject164, _templateObject165, _templateObject166, _templateObject167, _templateObject168, _templateObject169, _templateObject170, _templateObject171, _templateObject172, _templateObject173, _templateObject174, _templateObject175, _templateObject176, _templateObject177, _templateObject178, _templateObject179, _templateObject180, _templateObject181, _TAG_CLEAR_BUTTON_PRO, _templateObject182, _templateObject183, _templateObject184, _templateObject185, _templateObject186, _templateObject187, _templateObject188, _templateObject189, _templateObject190, _templateObject191, _templateObject192, _templateObject193, _templateObject194, _templateObject195, _templateObject196, _templateObject197, _templateObject198, _templateObject199, _templateObject200, _templateObject201, _templateObject202, _templateObject203, _templateObject204, _templateObject205, _templateObject206, _templateObject207, _templateObject208, _templateObject209, _templateObject210, _templateObject211, _templateObject212, _templateObject213, _templateObject214, _templateObject215, _templateObject216, _templateObject217, _templateObject218, _templateObject219, _templateObject220, _templateObject221, _templateObject222, _templateObject223, _templateObject224, _templateObject225, _templateObject226, _templateObject227, _templateObject228, _templateObject229, _templateObject230, _templateObject231, _templateObject232, _templateObject233, _templateObject234, _templateObject235, _templateObject236, _templateObject237, _templateObject238, _templateObject239, _templateObject240, _templateObject241, _templateObject242, _templateObject243, _templateObject244, _templateObject245, _templateObject246, _templateObject247, _templateObject248, _templateObject249, _templateObject250, _templateObject251, _templateObject252, _templateObject253, _templateObject254, _templateObject255, _templateObject256, _templateObject257, _templateObject258, _templateObject259, _templateObject260, _templateObject261, _templateObject262, _templateObject263, _templateObject264, _templateObject265, _templateObject266, _templateObject267, _templateObject268, _templateObject269, _templateObject270, _templateObject271, _templateObject272, _templateObject273, _templateObject274, _templateObject275, _templateObject276, _templateObject277, _templateObject278, _templateObject279, _templateObject280, _templateObject281, _templateObject282, _templateObject283, _templateObject284, _templateObject285, _templateObject286, _templateObject287, _templateObject288, _templateObject289, _templateObject290, _templateObject291, _templateObject292, _templateObject293, _templateObject294, _presetProgressIndica, _templateObject295, _templateObject296, _templateObject297, _templateObject298, _templateObject299, _templateObject300, _templateObject301, _templateObject302, _templateObject303, _templateObject304, _templateObject305, _templateObject306, _templateObject307, _templateObject308, _templateObject309, _templateObject310, _templateObject311, _templateObject312, _templateObject313, _templateObject314, _templateObject315, _templateObject316, _templateObject317, _templateObject318, _templateObject319, _templateObject320, _templateObject321, _templateObject322, _templateObject323, _templateObject324, _templateObject325, _templateObject326, _templateObject327, _templateObject328, _templateObject329, _templateObject330, _templateObject331, _templateObject332, _templateObject333, _templateObject334, _templateObject335, _templateObject336, _templateObject337, _templateObject338, _templateObject339, _templateObject340, _templateObject341, _templateObject342, _templateObject343, _templateObject344, _templateObject345, _templateObject346, _templateObject347, _templateObject348, _templateObject349, _templateObject350, _templateObject351, _templateObject352, _templateObject353, _templateObject354, _templateObject355, _templateObject356, _templateObject357, _templateObject358, _templateObject359, _templateObject360, _templateObject361, _templateObject362, _templateObject363, _templateObject364, _templateObject365, _templateObject366, _templateObject367, _templateObject368, _templateObject369, _templateObject370, _templateObject371, _templateObject372, _templateObject373, _templateObject374, _templateObject375, _templateObject376, _templateObject377, _templateObject378, _templateObject379, _templateObject380, _templateObject381, _templateObject382, _templateObject383, _templateObject384, _templateObject385, _templateObject386, _templateObject387, _templateObject388, _templateObject389, _templateObject390, _templateObject391, _templateObject392, _templateObject393, _templateObject394, _templateObject395, _templateObject396, _templateObject397, _templateObject398, _templateObject399, _templateObject400, _templateObject401, _templateObject402, _templateObject403, _templateObject404, _templateObject405, _templateObject406, _templateObject407, _templateObject408, _templateObject409, _templateObject410, _templateObject411, _templateObject412, _templateObject413, _templateObject414, _templateObject415, _templateObject416, _templateObject417, _templateObject418, _templateObject419, _templateObject420, _templateObject421, _templateObject422, _templateObject423, _templateObject424, _templateObject425, _templateObject426, _templateObject427, _templateObject428, _templateObject429, _templateObject430, _templateObject431, _templateObject432, _templateObject433, _templateObject434, _templateObject435, _templateObject436, _templateObject437, _templateObject438, _templateObject439, _templateObject440, _templateObject441, _templateObject442, _templateObject443, _templateObject444, _templateObject445, _templateObject446, _templateObject447, _templateObject448, _templateObject449, _templateObject450, _templateObject451, _templateObject452, _templateObject453, _templateObject454, _templateObject455, _templateObject456, _templateObject457, _templateObject458, _templateObject459, _templateObject460, _templateObject461, _templateObject462, _templateObject463, _templateObject464, _templateObject465, _templateObject466, _templateObject467, _templateObject468, _templateObject469, _templateObject470, _templateObject471, _templateObject472, _templateObject473, _templateObject474, _templateObject475, _templateObject476, _templateObject477, _templateObject478, _templateObject479, _templateObject480, _templateObject481, _templateObject482, _templateObject483, _templateObject484, _templateObject485, _templateObject486, _templateObject487, _templateObject488, _templateObject489, _templateObject490, _templateObject491, _templateObject492, _templateObject493, _templateObject494, _templateObject495, _templateObject496, _templateObject497, _templateObject498, _templateObject499, _templateObject500, _templateObject501, _templateObject502, _templateObject503, _templateObject504, _templateObject505, _templateObject506, _templateObject507, _templateObject508, _templateObject509, _templateObject510, _templateObject511, _templateObject512, _templateObject513, _templateObject514, _templateObject515, _templateObject516, _templateObject517, _templateObject518, _templateObject519, _templateObject520, _templateObject521, _templateObject522, _templateObject523, _templateObject524, _templateObject525, _templateObject526, _templateObject527, _templateObject528, _templateObject529, _templateObject530, _templateObject531, _templateObject532, _templateObject533, _templateObject534, _templateObject535, _templateObject536, _templateObject537, _templateObject538, _templateObject539, _templateObject540, _templateObject541, _templateObject542, _templateObject543, _templateObject544, _templateObject545, _templateObject546, _templateObject547, _templateObject548, _templateObject549, _templateObject550, _templateObject551, _templateObject552, _templateObject553, _templateObject554, _templateObject555, _templateObject556, _templateObject557, _templateObject558, _templateObject559, _templateObject560, _templateObject561, _templateObject562, _templateObject563, _templateObject564, _templateObject565, _templateObject566, _templateObject567, _templateObject568, _templateObject569, _templateObject570, _templateObject571, _templateObject572, _templateObject573, _templateObject574, _templateObject575, _templateObject576, _templateObject577, _templateObject578, _templateObject579, _templateObject580, _templateObject581, _templateObject582, _templateObject583, _templateObject584, _templateObject585, _templateObject586, _templateObject587, _templateObject588, _templateObject589, _templateObject590, _templateObject591, _templateObject592, _templateObject593, _templateObject594, _templateObject595, _templateObject596, _templateObject597, _templateObject598, _templateObject599, _templateObject600, _templateObject601, _templateObject602, _templateObject603, _templateObject604, _templateObject605, _templateObject606, _templateObject607, _templateObject608, _templateObject609, _templateObject610, _templateObject611, _templateObject612, _templateObject613, _templateObject614, _templateObject615, _templateObject616, _templateObject617, _templateObject618, _templateObject619, _templateObject620, _templateObject621, _templateObject622, _templateObject623, _templateObject624, _templateObject625, _templateObject626, _templateObject627, _templateObject628, _templateObject629, _templateObject630, _templateObject631, _templateObject632, _templateObject633, _templateObject634, _templateObject635, _templateObject636, _templateObject637, _templateObject638, _templateObject639, _templateObject640;
import _regeneratorRuntime from "/drone/src/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
import { default as default2, css as css73, keyframes as keyframes2 } from "styled-components";

// src/components/Accordion/Accordion.tsx
import React2, { forwardRef, memo } from "react";
import PropTypes from "prop-types";

// src/components/Accordion/hooks/useAccordionClassName.ts
import { useMemo } from "react";
import { appendClassName } from "@deliveryhero/armor-system";

// src/components/Accordion/utils/getClassNameByComponent.ts
import { makeBEM } from "@deliveryhero/armor-system";
var getClassNameByComponent = function getClassNameByComponent(_ref) {
  var component = _ref.component,
    classPrefix = _ref.classPrefix,
    disabled = _ref.disabled,
    expanded = _ref.expanded;
  var baseClassNames = makeBEM(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM(classPrefix, component, "disabled"));
  }
  if (expanded) {
    stateClassNames.push(makeBEM(classPrefix, component, "expanded"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var getClassNameByComponent_default = getClassNameByComponent;

// src/components/Accordion/hooks/useAccordionClassName.ts
var useAccordionClassName = function useAccordionClassName(classPrefix, className, disabled, expanded) {
  return useMemo(function () {
    return {
      Root: appendClassName(getClassNameByComponent_default({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }), className)
    };
  }, [classPrefix, className, disabled, expanded]);
};

// src/components/Accordion/hooks/useAccordion.ts
import { useCallback, useMemo as useMemo2 } from "react";
import { useControlledState } from "@deliveryhero/armor-system";
var useAccordion = function useAccordion(_a, ref) {
  var _b = _a,
    disabled = _b.disabled,
    expanded = _b.expanded,
    defaultExpanded = _b.defaultExpanded,
    onToggle = _b.onToggle,
    restProps = __objRest(_b, ["disabled", "expanded", "defaultExpanded", "onToggle"]);
  var _useControlledState = useControlledState(defaultExpanded, expanded),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    isExpanded = _useControlledState2[0],
    setIsExpanded = _useControlledState2[1];
  var handleHeaderToggle = useCallback(function (event) {
    setIsExpanded(!isExpanded);
    onToggle == null ? void 0 : onToggle(event, !isExpanded);
  }, [isExpanded, onToggle, setIsExpanded]);
  var contextValue = useMemo2(function () {
    return {
      disabled: disabled,
      isExpanded: disabled ? false : isExpanded,
      onToggle: disabled ? void 0 : handleHeaderToggle
    };
  }, [disabled, isExpanded, handleHeaderToggle]);
  return {
    rootProps: __spreadValues({
      isExpanded: isExpanded,
      ref: ref,
      disabled: disabled
    }, restProps),
    contextProps: {
      value: contextValue
    },
    disabled: disabled,
    isExpanded: isExpanded
  };
};

// src/components/Accordion/style.ts
import styled from "styled-components";
import { color, propsBlocker, token, marginProps, getComponentOverride, focus, transition, widthProps, spacing } from "@deliveryhero/armor-system";
var AccordionRoot = styled.div.withConfig(propsBlocker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-top: 1px solid ", ";\n    display: flex;\n    flex-direction: column;\n    margin-top: ", ";\n\n    color: ", ";\n    background-color: ", ";\n\n    &:first-child {\n        border-width: 0;\n    }\n\n    ", "\n    ", "\n    ", ";\n    ", ";\n    ", ";\n"])), color("neutral.03"), spacing(-0.25), token("body.color"), color("neutral.00"), focus, transition({
  all: true
}), getComponentOverride("Accordion"), marginProps, widthProps);

// src/components/Accordion/constants.ts
var ACCORDION_CLASS_PREFIX = "Accordion";
var ACCORDION_HEADER_CLASS_PREFIX = "AccordionHeader";
var ACCORDION_HEADER_ICON_CLASS_PREFIX = "AccordionHeaderIcon";
var ACCORDION_CONTENT_CLASS_PREFIX = "AccordionContent";
var accordionRoot = "AccordionRoot";
var accordionHeaderRoot = "AccordionHeaderRoot";
var accordionHeaderTypography = "AccordionHeaderTypography";
var accordionHeaderIcon = "AccordionHeaderIcon";
var accordionContent = "AccordionContent";

// src/components/Accordion/AccordionContext.ts
import * as React from "react";
var AccordionContext = React.createContext({
  disabled: false,
  isExpanded: false,
  onToggle: function onToggle() {}
});

// src/components/Accordion/Accordion.tsx
var Accordion = forwardRef(function Accordion2(_a, ref) {
  var _b = _a,
    children = _b.children,
    className = _b.className,
    props = __objRest(_b, ["children", "className"]);
  var _useAccordion = useAccordion(props, ref),
    rootProps = _useAccordion.rootProps,
    contextProps = _useAccordion.contextProps,
    disabled = _useAccordion.disabled,
    isExpanded = _useAccordion.isExpanded;
  var classOverride = useAccordionClassName(ACCORDION_CLASS_PREFIX, className, disabled, isExpanded);
  return /* @__PURE__ */React2.createElement(AccordionContext.Provider, __spreadValues({}, contextProps), /* @__PURE__ */React2.createElement(AccordionRoot, __spreadProps(__spreadValues({}, rootProps), {
    "data-testid": accordionRoot,
    className: classOverride.Root
  }), children));
});
Accordion.displayName = ACCORDION_CLASS_PREFIX;
Accordion.defaultProps = {
  defaultExpanded: false,
  disabled: false
};
Accordion.propTypes = {
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func
};
var MemoizedAccordion = memo(Accordion);

// src/components/Accordion/AccordionContent/AccordionContent.tsx
import React3, { forwardRef as forwardRef2, useContext, memo as memo2 } from "react";

// src/components/Accordion/AccordionContent/style.ts
import styled2, { css } from "styled-components";
import { paddingProps, propsBlocker as propsBlocker2, typography, spacing as spacing2, transition as transition2, pixelToRemToken, token as token2 } from "@deliveryhero/armor-system";
var getRootStyle = function getRootStyle(_ref2) {
  var isExpanded = _ref2.isExpanded;
  var result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", ";\n        line-height: 0;\n        padding: 0 ", ";\n    "])), transition2({
    all: true
  }), spacing2(6));
  if (isExpanded) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            max-height: max-content;\n            opacity: 1;\n            line-height: ", ";\n            padding: ", ";\n        "])), result, pixelToRemToken("typography.body.lineHeight"), spacing2(6));
  }
  return result;
};
var AccordionContentRoot = styled2.div.withConfig(propsBlocker2)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    max-height: 0;\n    opacity: 0;\n    ", ";\n    color: ", ";\n    overflow: hidden;\n    ", ";\n    ", ";\n"])), typography("paragraphLarge"), token2("body.color"), getRootStyle, paddingProps);

// src/components/Accordion/AccordionContent/hooks/useAccordionContentClassName.ts
import { useMemo as useMemo3 } from "react";
import { appendClassName as appendClassName2, makeBEM as makeBEM2 } from "@deliveryhero/armor-system";
var useAccordionContentClassName = function useAccordionContentClassName(classPrefix, className, disabled, expanded) {
  return useMemo3(function () {
    return {
      Root: appendClassName2([getClassNameByComponent_default({
        component: "Content",
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }), makeBEM2(ACCORDION_CONTENT_CLASS_PREFIX, "Root")].join(" "), className)
    };
  }, [classPrefix, className, disabled, expanded]);
};

// src/components/Accordion/AccordionContent/AccordionContent.tsx
var AccordionContent = forwardRef2(function AccordionContent2(_a, ref) {
  var _b = _a,
    children = _b.children,
    className = _b.className,
    restProps = __objRest(_b, ["children", "className"]);
  var _useContext = useContext(AccordionContext),
    disabled = _useContext.disabled,
    isExpanded = _useContext.isExpanded;
  var classOverride = useAccordionContentClassName(ACCORDION_CONTENT_CLASS_PREFIX, className, disabled, isExpanded);
  return /* @__PURE__ */React3.createElement(AccordionContentRoot, __spreadProps(__spreadValues({
    "data-testid": accordionContent
  }, restProps), {
    className: classOverride.Root,
    disabled: disabled,
    isExpanded: isExpanded,
    ref: ref
  }), children);
});
var MemoizedAccordionContent = memo2(AccordionContent);

// src/components/Accordion/AccordionHeader/AccordionHeader.tsx
import React6, { forwardRef as forwardRef4, useCallback as useCallback2, useContext as useContext2, memo as memo5 } from "react";
import { useRootRef as useRootRef2, useEventListener } from "@deliveryhero/armor-system";

// src/components/Accordion/AccordionHeader/style.ts
import styled4, { css as css3 } from "styled-components";
import { color as color3, typography as typography2, propsBlocker as propsBlocker4, spacing as spacing3, mouseCursor, token as token3, transition as transition4, borderRadius } from "@deliveryhero/armor-system";

// src/components/ExpansionIndicator/ExpansionIndicator.tsx
import React4, { memo as memo3 } from "react";

// src/components/ExpansionIndicator/style.ts
import styled3, { css as css2 } from "styled-components";
import { ArrowDownIcon } from "@deliveryhero/armor-icons";
import { marginProps as marginProps2, color as color2, transition as transition3, propsBlocker as propsBlocker3, expansion, getComponentOverride as getComponentOverride2, paddingProps as paddingProps2 } from "@deliveryhero/armor-system";
var getRootStyle2 = function getRootStyle2(_ref3) {
  var disabled = _ref3.disabled;
  var result = {};
  if (disabled) {
    result = css2(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: not-allowed;\n            color: ", ";\n        "])), result, color2("neutral.05"));
  }
  return result;
};
var ExpansionIndicatorRoot = styled3.div.withConfig(propsBlocker3)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    outline: none;\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), getRootStyle2, getComponentOverride2("ExpansionIndicator"), marginProps2, paddingProps2);
var ExpansionIndicatorContent = styled3.div.withConfig(propsBlocker3)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    align-items: center;\n    border-left-width: 1px;\n    border-left-style: solid;\n    border-left-color: transparent;\n    display: flex;\n    height: calc(100% - 16px);\n    justify-content: center;\n    width: 100%;\n"])));
var ExpansionIndicatorIcon = styled3(ArrowDownIcon)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"])), transition3({
  transform: true
}), expansion(180));
ExpansionIndicatorIcon.defaultProps = {
  small: true
};

// src/components/ExpansionIndicator/utils/useExpansionIndicatorClassName.ts
import { useMemo as useMemo4 } from "react";
import { appendClassName as appendClassName3, makeBEM as makeBEM3 } from "@deliveryhero/armor-system";
var getComponentClassName = function getComponentClassName(_ref4) {
  var component = _ref4.component,
    classPrefix = _ref4.classPrefix,
    disabled = _ref4.disabled,
    isExpanded = _ref4.isExpanded;
  var baseClassNames = makeBEM3(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM3(classPrefix, component, "disabled"));
  }
  if (isExpanded) {
    stateClassNames.push(makeBEM3(classPrefix, component, "expanded"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useExpansionIndicatorClassName = function useExpansionIndicatorClassName(classPrefix, className, disabled, isExpanded) {
  return useMemo4(function () {
    return {
      Root: appendClassName3(getComponentClassName({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled,
        isExpanded: isExpanded
      }), className),
      Content: getComponentClassName({
        component: "Content",
        classPrefix: classPrefix,
        disabled: disabled,
        isExpanded: isExpanded
      }),
      Icon: getComponentClassName({
        component: "Icon",
        classPrefix: classPrefix,
        disabled: disabled,
        isExpanded: isExpanded
      })
    };
  }, [classPrefix, className, disabled, isExpanded]);
};
var useExpansionIndicatorClassName_default = useExpansionIndicatorClassName;

// src/components/ExpansionIndicator/constants.ts
var EXPANSION_INDICATOR_CLASS_PREFIX = "ExpansionIndicator";
var expansionIndicatorContainer = "ExpansionIndicatorRoot";
var expansionIndicatorContent = "ExpansionIndicatorContent";
var expansionIndicatorIcon = "ExpansionIndicatorIcon";

// src/components/ExpansionIndicator/ExpansionIndicator.tsx
var ExpansionIndicator = function ExpansionIndicator(_a) {
  var _b = _a,
    className = _b.className,
    disabled = _b.disabled,
    isExpanded = _b.isExpanded,
    expanded = _b.expanded,
    onClick = _b.onClick,
    tabIndex = _b.tabIndex,
    restProps = __objRest(_b, ["className", "disabled", "isExpanded", "expanded", "onClick", "tabIndex"]);
  var reallyExpanded = isExpanded != null ? isExpanded : expanded;
  var classOverride = useExpansionIndicatorClassName_default(EXPANSION_INDICATOR_CLASS_PREFIX, className, disabled, reallyExpanded);
  return /* @__PURE__ */React4.createElement(ExpansionIndicatorRoot, __spreadProps(__spreadValues({
    "data-testid": expansionIndicatorContainer
  }, restProps), {
    className: classOverride.Root,
    disabled: disabled,
    onClick: onClick,
    tabIndex: tabIndex
  }), /* @__PURE__ */React4.createElement(ExpansionIndicatorContent, {
    className: classOverride.Content,
    "data-testid": expansionIndicatorContent
  }, /* @__PURE__ */React4.createElement(ExpansionIndicatorIcon, {
    className: classOverride.Icon,
    "data-testid": expansionIndicatorIcon,
    disabled: disabled,
    expanded: reallyExpanded
  })));
};
ExpansionIndicator.defaultProps = {
  displaySeparator: false
};
var MemoizedExpansionIndicator = memo3(ExpansionIndicator);

// src/components/Accordion/AccordionHeader/style.ts
var getRootStyle3 = function getRootStyle3(_ref5) {
  var disabled = _ref5.disabled;
  if (disabled) {
    return css3(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            pointer-events: none;\n            background-color: ", ";\n        "])), color3("neutral.03"));
  }
  return "";
};
var getHeaderElementsStyle = function getHeaderElementsStyle(_ref6) {
  var disabled = _ref6.disabled;
  if (disabled) {
    return css3(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), color3("neutral.07"));
  }
  return "";
};
var AccordionHeaderRoot = styled4.div.withConfig(propsBlocker4)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    min-height: ", ";\n    padding: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    &:focus-visible {\n        border-radius: ", ";\n    }\n\n    ", "\n    ", ";\n    ", ";\n"])), typography2("labelLarge"), token3("body.color"), spacing3(14), spacing3(4, 6), color3("primary.lightest"), borderRadius("sharp"), transition4({
  "background-color": true
}), mouseCursor, getRootStyle3);
var AccordionHeaderBody = styled4.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n"])));
var AccordionHeaderTitle = styled4.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    color: ", ";\n    padding-right: ", ";\n    ", ";\n"])), color3("neutral.11"), spacing3(3), getHeaderElementsStyle);
var AccordionHeaderTextContainer = styled4.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));
var AccordionHeaderIconContainer = styled4.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));
var AccordionHeaderDescription = styled4.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    width: 100%;\n    margin-top: ", ";\n    display: flex;\n    color: ", ";\n    ", ";\n    ", ";\n"])), spacing3(1), color3("neutral.07"), typography2("paragraphSmall"), getHeaderElementsStyle);
var accordionExpansionIndicatorStyle = function accordionExpansionIndicatorStyle(_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? css3(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n              .ExpansionIndicator-Icon {\n                  color: ", ";\n              }\n          "])), color3("neutral.07")) : {};
};
var AccordionHeaderExpansionIndicator = styled4(ExpansionIndicator)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    ", ";\n"])), accordionExpansionIndicatorStyle);

// src/components/Accordion/AccordionHeaderIcon/AccordionHeaderIcon.tsx
import React5, { forwardRef as forwardRef3, memo as memo4 } from "react";
import { useRootRef } from "@deliveryhero/armor-system";

// src/components/Accordion/AccordionHeaderIcon/style.ts
import styled5 from "styled-components";
import { color as color4, propsBlocker as propsBlocker5, spacing as spacing4 } from "@deliveryhero/armor-system";
var AccordionHeaderIconRoot = styled5.div.withConfig(propsBlocker5)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    display: flex;\n    color: ", ";\n\n    & > svg {\n        margin: 0 ", ";\n    }\n"])), color4("neutral.11"), spacing4(1));

// src/components/Accordion/AccordionHeader/hooks/useAccordionHeaderClassName.ts
import { useMemo as useMemo5 } from "react";
import { appendClassName as appendClassName4, makeBEM as makeBEM4 } from "@deliveryhero/armor-system";
var useAccordionHeaderClassName = function useAccordionHeaderClassName(classPrefix, className, disabled, expanded) {
  return useMemo5(function () {
    return {
      Root: appendClassName4(getClassNameByComponent_default({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }), className),
      Body: makeBEM4(ACCORDION_HEADER_CLASS_PREFIX, "Body"),
      Title: getClassNameByComponent_default({
        component: "HeaderTitle",
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }),
      Description: getClassNameByComponent_default({
        component: "HeaderDescription",
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }),
      IconContainer: getClassNameByComponent_default({
        component: "IconContainer",
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }),
      TextContainer: getClassNameByComponent_default({
        component: "TextContainer",
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }),
      Icon: getClassNameByComponent_default({
        component: "Icon",
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      }),
      ExpansionIndicator: getClassNameByComponent_default({
        component: "ExpansionIndicator",
        classPrefix: classPrefix,
        disabled: disabled,
        expanded: expanded
      })
    };
  }, [classPrefix, className, disabled, expanded]);
};

// src/components/Accordion/AccordionHeaderIcon/AccordionHeaderIcon.tsx
var AccordionHeaderIcon = forwardRef3(function AccordionHeaderIcon2(_a, ref) {
  var _b = _a,
    children = _b.children,
    className = _b.className,
    restProps = __objRest(_b, ["children", "className"]);
  var classOverride = useAccordionHeaderClassName(ACCORDION_HEADER_ICON_CLASS_PREFIX, className);
  var internalHeaderRootRef = useRootRef(ref);
  return /* @__PURE__ */React5.createElement(AccordionHeaderIconRoot, __spreadProps(__spreadValues({
    "data-testid": accordionHeaderIcon
  }, restProps), {
    className: classOverride.Root,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    ref: internalHeaderRootRef
  }), children);
});
var MemoizedAccordionHeaderIcon = memo4(AccordionHeaderIcon);

// src/components/Dropdown/constants.ts
var DROPDOWN_CLASS_PREFIX = "Dropdown";
var DROPDOWN_BEFORE_SECTION_CLASS_PREFIX = "DropdownBeforeSection";
var DROPDOWN_TAGS_CLASS_PREFIX = "DropdownTags";
var EMPTY_LABEL_VALUE = "";
var WHITESPACE_LABEL_VALUE = " ";
var DROPDOWN_ACTION_ITEM = "DropdownActionItem";
var DROPDOWN_OPTION_LIST_CONTAINER = "DropdownOptionListContainer";
var SINGLE_LINE_MAX_ALLOWED_HEIGHT = 40;
var BUFFER_TAGS_WIDTH = 100;

// src/components/Accordion/AccordionHeader/AccordionHeader.tsx
var AccordionHeader = forwardRef4(function AccordionHeader2(_a, ref) {
  var _b = _a,
    title = _b.title,
    icon = _b.icon,
    description = _b.description,
    children = _b.children,
    className = _b.className,
    restProps = __objRest(_b, ["title", "icon", "description", "children", "className"]);
  var _useContext2 = useContext2(AccordionContext),
    disabled = _useContext2.disabled,
    isExpanded = _useContext2.isExpanded,
    onToggle = _useContext2.onToggle;
  var classOverride = useAccordionHeaderClassName(ACCORDION_HEADER_CLASS_PREFIX, className, disabled, isExpanded);
  var internalHeaderRootRef = useRootRef2(ref);
  var enterKeyHandler = useCallback2(function (event) {
    var key = event.key,
      target = event.target;
    if (target === internalHeaderRootRef.current && key === "Enter") {
      onToggle == null ? void 0 : onToggle(event);
    }
  }, [internalHeaderRootRef, onToggle]);
  useEventListener("keyup", enterKeyHandler, internalHeaderRootRef, disabled);
  return /* @__PURE__ */React6.createElement(AccordionHeaderRoot, __spreadProps(__spreadValues({
    "data-testid": accordionHeaderRoot
  }, restProps), {
    className: classOverride.Root,
    disabled: disabled,
    isExpanded: isExpanded,
    onClick: onToggle,
    ref: internalHeaderRootRef,
    tabIndex: disabled ? -1 : 0
  }), /* @__PURE__ */React6.createElement(AccordionHeaderBody, {
    className: classOverride.Body
  }, /* @__PURE__ */React6.createElement(AccordionHeaderTextContainer, {
    className: classOverride.TextContainer
  }, title && /* @__PURE__ */React6.createElement(AccordionHeaderTitle, {
    className: classOverride.Title,
    "data-testid": accordionHeaderTypography,
    disabled: disabled
  }, title), children), /* @__PURE__ */React6.createElement(AccordionHeaderIconContainer, {
    className: classOverride.IconContainer
  }, /* @__PURE__ */React6.createElement(AccordionHeaderIcon, {
    className: classOverride.Icon,
    "data-testid": accordionHeaderIcon
  }, icon), /* @__PURE__ */React6.createElement(AccordionHeaderExpansionIndicator, {
    className: classOverride.ExpansionIndicator,
    disabled: disabled,
    isExpanded: isExpanded,
    "data-testid": DROPDOWN_ACTION_ITEM
  }))), description && /* @__PURE__ */React6.createElement(AccordionHeaderDescription, {
    className: classOverride.Description
  }, description));
});
var MemoizedAccordionHeader = memo5(AccordionHeader);

// src/components/ActionSheet/ActionSheet.tsx
import React7, { forwardRef as forwardRef5, memo as memo6 } from "react";
import PropTypes2 from "prop-types";

// src/components/ActionSheet/hooks/useActionSheetClassNames.ts
import { useMemo as useMemo6 } from "react";
import { makeRootClassName, makeBEM as makeBEM5 } from "@deliveryhero/armor-system";
var useActionSheetClassNames = function useActionSheetClassNames(classPrefix, className) {
  return useMemo6(function () {
    return {
      Root: makeRootClassName(classPrefix, className),
      LabelContainer: makeBEM5(classPrefix, "LabelContainer")
    };
  }, [classPrefix, className]);
};

// src/components/ActionSheet/hooks/useActionSheet.ts
import { useRootRef as useRootRef3 } from "@deliveryhero/armor-system";
var useActionSheet = function useActionSheet(_a, ref) {
  var _b = _a,
    label = _b.label,
    restProps = __objRest(_b, ["label"]);
  var innerRef = useRootRef3(ref);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: innerRef
    }),
    labelContainerProps: {
      label: label
    },
    label: label
  };
};

// src/components/ActionSheet/style.ts
import styled6, { css as css4 } from "styled-components";
import { color as color5, getComponentOverride as getComponentOverride3, marginProps as marginProps3, propsBlocker as propsBlocker6, reset, spacing as spacing5, token as token4, typography as typography3, widthProps as widthProps2 } from "@deliveryhero/armor-system";
var getLabelContainerStyle = function getLabelContainerStyle(_ref8) {
  var label = _ref8.label;
  var result = {};
  if (typeof label === "string") {
    result = css4(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), typography3("labelLarge"), token4("body.color"));
  }
  return result;
};
var ActionSheetRoot = styled6.div.withConfig(propsBlocker6)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    ", ";\n    align-items: center;\n    background-color: ", ";\n    display: flex;\n    justify-content: space-between;\n    padding: ", ";\n    ", ";\n    color: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n"])), reset, color5("primary.lightest"), spacing5(4, 6), typography3("paragraphMedium"), token4("body.color"), getComponentOverride3("ActionSheet"), marginProps3, widthProps2);
var ActionSheetLabelContainer = styled6.div.withConfig(propsBlocker6)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    ", ";\n"])), getLabelContainerStyle);

// src/components/ActionSheet/constants.ts
var ACTIONSHEET_CLASS_PREFIX = "ActionSheet";

// src/components/ActionSheet/ActionSheet.tsx
var ActionSheet = forwardRef5(function ActionSheet2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var classNames = useActionSheetClassNames(ACTIONSHEET_CLASS_PREFIX, className);
  var _useActionSheet = useActionSheet(props, ref),
    rootProps = _useActionSheet.rootProps,
    labelContainerProps = _useActionSheet.labelContainerProps,
    label = _useActionSheet.label;
  return /* @__PURE__ */React7.createElement(ActionSheetRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), /* @__PURE__ */React7.createElement(ActionSheetLabelContainer, __spreadProps(__spreadValues({}, labelContainerProps), {
    className: classNames.LabelContainer
  }), label), children);
});
ActionSheet.defaultProps = {
  label: "No items selected"
};
ActionSheet.propTypes = {
  /** Example description */
  label: PropTypes2.string
};
var MemoizedActionSheet = memo6(ActionSheet);

// src/components/Box/Box.tsx
import React8, { memo as memo7 } from "react";
import PropTypes3 from "prop-types";

// src/components/Box/style.ts
import styled7 from "styled-components";
import { marginProps as marginProps4, paddingProps as paddingProps3, sizeProps, textAlignmentProps, displayProps, colorProps, propsBlocker as propsBlocker7 } from "@deliveryhero/armor-system";
var BoxRoot = styled7.div.withConfig(propsBlocker7)(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), marginProps4, paddingProps3, sizeProps, textAlignmentProps, displayProps, colorProps);

// src/components/Box/constants.ts
var BOX_CLASS_PREFIX = "Box";

// src/components/Box/hooks/useBoxClassName.ts
import { useMemo as useMemo7 } from "react";
import { makeRootClassName as makeRootClassName2 } from "@deliveryhero/armor-system";
var useBoxClassName = function useBoxClassName(classPrefix, className) {
  return useMemo7(function () {
    var rootClassNames = makeRootClassName2(classPrefix, className);
    return {
      Root: rootClassNames
    };
  }, [classPrefix, className]);
};

// src/components/Box/Box.tsx
var Box = function Box(_a) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useBoxClassName(BOX_CLASS_PREFIX, className);
  return /* @__PURE__ */React8.createElement(BoxRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameComponents.Root
  }));
};
Box.propTypes = {
  /** Defines element margin */
  margin: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element margin top */
  marginTop: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element margin bottom */
  marginBottom: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element margin left */
  marginLeft: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element margin right */
  marginRight: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element margin left and right */
  marginX: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element margin top and bottom */
  marginY: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element padding */
  padding: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element padding top */
  paddingTop: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element padding bottom */
  paddingBottom: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element padding left */
  paddingLeft: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element padding right */
  paddingRight: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element padding left and right */
  paddingX: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element padding top and bottom */
  paddingY: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element width */
  width: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element minimum width */
  minWidth: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element maximum width */
  maxWidth: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element height */
  height: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element minimum height */
  minHeight: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element maximum height */
  maxHeight: PropTypes3.oneOfType([PropTypes3.string, PropTypes3.number]),
  /** Defines element text alignment */
  textAlign: PropTypes3.oneOf(["left", "center", "right"]),
  /** Defines element display type */
  display: PropTypes3.oneOf(["initial", "inherit", "flex", "inline-flex", "block", "inline-block", "inline"])
};
var MemoizedBox = memo7(Box);

// src/components/Badge/Badge.tsx
import React9, { forwardRef as forwardRef6, memo as memo8 } from "react";

// src/components/Badge/style.ts
import styled8 from "styled-components";
import { propsBlocker as propsBlocker8, marginProps as marginProps5, typography as typography4 } from "@deliveryhero/armor-system";
var BadgeRoot = styled8.div.withConfig(propsBlocker8)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n    ", ";\n    color: inherit;\n    font-size: 14px; // todo: remove this when label medium is fixed\n    ", ";\n"])), typography4("labelMedium"), marginProps5);

// src/components/Badge/hooks/useBadgeClassName.ts
import { useMemo as useMemo8 } from "react";
import { appendClassName as appendClassName5, makeBEM as makeBEM6 } from "@deliveryhero/armor-system";
var useBadgeClassName = function useBadgeClassName(classPrefix, className) {
  return useMemo8(function () {
    return {
      Root: appendClassName5(makeBEM6(classPrefix, "Root"), className)
    };
  }, [classPrefix, className]);
};

// src/components/Badge/constants.ts
var BADGE_CLASS_PREFIX = "Badge";

// src/components/Badge/Badge.tsx
var Badge = forwardRef6(function Badge2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var classOverride = useBadgeClassName(BADGE_CLASS_PREFIX, className);
  return /* @__PURE__ */React9.createElement(BadgeRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classOverride.Root,
    ref: ref
  }), children);
});
var MemoizedBadge = memo8(Badge);

// src/components/Button/Button.tsx
import React10, { forwardRef as forwardRef7, memo as memo9 } from "react";
import PropTypes4 from "prop-types";

// src/components/Button/hooks/useButtonClassName.ts
import { useMemo as useMemo9 } from "react";
import { makeBEM as makeBEM7, makeRootClassName as makeRootClassName3 } from "@deliveryhero/armor-system";
var useButtonClassName = function useButtonClassName(classPrefix, className, disabled, small, wide, primary, secondary, tertiary, danger) {
  return useMemo9(function () {
    var baseClassNames = makeRootClassName3(classPrefix, className);
    var stateClassNames = [];
    if (disabled) {
      stateClassNames.push(makeBEM7(classPrefix, "Root", "disabled"));
    }
    if (small) {
      stateClassNames.push(makeBEM7(classPrefix, "Root", "small"));
    }
    if (wide) {
      stateClassNames.push(makeBEM7(classPrefix, "Root", "wide"));
    }
    if (primary && !secondary && !tertiary) {
      stateClassNames.push(makeBEM7(classPrefix, "Root", "primary"));
    }
    if (secondary) {
      stateClassNames.push(makeBEM7(classPrefix, "Root", "secondary"));
    }
    if (tertiary) {
      stateClassNames.push(makeBEM7(classPrefix, "Root", "tertiary"));
    }
    if (danger) {
      stateClassNames.push(makeBEM7(classPrefix, "Root", "danger"));
    }
    return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
  }, [classPrefix, className, disabled, small, wide, primary, secondary, tertiary, danger]);
};

// src/components/Button/style.ts
import styled9, { css as css5 } from "styled-components";
import { reset as reset2, propsBlocker as propsBlocker9, getComponentOverride as getComponentOverride4, marginProps as marginProps6, paddingProps as paddingProps4, widthProps as widthProps3, transition as transition5, typography as typography5, spacing as spacing6, token as token5, focus as focus2 } from "@deliveryhero/armor-system";
var getPrimaryInitialColors = function getPrimaryInitialColors() {
  return css5(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n    color: ", ";\n    border-color: ", ";\n    background-color: ", ";\n"])), token5("text.color.onbranded", "color.neutral.00"), token5("action.color.primary.enabled", "color.primary.main"), token5("action.color.primary.enabled", "color.primary.main"));
};
var getTertiaryInitialColors = function getTertiaryInitialColors() {
  return css5(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), token5("action.color.primary.enabled", "color.primary.main"));
};
var getPrimaryDangerInitialColors = function getPrimaryDangerInitialColors() {
  return css5(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    color: ", ";\n    border-color: ", ";\n    background-color: ", ";\n"])), token5("text.color.onerror", "color.neutral.00"), token5("action.color.danger.enabled", "color.error.main"), token5("action.color.danger.enabled", "color.error.main"));
};
var getTertiaryDangerInitialColors = function getTertiaryDangerInitialColors() {
  return css5(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), token5("action.color.danger.enabled", "color.error.main"));
};
var getPrimaryDisabledColors = function getPrimaryDisabledColors() {
  return css5(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n    color: ", ";\n    border-color: ", ";\n    background-color: ", ";\n"])), token5("text.color.disabled", "color.neutral.05"), token5("action.color.primary.disabled", "color.neutral.03"), token5("action.color.primary.disabled", "color.neutral.03"));
};
var getSecondaryDisabledColors = function getSecondaryDisabledColors() {
  return css5(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n    color: ", ";\n    border-color: ", ";\n"])), token5("text.color.disabled", "color.neutral.05"), token5("action.color.primary.disabled", "color.neutral.05"));
};
var getDynamicStyle = function getDynamicStyle(_ref9) {
  var secondary = _ref9.secondary,
    tertiary = _ref9.tertiary,
    danger = _ref9.danger,
    small = _ref9.small,
    disabled = _ref9.disabled,
    likeDisabled = _ref9.likeDisabled;
  var result = {};
  if (secondary) {
    result = css5(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n            color: ", ";\n            border-color: ", ";\n            background-color: transparent;\n\n            &:enabled {\n                &:hover {\n                    color: ", ";\n                    border-color: ", ";\n                    background-color: ", ";\n                }\n\n                &:active {\n                    color: ", ";\n                    border-color: ", ";\n                    background-color: ", ";\n                }\n            }\n        "])), token5("action.color.primary.enabled", "color.primary.main"), token5("action.color.primary.enabled", "color.primary.main"), token5("action.color.primary.hover", "color.primary.05"), token5("action.color.primary.hover", "color.primary.05"), token5("action.color.tertiary.hover", "transparent"), token5("action.color.primary.pressed", "color.primary.10"), token5("action.color.primary.pressed", "color.primary.10"), token5("action.color.tertiary.pressed", "color.neutral.02"));
  } else if (tertiary) {
    result = css5(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n            ", ";\n\n            &:enabled {\n                &:hover {\n                    color: ", ";\n                    background-color: ", ";\n                }\n\n                &:active {\n                    color: ", ";\n                    background-color: ", ";\n                }\n            }\n        "])), getTertiaryInitialColors, token5("action.color.primary.hover", "color.primary.05"), token5("action.color.tertiary.hover"), token5("action.color.primary.pressed", "color.primary.10"), token5("action.color.tertiary.pressed", "color.neutral.02"));
  } else {
    result = css5(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n            ", ";\n            &:enabled {\n                &:hover {\n                    color: ", ";\n                    border-color: ", ";\n                    background-color: ", ";\n                }\n\n                &:active {\n                    color: ", ";\n                    border-color: ", ";\n                    background-color: ", ";\n                }\n            }\n        "])), getPrimaryInitialColors, token5("text.color.onbranded", "color.neutral.00"), token5("action.color.primary.hover", "color.primary.05"), token5("action.color.primary.hover", "color.primary.05"), token5("text.color.onbranded", "color.neutral.00"), token5("action.color.primary.pressed", "color.primary.08"), token5("action.color.primary.pressed", "color.primary.08"));
  }
  if (danger) {
    if (tertiary) {
      result = css5(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n                ", ";\n                ", ";\n\n                &:disabled {\n                    color: ", ";\n                }\n\n                &:enabled {\n                    &:hover {\n                        color: ", ";\n                        background-color: ", ";\n                    }\n\n                    &:active {\n                        color: ", ";\n                        background-color: ", ";\n                    }\n                }\n            "])), result, getTertiaryDangerInitialColors, token5("text.color.disabled", "color.neutral.05"), token5("action.color.danger.hover", "color.error.05"), token5("action.color.tertiary.hover"), token5("action.color.danger.pressed", "color.error.08"), token5("action.color.tertiary.pressed"));
    } else {
      result = css5(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n                ", ";\n                ", ";\n\n                &:enabled {\n                    &:hover {\n                        color: ", ";\n                        border-color: ", ";\n                        background-color: ", ";\n                    }\n\n                    &:active {\n                        border-color: ", ";\n                        background-color: ", ";\n                    }\n                }\n            "])), result, getPrimaryDangerInitialColors, token5("text.color.onerror"), token5("action.color.danger.hover", "color.error.05"), token5("action.color.danger.hover", "color.error.05"), token5("action.color.danger.pressed", "color.error.08"), token5("action.color.danger.pressed", "color.error.08"));
    }
  }
  if (small) {
    result = css5(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n            ", ";\n            padding: ", ";\n            height: ", ";\n        "])), result, spacing6("action.spacing.small", "action.spacing.medium", [2, 3]), spacing6("action.sizing.small", [10]));
  }
  if (disabled || likeDisabled) {
    result = css5(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: not-allowed;\n        "])), result);
    if (tertiary) {
      result = css5(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n                ", ";\n                color: ", ";\n\n                &:enabled {\n                    &:hover,\n                    &:focus,\n                    &:active,\n                    &:focus:not(:active) {\n                        color: ", ";\n                    }\n                }\n            "])), result, token5("text.color.disabled", "color.neutral.05"), token5("text.color.disabled", "color.neutral.05"));
    } else if (secondary) {
      result = css5(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n                ", ";\n                ", ";\n\n                &:enabled {\n                    &:hover,\n                    &:focus,\n                    &:active,\n                    &:focus:not(:active) {\n                        ", ";\n                    }\n                }\n            "])), result, getSecondaryDisabledColors, getSecondaryDisabledColors);
    } else {
      result = css5(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n                ", ";\n                ", ";\n\n                &:enabled {\n                    &:hover,\n                    &:focus,\n                    &:active,\n                    &:focus:not(:active) {\n                        ", ";\n                    }\n                }\n            "])), result, getPrimaryDisabledColors, getPrimaryDisabledColors);
    }
  }
  return result;
};
var Wrapper = function Wrapper(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var ButtonRoot = styled9(Wrapper).withConfig(propsBlocker9)(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n    ", ";\n    align-items: center;\n    appearance: none;\n    border: 1px solid transparent;\n    cursor: pointer;\n    display: inline-flex;\n    justify-content: center;\n    outline: none;\n    padding: ", ";\n    position: relative;\n    text-align: center;\n    text-decoration: none;\n    letter-spacing: 0;\n    user-select: none;\n    vertical-align: middle;\n    height: ", ";\n\n    &:hover,\n    &:focus,\n    &:disabled,\n    &:active,\n    &:visited {\n        text-decoration: none;\n        outline: none;\n    }\n\n    ", ";\n    ", ";\n\n    border-radius: ", ";\n\n    background-color: transparent;\n\n    svg {\n        color: inherit;\n    }\n\n    ", ";\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset2(), spacing6("action.spacing.medium", "action.spacing.large", [3, 4]), spacing6("action.sizing.medium", [12]), typography5("desktop.subtitleLarge", "labelLarge"), transition5({
  all: true
}), token5("action.borderRadius.small", "shape.borderRadius.soft", {
  returnUnit: "px"
}), getDynamicStyle, function (_ref10) {
  var secondary = _ref10.secondary,
    tertiary = _ref10.tertiary,
    danger = _ref10.danger,
    disabled = _ref10.disabled;
  return focus2({
    inverse: !secondary && !tertiary,
    error: danger,
    disabled: disabled,
    useBorder: true
  });
}, getComponentOverride4("Button"), marginProps6, paddingProps4, widthProps3);

// src/components/Button/constants.ts
var BUTTON_CLASS_PREFIX = "Button";
var BUTTON_ICON_DEFAULT_SIZE = {
  small: true
};

// src/components/Button/hooks/useButton.ts
import { useRootRef as useRootRef4, getChildrenWithIconProps, useTheme, spacing as spacing7 } from "@deliveryhero/armor-system";

// src/components/Button/utils/getIconMargin.ts
var getButtonIconPositionMarginMap = function getButtonIconPositionMarginMap(itemSpacing) {
  return {
    first: {
      marginRight: itemSpacing
    },
    last: {
      marginLeft: itemSpacing
    },
    single: {
      marginLeft: -1.25,
      marginRight: -1.25
    }
  };
};
function getIconMargin(childrenCount, iconIndex, itemSpacing) {
  var _getButtonIconPositio = getButtonIconPositionMarginMap(itemSpacing),
    first = _getButtonIconPositio.first,
    last = _getButtonIconPositio.last,
    single = _getButtonIconPositio.single;
  var isSingleChild = childrenCount === 1;
  var isFirst = !isSingleChild && iconIndex === 0;
  var isLast = !isSingleChild && iconIndex === childrenCount - 1;
  if (isFirst) {
    return first;
  }
  if (isLast) {
    return last;
  }
  if (isSingleChild) {
    return single;
  }
  return {};
}
var getIconMargin_default = getIconMargin;

// src/components/Button/hooks/useButton.ts
var preventDefault = function preventDefault(event) {
  event.preventDefault();
};
var useButton = function useButton(_a, ref) {
  var _b = _a,
    disabled = _b.disabled,
    small = _b.small,
    wide = _b.wide,
    primary = _b.primary,
    secondary = _b.secondary,
    tertiary = _b.tertiary,
    danger = _b.danger,
    tag = _b.tag,
    likeDisabled = _b.likeDisabled,
    tabIndex = _b.tabIndex,
    baseChildren = _b.children,
    restProps = __objRest(_b, ["disabled", "small", "wide", "primary", "secondary", "tertiary", "danger", "tag", "likeDisabled", "tabIndex", "children"]);
  var innerRef = useRootRef4(ref);
  var theme = useTheme();
  var itemSpacing = spacing7("action.spacing.small", [2])({
    theme: theme
  });
  var children = getChildrenWithIconProps(baseChildren, function (childrenCount, iconIndex) {
    return __spreadValues(__spreadValues({}, BUTTON_ICON_DEFAULT_SIZE), getIconMargin_default(childrenCount, iconIndex, itemSpacing));
  });
  var isDisabled = disabled || likeDisabled;
  var Tag3 = tag || "button";
  var isNotButtonTag = Tag3 !== "button";
  var onClick = isNotButtonTag && isDisabled ? preventDefault : restProps == null ? void 0 : restProps.onClick;
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      small: small,
      wide: wide,
      disabled: disabled,
      likeDisabled: likeDisabled,
      primary: primary,
      secondary: secondary,
      tertiary: tertiary,
      danger: danger,
      tabIndex: isDisabled ? -1 : tabIndex,
      onClick: onClick
    }),
    tagProps: {
      ref: innerRef
    },
    classNameProps: [isDisabled, small, wide, primary, secondary, tertiary, danger],
    Tag: Tag3,
    children: children
  };
};

// src/components/Button/Button.tsx
var Button = forwardRef7(function Button2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var _useButton = useButton(props, ref),
    rootProps = _useButton.rootProps,
    tagProps = _useButton.tagProps,
    classNameProps = _useButton.classNameProps,
    Tag3 = _useButton.Tag,
    children = _useButton.children;
  var classNameRoot = useButtonClassName.apply(void 0, [BUTTON_CLASS_PREFIX, className].concat(_toConsumableArray(classNameProps)));
  return /* @__PURE__ */React10.createElement(ButtonRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameRoot
  }), function (forwardedProps) {
    return /* @__PURE__ */React10.createElement(Tag3, __spreadValues(__spreadValues({}, forwardedProps), tagProps), children);
  });
});
Button.defaultProps = {
  primary: true,
  secondary: false,
  tertiary: false,
  danger: false,
  small: false,
  wide: false,
  tag: "button",
  type: "button",
  disabled: false
};
Button.propTypes = {
  /** Renders the button as Primary (default) */
  primary: PropTypes4.bool,
  /** Renders the button as Secondary */
  secondary: PropTypes4.bool,
  /** Renders the button as Tertiary */
  tertiary: PropTypes4.bool,
  /** Renders the button as Danger */
  danger: PropTypes4.bool,
  /** Decreases button height to 32px */
  small: PropTypes4.bool,
  /** Tells to occupy entire width of a parent container */
  wide: PropTypes4.bool,
  /** Tag name or component */
  tag: PropTypes4.oneOfType([PropTypes4.elementType, PropTypes4.string]),
  /** HTML Button type */
  type: PropTypes4.oneOf(["button", "submit", "reset"]),
  /** HTML Anchor href */
  href: PropTypes4.string,
  /** HTML Anchor target */
  target: PropTypes4.string,
  /** HTML Anchor rel */
  rel: PropTypes4.string,
  /** HTML Button disabled */
  disabled: PropTypes4.bool
};
Button.displayName = BUTTON_CLASS_PREFIX;
var MemoizedButton = memo9(Button);

// src/components/Checkbox/Checkbox.tsx
import React14, { forwardRef as forwardRef9, memo as memo12 } from "react";
import PropTypes6 from "prop-types";

// src/components/SelectorLabel/SelectorLabel.tsx
import React12, { memo as memo11 } from "react";

// src/components/SelectorLabel/style.ts
import styled10, { css as css6 } from "styled-components";
import { color as color6, durationNormal, propsBlocker as propsBlocker10, spacing as spacing8 } from "@deliveryhero/armor-system";
var getStyle = function getStyle(_ref11) {
  var disabled = _ref11.disabled,
    error = _ref11.error;
  var result = css6(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n        padding-left: ", ";\n    "])), spacing8(4));
  if (disabled && error) {
    result = css6(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color6("error.lighter"));
  } else if (disabled) {
    result = css6(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color6("neutral.05"));
  } else if (error) {
    result = css6(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color6("error.main"));
  }
  return result;
};
var SelectorLabelRoot = styled10.div.withConfig(propsBlocker10)(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n    transition: all ", "ms ease;\n    ", ";\n"])), durationNormal, getStyle);

// src/components/SelectorLabel/utils/useSelectorLabelClassName.ts
import { useMemo as useMemo10 } from "react";
import { appendClassName as appendClassName6 } from "@deliveryhero/armor-system";

// src/styling/extractMarginProps.ts
var extractMarginProps = function extractMarginProps(_a) {
  var _b = _a,
    margin = _b.margin,
    marginTop = _b.marginTop,
    marginBottom = _b.marginBottom,
    marginLeft = _b.marginLeft,
    marginRight = _b.marginRight,
    marginX = _b.marginX,
    marginY = _b.marginY,
    restProps = __objRest(_b, ["margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "marginX", "marginY"]);
  var marginProps58 = {
    margin: margin,
    marginTop: marginTop,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginX: marginX,
    marginY: marginY
  };
  return __spreadValues({
    marginProps: marginProps58
  }, restProps);
};

// src/styling/selectorClassGeneratorBasedOnComponent.ts
import { makeBEM as makeBEM8 } from "@deliveryhero/armor-system";
var selectorClassGeneratorBasedOnComponent = function selectorClassGeneratorBasedOnComponent(_ref12) {
  var component = _ref12.component,
    classPrefix = _ref12.classPrefix,
    disabled = _ref12.disabled,
    checked = _ref12.checked,
    error = _ref12.error;
  var baseClassNames = makeBEM8(classPrefix, component);
  var stateClassNames = [];
  if (checked) {
    stateClassNames.push(makeBEM8(classPrefix, component, "checked"));
  }
  if (disabled) {
    stateClassNames.push(makeBEM8(classPrefix, component, "disabled"));
  }
  if (error) {
    stateClassNames.push(makeBEM8(classPrefix, component, "error"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};

// src/components/SelectorLabel/utils/useSelectorLabelClassName.ts
var useSelectorLabelClassName = function useSelectorLabelClassName(classPrefix, className, disabled, checked, error) {
  return useMemo10(function () {
    return {
      Root: appendClassName6(selectorClassGeneratorBasedOnComponent({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked,
        error: error
      }), className)
    };
  }, [classPrefix, className, disabled, checked, error]);
};
var useSelectorLabelClassName_default = useSelectorLabelClassName;

// src/components/Typography/Typography.tsx
import React11, { forwardRef as forwardRef8, memo as memo10 } from "react";
import PropTypes5 from "prop-types";

// src/components/Typography/hooks/useTypographyClassNames.ts
import { useMemo as useMemo11 } from "react";
import { makeBEM as makeBEM9, makeRootClassName as makeRootClassName4 } from "@deliveryhero/armor-system";
var useTypographyClassNames = function useTypographyClassNames(classPrefix, className, props) {
  var _ref13 = props || {},
    paragraph = _ref13.paragraph,
    label = _ref13.label,
    pageTitle = _ref13.pageTitle,
    subSectionTitle = _ref13.subSectionTitle,
    sectionTitle = _ref13.sectionTitle,
    small = _ref13.small,
    medium = _ref13.medium,
    large = _ref13.large,
    variant = _ref13.variant,
    disabled = _ref13.disabled,
    error = _ref13.error;
  return useMemo11(function () {
    var rootClassNames = makeRootClassName4(classPrefix, className);
    var rootStateClassNames = [];
    if (paragraph) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "paragraph"));
    }
    if (label) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "label"));
    }
    if (pageTitle) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "pageTitle"));
    }
    if (sectionTitle) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "sectionTitle"));
    }
    if (subSectionTitle) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "subSectionTitle"));
    }
    if (large) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "large"));
    }
    if (medium) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "medium"));
    }
    if (small) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "small"));
    }
    if (variant) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", variant));
    }
    if (disabled) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "disabled"));
    }
    if (error) {
      rootStateClassNames.push(makeBEM9(classPrefix, "Root", "error"));
    }
    return {
      Root: "".concat(rootClassNames, " ").concat(rootStateClassNames.join(" ")).trim()
    };
  }, [classPrefix, className, paragraph, label, pageTitle, sectionTitle, subSectionTitle, large, medium, small, variant, disabled, error]);
};

// src/components/Typography/style.ts
import styled11, { css as css7 } from "styled-components";
import { colorProps as colorProps2, marginProps as marginProps7, textAlignmentProps as textAlignmentProps2, propsBlocker as propsBlocker11, getComponentOverride as getComponentOverride5, typography as typography6, token as token6 } from "@deliveryhero/armor-system";
var getRootStyle4 = function getRootStyle4(_ref14) {
  var error = _ref14.error,
    disabled = _ref14.disabled,
    typographyTokenName = _ref14.typographyTokenName;
  var textColor = token6("text.color.primary", "body.color");
  if (disabled) {
    textColor = token6("text.color.disabled", "color.neutral.05");
  }
  if (error) {
    textColor = token6("text.color.error", "color.error.main");
  }
  return css7(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n        ", ";\n        color: ", ";\n    "])), typography6(typographyTokenName), textColor);
};
var getWordBreakStyle = function getWordBreakStyle(_ref15) {
  var wordBreak = _ref15.wordBreak;
  if (!wordBreak) return "";
  return css7(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n        word-break: ", ";\n    "])), wordBreak);
};
var getMaxLinesStyle = function getMaxLinesStyle(_ref16) {
  var maxLines = _ref16.maxLines,
    typographyTokenName = _ref16.typographyTokenName,
    theme = _ref16.theme;
  var _typography = typography6(typographyTokenName)({
      theme: theme
    }),
    lineHeight = _typography.lineHeight;
  if (typeof maxLines !== "undefined") {
    return css7(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n            max-height: calc(", " * ", ");\n            overflow-y: hidden;\n        "])), lineHeight, Number(maxLines));
  }
  return "";
};
var Wrapper2 = function Wrapper2(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var TypographyRoot = styled11(Wrapper2).withConfig(propsBlocker11)(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    margin-inline-start: 0;\n    margin-inline-end: 0;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), getRootStyle4, getMaxLinesStyle, getComponentOverride5("Typography"), marginProps7, colorProps2, textAlignmentProps2, getWordBreakStyle);

// src/components/Typography/constants.ts
var TYPOGRAPHY_CLASS_PREFIX = "Typography";

// src/components/Typography/utils/getTagName.ts
var getTagByVariant = function getTagByVariant(variant) {
  if (variant.includes("LargeTitle")) {
    return "h1";
  }
  if (variant.includes("Title2")) {
    return "h2";
  }
  if (variant.includes("Title3")) {
    return "h3";
  }
  if (variant.includes("Title4")) {
    return "h4";
  }
  if (variant.includes("SubtitleLarge")) {
    return "h5";
  }
  if (variant.includes("SubtitleMedium")) {
    return "h6";
  }
  if (variant.includes("Body")) {
    return "p";
  }
  return "div";
};
var getTagName = function getTagName(props) {
  var tag = props.tag,
    paragraph = props.paragraph,
    pageTitle = props.pageTitle,
    subSectionTitle = props.subSectionTitle,
    sectionTitle = props.sectionTitle,
    variant = props.variant;
  if (tag) {
    return tag;
  }
  if (variant) {
    return getTagByVariant(variant);
  }
  if (paragraph) {
    return "p";
  }
  if (pageTitle) {
    return "h1";
  }
  if (sectionTitle) {
    return "h2";
  }
  if (subSectionTitle) {
    return "h3";
  }
  return "div";
};

// src/components/Typography/utils/getTypographyName.ts
var getTypographyName = function getTypographyName(_ref17) {
  var pageTitle = _ref17.pageTitle,
    sectionTitle = _ref17.sectionTitle,
    subSectionTitle = _ref17.subSectionTitle,
    label = _ref17.label,
    paragraph = _ref17.paragraph,
    small = _ref17.small,
    large = _ref17.large,
    variant = _ref17.variant;
  if (variant) {
    return variant;
  }
  var typographyName = "body";
  if (pageTitle) {
    typographyName = "pageTitle";
  } else if (sectionTitle) {
    typographyName = "sectionTitle";
  } else if (subSectionTitle) {
    typographyName = "subSectionTitle";
  } else if (label) {
    typographyName = "labelMedium";
    if (large) {
      typographyName = "labelLarge";
    } else if (small) {
      typographyName = "labelSmall";
    }
  } else if (paragraph) {
    typographyName = "paragraphMedium";
    if (large) {
      typographyName = "paragraphLarge";
    } else if (small) {
      typographyName = "paragraphSmall";
    }
  }
  return typographyName;
};

// src/components/Typography/hooks/useTypography.ts
var useTypography = function useTypography(props, ref) {
  var Tag3 = getTagName(props);
  var typographyTokenName = getTypographyName(props);
  return {
    rootProps: __spreadProps(__spreadValues({}, props), {
      typographyTokenName: typographyTokenName
    }),
    tagProps: {
      ref: ref
    },
    Tag: Tag3
  };
};

// src/components/Typography/Typography.tsx
var Typography = forwardRef8(function Typography2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var _useTypography = useTypography(props, ref),
    rootProps = _useTypography.rootProps,
    tagProps = _useTypography.tagProps,
    Tag3 = _useTypography.Tag;
  var classNameComponents = useTypographyClassNames(TYPOGRAPHY_CLASS_PREFIX, className, props);
  return /* @__PURE__ */React11.createElement(TypographyRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root
  }), function (forwardedProps) {
    return /* @__PURE__ */React11.createElement(Tag3, __spreadValues(__spreadValues({}, forwardedProps), tagProps), children);
  });
});
Typography.defaultProps = {
  large: false,
  medium: false,
  small: false
};
Typography.propTypes = {
  disabled: PropTypes5.bool,
  error: PropTypes5.bool,
  large: PropTypes5.bool,
  medium: PropTypes5.bool,
  small: PropTypes5.bool,
  /** Tag name or component */
  tag: PropTypes5.oneOfType([PropTypes5.elementType, PropTypes5.string])
};
var MemoizedTypography = memo10(Typography);

// src/components/SelectorLabel/constants.ts
var SELECTOR_LABEL_CLASS_PREFIX = "SelectorLabel";

// src/components/SelectorLabel/SelectorLabel.tsx
var SelectorLabel = function SelectorLabel(_ref18) {
  var checked = _ref18.checked,
    children = _ref18.children,
    className = _ref18.className,
    error = _ref18.error,
    disabled = _ref18.disabled,
    typographyProps = _ref18.typographyProps;
  var classOverride = useSelectorLabelClassName_default(SELECTOR_LABEL_CLASS_PREFIX, className, disabled, checked, error);
  return children ? /* @__PURE__ */React12.createElement(SelectorLabelRoot, {
    disabled: disabled,
    error: error,
    className: classOverride.Root
  }, typographyProps ? /* @__PURE__ */React12.createElement(Typography, __spreadValues({
    disabled: disabled,
    error: error,
    margin: 0,
    tag: "div"
  }, typographyProps), children) : children) : null;
};
SelectorLabel.displayName = SELECTOR_LABEL_CLASS_PREFIX;
var MemoizedSelectorLabel = memo11(SelectorLabel);

// src/components/Checkbox/hooks/useCheckboxClassName.ts
import { useMemo as useMemo12 } from "react";
import { appendClassName as appendClassName7, makeBEM as makeBEM10 } from "@deliveryhero/armor-system";
var useCheckboxClassName = function useCheckboxClassName(classPrefix, className, disabled, checked, error) {
  return useMemo12(function () {
    return {
      Root: appendClassName7(selectorClassGeneratorBasedOnComponent({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked,
        error: error
      }), className),
      Input: selectorClassGeneratorBasedOnComponent({
        component: "Input",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked,
        error: error
      }),
      Checkmark: selectorClassGeneratorBasedOnComponent({
        component: "Checkmark",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked,
        error: error
      }),
      Label: makeBEM10(classPrefix, "Label"),
      Icon: makeBEM10(classPrefix, "Icon")
    };
  }, [classPrefix, className, disabled, checked, error]);
};

// src/components/Checkbox/style.ts
import styled12, { css as css8 } from "styled-components";
import { marginProps as marginProps8, propsBlocker as propsBlocker12, getComponentOverride as getComponentOverride6, fontWeightRegular, mouseCursor as mouseCursor2, pointerEvents, getFocusStyle, token as token7, transition as transition6 } from "@deliveryhero/armor-system";
import { TickThickIcon, DashIcon } from "@deliveryhero/armor-icons";
var checkmarkSizing = function checkmarkSizing() {
  return css8(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n    width: ", "px;\n    height: ", "px;\n"])), token7("control.sizing.mini", 16), token7("control.sizing.mini", 16));
};
var checkedHover = function checkedHover() {
  return css8(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n    border-color: ", ";\n    background-color: ", ";\n"])), token7("control.color.primary.selected-hover", "color.primary.05"), token7("control.color.primary.selected-hover", "color.primary.05"));
};
var uncheckedHover = function uncheckedHover() {
  return css8(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n    border-color: ", ";\n"])), token7("control.color.primary.hover", "color.primary.05"));
};
var getIconStyle = function getIconStyle(_ref19) {
  var disabled = _ref19.disabled,
    checked = _ref19.checked;
  var result = css8(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n        color: ", ";\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 12px;\n        height: 12px;\n        transform: translate(-50%, -50%);\n    "])), token7("icon.color.onbranded", "color.neutral.00"));
  if (!checked) {
    result = css8(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n            ", ";\n            display: none;\n        "])), result);
  }
  if (disabled) {
    result = css8(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, token7("icon.color.disabled", "color.neutral.03"));
  }
  return result;
};
var StyledCheckedIcon = styled12(TickThickIcon)(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n    ", ";\n"])), getIconStyle);
StyledCheckedIcon.defaultProps = {
  medium: true
};
var StyledDashIcon = styled12(DashIcon)(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n    ", ";\n"])), getIconStyle);
StyledDashIcon.defaultProps = {
  medium: true
};
var CheckboxCheckmark = styled12.div.withConfig(propsBlocker12)(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n    position: relative;\n    ", ";\n\n    &::before {\n        ", ";\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 0;\n        border-radius: ", ";\n        box-sizing: border-box;\n        border: ", "px solid\n            ", ";\n        background-color: ", ";\n        ", ";\n    }\n\n    ", ";\n"])), checkmarkSizing, checkmarkSizing, token7("control.borderRadius.small", "shape.borderRadius.soft", {
  returnUnit: "px"
}), token7("control.borderWidth.thin", 1), token7("control.color.primary.enabled", "color.neutral.03"), token7("control.color.secondary.enabled", "color.neutral.00"), transition6({
  all: true
}), pointerEvents);
var CheckboxInput = styled12.input.withConfig(propsBlocker12)(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n    opacity: 0;\n    position: absolute;\n    margin: 0;\n    height: 0;\n    width: 0;\n\n    &:not(:checked)\n        + ", ":hover:before,\n        &:not(:checked)\n        + ", ":active:before {\n        border-width: ", "px;\n        border-style: solid;\n        ", "\n    }\n\n    &:checked\n        + ", ":hover:before,\n        &:not(:checked)\n        + ", ":active:before {\n        ", "\n    }\n\n    &:checked + ", ":before {\n        opacity: 1;\n        box-sizing: border-box;\n        border-color: ", ";\n        background-color: ", ";\n    }\n\n    &:disabled + ", ":before {\n        box-shadow: none;\n        border-width: ", "px;\n        border-style: solid;\n        box-sizing: border-box;\n        border-color: ", ";\n        background-color: ", ";\n    }\n\n    &:focus-visible + ", ":before {\n        ", "\n    }\n"])), CheckboxCheckmark, CheckboxCheckmark, token7("control.borderWidth.thin", 1), uncheckedHover, CheckboxCheckmark, CheckboxCheckmark, checkedHover, CheckboxCheckmark, token7("control.color.primary.selected", "color.primary.main"), token7("control.color.primary.selected", "color.primary.main"), CheckboxCheckmark, token7("control.borderWidth.thin", 1), token7("control.color.primary.disabled", "color.neutral.03"), token7("control.color.secondary.disabled", "color.neutral.02"), CheckboxCheckmark, function (_ref20) {
  var checked = _ref20.checked,
    disabled = _ref20.disabled,
    error = _ref20.error;
  return getFocusStyle({
    inverse: checked,
    disabled: disabled,
    error: error
  });
});
var CheckboxRoot = styled12.label.withConfig(propsBlocker12)(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    margin: 0;\n    font-weight: ", ";\n\n    &:hover {\n        ", " {\n            &:checked:not(:focus-visible):not(:disabled)\n                + ", ":before {\n                ", "\n            }\n\n            &:not(:checked):not(:disabled) + ", ":before {\n                ", "\n            }\n        }\n    }\n\n    ", ";\n    ", ";\n    ", ";\n"])), fontWeightRegular, CheckboxInput, CheckboxCheckmark, checkedHover, CheckboxCheckmark, uncheckedHover, mouseCursor2, getComponentOverride6("Checkbox"), marginProps8);

// src/components/Checkbox/hooks/useCheckbox.tsx
import { useCallback as useCallback3, useMemo as useMemo13 } from "react";
import { useControlledState as useControlledState2, useRootRef as useRootRef5, generateId } from "@deliveryhero/armor-system";

// src/components/Checkbox/constants.ts
var CHECKBOX_CLASS_PREFIX = "Checkbox";
var checkboxIdPrefix = "checkbox-id-";
var CHECKBOX_CHECK_TYPE_DASH = "dash";
var CHECKBOX_CHECK_TYPE_TICK = "tick";

// src/components/Checkbox/hooks/useCheckbox.tsx
var useCheckbox = function useCheckbox(_a, ref) {
  var _b = _a,
    checked = _b.checked,
    checkedIcon = _b.checkedIcon,
    defaultChecked = _b.defaultChecked,
    disabled = _b.disabled,
    error = _b.error,
    propsId = _b.id,
    name = _b.name,
    label = _b.label,
    onChange = _b.onChange,
    readOnly = _b.readOnly,
    restProps = __objRest(_b, ["checked", "checkedIcon", "defaultChecked", "disabled", "error",
    // todo: forward all input-specific props directly to the input node, as it is done in <TextInput>
    // todo: packages/core/src/components/TextInput/hooks/useTextInput.ts:24
    "id", "name", "label", "onChange", "readOnly"]);
  var internalInputRef = useRootRef5(ref);
  var id = generateId(propsId, checkboxIdPrefix);
  var _useControlledState3 = useControlledState2(defaultChecked, checked),
    _useControlledState4 = _slicedToArray(_useControlledState3, 2),
    controlledChecked = _useControlledState4[0],
    setControlledChecked = _useControlledState4[1];
  var handleOnChange2 = useCallback3(function (event) {
    onChange == null ? void 0 : onChange(event);
    setControlledChecked(event.target.checked);
  }, [onChange, setControlledChecked]);
  var typographyProps = useMemo13(function () {
    return {
      paragraph: true,
      large: true
    };
  }, []);
  return {
    rootProps: __spreadValues({
      disabled: disabled,
      htmlFor: id,
      checked: controlledChecked
    }, restProps),
    checkboxInputProps: {
      checked: controlledChecked,
      error: error,
      checkedIcon: checkedIcon,
      disabled: disabled,
      id: id,
      name: name,
      onChange: handleOnChange2,
      ref: internalInputRef,
      type: "checkbox",
      readOnly: readOnly
    },
    checkboxCheckmarkProps: {
      checked: checked,
      checkedIcon: checkedIcon,
      disabled: disabled,
      hasLabel: !!label
    },
    selectorLabelProps: {
      disabled: disabled,
      error: error,
      typographyProps: typographyProps
    },
    iconProps: {
      disabled: disabled,
      checked: controlledChecked
    },
    label: label,
    disabled: disabled,
    checked: checked,
    error: error,
    checkedIcon: checkedIcon
  };
};

// src/components/Checkbox/Checkbox.tsx
var Checkbox = forwardRef9(function Checkbox2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var _useCheckbox = useCheckbox(props, ref),
    rootProps = _useCheckbox.rootProps,
    checkboxInputProps = _useCheckbox.checkboxInputProps,
    checkboxCheckmarkProps = _useCheckbox.checkboxCheckmarkProps,
    selectorLabelProps = _useCheckbox.selectorLabelProps,
    iconProps = _useCheckbox.iconProps,
    label = _useCheckbox.label,
    disabled = _useCheckbox.disabled,
    checked = _useCheckbox.checked,
    error = _useCheckbox.error,
    checkedIcon = _useCheckbox.checkedIcon;
  var classOverride = useCheckboxClassName(CHECKBOX_CLASS_PREFIX, className, disabled, checked, error);
  return /* @__PURE__ */React14.createElement(CheckboxRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  }), /* @__PURE__ */React14.createElement(CheckboxInput, __spreadValues({
    className: classOverride.Input
  }, checkboxInputProps)), /* @__PURE__ */React14.createElement(CheckboxCheckmark, __spreadValues({
    className: classOverride.Checkmark
  }, checkboxCheckmarkProps), checkedIcon === "dash" ? /* @__PURE__ */React14.createElement(StyledDashIcon, __spreadValues({
    className: classOverride.Icon
  }, iconProps)) : /* @__PURE__ */React14.createElement(StyledCheckedIcon, __spreadValues({
    className: classOverride.Icon
  }, iconProps))), !!label && /* @__PURE__ */React14.createElement(SelectorLabel, __spreadValues({
    className: classOverride.Label
  }, selectorLabelProps), label));
});
Checkbox.displayName = CHECKBOX_CLASS_PREFIX;
Checkbox.defaultProps = {
  checkedIcon: "tick",
  disabled: false
};
Checkbox.propTypes = {
  checked: PropTypes6.bool,
  checkedIcon: PropTypes6.oneOf(["tick", "dash"]),
  disabled: PropTypes6.bool,
  error: PropTypes6.bool,
  id: PropTypes6.string,
  label: PropTypes6.string,
  onChange: PropTypes6.func
};
var MemoizedCheckbox = memo12(Checkbox);

// src/components/ConditionTag/ConditionTag.tsx
import React20, { forwardRef as forwardRef13, memo as memo16 } from "react";

// src/components/ConditionTag/hooks/useConditionTagClassNames.ts
import { useMemo as useMemo14 } from "react";
import { makeRootClassName as makeRootClassName5, makeBEM as makeBEM11 } from "@deliveryhero/armor-system";
var useConditionTagClassNames = function useConditionTagClassNames(classPrefix, className) {
  return useMemo14(function () {
    return {
      Root: makeRootClassName5(classPrefix, className),
      Label: makeBEM11(classPrefix, "Label"),
      Value: makeBEM11(classPrefix, "Value"),
      ValueSegment: makeBEM11(classPrefix, "ValueSegment"),
      ValueMoreLink: makeBEM11(classPrefix, "ValueMoreLink"),
      ValueTailElement: makeBEM11(classPrefix, "ValueTailElement"),
      CloseIconContainer: makeBEM11(classPrefix, "CloseIconContainer")
    };
  }, [classPrefix, className]);
};

// src/components/ConditionTag/hooks/useConditionTag.ts
import { useMemo as useMemo15 } from "react";
import { useRootRef as useRootRef6 } from "@deliveryhero/armor-system";

// src/components/ConditionTag/constants.ts
var CONDITION_TAG_CLASS_PREFIX = "ConditionTag";
var MAX_VISIBLE_TAGS = 3;

// src/components/ConditionTag/hooks/useConditionTag.ts
var useConditionTag = function useConditionTag(_a, ref) {
  var _b = _a,
    label = _b.label,
    value = _b.value,
    onCloseButtonClick = _b.onCloseButtonClick,
    enableCloseIcon = _b.enableCloseIcon,
    path = _b.path,
    restProps = __objRest(_b, ["label", "value", "onCloseButtonClick", "enableCloseIcon", "path"]);
  var innerRef = useRootRef6(ref);
  var _useMemo = useMemo15(function () {
      var fullValue = Array.isArray(value) ? value : [value];
      if (fullValue.length > MAX_VISIBLE_TAGS) {
        var head = fullValue.splice(0, MAX_VISIBLE_TAGS);
        return [head, fullValue];
      }
      return [fullValue, []];
    }, [value]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    valueHead = _useMemo2[0],
    valueTail = _useMemo2[1];
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: innerRef
    }),
    closeButtonProps: {
      onClick: onCloseButtonClick,
      "data-path": path
    },
    label: label,
    valueHead: valueHead,
    valueTail: valueTail,
    hasTail: !!valueTail.length,
    tailLength: valueTail.length,
    enableCloseIcon: enableCloseIcon
  };
};

// src/components/ConditionTag/style.ts
import styled14 from "styled-components";
import { marginProps as marginProps10, propsBlocker as propsBlocker14, reset as reset4, typography as typography8, spacing as spacing11, notLastChild, transition as transition9, token as token15, getComponentOverride as getComponentOverride8 } from "@deliveryhero/armor-system";

// src/components/Link/Link.tsx
import React15, { forwardRef as forwardRef10, memo as memo13 } from "react";
import PropTypes7 from "prop-types";

// src/components/Link/hooks/useLinkClassNames.ts
import { useMemo as useMemo16 } from "react";
import { makeRootClassName as makeRootClassName6, makeBEM as makeBEM12 } from "@deliveryhero/armor-system";
var useLinkClassNames = function useLinkClassNames(classPrefix, className, props) {
  var _ref21 = props || {},
    disabled = _ref21.disabled,
    small = _ref21.small,
    medium = _ref21.medium,
    large = _ref21.large,
    underline = _ref21.underline,
    pressed = _ref21.pressed;
  return useMemo16(function () {
    var rootClassNames = makeRootClassName6(classPrefix, className);
    var rootStateClassNames = [];
    if (small) {
      rootStateClassNames.push(makeBEM12(classPrefix, "Root", "small"));
    }
    if (medium) {
      rootStateClassNames.push(makeBEM12(classPrefix, "Root", "medium"));
    }
    if (large) {
      rootStateClassNames.push(makeBEM12(classPrefix, "Root", "large"));
    }
    if (underline) {
      rootStateClassNames.push(makeBEM12(classPrefix, "Root", "underline"));
    }
    if (disabled) {
      rootStateClassNames.push(makeBEM12(classPrefix, "Root", "disabled"));
    }
    if (pressed) {
      rootStateClassNames.push(makeBEM12(classPrefix, "Root", "pressed"));
    }
    return {
      Root: "".concat(rootClassNames, " ").concat(rootStateClassNames.join(" ")).trim()
    };
  }, [classPrefix, className, small, medium, large, underline, disabled, pressed]);
};

// src/components/Link/hooks/useLink.ts
import { getChildrenWithIconProps as getChildrenWithIconProps2 } from "@deliveryhero/armor-system";

// src/components/Link/constants.ts
var LINK_CLASS_PREFIX = "Link";
var LINK_ICON_DEFAULT_SIZE = {
  small: true
};
var LINK_ICON_POSITION_MARGIN_MAP = {
  first: {
    marginRight: 1
  },
  last: {
    marginLeft: 1
  }
};

// src/components/Link/utils/getIconMargin.ts
function getIconMargin2(childrenCount, iconIndex) {
  var first = LINK_ICON_POSITION_MARGIN_MAP.first,
    last = LINK_ICON_POSITION_MARGIN_MAP.last;
  var isFirst = iconIndex === 0;
  var isLast = iconIndex === childrenCount - 1;
  if (isFirst) {
    return first;
  }
  if (isLast) {
    return last;
  }
  return {};
}
var getIconMargin_default2 = getIconMargin2;

// src/components/Link/hooks/useLink.ts
var useLink = function useLink(props, ref) {
  var _a = props,
    _a$tag = _a.tag,
    Tag3 = _a$tag === void 0 ? "a" : _a$tag,
    disabled = _a.disabled,
    baseChildren = _a.children,
    restProps = __objRest(_a, ["tag", "disabled", "children"]);
  var children = getChildrenWithIconProps2(baseChildren, function (childrenCount, iconIndex) {
    return __spreadValues(__spreadValues({}, LINK_ICON_DEFAULT_SIZE), getIconMargin_default2(childrenCount, iconIndex));
  });
  var rootPropsDisabled = disabled && {
    tabIndex: -1,
    onClick: function onClick(event) {
      return event.preventDefault();
    }
  };
  return {
    rootProps: __spreadValues(__spreadValues({
      disabled: disabled
    }, restProps), rootPropsDisabled),
    Tag: Tag3,
    tagProps: {
      ref: ref
    },
    children: children
  };
};

// src/components/Link/style/LinkRoot.ts
import styled13 from "styled-components";
import { reset as reset3, propsBlocker as propsBlocker13, marginProps as marginProps9, getComponentOverride as getComponentOverride7, transition as transition8, fontFamilyRoboto } from "@deliveryhero/armor-system";

// src/components/Link/style/mixins/getSizeStyle.ts
import { typography as typography7 } from "@deliveryhero/armor-system";
import { css as css9 } from "styled-components";
var getSizeStyle = function getSizeStyle(_ref22) {
  var small = _ref22.small,
    medium = _ref22.medium,
    large = _ref22.large;
  if (small) {
    return css9(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n            ", ";\n        "])), typography7("desktop.bodySmall", "paragraphSmall"));
  }
  if (medium) {
    return css9(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n            ", ";\n        "])), typography7("desktop.bodyMedium", "paragraphMedium"));
  }
  if (large) {
    return css9(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n            ", ";\n        "])), typography7("desktop.bodyLarge", "paragraphLarge"));
  }
  return void 0;
};
var getSizeStyle_default = getSizeStyle;

// src/components/Link/style/mixins/getActiveStyle.ts
import { token as token8 } from "@deliveryhero/armor-system";
import { css as css10 } from "styled-components";
var getActiveStyle = function getActiveStyle(_ref23) {
  var disabled = _ref23.disabled;
  if (disabled) {
    return void 0;
  }
  return css10(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n        &:active {\n            color: ", ";\n\n            &:after {\n                background-color: ", ";\n            }\n        }\n    "])), token8("action.color.primary.pressed", "color.primary.10"), token8("action.color.primary.pressed", "color.primary.10"));
};
var getActiveStyle_default = getActiveStyle;

// src/components/Link/style/mixins/getDisabledStyle.ts
import { token as token9, mouseCursor as mouseCursor3 } from "@deliveryhero/armor-system";
import { css as css11 } from "styled-components";
var getDisabledStyle = function getDisabledStyle(_ref24) {
  var disabled = _ref24.disabled;
  if (!disabled) {
    return void 0;
  }
  return css11(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n        color: ", ";\n        ", "\n\n        &&:after {\n            background-color: ", ";\n        }\n    "])), token9("text.color.disabled", "color.neutral.05"), mouseCursor3({
    disabled: disabled
  }), token9("text.color.disabled", "color.neutral.05"));
};
var getDisabledStyle_default = getDisabledStyle;

// src/components/Link/style/mixins/getFocusStyle.ts
import { token as token10, spacing as spacing9 } from "@deliveryhero/armor-system";
import { css as css12 } from "styled-components";
var getFocusStyle2 = function getFocusStyle2(_ref25) {
  var disabled = _ref25.disabled,
    inline = _ref25.inline,
    underline = _ref25.underline;
  if (disabled) {
    return void 0;
  }
  var isInline = inline || underline;
  return css12(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n        outline: none;\n\n        &:focus-visible {\n            z-index: 1;\n            position: relative;\n            color: ", ";\n\n            &:before {\n                content: '';\n\n                z-index: -1;\n                position: absolute;\n                left: -", ";\n                right: -", ";\n                top: 0;\n                bottom: ", ";\n\n                border-radius: ", ";\n                background-color: ", ";\n            }\n        }\n    "])), token10("action.color.primary.enabled", "color.primary.07"), spacing9("action.spacing.xsmall", [1]), spacing9("action.spacing.xsmall", [1]), isInline ? spacing9(-0.25) : 0, token10("action.borderRadius.small", "shape.borderRadius.soft", {
    returnUnit: "px"
  }), token10("action.color.secondary.hover", "color.primary.02"));
};
var getFocusStyle_default = getFocusStyle2;

// src/components/Link/style/mixins/getHoverStyle.ts
import { token as token11 } from "@deliveryhero/armor-system";
import { css as css13 } from "styled-components";
var getHoverStyle = function getHoverStyle(_ref26) {
  var disabled = _ref26.disabled,
    focused = _ref26.focused;
  if (disabled || focused) {
    return void 0;
  }
  return css13(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n        &:hover:not(:active) {\n            color: ", ";\n\n            &:after {\n                background-color: ", ";\n            }\n        }\n    "])), token11("action.color.primary.hover", "color.primary.05"), token11("action.color.primary.hover", "color.primary.05"));
};
var getHoverStyle_default = getHoverStyle;

// src/components/Link/style/mixins/getInlineStyle.ts
import { token as token12, pointerEvents as pointerEvents2, transition as transition7, spacing as spacing10 } from "@deliveryhero/armor-system";
import { css as css14 } from "styled-components";
var getInlineStyle = function getInlineStyle(_ref27) {
  var inline = _ref27.inline,
    underline = _ref27.underline;
  if (!inline && !underline) {
    return void 0;
  }
  return css14(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n        z-index: 1;\n        position: relative;\n\n        &:after {\n            content: '';\n\n            z-index: -1;\n            position: absolute;\n            left: 0;\n            right: 0;\n            bottom: ", ";\n            height: ", ";\n\n            background-color: ", ";\n\n            ", ";\n            ", "\n        }\n    "])), spacing10(-0.25), spacing10(0.25), token12("action.color.primary.enabled", "color.primary.07"), transition7({
    "background-color": true
  }), pointerEvents2({
    disabled: true
  }));
};
var getInlineStyle_default = getInlineStyle;

// src/components/Link/style/mixins/getVisitedStyle.ts
import { token as token13 } from "@deliveryhero/armor-system";
import { css as css15 } from "styled-components";
var getVisitedStyle = function getVisitedStyle(_ref28) {
  var disabled = _ref28.disabled;
  if (disabled) {
    return void 0;
  }
  return css15(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n        &:visited:not(:focus-visible) {\n            color: ", ";\n\n            &:after {\n                background-color: ", ";\n            }\n        }\n    "])), token13("action.color.visited.enabled", "color.visited.02"), token13("action.color.visited.enabled", "color.visited.02"));
};
var getVisitedStyle_default = getVisitedStyle;

// src/components/Link/style/mixins/getRootStyle.ts
import { token as token14 } from "@deliveryhero/armor-system";
import { css as css16 } from "styled-components";
var getRootStyle5 = function getRootStyle5() {
  return css16(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        text-decoration: none;\n        cursor: pointer;\n        color: ", ";\n\n        svg {\n            color: inherit;\n        }\n    "])), token14("action.color.primary.enabled", "color.primary.07"));
};
var getRootStyle_default = getRootStyle5;

// src/components/Link/style/LinkRoot.ts
var LinkTagWrapper = function LinkTagWrapper(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(restProps);
};
var LinkRoot = styled13(LinkTagWrapper).withConfig(propsBlocker13)(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n    ", ";\n\n    font-family: ", ";\n\n    ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    ", ";\n    ", ";\n"])), reset3, fontFamilyRoboto, transition8({
  all: true
}), getRootStyle_default, getSizeStyle_default, getVisitedStyle_default, getFocusStyle_default, getHoverStyle_default, getActiveStyle_default, getDisabledStyle_default, getInlineStyle_default, marginProps9, getComponentOverride7("Link"));
var LinkRoot_default = LinkRoot;

// src/components/Link/Link.tsx
var Link = forwardRef10(function Link2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNameComponents = useLinkClassNames(LINK_CLASS_PREFIX, className, props);
  var _useLink = useLink(props, ref),
    rootProps = _useLink.rootProps,
    children = _useLink.children,
    Tag3 = _useLink.Tag,
    tagProps = _useLink.tagProps;
  return /* @__PURE__ */React15.createElement(LinkRoot_default, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root
  }), function (forwardedProps) {
    return /* @__PURE__ */React15.createElement(Tag3, __spreadValues(__spreadValues({}, forwardedProps), tagProps), children);
  });
});
Link.defaultProps = {
  small: false,
  medium: false,
  large: false,
  pressed: false,
  disabled: false,
  underline: false
};
Link.propTypes = {
  small: PropTypes7.bool,
  medium: PropTypes7.bool,
  large: PropTypes7.bool,
  pressed: PropTypes7.bool,
  disabled: PropTypes7.bool,
  underline: PropTypes7.bool,
  href: PropTypes7.string,
  target: PropTypes7.string,
  to: PropTypes7.string,
  tag: PropTypes7.oneOfType([PropTypes7.elementType, PropTypes7.string])
};
var MemoizedLink = memo13(Link);

// src/components/ConditionTag/style.ts
var ConditionTagRoot = styled14.div.withConfig(propsBlocker14)(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n    ", ";\n    width: fit-content;\n    height: 28px;\n    overflow: hidden;\n    border: ", "px solid\n        ", ";\n    display: inline-flex;\n    flex-flow: row nowrap;\n    position: relative;\n    border-radius: ", ";\n    ", ";\n\n    &:hover {\n        .ConditionTag-CloseIconContainer {\n            opacity: 1;\n            transform: translateX(0);\n            background-color: ", ";\n        }\n    }\n    ", ";\n"])), reset4, token15("control.borderWidth.thin", 1), token15("control.color.primary.enabled", "color.neutral.03"), token15("action.borderRadius.pill", "shape.borderRadius.pill", {
  returnUnit: "px"
}), marginProps10, token15("base.color.flat", "white"), getComponentOverride8("ConditionTag"));
var ConditionTagLabel = styled14.div.withConfig(propsBlocker14)(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    background-color: ", ";\n    padding: ", " ", ";\n    border-right: ", "px solid\n        ", ";\n    display: flex;\n    align-items: center;\n    user-select: none;\n"])), typography8("desktop.caption", "labelSmall"), token15("text.color.primary", "body.color"), token15("control.color.secondary.disabled", "color.neutral.02"), spacing11(1.5), spacing11("control.spacing.small", [2]), token15("control.borderWidth.thin", 1), token15("control.color.primary.enabled", "color.neutral.03"));
var ConditionTagValue = styled14.div.withConfig(propsBlocker14)(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n    display: flex;\n"])));
var ConditionTagValueSegment = styled14.div.withConfig(propsBlocker14)(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    background-color: ", ";\n    padding: ", " ", ";\n    display: flex;\n    align-items: center;\n    min-width: ", ";\n    &", " {\n        border-right: ", "px solid\n            ", ";\n    }\n"])), typography8("desktop.bodySmall", "paragraphSmall"), token15("text.color.primary", "body.color"), token15("control.color.secondary.enabled", "color.neutral.00"), spacing11(1.25), spacing11("control.spacing.small", [2]), spacing11(4), notLastChild, token15("control.borderWidth.thin", 1), token15("control.color.primary.enabled", "color.neutral.03"));
var ConditionTagValueMoreLink = styled14(Link)(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n    ", ";\n"])), typography8("desktop.caption", "labelSmall"));
var ConditionTagValueTailElement = styled14.div.withConfig(propsBlocker14)(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral([""])));
var ConditionTagCloseIconContainer = styled14.div.withConfig(propsBlocker14)(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transform: translateX(", ");\n    ", ";\n    position: absolute;\n    top: ", ";\n    right: ", ";\n"])), spacing11(6), transition9({
  opacity: true,
  transform: true
}), spacing11(0.35), spacing11(0.5));

// src/components/Tooltip/Tooltip.tsx
import React18, { forwardRef as forwardRef11, memo as memo14 } from "react";
import PropTypes8 from "prop-types";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { PortalToBody, durationNormal as durationNormal3 } from "@deliveryhero/armor-system";

// src/components/Tooltip/hooks/useTooltipClassNames.ts
import { useMemo as useMemo17 } from "react";
import { makeBEM as makeBEM13, makeRootClassName as makeRootClassName7 } from "@deliveryhero/armor-system";
var useTooltipClassNames = function useTooltipClassNames(classPrefix, className, align) {
  return useMemo17(function () {
    var rootClassNames = makeRootClassName7(classPrefix, className);
    var rootStateClassNames = [];
    if (align) {
      rootStateClassNames.push(makeBEM13(classPrefix, "Root", "align-".concat(align === "top" ? "top" : "bottom")));
    }
    return {
      Root: "".concat(rootClassNames, " ").concat(rootStateClassNames.join(" ")).trim(),
      Arrow: makeBEM13(classPrefix, "Arrow"),
      Container: makeBEM13(classPrefix, "Container")
    };
  }, [classPrefix, className, align]);
};

// src/components/Tooltip/style.ts
import styled15, { css as css17 } from "styled-components";
import { widthProps as widthProps4, zIndex, getComponentOverride as getComponentOverride9, propsBlocker as propsBlocker15, popperArrow, popperArrowPlacement, typography as typography9, token as token16, spacing as spacing12, transition as transition10, reset as reset5 } from "@deliveryhero/armor-system";
var getRootStyle6 = function getRootStyle6(_ref29) {
  var error = _ref29.error;
  if (error) {
    return css17(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n            color: ", ";\n            background-color: ", ";\n            border-color: ", ";\n        "])), token16("text.color.ondanger", "color.neutral.00"), token16("control.color.danger.enabled", "color.error.08"), token16("control.color.danger.enabled"));
  }
  return css17(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: ", ";\n        border-color: ", ";\n    "])), token16("text.color.inverse", "color.neutral.00"), token16("base.color.highest", "color.neutral.11"), token16("base.color.highest"));
};
var getArrowStyle = function getArrowStyle(_ref30) {
  var error = _ref30.error;
  if (error) {
    return css17(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n            &:before {\n                background-color: ", ";\n            }\n        "])), token16("control.color.danger.enabled", "color.error.08"));
  }
  return css17(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n        &:before {\n            background-color: ", ";\n        }\n    "])), token16("base.color.highest", "color.neutral.11"));
};
var getSizeStyle2 = function getSizeStyle2(_ref31) {
  var small = _ref31.small;
  if (small) {
    return css17(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n            padding: ", ";\n        "])), spacing12("base.spacing.xsmall", "base.spacing.small", [1, 2]));
  }
  return css17(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["\n        padding: ", ";\n    "])), spacing12("base.spacing.small", "base.spacing.medium", [2, 3]));
};
var TooltipRoot = styled15.div.withConfig(propsBlocker15)(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    text-align: left;\n    border-radius: ", ";\n    border: ", "px solid;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), token16("base.borderRadius.small", "shape.borderRadius.soft", {
  returnUnit: "px"
}), token16("base.borderWidth.thin"), transition10({
  opacity: true
}), popperArrowPlacement("Tooltip-Arrow"), typography9("desktop.bodySmall", "paragraphSmall"), zIndex, getRootStyle6, getSizeStyle2, getComponentOverride9("Tooltip"), widthProps4);
var TooltipContainer = styled15.div.withConfig(propsBlocker15)(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n    .Tooltip-Container.enter {\n        opacity: 0;\n    }\n    .Tooltip-Container.enter-active {\n        opacity: 1;\n    }\n    .Tooltip-Container.exit {\n        opacity: 1;\n    }\n    .Tooltip-Container.exit-active {\n        opacity: 0;\n    }\n"])));
var TooltipArrow = styled15.div.withConfig(propsBlocker15)(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"])), popperArrow, getArrowStyle);
var TriggerWrapper = styled15.div.withConfig(propsBlocker15)(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["\n    ", "\n\n    display: inline-block;\n\n    & > * {\n        pointer-events: none;\n    }\n"])), reset5);

// src/components/Tooltip/constants.ts
var TOOLTIP_CLASS_PREFIX = "Tooltip";
var TOOLTIP_ALIGN_PLACEMENTS = [
// top
"top-start", "top", "top-end",
// right
"right-start", "right", "right-end",
// bottom
"bottom-start", "bottom", "bottom-end",
// left
"left-start", "left", "left-end"];

// src/components/Tooltip/hooks/useTooltip.ts
import React17, { useMemo as useMemo18, useRef as useRef2 } from "react";
import { usePopper, useControlledFlagState, useOverlay, useRootRef as useRootRef7 } from "@deliveryhero/armor-system";

// src/components/Tooltip/hooks/useEventProxy.ts
import { useCallback as useCallback4, useRef, useEffect } from "react";
import { useEventListener as useEventListener2, durationNormal as durationNormal2 } from "@deliveryhero/armor-system";
var useEventProxy = function useEventProxy(children, setOpen, tooltipRef, disableInteractive) {
  var _a, _b;
  var leaveTimer = useRef();
  var childrenElement = children;
  var onMouseOver = (_a = childrenElement == null ? void 0 : childrenElement.props) == null ? void 0 : _a.onMouseOver;
  var onMouseOut = (_b = childrenElement == null ? void 0 : childrenElement.props) == null ? void 0 : _b.onMouseOut;
  var onMouseOverProxy = useCallback4(function (event) {
    if (leaveTimer.current) {
      clearTimeout(leaveTimer.current);
    }
    setOpen(true);
    onMouseOver == null ? void 0 : onMouseOver(event);
  }, [onMouseOver, setOpen]);
  var onMouseOutProxy = useCallback4(function (event) {
    leaveTimer.current = setTimeout(function () {
      setOpen(false);
      onMouseOut == null ? void 0 : onMouseOut(event);
    }, durationNormal2);
  }, [onMouseOut, setOpen]);
  useEffect(function () {
    var timerRef = leaveTimer.current;
    return function () {
      if (timerRef) {
        clearTimeout(timerRef);
      }
    };
  }, []);
  useEventListener2("mouseover", onMouseOverProxy, tooltipRef, disableInteractive);
  useEventListener2("mouseout", onMouseOutProxy, tooltipRef, disableInteractive);
  return {
    onMouseOverProxy: onMouseOverProxy,
    onMouseOutProxy: onMouseOutProxy
  };
};

// src/components/Tooltip/utils/validateTrigger.tsx
import React16 from "react";
import { isFragment } from "react-is";
import { consoleWarn } from "@deliveryhero/armor-system";
var validateTrigger = function validateTrigger(trigger) {
  var _a;
  if (!trigger) {
    consoleWarn("Tooltip should have a trigger element to attach itself to.");
    return null;
  }
  if (Array.isArray(trigger)) {
    consoleWarn("Tooltip component can only accept single-node trigger element. Wrap your nodes with a parent element.");
    return null;
  }
  if (isFragment(trigger)) {
    consoleWarn("Tooltip component does not support React.Fragment as a trigger element.");
    return trigger;
  }
  if (typeof trigger === "string" || typeof trigger === "number") {
    return /* @__PURE__ */React16.createElement("span", null, trigger);
  }
  if (trigger && ((_a = trigger == null ? void 0 : trigger.props) == null ? void 0 : _a.disabled)) {
    return /* @__PURE__ */React16.createElement(TriggerWrapper, null, trigger);
  }
  return trigger;
};

// src/components/Tooltip/hooks/useTooltip.ts
var useTooltip = function useTooltip(_a, ref) {
  var _b = _a,
    children = _b.children,
    trigger = _b.trigger,
    content = _b.content,
    open = _b.open,
    defaultOpen = _b.defaultOpen,
    onOpenChange = _b.onOpenChange,
    onToggle = _b.onToggle,
    error = _b.error,
    disableInteractive = _b.disableInteractive,
    align = _b.align,
    offset = _b.offset,
    allowedAutoPlacements = _b.allowedAutoPlacements,
    arrowPadding = _b.arrowPadding,
    zIndex6 = _b.zIndex,
    enablePortal = _b.enablePortal,
    restProps = __objRest(_b, ["children", "trigger", "content", "open", "defaultOpen", "onOpenChange", /** @deprecated */
    "onToggle", "error", "disableInteractive",
    // popper and portaling
    "align", "offset", "allowedAutoPlacements", "arrowPadding", "zIndex", "enablePortal"]);
  var panelRef = useRootRef7(ref);
  var triggerRef = useRef2(null);
  var realTrigger = trigger || children;
  var realContent = trigger ? children : content;
  var _useControlledFlagSta = useControlledFlagState(defaultOpen, open, onToggle !== void 0 ? onToggle : onOpenChange),
    _useControlledFlagSta2 = _slicedToArray(_useControlledFlagSta, 2),
    reallyOpen = _useControlledFlagSta2[0],
    setReallyOpen = _useControlledFlagSta2[1];
  var _useEventProxy = useEventProxy(children, setReallyOpen, panelRef, disableInteractive),
    onMouseOverProxy = _useEventProxy.onMouseOverProxy,
    onMouseOutProxy = _useEventProxy.onMouseOutProxy;
  var _usePopper = usePopper(panelRef, triggerRef, {
      align: align,
      offset: offset,
      allowedAutoPlacements: allowedAutoPlacements,
      arrowPadding: arrowPadding
    }),
    arrowProps = _usePopper.arrowProps,
    panelProps = _usePopper.panelProps;
  var _useOverlay = useOverlay(reallyOpen, {
      zIndex: zIndex6
    }),
    realZIndex = _useOverlay.zIndex;
  var validTrigger = validateTrigger(realTrigger);
  var triggerClone = useMemo18(function () {
    if (!validTrigger) {
      return null;
    }
    return React17.cloneElement(validTrigger, {
      ref: triggerRef,
      onMouseEnter: onMouseOverProxy,
      onMouseLeave: onMouseOutProxy
    });
  }, [validTrigger, triggerRef, onMouseOverProxy, onMouseOutProxy]);
  return {
    trigger: triggerClone,
    portalProps: {
      enablePortal: enablePortal
    },
    rootProps: __spreadProps(__spreadValues(__spreadValues({}, restProps), panelProps), {
      ref: panelRef,
      error: error,
      zIndex: realZIndex
    }),
    arrowProps: __spreadProps(__spreadValues({}, arrowProps), {
      error: error
    }),
    content: realContent,
    isOpen: reallyOpen && !!realContent,
    align: align,
    validTrigger: validTrigger
  };
};

// src/components/Tooltip/Tooltip.tsx
var Tooltip = forwardRef11(function Tooltip2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var _useTooltip = useTooltip(props, ref),
    align = _useTooltip.align,
    isOpen = _useTooltip.isOpen,
    trigger = _useTooltip.trigger,
    validTrigger = _useTooltip.validTrigger,
    content = _useTooltip.content,
    portalProps = _useTooltip.portalProps,
    rootProps = _useTooltip.rootProps,
    arrowProps = _useTooltip.arrowProps;
  var classNames = useTooltipClassNames(TOOLTIP_CLASS_PREFIX, className, align);
  if (!validTrigger) {
    return trigger || null;
  }
  return /* @__PURE__ */React18.createElement(React18.Fragment, null, trigger, /* @__PURE__ */React18.createElement(PortalToBody, __spreadValues({}, portalProps), /* @__PURE__ */React18.createElement(TooltipContainer, null, /* @__PURE__ */React18.createElement(TransitionGroup, null, isOpen && /* @__PURE__ */React18.createElement(CSSTransition, {
    timeout: durationNormal3,
    className: classNames.Container
  }, /* @__PURE__ */React18.createElement(TooltipRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), content, /* @__PURE__ */React18.createElement(TooltipArrow, __spreadProps(__spreadValues({}, arrowProps), {
    className: classNames.Arrow
  }))))))));
});
Tooltip.defaultProps = {
  align: "top",
  error: false,
  small: false
};
Tooltip.propTypes = {
  /** Tooltip alignment */
  align: PropTypes8.oneOf(TOOLTIP_ALIGN_PLACEMENTS),
  small: PropTypes8.bool
};
var MemoizedTooltip = memo14(Tooltip);

// src/components/ClearButton/ClearButton.tsx
import React19, { forwardRef as forwardRef12, memo as memo15 } from "react";
import PropTypes9 from "prop-types";

// src/components/ClearButton/hooks/useClearButton.ts
import { useMemo as useMemo19 } from "react";
import { useRootRef as useRootRef8 } from "@deliveryhero/armor-system";

// src/components/ClearButton/style/ClearButtonRoot.ts
import { buttonReset, propsBlocker as propsBlocker16, reset as reset6, spacing as spacing13, token as token18, getComponentOverride as getComponentOverride10, marginProps as marginProps11 } from "@deliveryhero/armor-system";
import styled16, { css as css20 } from "styled-components";

// src/components/ClearButton/style/maps.ts
import { token as token17 } from "@deliveryhero/armor-system";
import { css as css18 } from "styled-components";
var stateStyleMap = {
  "circle-filled": {
    enabled: css18(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), token17("icon.color.primary", "color.neutral.07")),
    hover: css18(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), token17("icon.color.secondary", "color.neutral.05")),
    pressed: css18(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), token17("icon.color.primary", "color.neutral.11")),
    disabled: css18(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), token17("icon.color.disabled", "color.neutral.05"))
  },
  thin: {
    enabled: css18(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), token17("icon.color.primary", "color.neutral.11")),
    hover: css18(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["\n            color: ", ";\n            background: ", ";\n        "])), token17("icon.color.primary", "color.neutral.11"), token17("action.color.tertiary.hover", "color.neutral.02")),
    pressed: css18(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["\n            color: ", ";\n            background: ", ";\n        "])), token17("icon.color.primary", "color.neutral.11"), token17("action.color.tertiary.pressed", "color.neutral.03")),
    disabled: css18(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), token17("icon.color.disabled", "color.neutral.05"))
  }
};

// src/components/ClearButton/style/makeClearButtonIconStyle.ts
import { css as css19 } from "styled-components";
import { focus as focus3 } from "@deliveryhero/armor-system";

// src/components/ClearButton/constants.ts
var CLEAR_BUTTON_CLASS_PREFIX = "ClearButton";
var CLEAR_BUTTON_DEFAULT_TYPE = "circle-filled";
var CLEAR_BUTTON_DEFAULT_STATE = "enabled";
var CLEAR_BUTTON_DEFAULT_SIZE = "large";
var CLEAR_BUTTON_TYPE_CLASSNAME_MAP = {
  "circle-filled": "CircleFilledIcon",
  thin: "ThinIcon"
};
var CLEAR_BUTTON_SIZE_MAP = {
  medium: 20 / 4,
  large: 24 / 4
};
var CLEAR_BUTTON_SIZE_TOKEN_MAP = {
  medium: "action.sizing.mini",
  large: "action.sizing.tiny"
};

// src/components/ClearButton/style/makeClearButtonIconStyle.ts
var makeClearButtonIconStyle = function makeClearButtonIconStyle(styleMap) {
  return function (_ref32) {
    var _ref32$_type = _ref32._type,
      type = _ref32$_type === void 0 ? CLEAR_BUTTON_DEFAULT_TYPE : _ref32$_type,
      _ref32$state = _ref32.state,
      state = _ref32$state === void 0 ? CLEAR_BUTTON_DEFAULT_STATE : _ref32$state;
    var style = styleMap[type];
    var classname = "".concat(CLEAR_BUTTON_CLASS_PREFIX, "-").concat(CLEAR_BUTTON_TYPE_CLASSNAME_MAP[type]);
    return css19(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["\n            .", "--", " {\n                ", "\n            }\n\n            &:not(:disabled) {\n                [class*='", "'] {\n                    &:hover {\n                        ", "\n                    }\n\n                    &:active {\n                        ", "\n                    }\n                }\n            }\n\n            ", "\n        "])), classname, state, style[state], classname, style.hover, style.pressed, focus3());
  };
};

// src/components/ClearButton/style/ClearButtonRoot.ts
var clearButtonBaseStyle = function clearButtonBaseStyle(_ref33) {
  var _ref33$size = _ref33.size,
    size = _ref33$size === void 0 ? CLEAR_BUTTON_DEFAULT_SIZE : _ref33$size;
  var sizeValue = CLEAR_BUTTON_SIZE_MAP[size];
  var sizeToken = CLEAR_BUTTON_SIZE_TOKEN_MAP[size];
  return css20(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        vertical-align: center;\n\n        width: calc(", " - 1px);\n        height: calc(", " - 1px);\n\n        border-radius: ", ";\n\n        & > svg {\n            width: ", ";\n            height: ", ";\n        }\n    "])), spacing13(sizeToken, [sizeValue]), spacing13(sizeToken, [sizeValue]), token18("action.borderRadius.pill", "shape.borderRadius.pill", {
    returnUnit: "px"
  }), spacing13(sizeToken, [sizeValue]), spacing13(sizeToken, [sizeValue]));
};
var ClearButtonRoot = styled16.button.withConfig(propsBlocker16)(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n\n    ", "\n    ", "\n\n    ", ";\n    ", ";\n"])), reset6, buttonReset, clearButtonBaseStyle, makeClearButtonIconStyle(stateStyleMap), getComponentOverride10(CLEAR_BUTTON_CLASS_PREFIX), marginProps11);

// src/components/ClearButton/style/Icon.ts
import { CancelCircleFilledIcon, CancelIcon } from "@deliveryhero/armor-icons";
import { transition as transition11 } from "@deliveryhero/armor-system";
import styled17, { css as css21 } from "styled-components";
var iconDefaultStyle = css21(_templateObject101 || (_templateObject101 = _taggedTemplateLiteral(["\n    border-radius: inherit;\n\n    ", "\n"])), transition11({
  color: true,
  background: true
}));
var ClearButtonCircleFilledIcon = styled17(CancelCircleFilledIcon)(_templateObject102 || (_templateObject102 = _taggedTemplateLiteral(["\n    ", "\n"])), iconDefaultStyle);
var ClearButtonThinIcon = styled17(CancelIcon)(_templateObject103 || (_templateObject103 = _taggedTemplateLiteral(["\n    ", "\n"])), iconDefaultStyle);

// src/components/ClearButton/hooks/useClearButton.ts
var useClearButton = function useClearButton(_a, ref) {
  var _b = _a,
    _b$type = _b.type,
    type = _b$type === void 0 ? CLEAR_BUTTON_DEFAULT_TYPE : _b$type,
    _b$state = _b.state,
    state = _b$state === void 0 ? CLEAR_BUTTON_DEFAULT_STATE : _b$state,
    _b$size = _b.size,
    size = _b$size === void 0 ? CLEAR_BUTTON_DEFAULT_SIZE : _b$size,
    iconSize = _b.iconSize,
    restProps = __objRest(_b, ["type", "state", "size", "iconSize"]);
  var innerRef = useRootRef8(ref);
  var isDisabled = state === "disabled";
  var isCircleFilled = type === "circle-filled";
  var isThin = type === "thin";
  var Icon = useMemo19(function () {
    return isCircleFilled ? ClearButtonCircleFilledIcon : ClearButtonThinIcon;
  }, [isCircleFilled]);
  return {
    type: type,
    state: state,
    iconSize: iconSize,
    size: size,
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      disabled: isDisabled,
      _type: type,
      ref: innerRef,
      state: state,
      size: size
    }),
    iconProps: iconSize ? _defineProperty({}, iconSize, true) : __spreadValues(__spreadValues({}, isCircleFilled && {
      large: true
    }), isThin && {
      small: true
    }),
    Icon: Icon
  };
};

// src/components/ClearButton/hooks/useClearButtonClassNames.ts
import { useMemo as useMemo20 } from "react";
import { makeRootClassName as makeRootClassName8, makeBEM as makeBEM14 } from "@deliveryhero/armor-system";
var useClearButtonClassNames = function useClearButtonClassNames(classPrefix, className, type, state, iconSize, size) {
  return useMemo20(function () {
    var iconPrefix = CLEAR_BUTTON_TYPE_CLASSNAME_MAP[type != null ? type : CLEAR_BUTTON_DEFAULT_TYPE];
    var root = makeRootClassName8(classPrefix, className);
    var rootClassname = [root, size && "".concat(root, "--").concat(size)].filter(Boolean).join(" ");
    var iconClassname = [makeBEM14(classPrefix, iconPrefix), makeBEM14(classPrefix, iconPrefix, state), iconSize && makeBEM14(classPrefix, iconPrefix, iconSize)].filter(Boolean).join(" ");
    return {
      Root: rootClassname,
      Icon: iconClassname
    };
  }, [type, classPrefix, className, size, state, iconSize]);
};

// src/components/ClearButton/util/warnWhenTypeAndIconSizeAreNotSupported.ts
var warnWhenTypeAndIconSizeAreNotSupported = function warnWhenTypeAndIconSizeAreNotSupported() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var type = props.type,
    iconSize = props.iconSize;
  var typeSizeMap = {
    "circle-filled": ["medium", "large"],
    thin: ["small", "medium"]
  };
  if (type && type in typeSizeMap) {
    if (iconSize && !typeSizeMap[type].includes(iconSize)) {
      var supportedIconSizes = typeSizeMap[type].join(", ");
      return new Error("".concat(CLEAR_BUTTON_CLASS_PREFIX, ": the type \"").concat(type, "\" only supports the following iconSizes: ").concat(supportedIconSizes));
    }
  }
  return null;
};

// src/components/ClearButton/ClearButton.tsx
var ClearButton = forwardRef12(function ClearButton2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var _useClearButton = useClearButton(props, ref),
    rootProps = _useClearButton.rootProps,
    iconProps = _useClearButton.iconProps,
    Icon = _useClearButton.Icon,
    type = _useClearButton.type,
    state = _useClearButton.state,
    iconSize = _useClearButton.iconSize,
    size = _useClearButton.size;
  var classNames = useClearButtonClassNames(CLEAR_BUTTON_CLASS_PREFIX, className, type, state, iconSize, size);
  return /* @__PURE__ */React19.createElement(ClearButtonRoot, __spreadProps(__spreadValues({}, rootProps), {
    type: "button",
    className: classNames.Root
  }), /* @__PURE__ */React19.createElement(Icon, __spreadProps(__spreadValues({}, iconProps), {
    className: classNames.Icon
  })));
});
ClearButton.defaultProps = {
  type: CLEAR_BUTTON_DEFAULT_TYPE,
  state: CLEAR_BUTTON_DEFAULT_STATE,
  size: CLEAR_BUTTON_DEFAULT_SIZE
};
ClearButton.propTypes = {
  type: PropTypes9.oneOf(["circle-filled", "thin"]),
  state: PropTypes9.oneOf(["enabled", "hover", "pressed", "disabled"]),
  iconSize: warnWhenTypeAndIconSizeAreNotSupported,
  size: PropTypes9.oneOf(["medium", "large"])
};
ClearButton.displayName = CLEAR_BUTTON_CLASS_PREFIX;
var MemoizedClearButton = memo15(ClearButton);

// src/components/ConditionTag/ConditionTag.tsx
var ConditionTag = forwardRef13(function ConditionTag2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNames = useConditionTagClassNames(CONDITION_TAG_CLASS_PREFIX, className);
  var _useConditionTag = useConditionTag(props, ref),
    rootProps = _useConditionTag.rootProps,
    closeButtonProps = _useConditionTag.closeButtonProps,
    label = _useConditionTag.label,
    valueHead = _useConditionTag.valueHead,
    valueTail = _useConditionTag.valueTail,
    hasTail = _useConditionTag.hasTail,
    tailLength = _useConditionTag.tailLength,
    enableCloseIcon = _useConditionTag.enableCloseIcon;
  return /* @__PURE__ */React20.createElement(ConditionTagRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), /* @__PURE__ */React20.createElement(ConditionTagLabel, {
    className: classNames.Label
  }, label), /* @__PURE__ */React20.createElement(ConditionTagValue, {
    className: classNames.Value
  }, valueHead.map(function (item, index) {
    return /* @__PURE__ */React20.createElement(ConditionTagValueSegment, {
      key: index,
      className: classNames.ValueSegment
    }, item);
  }), hasTail && /* @__PURE__ */React20.createElement(ConditionTagValueSegment, {
    className: classNames.ValueSegment
  }, /* @__PURE__ */React20.createElement(Tooltip, {
    minWidth: 20,
    maxWidth: 70,
    trigger: /* @__PURE__ */React20.createElement(ConditionTagValueMoreLink, {
      tag: "span",
      className: classNames.ValueMoreLink
    }, tailLength, " more")
  }, valueTail.map(function (item, index) {
    return /* @__PURE__ */React20.createElement(ConditionTagValueTailElement, {
      className: classNames.ValueTailElement,
      key: index
    }, item);
  })))), enableCloseIcon && /* @__PURE__ */React20.createElement(ConditionTagCloseIconContainer, __spreadProps(__spreadValues({}, closeButtonProps), {
    className: classNames.CloseIconContainer
  }), /* @__PURE__ */React20.createElement(ClearButton, null)));
});
ConditionTag.defaultProps = {
  enableCloseIcon: true
};
ConditionTag.propTypes = {};
var MemoizedConditionTag = memo16(ConditionTag);

// src/components/Container/Container.tsx
import React21, { forwardRef as forwardRef14, memo as memo17 } from "react";

// src/components/Container/hooks/useContainerClassNames.ts
import { useMemo as useMemo21 } from "react";
import { makeRootClassName as makeRootClassName9 } from "@deliveryhero/armor-system";
var useContainerClassNames = function useContainerClassNames(classPrefix, className) {
  return useMemo21(function () {
    return {
      Root: makeRootClassName9(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/Container/style.ts
import styled18 from "styled-components";
import { marginProps as marginProps12, paddingProps as paddingProps5, sizeProps as sizeProps2, propsBlocker as propsBlocker17, spacing as spacing14 } from "@deliveryhero/armor-system";
var ContainerRoot = styled18.div.withConfig(propsBlocker17)(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    padding: 0 ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), spacing14(2), sizeProps2, paddingProps5, marginProps12);

// src/components/Container/constants.ts
var CONTAINER_CLASS_PREFIX = "Container";

// src/components/Container/Container.tsx
var Container = forwardRef14(function Container2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var classNameComponents = useContainerClassNames(CONTAINER_CLASS_PREFIX, className);
  return /* @__PURE__ */React21.createElement(ContainerRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }), children);
});
Container.defaultProps = {};
Container.propTypes = {};
var MemoizedContainer = memo17(Container);

// src/components/ContextMenu/ContextMenu.tsx
import React25, { forwardRef as forwardRef17, memo as memo20 } from "react";
import PropTypes12 from "prop-types";
import { PortalToBody as PortalToBody2 } from "@deliveryhero/armor-system";

// src/components/ContextMenu/hooks/useContextMenuClassNames.ts
import { useMemo as useMemo22 } from "react";
import { makeRootClassName as makeRootClassName10, makeBEM as makeBEM15 } from "@deliveryhero/armor-system";
var useContextMenuClassNames = function useContextMenuClassNames(classPrefix, className) {
  return useMemo22(function () {
    return {
      Root: makeRootClassName10(classPrefix, className),
      Arrow: makeBEM15(classPrefix, "Arrow")
    };
  }, [classPrefix, className]);
};

// src/components/ContextMenu/hooks/useContextMenu.ts
import React22, { useMemo as useMemo23, useRef as useRef3 } from "react";
import { usePopper as usePopper2, useOuterClick, useControlledFlagState as useControlledFlagState2, useOverlay as useOverlay2, useRootRef as useRootRef9 } from "@deliveryhero/armor-system";

// src/components/ContextMenu/hooks/useEventProxy.ts
import { useCallback as useCallback5 } from "react";
var useEventProxy2 = function useEventProxy2(trigger, setOpen, open) {
  var _a;
  var triggerElement = trigger;
  var onClick = (_a = triggerElement == null ? void 0 : triggerElement.props) == null ? void 0 : _a.onClick;
  var onClickProxy = useCallback5(function (event) {
    onClick == null ? void 0 : onClick(event);
    if (event.isPropagationStopped()) {
      return;
    }
    setOpen(!open);
  }, [onClick, setOpen, open]);
  return {
    onClickProxy: onClickProxy
  };
};

// src/components/ContextMenu/hooks/useContextMenu.ts
var emptyMenuElements = [];
var useContextMenu = function useContextMenu(_a, ref) {
  var _b = _a,
    children = _b.children,
    menuElements = _b.menuElements,
    trigger = _b.trigger,
    onMenuElementSelect = _b.onMenuElementSelect,
    open = _b.open,
    defaultOpen = _b.defaultOpen,
    onOpenChange = _b.onOpenChange,
    onToggle = _b.onToggle,
    align = _b.align,
    offset = _b.offset,
    allowedAutoPlacements = _b.allowedAutoPlacements,
    arrowPadding = _b.arrowPadding,
    zIndex6 = _b.zIndex,
    enablePortal = _b.enablePortal,
    restProps = __objRest(_b, ["children", "menuElements", "trigger", "onMenuElementSelect", "open", "defaultOpen", "onOpenChange", "onToggle",
    // popper and portaling
    "align", "offset", "allowedAutoPlacements", "arrowPadding", "zIndex", "enablePortal"]);
  var _useControlledFlagSta3 = useControlledFlagState2(defaultOpen, open, onToggle !== void 0 ? onToggle : onOpenChange),
    _useControlledFlagSta4 = _slicedToArray(_useControlledFlagSta3, 4),
    reallyOpen = _useControlledFlagSta4[0],
    setReallyOpen = _useControlledFlagSta4[1],
    setClose = _useControlledFlagSta4[3];
  var rootRef = useRootRef9(ref);
  var triggerRef = useRef3();
  var _usePopper2 = usePopper2(rootRef, triggerRef, {
      align: align,
      arrowPadding: arrowPadding,
      offset: offset,
      allowedAutoPlacements: allowedAutoPlacements
    }),
    panelProps = _usePopper2.panelProps,
    arrowProps = _usePopper2.arrowProps;
  useOuterClick([rootRef, triggerRef], setClose, reallyOpen);
  var _useOverlay2 = useOverlay2(reallyOpen, {
      zIndex: zIndex6
    }),
    realZIndex = _useOverlay2.zIndex;
  var _useEventProxy2 = useEventProxy2(trigger, setReallyOpen, !!reallyOpen),
    onClickProxy = _useEventProxy2.onClickProxy;
  var triggerClone = useMemo23(function () {
    if (!trigger) {
      return null;
    }
    return React22.cloneElement(trigger, {
      ref: triggerRef,
      onClick: onClickProxy
    });
  }, [onClickProxy, trigger]);
  var displayChildren = !!children;
  var displayMenuElements = !displayChildren && !!menuElements;
  var smartMenuElements = useMemo23(function () {
    if (!menuElements || !onMenuElementSelect) {
      return menuElements;
    }
    return menuElements.map(function (element) {
      return __spreadProps(__spreadValues({}, element), {
        props: __spreadProps(__spreadValues({}, element.props), {
          onClick: function onClick(event) {
            var _a2, _b2;
            (_b2 = (_a2 = element.props) == null ? void 0 : _a2.onClick) == null ? void 0 : _b2.call(_a2, event);
            if (event.isPropagationStopped()) {
              return;
            }
            onMenuElementSelect(element.id, element, {
              closeMenu: setClose
            });
          }
        })
      });
    });
  }, [menuElements, onMenuElementSelect, setClose]);
  return {
    portalProps: {
      enablePortal: enablePortal
    },
    rootProps: __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, restProps), {
      ref: rootRef
    }), panelProps), {
      displayMenuElements: displayMenuElements,
      zIndex: realZIndex
    }),
    arrowProps: arrowProps,
    trigger: triggerClone,
    open: reallyOpen,
    displayChildren: displayChildren,
    displayMenuElements: displayMenuElements,
    menuElements: smartMenuElements || emptyMenuElements,
    children: children
  };
};

// src/components/ContextMenu/style.ts
import styled19, { css as css22 } from "styled-components";
import { spacing as spacing15, typography as typography10, sizeProps as sizeProps3, zIndex as zIndex2, propsBlocker as propsBlocker18, getComponentOverride as getComponentOverride11, paddingProps as paddingProps6, popperArrow as popperArrow2, popperArrowPlacement as popperArrowPlacement2, token as token19 } from "@deliveryhero/armor-system";
var getRootStyle7 = function getRootStyle7(_ref35) {
  var displayMenuElements = _ref35.displayMenuElements;
  var result = {};
  if (displayMenuElements) {
    result = css22(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["\n            ", ";\n            padding-top: ", ";\n            padding-bottom: ", ";\n        "])), result, spacing15("base.spacing.large", [4]), spacing15("base.spacing.small", [4]));
  }
  return result;
};
var ContextMenuRoot = styled19.div.withConfig(propsBlocker18)(_templateObject106 || (_templateObject106 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    margin: 0;\n    text-align: left;\n\n    ", ";\n    color: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), typography10("desktop.bodyMedium", "paragraphLarge"), token19("text.color.primary", "color.neutral.07"), token19("base.borderRadius.large", "shape.borderRadius.soft", {
  returnUnit: "px"
}), token19("base.color.flat", "color.neutral.00"), token19("base.elevation.high", "elevation.small"), popperArrowPlacement2("ContextMenu-Arrow"), zIndex2, getRootStyle7, getComponentOverride11("ContextMenu"), sizeProps3, paddingProps6);
var ContextMenuArrow = styled19.div.withConfig(propsBlocker18)(_templateObject107 || (_templateObject107 = _taggedTemplateLiteral(["\n    ", "\n"])), popperArrow2);

// src/components/ContextMenu/constants.ts
var CONTEXTMENU_CLASS_PREFIX = "ContextMenu";

// src/components/Menu/Menu.tsx
import React23, { forwardRef as forwardRef15, memo as memo18 } from "react";
import PropTypes10 from "prop-types";

// src/components/Menu/hooks/useMenuClassNames.ts
import { useMemo as useMemo24 } from "react";
import { makeRootClassName as makeRootClassName11 } from "@deliveryhero/armor-system";
var useMenuClassNames = function useMenuClassNames(classPrefix, className) {
  return useMemo24(function () {
    return {
      Root: makeRootClassName11(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/Menu/style.ts
import styled20, { css as css23 } from "styled-components";
import { marginProps as marginProps13, paddingProps as paddingProps7, color as color7, reset as reset7, getComponentOverride as getComponentOverride12, propsBlocker as propsBlocker19, durationNormal as durationNormal4, token as token20 } from "@deliveryhero/armor-system";
var getRootStyle8 = function getRootStyle8(_ref36) {
  var enableBottomSeparator = _ref36.enableBottomSeparator,
    secondary = _ref36.secondary,
    tertiary = _ref36.tertiary,
    expanded = _ref36.expanded,
    enableEffects = _ref36.enableEffects;
  var result = {};
  if (enableBottomSeparator) {
    result = css23(_templateObject108 || (_templateObject108 = _taggedTemplateLiteral(["\n            ", ";\n            border-bottom: 1px solid ", ";\n        "])), result, color7("neutral.03"));
  }
  if (secondary || tertiary) {
    result = css23(_templateObject109 || (_templateObject109 = _taggedTemplateLiteral(["\n            ", ";\n        "])), result);
  }
  if (expanded !== void 0) {
    result = css23(_templateObject110 || (_templateObject110 = _taggedTemplateLiteral(["\n            ", ";\n            overflow-y: hidden;\n            height: ", ";\n        "])), result, expanded ? "auto" : "0");
    if (enableEffects) {
      result = css23(_templateObject111 || (_templateObject111 = _taggedTemplateLiteral(["\n                ", ";\n                opacity: ", ";\n                transform: translateX(", ");\n                transition: transform ", "ms ease-in-out,\n                    opacity ", "ms ease;\n            "])), result, expanded ? "1" : "0", expanded ? "0" : "-5px", durationNormal4, durationNormal4);
    }
  }
  return result;
};
var MenuRoot = styled20.div.withConfig(propsBlocker19)(_templateObject112 || (_templateObject112 = _taggedTemplateLiteral(["\n    ", ";\n    background-color: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset7, token20("base.color.flat", "color.neutral.00"), getRootStyle8, getComponentOverride12("Menu"), marginProps13, paddingProps7);

// src/components/Menu/constants.ts
var MENU_CLASS_PREFIX = "Menu";

// src/components/Menu/Menu.tsx
var Menu = forwardRef15(function Menu2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useMenuClassNames(MENU_CLASS_PREFIX, className);
  return /* @__PURE__ */React23.createElement(MenuRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }));
});
Menu.defaultProps = {
  enableBottomSeparator: false,
  enableEffects: true
};
Menu.propTypes = {
  enableBottomSeparator: PropTypes10.bool
};
var MemoizedMenu = memo18(Menu);

// src/components/Menu/MenuElement/MenuElement.tsx
import React24, { forwardRef as forwardRef16, memo as memo19 } from "react";
import PropTypes11 from "prop-types";

// src/components/Menu/MenuElement/utils/useMenuElementClassNames.ts
import { useMemo as useMemo25 } from "react";
import { makeBEM as makeBEM16, makeRootClassName as makeRootClassName12 } from "@deliveryhero/armor-system";
var useMenuElementClassNames = function useMenuElementClassNames(classPrefix, className) {
  return useMemo25(function () {
    return {
      Root: makeRootClassName12(classPrefix, className),
      Content: makeBEM16(classPrefix, "Content"),
      ExpansionHandle: makeBEM16(classPrefix, "ExpansionHandle"),
      ExpansionHandleArrow: makeBEM16(classPrefix, "ExpansionHandleArrow")
    };
  }, [classPrefix, className]);
};

// src/components/Menu/MenuElement/style.ts
import styled21, { css as css24 } from "styled-components";
import { color as color8, marginProps as marginProps14, paddingProps as paddingProps8, pixelToRem, propsBlocker as propsBlocker20, reset as reset8, spacing as spacing16, typography as typography11, getComponentOverride as getComponentOverride13, fontSize02, durationNormal as durationNormal5, token as token21 } from "@deliveryhero/armor-system";
var MenuElementRootWrapper = function MenuElementRootWrapper(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var getPrimaryDisabledColors2 = function getPrimaryDisabledColors2() {
  return css24(_templateObject113 || (_templateObject113 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    &:hover {\n        background-color: ", ";\n    }\n"])), token21("text.color.disabled", "color.neutral.05"), token21("control.color.secondary.disabled", "color.neutral.02"), token21("control.color.secondary.disabled", "color.neutral.02"));
};
var getRootStyle9 = function getRootStyle9(_ref37) {
  var enableExpansionHandle = _ref37.enableExpansionHandle,
    secondary = _ref37.secondary,
    tertiary = _ref37.tertiary,
    selected = _ref37.selected,
    small = _ref37.small,
    disabled = _ref37.disabled;
  var borderWidth = small ? 0.5 : 1;
  var result = css24(_templateObject114 || (_templateObject114 = _taggedTemplateLiteral(["\n        &:hover {\n            background-color: ", ";\n        }\n    "])), token21("control.color.secondary.hover", "color.primary.lightest"));
  if (secondary) {
    result = css24(_templateObject115 || (_templateObject115 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            color: ", ";\n            padding-left: ", ";\n        "])), result, typography11("paragraphLarge"), token21("body.color"), spacing16(16));
  } else if (tertiary) {
    result = css24(_templateObject116 || (_templateObject116 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            color: ", ";\n            padding-left: ", ";\n        "])), result, typography11("paragraphLarge"), token21("body.color"), spacing16(20));
  }
  if (enableExpansionHandle) {
    result = css24(_templateObject117 || (_templateObject117 = _taggedTemplateLiteral(["\n            ", ";\n            padding-right: 0;\n        "])), result);
  }
  if (small && !secondary && !tertiary) {
    result = css24(_templateObject118 || (_templateObject118 = _taggedTemplateLiteral(["\n            ", ";\n            font-size: ", ";\n            padding-left: ", ";\n            padding-right: ", ";\n        "])), result, pixelToRem(fontSize02), spacing16(4), spacing16(4));
  }
  if (selected) {
    result = css24(_templateObject119 || (_templateObject119 = _taggedTemplateLiteral(["\n            ", ";\n\n            &:hover {\n                background-color: ", ";\n            }\n\n            &:before {\n                width: ", ";\n            }\n        "])), result, token21("base.color.flat", "color.neutral.00"), spacing16(borderWidth));
    if (enableExpansionHandle) {
      result = css24(_templateObject120 || (_templateObject120 = _taggedTemplateLiteral(["\n                ", ";\n\n                &:hover {\n                    background-color: ", ";\n                }\n            "])), result, color8("primary.lightest"));
    }
  }
  if (disabled) {
    result = css24(_templateObject121 || (_templateObject121 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: not-allowed;\n            ", ";\n        "])), result, getPrimaryDisabledColors2);
  }
  return result;
};
var MenuElementRoot = styled21(MenuElementRootWrapper).withConfig(propsBlocker20)(_templateObject122 || (_templateObject122 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    display: flex;\n    position: relative;\n    cursor: pointer;\n    text-decoration: none;\n    background-color: ", ";\n    transition: background-color ", "ms ease;\n\n    &:before {\n        background-color: ", ";\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        width: 0;\n    }\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset8, function (_ref38) {
  var small = _ref38.small,
    typographyProp = _ref38.typographyProp;
  return (!small || !typographyProp) && typography11("desktop.bodyMedium", "paragraphMedium");
}, token21("text.color.primary", "color.neutral.11"), spacing16("control.spacing.large", [6]), spacing16("control.spacing.large", [6]), token21("base.color.flat", "color.neutral.00"), durationNormal5, token21("control.color.primary.selected", "color.primary.main"), getRootStyle9, getComponentOverride13("MenuElement"), marginProps14, paddingProps8);
var getContentStyle = function getContentStyle(_ref39) {
  var small = _ref39.small;
  var spacingY = small ? 2 : 4;
  return css24(_templateObject123 || (_templateObject123 = _taggedTemplateLiteral(["\n        padding-top: ", ";\n        padding-bottom: ", ";\n    "])), spacing16("control.spacing.medium", [spacingY]), spacing16("control.spacing.medium", [spacingY]));
};
var MenuElementContent = styled21.div.withConfig(propsBlocker20)(_templateObject124 || (_templateObject124 = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    display: flex;\n\n    ", ";\n"])), getContentStyle);
var MenuElementExpansionHandle = styled21.div.withConfig(propsBlocker20)(_templateObject125 || (_templateObject125 = _taggedTemplateLiteral(["\n    display: flex;\n    align-self: stretch;\n    cursor: pointer;\n    padding: ", ";\n"])), spacing16(4));

// src/components/Menu/MenuElement/constants.ts
var MENU_ELEMENT_CLASS_PREFIX = "MenuElement";
var MENU_ELEMENT_DEFAULT_TYPOGRAPHY_PROPS = {
  paragraph: true,
  medium: true
};

// src/components/Menu/MenuElement/hooks/useMenuElement.ts
var preventDefault2 = function preventDefault2(event) {
  event.preventDefault();
};
var useMenuElement = function useMenuElement(_a) {
  var _b = _a,
    enableExpansionHandle = _b.enableExpansionHandle,
    expanded = _b.expanded,
    primary = _b.primary,
    secondary = _b.secondary,
    tertiary = _b.tertiary,
    small = _b.small,
    depthLevel = _b.depthLevel,
    _b$tag = _b.tag,
    Tag3 = _b$tag === void 0 ? "div" : _b$tag,
    selected = _b.selected,
    disabled = _b.disabled,
    _b$typographyProp = _b.typographyProp,
    typographyProp = _b$typographyProp === void 0 ? MENU_ELEMENT_DEFAULT_TYPOGRAPHY_PROPS : _b$typographyProp,
    restProps = __objRest(_b, ["enableExpansionHandle", "expanded", "primary", "secondary", "tertiary", "small", "depthLevel", "tag", "selected", "disabled", "typographyProp"]);
  var dataExpanded = expanded ? "1" : "0";
  var dataSelected = selected ? "1" : "0";
  var onClick = disabled ? preventDefault2 : restProps == null ? void 0 : restProps.onClick;
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      primary: primary,
      secondary: secondary,
      tertiary: tertiary,
      depthLevel: depthLevel,
      enableExpansionHandle: enableExpansionHandle,
      expanded: expanded,
      selected: selected,
      disabled: disabled,
      small: small,
      typographyProp: typographyProp,
      "data-expanded": dataExpanded,
      "data-selected": dataSelected,
      onClick: onClick
    }),
    contentProps: __spreadValues({
      small: !!small
    }, typographyProp),
    getExpansionHandleArrowProps: function getExpansionHandleArrowProps() {
      return {
        expanded: expanded
      };
    },
    Tag: Tag3,
    enableExpansionHandle: enableExpansionHandle
  };
};

// src/components/Menu/MenuElement/MenuElement.tsx
var MenuElement = forwardRef16(function MenuElement2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var classNameComponents = useMenuElementClassNames(MENU_ELEMENT_CLASS_PREFIX, className);
  var _useMenuElement = useMenuElement(props),
    rootProps = _useMenuElement.rootProps,
    contentProps = _useMenuElement.contentProps,
    getExpansionHandleArrowProps = _useMenuElement.getExpansionHandleArrowProps,
    Tag3 = _useMenuElement.Tag,
    enableExpansionHandle = _useMenuElement.enableExpansionHandle;
  return /* @__PURE__ */React24.createElement(MenuElementRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root
  }), function (forwardedProps) {
    return /* @__PURE__ */React24.createElement(Tag3, __spreadProps(__spreadValues({}, forwardedProps), {
      ref: ref
    }), /* @__PURE__ */React24.createElement(MenuElementContent, __spreadProps(__spreadValues({}, contentProps), {
      className: classNameComponents.Content
    }), children), enableExpansionHandle && /* @__PURE__ */React24.createElement(MenuElementExpansionHandle, {
      className: classNameComponents.ExpansionHandle
    }, /* @__PURE__ */React24.createElement(MemoizedExpansionIndicator, __spreadProps(__spreadValues({}, getExpansionHandleArrowProps()), {
      className: classNameComponents.ExpansionHandleArrow
    }))));
  });
});
MenuElement.defaultProps = {
  primary: false,
  secondary: false,
  tertiary: false,
  selected: false,
  enableExpansionHandle: false,
  expanded: false,
  disabled: false
};
MenuElement.propTypes = {
  tag: PropTypes11.oneOfType([PropTypes11.elementType, PropTypes11.string]),
  primary: PropTypes11.bool,
  secondary: PropTypes11.bool,
  tertiary: PropTypes11.bool,
  selected: PropTypes11.bool,
  enableExpansionHandle: PropTypes11.bool,
  expanded: PropTypes11.bool,
  href: PropTypes11.string,
  target: PropTypes11.string,
  rel: PropTypes11.string,
  disabled: PropTypes11.bool
};
var MemoizedMenuElement = memo19(MenuElement);

// src/components/ContextMenu/ContextMenu.tsx
var ContextMenu = forwardRef17(function ContextMenu2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNameComponents = useContextMenuClassNames(CONTEXTMENU_CLASS_PREFIX, className);
  var _useContextMenu = useContextMenu(props, ref),
    portalProps = _useContextMenu.portalProps,
    rootProps = _useContextMenu.rootProps,
    arrowProps = _useContextMenu.arrowProps,
    trigger = _useContextMenu.trigger,
    open = _useContextMenu.open,
    displayChildren = _useContextMenu.displayChildren,
    displayMenuElements = _useContextMenu.displayMenuElements,
    menuElements = _useContextMenu.menuElements,
    children = _useContextMenu.children;
  return /* @__PURE__ */React25.createElement(React25.Fragment, null, trigger, open && /* @__PURE__ */React25.createElement(PortalToBody2, __spreadValues({}, portalProps), /* @__PURE__ */React25.createElement(ContextMenuRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root
  }), /* @__PURE__ */React25.createElement(ContextMenuArrow, __spreadValues({
    className: classNameComponents.Arrow
  }, arrowProps)), displayChildren && children, displayMenuElements && menuElements.map(function (_ref40) {
    var id = _ref40.id,
      label = _ref40.label,
      elementProps = _ref40.props;
    return /* @__PURE__ */React25.createElement(MenuElement, __spreadProps(__spreadValues({}, elementProps), {
      key: id,
      typographyProp: {
        paragraph: true,
        medium: true
      },
      small: true
    }), label);
  }))));
});
ContextMenu.defaultProps = {
  align: "bottom"
};
ContextMenu.propTypes = {
  open: PropTypes12.bool,
  onToggle: PropTypes12.func
  // align: PropTypes.string,
};

var MemoizedContextMenu = memo20(ContextMenu);

// src/components/Card/Card.tsx
import React26, { forwardRef as forwardRef18, memo as memo21 } from "react";

// src/components/Card/hooks/useCardClassName.ts
import { useMemo as useMemo26 } from "react";
import { makeRootClassName as makeRootClassName13 } from "@deliveryhero/armor-system";
var useCardClassName = function useCardClassName(classPrefix, className) {
  return useMemo26(function () {
    var baseClassNames = makeRootClassName13(classPrefix, className);
    return baseClassNames;
  }, [classPrefix, className]);
};

// src/components/Card/style.ts
import styled22 from "styled-components";
import { marginProps as marginProps15, paddingProps as paddingProps9, propsBlocker as propsBlocker21, sizeProps as sizeProps4, token as token22 } from "@deliveryhero/armor-system";
var CardRoot = styled22.div.withConfig(propsBlocker21)(_templateObject126 || (_templateObject126 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: ", ";\n    border: ", "px solid\n        ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), token22("action.color.inverse.enabled", "color.neutral.00"), token22("base.borderRadius.large", "shape.borderRadius.soft", {
  returnUnit: "px"
}), token22("base.borderWidth.thin", 1), token22("border.color.high", "color.neutral.03"), marginProps15, paddingProps9, sizeProps4);

// src/components/Card/constants.ts
var CARD_CLASS_PREFIX = "Card";

// src/components/Card/Card.tsx
var Card = forwardRef18(function Card2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameRoot = useCardClassName(CARD_CLASS_PREFIX, className);
  return /* @__PURE__ */React26.createElement(CardRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameRoot,
    ref: ref
  }));
});
var MemoizedCard = memo21(Card);

// src/components/CloseButton/CloseButton.tsx
import React27, { forwardRef as forwardRef19, memo as memo22 } from "react";

// src/components/CloseButton/hooks/useCloseButtonClassName.ts
import { useMemo as useMemo27 } from "react";
import { makeBEM as makeBEM17, makeRootClassName as makeRootClassName14 } from "@deliveryhero/armor-system";
var useCloseButtonClassName = function useCloseButtonClassName(classPrefix, className) {
  return useMemo27(function () {
    return {
      Root: makeRootClassName14(classPrefix, className),
      Icon: makeBEM17(classPrefix, "Icon")
    };
  }, [classPrefix, className]);
};

// src/components/CloseButton/constants.tsx
var CLOSE_BUTTON_CLASS_PREFIX = "CloseButton";

// src/components/CloseButton/style.ts
import styled23 from "styled-components";
import { CancelIcon as CancelIcon2 } from "@deliveryhero/armor-icons";
import { borderRadius as borderRadius2, color as color9, pixelToRem as pixelToRem2, reset as reset9, propsBlocker as propsBlocker22, getComponentOverride as getComponentOverride14, marginProps as marginProps16, focus as focus4 } from "@deliveryhero/armor-system";
var CloseButtonRoot = styled23.div.withConfig(propsBlocker22)(_templateObject127 || (_templateObject127 = _taggedTemplateLiteral(["\n    ", ";\n    display: flex;\n    justify-content: flex-end;\n    color: ", ";\n    height: min-content;\n    width: min-content;\n    cursor: pointer;\n    flex: 0 0 auto;\n    border: 0 none;\n    outline: none;\n    font-size: ", ";\n    border-radius: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n    ", ";\n    ", ";\n    ", ";\n"])), reset9(), color9("neutral.11"), pixelToRem2(16), borderRadius2("pill"), color9("neutral.02"), getComponentOverride14("CloseButton"), focus4(), marginProps16);
var CloseButtonIcon = styled23(CancelIcon2).attrs({
  small: true
})(_templateObject128 || (_templateObject128 = _taggedTemplateLiteral([""])));

// src/components/CloseButton/CloseButton.tsx
var CloseButton = memo22(forwardRef19(function CloseButton2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useCloseButtonClassName(CLOSE_BUTTON_CLASS_PREFIX, className);
  return /* @__PURE__ */React27.createElement(CloseButtonRoot, __spreadProps(__spreadValues({}, restProps), {
    ref: ref,
    className: classNameComponents.Root,
    tabIndex: 0
  }), /* @__PURE__ */React27.createElement(CloseButtonIcon, {
    className: classNameComponents.Icon
  }));
}));
CloseButton.displayName = CLOSE_BUTTON_CLASS_PREFIX;

// src/components/Dialog/Dialog.tsx
import React29, { forwardRef as forwardRef20, memo as memo24 } from "react";
import { PortalToBody as PortalToBody3 } from "@deliveryhero/armor-system";

// src/components/Dialog/hooks/useDialogClassNames.ts
import { useMemo as useMemo28 } from "react";
import { makeBEM as makeBEM18, makeRootClassName as makeRootClassName15 } from "@deliveryhero/armor-system";
var useDialogClassNames = function useDialogClassNames(classPrefix, open, className) {
  return useMemo28(function () {
    return {
      Root: "".concat(makeRootClassName15(classPrefix, className), " ").concat(makeBEM18(classPrefix, "Root", open ? "open" : "closed")),
      Backdrop: makeBEM18(classPrefix, "Backdrop"),
      AlignmentContainer: makeBEM18(classPrefix, "AlignmentContainer"),
      Window: makeBEM18(classPrefix, "Window"),
      CloseButton: makeBEM18(classPrefix, "CloseButton"),
      Content: makeBEM18(classPrefix, "Content")
    };
  }, [classPrefix, className, open]);
};

// src/components/Dialog/hooks/useDialog.ts
import { useCallback as useCallback6 } from "react";
import { useControlledFlagState as useControlledFlagState3, useOverlay as useOverlay3, extractSizeProps, useRootRef as useRootRef10, useDisplayEffects, useDocumentKeydown } from "@deliveryhero/armor-system";

// src/components/Dialog/constants.ts
var DIALOG_CLASS_PREFIX = "Dialog";
var dialogCloseButton = "DialogCloseButton";
var DIALOG_SCROLL_DOCUMENT = "document";
var DIALOG_SCROLL_DIALOG = "dialog";

// src/components/Dialog/hooks/useDialog.ts
var useDialog = function useDialog(_a, ref) {
  var _b = _a,
    open = _b.open,
    defaultOpen = _b.defaultOpen,
    onOpenChange = _b.onOpenChange,
    onClose = _b.onClose,
    zIndex6 = _b.zIndex,
    enablePortal = _b.enablePortal,
    enableBackdrop = _b.enableBackdrop,
    disableOverlay = _b.disableOverlay,
    enableCloseButton = _b.enableCloseButton,
    disableCloseButton = _b.disableCloseButton,
    enableCloseByEscape = _b.enableCloseByEscape,
    disableCloseByEscape = _b.disableCloseByEscape,
    enableCloseOnBackdropClick = _b.enableCloseOnBackdropClick,
    enableWindowScrollBlock = _b.enableWindowScrollBlock,
    enableEffects = _b.enableEffects,
    disableEffects = _b.disableEffects,
    onCloseButtonClick = _b.onCloseButtonClick,
    scroll = _b.scroll,
    restProps = __objRest(_b, [
    // ComponentBehaviourOpenStateType
    "open", "defaultOpen", "onOpenChange", /** @deprecated @see onOpenChange */
    "onClose",
    // ComponentBehaviourPortalType & ComponentBehaviourOverlayType
    "zIndex", "enablePortal",
    // ComponentBehaviourModalDialogType
    "enableBackdrop", /** @deprecated @see enableBackdrop */
    "disableOverlay", "enableCloseButton", /** @deprecated */
    "disableCloseButton", "enableCloseByEscape", /** @deprecated @see enableCloseByEscape */
    "disableCloseByEscape", "enableCloseOnBackdropClick", "enableWindowScrollBlock", "enableEffects", /** @deprecated @see enableEffects */
    "disableEffects", /** @deprecated @see disableEffects */
    "onCloseButtonClick",
    // other
    "scroll"]);
  var reallyEnableCloseButton = enableCloseButton !== void 0 ? enableCloseButton : !disableCloseButton;
  var reallyEnableCloseByEscape = enableCloseByEscape !== void 0 ? enableCloseByEscape : !disableCloseByEscape;
  var reallyEnableBackdrop = enableBackdrop !== void 0 ? enableBackdrop : !disableOverlay;
  var _useControlledFlagSta5 = useControlledFlagState3(defaultOpen, open, onOpenChange),
    _useControlledFlagSta6 = _slicedToArray(_useControlledFlagSta5, 4),
    reallyOpen = _useControlledFlagSta6[0],
    setClose = _useControlledFlagSta6[3];
  var _useOverlay3 = useOverlay3(reallyOpen, {
      zIndex: zIndex6,
      blockWindowScroll: enableWindowScrollBlock !== false
    }),
    realZIndex = _useOverlay3.zIndex,
    isTopOverlay = _useOverlay3.isTopOverlay;
  var onCloseInternal = useCallback6(function () {
    if (isTopOverlay()) {
      onClose == null ? void 0 : onClose();
      setClose();
    }
  }, [onClose, setClose, isTopOverlay]);
  var rootRef = useRootRef10(ref);
  var onBackdropClick = useCallback6(function () {
    if (reallyEnableBackdrop && enableCloseOnBackdropClick !== false) {
      onCloseInternal();
    }
  }, [onCloseInternal, enableCloseOnBackdropClick, reallyEnableBackdrop]);
  var _useDisplayEffects = useDisplayEffects(!!reallyOpen),
    display = _useDisplayEffects.display,
    effectToggle = _useDisplayEffects.effectToggle;
  var onCloseButtonClickInternal = useCallback6(function (event) {
    if (onCloseButtonClick) {
      onCloseButtonClick(event);
      if (event.isPropagationStopped()) {
        return;
      }
    }
    onCloseInternal();
  }, [onCloseButtonClick, onCloseInternal]);
  var onKeyDown = useCallback6(function (event) {
    if (!reallyEnableCloseByEscape || event.key !== "Escape" || !isTopOverlay()) {
      return;
    }
    onCloseInternal();
  }, [isTopOverlay, onCloseInternal, reallyEnableCloseByEscape]);
  useDocumentKeydown(onKeyDown);
  var _extractSizeProps = extractSizeProps(restProps),
    sizeProps10 = _extractSizeProps.sizeProps,
    restSizeProps = _extractSizeProps.restSizeProps;
  return {
    portalProps: {
      enablePortal: enablePortal
    },
    rootProps: __spreadProps(__spreadValues({}, restSizeProps), {
      zIndex: realZIndex,
      ref: rootRef
    }),
    getBackdropProps: function getBackdropProps() {
      return {
        disableEffects: enableEffects !== void 0 ? !enableEffects : disableEffects,
        effectToggle: effectToggle,
        display: display,
        onClick: onBackdropClick
      };
    },
    alignmentContainerProps: {
      display: display,
      enableCloseButton: reallyEnableCloseButton,
      scroll: scroll
    },
    windowProps: __spreadProps(__spreadValues({}, sizeProps10), {
      effectToggle: effectToggle,
      enableEffects: enableEffects !== void 0 ? enableEffects : !disableEffects,
      scroll: scroll
    }),
    getCloseButtonProps: function getCloseButtonProps() {
      return {
        "data-testid": dialogCloseButton,
        onClick: onCloseButtonClickInternal,
        tabIndex: -1
      };
    },
    contentProps: {},
    enableCloseButton: reallyEnableCloseButton,
    enableBackdrop: reallyEnableBackdrop,
    open: !!reallyOpen
  };
};

// src/components/Dialog/style.ts
import styled24, { css as css25 } from "styled-components";
import { fixedCover, propsBlocker as propsBlocker23, reset as reset10, sizeProps as sizeProps5, spacing as spacing18, zIndex as zIndex3, getComponentOverride as getComponentOverride15 } from "@deliveryhero/armor-system";
var DialogRoot = styled24.div.withConfig(propsBlocker23)(_templateObject129 || (_templateObject129 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n"])), reset10, zIndex3, getComponentOverride15("Dialog"));
var getAlignmentContainerStyle = function getAlignmentContainerStyle(_ref41) {
  var scroll = _ref41.scroll,
    display = _ref41.display,
    enableCloseButton = _ref41.enableCloseButton;
  var containerDisplay = scroll === DIALOG_SCROLL_DOCUMENT ? "block" : "flex";
  if (!display) {
    containerDisplay = "none";
  }
  var result = css25(_templateObject130 || (_templateObject130 = _taggedTemplateLiteral(["\n        overflow-y: ", ";\n        display: ", ";\n    "])), scroll === DIALOG_SCROLL_DOCUMENT ? "auto" : "unset", containerDisplay);
  if (enableCloseButton) {
    result = css25(_templateObject131 || (_templateObject131 = _taggedTemplateLiteral(["\n            ", ";\n\n            .DialogTitle-Text {\n                margin-right: ", ";\n            }\n        "])), result, spacing18(9));
  }
  return result;
};
var DialogAlignmentContainer = styled24.div.withConfig(propsBlocker23)(_templateObject132 || (_templateObject132 = _taggedTemplateLiteral(["\n    ", ";\n    z-index: inherit;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    pointer-events: none;\n\n    ", ";\n"])), fixedCover, getAlignmentContainerStyle);
var getWindowStyle = function getWindowStyle(_ref42) {
  var enableEffects = _ref42.enableEffects,
    effectToggle = _ref42.effectToggle,
    scroll = _ref42.scroll;
  return css25(_templateObject133 || (_templateObject133 = _taggedTemplateLiteral(["\n        max-height: ", ";\n        display: ", ";\n\n        transition: ", ";\n        transform: translateY(", ");\n        opacity: ", ";\n    "])), scroll === DIALOG_SCROLL_DOCUMENT ? "none" : css25(_templateObject134 || (_templateObject134 = _taggedTemplateLiteral(["calc(100% - ", ")"])), spacing18(16)), scroll === DIALOG_SCROLL_DOCUMENT ? "inline-block" : "flex", enableEffects ? "transform 100ms ease, opacity 100ms ease" : "none", effectToggle ? 0 : "20px", effectToggle ? 1 : 0);
};
var DialogWindow = styled24(Card)(_templateObject135 || (_templateObject135 = _taggedTemplateLiteral(["\n    position: relative;\n    overflow-y: auto;\n    overflow-x: hidden;\n    pointer-events: auto;\n\n    flex-direction: column;\n    text-align: left;\n\n    margin: ", ";\n    min-height: ", ";\n    min-width: ", ";\n\n    ", ";\n    ", ";\n"])), spacing18(12), spacing18(23), spacing18(100), getWindowStyle, sizeProps5);
var DialogContent = styled24.div.withConfig(propsBlocker23)(_templateObject136 || (_templateObject136 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    max-height: 100%;\n    overflow: auto;\n"])));
var DialogCloseButton = styled24(CloseButton)(_templateObject137 || (_templateObject137 = _taggedTemplateLiteral(["\n    margin-top: -", ";\n    margin-right: -", ";\n    position: absolute;\n    top: ", ";\n    right: ", ";\n"])), spacing18(2), spacing18(2), spacing18(6.5), spacing18(6.5));

// src/components/Backdrop/Backdrop.tsx
import React28, { memo as memo23 } from "react";
import PropTypes13 from "prop-types";

// src/components/Backdrop/style.ts
import styled25, { css as css26 } from "styled-components";
import { fixedCover as fixedCover2, getComponentOverride as getComponentOverride16, propsBlocker as propsBlocker24, durationNormal as durationNormal6 } from "@deliveryhero/armor-system";
var BackdropRoot = styled25.div.withConfig(propsBlocker24)(_templateObject138 || (_templateObject138 = _taggedTemplateLiteral(["\n    ", ";\n    z-index: inherit;\n    ", "\n\n    ", ";\n"])), fixedCover2, function (_ref43) {
  var display = _ref43.display,
    effectToggle = _ref43.effectToggle,
    disableEffects = _ref43.disableEffects;
  return css26(_templateObject139 || (_templateObject139 = _taggedTemplateLiteral(["\n        opacity: ", ";\n        display: ", ";\n        transition: ", ";\n        background-color: rgba(0, 0, 0, 0.5);\n    "])), effectToggle ? 1 : 0, display ? "initial" : "none", disableEffects ? "none" : "opacity ".concat(durationNormal6, "ms ease"));
}, getComponentOverride16("Backdrop"));

// src/components/Backdrop/constants.ts
var BACKDROP_CLASS_PREFIX = "Backdrop";

// src/components/Backdrop/Backdrop.tsx
var Backdrop = memo23(function (_a) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  return /* @__PURE__ */React28.createElement(BackdropRoot, __spreadProps(__spreadValues({}, restProps), {
    className: "Backdrop ".concat(className)
  }));
});
Backdrop.displayName = BACKDROP_CLASS_PREFIX;
Backdrop.defaultProps = {
  tabIndex: 0
};
Backdrop.propTypes = {
  id: PropTypes13.string
};

// src/components/Dialog/Dialog.tsx
var Dialog = forwardRef20(function Dialog2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var _useDialog = useDialog(props, ref),
    portalProps = _useDialog.portalProps,
    rootProps = _useDialog.rootProps,
    getBackdropProps = _useDialog.getBackdropProps,
    alignmentContainerProps = _useDialog.alignmentContainerProps,
    windowProps = _useDialog.windowProps,
    getCloseButtonProps = _useDialog.getCloseButtonProps,
    contentProps = _useDialog.contentProps,
    enableCloseButton = _useDialog.enableCloseButton,
    enableBackdrop = _useDialog.enableBackdrop,
    open = _useDialog.open;
  var classNames = useDialogClassNames(DIALOG_CLASS_PREFIX, open, className);
  return /* @__PURE__ */React29.createElement(PortalToBody3, __spreadValues({}, portalProps), /* @__PURE__ */React29.createElement(DialogRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), enableBackdrop && /* @__PURE__ */React29.createElement(Backdrop, __spreadProps(__spreadValues({}, getBackdropProps()), {
    className: classNames.Backdrop
  })), /* @__PURE__ */React29.createElement(DialogAlignmentContainer, __spreadProps(__spreadValues({}, alignmentContainerProps), {
    className: classNames.AlignmentContainer
  }), /* @__PURE__ */React29.createElement(DialogWindow, __spreadProps(__spreadValues({}, windowProps), {
    className: classNames.Window
  }), enableCloseButton && /* @__PURE__ */React29.createElement(DialogCloseButton, __spreadProps(__spreadValues({}, getCloseButtonProps()), {
    className: classNames.CloseButton
  })), /* @__PURE__ */React29.createElement(DialogContent, __spreadProps(__spreadValues({}, contentProps), {
    className: classNames.Content
  }), children)))));
});
Dialog.defaultProps = {
  disableOverlay: false,
  disableEffects: false,
  disableCloseButton: false,
  disableCloseByEscape: false,
  scroll: DIALOG_SCROLL_DIALOG
};
var MemoizedDialog = memo24(Dialog);

// src/components/Dialog/DialogTitle/DialogTitle.tsx
import React30, { memo as memo25 } from "react";
import PropTypes14 from "prop-types";

// src/components/Dialog/DialogTitle/utils/useDialogTitleClassName.ts
import { useMemo as useMemo29 } from "react";
import { makeBEM as makeBEM19, makeRootClassName as makeRootClassName16 } from "@deliveryhero/armor-system";
var useDialogTitleClassNames = function useDialogTitleClassNames(classPrefix, className) {
  return useMemo29(function () {
    return {
      Root: makeRootClassName16(classPrefix, className),
      Text: makeBEM19(classPrefix, "Text"),
      Description: makeBEM19(classPrefix, "Description")
    };
  }, [classPrefix, className]);
};

// src/components/Dialog/DialogTitle/style.ts
import styled26 from "styled-components";
import { paddingProps as paddingProps10, propsBlocker as propsBlocker25, getComponentOverride as getComponentOverride17, spacing as spacing19, color as color10 } from "@deliveryhero/armor-system";
var DialogTitleRoot = styled26.div.withConfig(propsBlocker25)(_templateObject140 || (_templateObject140 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    flex: 0 0;\n    color: red;\n    padding: ", ";\n    &:not(:last-child) {\n        padding-bottom: ", ";\n    }\n    ", ";\n"])), spacing19(6), spacing19(0), paddingProps10);
var DialogTitleText = styled26(Typography)(_templateObject141 || (_templateObject141 = _taggedTemplateLiteral(["\n    margin: 0;\n"])));
var DialogTitleDescription = styled26(Typography)(_templateObject142 || (_templateObject142 = _taggedTemplateLiteral(["\n    letter-spacing: 0;\n    color: ", ";\n    margin-top: ", ";\n    ", ";\n"])), color10("neutral.07"), spacing19(2), getComponentOverride17("DialogTitle"));

// src/components/Dialog/DialogTitle/constants.ts
var DIALOG_TITLE_CLASS_PREFIX = "DialogTitle";
var dialogTitleText = "DialogTitleText";

// src/components/Dialog/DialogTitle/DialogTitle.tsx
var DialogTitle = function DialogTitle(_a) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    description = _b.description,
    restProps = __objRest(_b, ["className", "children", "description"]);
  var classNameComponents = useDialogTitleClassNames(DIALOG_TITLE_CLASS_PREFIX, className);
  return /* @__PURE__ */React30.createElement(DialogTitleRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameComponents.Root
  }), /* @__PURE__ */React30.createElement(DialogTitleText, {
    className: classNameComponents.Text,
    "data-testid": dialogTitleText,
    subSectionTitle: true
  }, children), !!description && /* @__PURE__ */React30.createElement(DialogTitleDescription, {
    paragraph: true,
    large: true,
    className: classNameComponents.Description
  }, description));
};
DialogTitle.defaultProps = {};
DialogTitle.propTypes = {
  /** A value of brief description displayed above the title. Can be any valid ReactNode. */
  description: PropTypes14.node
};
var MemoizedDialogTitle = memo25(DialogTitle);

// src/components/Dialog/DialogContent/DialogContent.tsx
import React31, { memo as memo26 } from "react";

// src/components/Dialog/DialogContent/utils/useDialogContentClassName.ts
import { useMemo as useMemo30 } from "react";
import { makeRootClassName as makeRootClassName17 } from "@deliveryhero/armor-system";
var useDialogContentClassName = function useDialogContentClassName(classPrefix, className) {
  return useMemo30(function () {
    return makeRootClassName17(classPrefix, className);
  }, [classPrefix, className]);
};

// src/components/Dialog/DialogContent/style.ts
import styled27 from "styled-components";
import { typography as typography12, paddingProps as paddingProps11, spacing as spacing20, propsBlocker as propsBlocker26, getComponentOverride as getComponentOverride18, token as token23 } from "@deliveryhero/armor-system";
var DialogContentRoot = styled27.div.withConfig(propsBlocker26)(_templateObject143 || (_templateObject143 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    ", "\n\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-top: ", ";\n    padding-bottom: 0;\n    padding-left: ", ";\n    padding-right: ", ";\n    &:first-child {\n        padding-top: ", ";\n    }\n    &:last-child {\n        padding-bottom: ", ";\n    }\n\n    ", ";\n    ", ";\n"])), typography12("paragraphLarge"), token23("body.color"), function (_ref44) {
  var enableVerticalScroll = _ref44.enableVerticalScroll;
  return enableVerticalScroll ? "overflow-y: auto;" : "";
}, spacing20(1), spacing20(6), spacing20(6), spacing20(8), spacing20(8), getComponentOverride18("DialogContent"), paddingProps11);

// src/components/Dialog/DialogContent/constants.ts
var DIALOG_CONTENT_CLASS_PREFIX = "DialogContent";

// src/components/Dialog/DialogContent/DialogContent.tsx
var DialogContent2 = function DialogContent2(_a) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var classNameRoot = useDialogContentClassName(DIALOG_CONTENT_CLASS_PREFIX, className);
  return /* @__PURE__ */React31.createElement(DialogContentRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameRoot
  }), children);
};
DialogContent2.defaultProps = {
  enableVerticalScroll: true
};
DialogContent2.propTypes = {};
var MemoizedDialogContent = memo26(DialogContent2);

// src/components/Dialog/DialogActions/DialogActions.tsx
import React32, { memo as memo27 } from "react";

// src/components/Dialog/DialogActions/utils/useDialogActionsClassName.ts
import { useMemo as useMemo31 } from "react";
import { makeRootClassName as makeRootClassName18 } from "@deliveryhero/armor-system";
var useDialogActionsClassName = function useDialogActionsClassName(classPrefix, className) {
  return useMemo31(function () {
    return makeRootClassName18(classPrefix, className);
  }, [classPrefix, className]);
};

// src/components/Dialog/DialogActions/style.ts
import styled28 from "styled-components";
import { paddingProps as paddingProps12, propsBlocker as propsBlocker27, spacing as spacing21 } from "@deliveryhero/armor-system";
var DialogActionsRoot = styled28.div.withConfig(propsBlocker27)(_templateObject144 || (_templateObject144 = _taggedTemplateLiteral(["\n    flex: 0 0;\n    display: flex;\n    justify-content: flex-end;\n    box-sizing: border-box;\n    flex-shrink: 0;\n    padding: ", ";\n    &:not(:first-child) {\n        padding-top: ", ";\n    }\n    & > *:not(:last-child) {\n        margin-right: ", ";\n    }\n    ", ";\n"])), spacing21(6), spacing21(4), spacing21(4), paddingProps12);

// src/components/Dialog/DialogActions/constants.ts
var DIALOG_ACTIONS_CLASS_PREFIX = "DialogActions";

// src/components/Dialog/DialogActions/DialogActions.tsx
var DialogActions = function DialogActions(_a) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameRoot = useDialogActionsClassName(DIALOG_ACTIONS_CLASS_PREFIX, className);
  return /* @__PURE__ */React32.createElement(DialogActionsRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameRoot
  }));
};
DialogActions.defaultProps = {};
DialogActions.propTypes = {};
var MemoizedDialogActions = memo27(DialogActions);

// src/components/Dropdown/Dropdown.tsx
import React55, { forwardRef as forwardRef29, memo as memo39 } from "react";
import { PortalToBody as PortalToBody4 } from "@deliveryhero/armor-system";

// src/components/Dropdown/hooks/useDropdown.ts
import { useCallback as useCallback10, useEffect as useEffect7, useRef as useRef4, useState as useState3, isValidElement } from "react";
import { useControlledState as useControlledState3, useDerivedState, useOuterClick as useOuterClick2, useOverlay as useOverlay4, usePopper as usePopper3, useRootRef as useRootRef11, useDetectEscapeKeyPressed } from "@deliveryhero/armor-system";

// src/utils/dropdown/useOnValueUpdate.ts
import { useCallback as useCallback7 } from "react";
var denormalizeValue = function denormalizeValue(value, multiple) {
  return multiple ? value : value[0];
};
var useOnValueUpdate = function useOnValueUpdate(setInternalValue, onSelect, onChange, name) {
  return useCallback7(function (internalValue, multiple, selectedOption, itemIndex, options, isFlat) {
    var chosenItem = selectedOption.value;
    if (typeof chosenItem === "undefined") {
      return;
    }
    var nextValue;
    if (multiple) {
      if (internalValue.includes(chosenItem)) {
        nextValue = internalValue.filter(function (item) {
          return item !== chosenItem;
        });
      } else {
        nextValue = [].concat(_toConsumableArray(internalValue), [chosenItem]);
      }
    } else {
      nextValue = [chosenItem];
    }
    if (onChange) {
      onChange({
        target: {
          value: denormalizeValue(nextValue, multiple),
          name: name
        }
      });
    }
    if (onSelect && options) {
      var option = isFlat ? selectedOption.label : selectedOption;
      if (typeof option === "number") {
        option = option.toString();
      }
      onSelect(option, options.indexOf(option));
    }
    setInternalValue(nextValue);
  }, [onSelect, onChange, setInternalValue, name]);
};

// src/utils/dropdown/useOptions.ts
import { useMemo as useMemo32, useState, useEffect as useEffect2 } from "react";
var useOptions = function useOptions(options, formatOption) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    dynamicInternalOptions = _useState2[0],
    setDynamicInternalOptions = _useState2[1];
  var _useMemo3 = useMemo32(function () {
      var isOptionFlat = false;
      if (!options || !Array.isArray(options)) {
        return {
          isFlat: isOptionFlat,
          internalOptions: []
        };
      }
      var formattedOptions = options.map(function (option, index) {
        if (option && typeof option === "object" && "value" in option) {
          var formattedOption = option;
          if (formatOption) {
            formattedOption = __spreadProps(__spreadValues({}, formattedOption), {
              label: formatOption(option)
            });
          }
          return formattedOption;
        }
        isOptionFlat = true;
        return {
          label: formatOption ? formatOption(option) : option,
          value: index
        };
      });
      return {
        isFlat: isOptionFlat,
        internalOptions: formattedOptions
      };
    }, [formatOption, options]),
    isFlat = _useMemo3.isFlat,
    internalOptions = _useMemo3.internalOptions;
  useEffect2(function () {
    setDynamicInternalOptions(internalOptions);
  }, [internalOptions]);
  return {
    isFlat: isFlat,
    internalOptions: internalOptions,
    dynamicInternalOptions: dynamicInternalOptions,
    setDynamicInternalOptions: setDynamicInternalOptions
  };
};

// src/utils/dropdown/useSelectedValueToDisplay.ts
import { useMemo as useMemo33 } from "react";
import { stripHTMLTagsMemoized as stripHTMLTags } from "@deliveryhero/armor-system";
var useSelectedValueToDisplay = function useSelectedValueToDisplay(internalValue, internalOptions, onRenderSelectedValue) {
  return useMemo33(function () {
    if (onRenderSelectedValue) {
      return onRenderSelectedValue(internalValue, internalOptions);
    }
    if (!internalValue.length) {
      return EMPTY_LABEL_VALUE;
    }
    return internalOptions.filter(function (option) {
      return internalValue.includes(option.value);
    }).map(function (option) {
      return stripHTMLTags(option.label);
    }).join(", ");
  }, [onRenderSelectedValue, internalValue, internalOptions]);
};

// src/utils/dropdown/useValue.ts
import { useState as useState2, useEffect as useEffect3 } from "react";
var normalizeValue = function normalizeValue(value) {
  if (typeof value === "undefined") {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};
var useValue = function useValue(value, defaultValue) {
  var _useState3 = useState2(normalizeValue(defaultValue)),
    _useState4 = _slicedToArray(_useState3, 2),
    ownValue = _useState4[0],
    setOwnValue = _useState4[1];
  var controlled = typeof value !== "undefined";
  useEffect3(function () {
    if (controlled) {
      setOwnValue([]);
    }
  }, [controlled]);
  if (controlled) {
    return [normalizeValue(value), function () {}];
  }
  return [ownValue, setOwnValue];
};

// src/components/Dropdown/hooks/useOnOptionListUpdate.ts
import { useEffect as useEffect4 } from "react";
import { stripHTMLTagsMemoized as stripHTMLTags2 } from "@deliveryhero/armor-system";
var formatOptionLabel = function formatOptionLabel(option) {
  return __spreadProps(__spreadValues({}, option), {
    label: stripHTMLTags2(option.label)
  });
};
var optionsArraysDiff = function optionsArraysDiff(arrayOne, arrayTwo) {
  var formattedArrayOne = arrayOne.map(formatOptionLabel);
  var formattedArrayTwo = arrayTwo.map(formatOptionLabel);
  return formattedArrayOne.filter(function (_ref45) {
    var value1 = _ref45.value,
      label1 = _ref45.label;
    return !formattedArrayTwo.some(function (_ref46) {
      var value2 = _ref46.value,
        label2 = _ref46.label;
      return value1 === value2 && label1 === label2;
    });
  });
};
var useOnOptionListUpdate = function useOnOptionListUpdate(internalOptions, dynamicInternalOptions, setInternalValue, searchQuery, isOptionListShown, preserveSelection) {
  return useEffect4(function () {
    if (!preserveSelection && (!searchQuery || !isOptionListShown) && (internalOptions.length !== dynamicInternalOptions.length || optionsArraysDiff(internalOptions, dynamicInternalOptions).length)) {
      setInternalValue([]);
    }
  }, [internalOptions, dynamicInternalOptions, setInternalValue, preserveSelection, searchQuery, isOptionListShown]);
};

// src/components/Dropdown/hooks/usePanelWidth.ts
import { useEffect as useEffect5, useCallback as useCallback8 } from "react";
import { RESIZE_OBSERVER_SUPPORTED } from "@deliveryhero/armor-system";
var usePanelWidth = function usePanelWidth(containerRef, dropdownRef, isDropdownShown) {
  var updateDropdownWidth = useCallback8(function () {
    if (!dropdownRef.current || !containerRef.current) {
      return;
    }
    var currentInputWidth = containerRef.current.offsetWidth;
    dropdownRef.current.style.width = "".concat(currentInputWidth, "px");
  }, [containerRef, dropdownRef]);
  useEffect5(function () {
    var observer = null;
    if (RESIZE_OBSERVER_SUPPORTED && dropdownRef.current) {
      observer = new ResizeObserver(function () {
        updateDropdownWidth();
      });
      observer.observe(containerRef.current);
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [containerRef, dropdownRef, updateDropdownWidth]);
  useEffect5(function () {
    if (isDropdownShown) {
      updateDropdownWidth();
    }
  }, [isDropdownShown, updateDropdownWidth]);
};

// src/components/OptionList/constants.ts
var OPTION_LIST_CLASS_PREFIX = "OptionList";
var OPTION_LIST_ITEM_CLASS_PREFIX = "OptionListItem";
var OPTION_LIST_FOOTER_CLASS_PREFIX = "OptionListFooter";
var OPTION_LIST_ITEM_GROUP_CLASS_PREFIX = "OptionListItemGroup";
var OPTION_LIST_ITEM = "OptionListItem";
var MAX_OPTIONS_SELECT_ALL_THRESHOLD = 1e4;
var INITIAL_CURSOR_POSITION = -1;
var OPTION_LIST_ITEM_FOCUSED_CLASS = "OptionList-OptionListItem-focused";

// src/components/Dropdown/hooks/useOnInternalItemGroupsUpdate.ts
import { useEffect as useEffect6 } from "react";

// src/components/Dropdown/utils/calculateActiveGroupMemberCounts.ts
var calculateActiveGroupMemberCounts = function calculateActiveGroupMemberCounts(internalOptions) {
  var groupMemberCounts = {};
  internalOptions.forEach(function (member) {
    if (member == null ? void 0 : member.disabled) {
      return;
    }
    var memberGroupId = member == null ? void 0 : member.groupId;
    if (memberGroupId) {
      if (memberGroupId in groupMemberCounts) {
        groupMemberCounts = __spreadProps(__spreadValues({}, groupMemberCounts), _defineProperty({}, memberGroupId, groupMemberCounts[memberGroupId] + 1));
      } else {
        groupMemberCounts = __spreadProps(__spreadValues({}, groupMemberCounts), _defineProperty({}, memberGroupId, 1));
      }
    }
  });
  return groupMemberCounts;
};

// src/components/Dropdown/hooks/useOnInternalItemGroupsUpdate.ts
var useOnInternalItemGroupsUpdate = function useOnInternalItemGroupsUpdate(internalValue, internalOptions, setInternalGroups, groups, enableGroupSelection) {
  return useEffect6(function () {
    if (enableGroupSelection) {
      var groupMemberCounts = calculateActiveGroupMemberCounts(internalOptions);
      var updatedInternalGroups = {};
      if (!internalValue) {
        setInternalGroups({});
      } else {
        internalValue.forEach(function (selectedOptionId) {
          var matchingOption = internalOptions.find(function (option) {
            return option.value === selectedOptionId;
          });
          var itemsGroupId = matchingOption == null ? void 0 : matchingOption.groupId;
          if (matchingOption && itemsGroupId) {
            var selectedGroups = Object.keys(updatedInternalGroups);
            if (selectedGroups.includes(itemsGroupId) && internalValue.length) {
              updatedInternalGroups = __spreadProps(__spreadValues({}, updatedInternalGroups), _defineProperty({}, itemsGroupId, __spreadProps(__spreadValues({}, updatedInternalGroups[itemsGroupId]), {
                selectedItemsCount: updatedInternalGroups[itemsGroupId].selectedItemsCount + 1,
                selectedItemIds: [].concat(_toConsumableArray(updatedInternalGroups[itemsGroupId].selectedItemIds), [selectedOptionId])
              })));
            } else {
              updatedInternalGroups = __spreadProps(__spreadValues({}, updatedInternalGroups), _defineProperty({}, itemsGroupId, __spreadProps(__spreadValues({}, matchingOption), {
                totalItemsCount: groupMemberCounts[itemsGroupId],
                selectedItemsCount: 1,
                selectedItemIds: [selectedOptionId]
              })));
            }
          }
        });
        setInternalGroups(updatedInternalGroups);
      }
    }
  }, [internalValue, internalOptions, groups, setInternalGroups, enableGroupSelection]);
};

// src/components/Dropdown/hooks/useOnToggleAll.ts
import { useCallback as useCallback9 } from "react";

// src/components/Dropdown/utils/handleOnChange.ts
var handleOnChange = function handleOnChange(value, onChange) {
  if (onChange) {
    onChange({
      target: {
        value: value
      }
    });
  }
};

// src/components/Dropdown/hooks/useOnToggleAll.ts
var useOnToggleAll = function useOnToggleAll(setInternalValue, internalOptions, internalValue, onChange, setInitialSelection) {
  var onToggleAll = useCallback9(function () {
    var selectAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var preselectedDisabledOptionItems = [];
    var unselectedDisabledOptionItems = [];
    internalOptions.forEach(function (option) {
      if (option.disabled) {
        if (!internalValue.includes(option.value)) {
          unselectedDisabledOptionItems.push(option.value);
        } else {
          preselectedDisabledOptionItems.push(option.value);
        }
      }
    });
    if (!selectAll) {
      handleOnChange([], onChange);
      if (setInitialSelection) {
        setInitialSelection([].concat(preselectedDisabledOptionItems));
      }
      if (setInternalValue) {
        setInternalValue([].concat(preselectedDisabledOptionItems));
      }
      return;
    }
    if (internalValue.length + unselectedDisabledOptionItems.length === internalOptions.length) {
      var updatedOptionValues = [].concat(preselectedDisabledOptionItems, unselectedDisabledOptionItems);
      if (internalValue.length < internalOptions.length) {
        updatedOptionValues = [].concat(preselectedDisabledOptionItems);
      }
      handleOnChange(updatedOptionValues, onChange);
      if (setInternalValue) {
        setInternalValue(updatedOptionValues);
      }
      return;
    }
    var enabledOptionValuesOnSelect = [];
    internalOptions.forEach(function (option) {
      if (!option.disabled || option.disabled && internalValue.includes(option.value)) {
        enabledOptionValuesOnSelect.push(option.value);
      }
    });
    handleOnChange(enabledOptionValuesOnSelect, onChange);
    if (setInternalValue) {
      setInternalValue(enabledOptionValuesOnSelect);
    }
  }, [setInternalValue, internalOptions, internalValue, onChange, setInitialSelection]);
  return onToggleAll;
};

// src/components/Dropdown/hooks/useDropdown.ts
var useDropdown = function useDropdown(_a, ref) {
  var _b = _a,
    disabled = _b.disabled,
    _b$isActionSeparatorD = _b.isActionSeparatorDisplayed,
    isActionSeparatorDisplayed = _b$isActionSeparatorD === void 0 ? true : _b$isActionSeparatorD,
    error = _b.error,
    label = _b.label,
    onSelect = _b.onSelect,
    onRenderSelectedValue = _b.onRenderSelectedValue,
    options = _b.options,
    onChange = _b.onChange,
    _b$multiple = _b.multiple,
    multiple = _b$multiple === void 0 ? false : _b$multiple,
    formatOption = _b.formatOption,
    enableSelectAllOption = _b.enableSelectAllOption,
    selectAllLabel = _b.selectAllLabel,
    enableSearchOption = _b.enableSearchOption,
    enableOptionContentEllipsis = _b.enableOptionContentEllipsis,
    enableFooter = _b.enableFooter,
    enableClearButton = _b.enableClearButton,
    _b$preserveSelection = _b.preserveSelection,
    preserveSelection = _b$preserveSelection === void 0 ? true : _b$preserveSelection,
    onCancelClick = _b.onCancelClick,
    onConfirmClick = _b.onConfirmClick,
    footerContent = _b.footerContent,
    searchPlaceholder = _b.searchPlaceholder,
    defaultSearchQuery = _b.defaultSearchQuery,
    tagLabelMaxLength = _b.tagLabelMaxLength,
    enableVirtualization = _b.enableVirtualization,
    _b$openTagsCount = _b.openTagsCount,
    openTagsCount = _b$openTagsCount === void 0 ? enableVirtualization ? 20 : 10 : _b$openTagsCount,
    renderAggregatedTagsLabel = _b.renderAggregatedTagsLabel,
    singleLine = _b.singleLine,
    zIndex6 = _b.zIndex,
    enablePortal = _b.enablePortal,
    groups = _b.groups,
    renderItemAdditionalInfo = _b.renderItemAdditionalInfo,
    enableGroupSelection = _b.enableGroupSelection,
    dataTestIdInput = _b["data-testid-input"],
    large = _b.large,
    open = _b.open,
    defaultOpen = _b.defaultOpen,
    onOpenChange = _b.onOpenChange,
    isListExpanded = _b.isListExpanded,
    autoFocus = _b.autoFocus,
    defaultValue = _b.defaultValue,
    name = _b.name,
    placeholder = _b.placeholder,
    value = _b.value,
    tabIndex = _b.tabIndex,
    maxDropdownWidth = _b.maxDropdownWidth,
    minDropdownWidth = _b.minDropdownWidth,
    maxDropdownHeight = _b.maxDropdownHeight,
    _b$disableScrollGradi = _b.disableScrollGradientEffect,
    disableScrollGradientEffect = _b$disableScrollGradi === void 0 ? false : _b$disableScrollGradi,
    restProps = __objRest(_b, ["disabled", "isActionSeparatorDisplayed", "error", "label", "onSelect", "onRenderSelectedValue", "options", "onChange", "multiple", "formatOption", "enableSelectAllOption", "selectAllLabel", "enableSearchOption", "enableOptionContentEllipsis", "enableFooter", "enableClearButton", "preserveSelection", "onCancelClick", "onConfirmClick", "footerContent", "searchPlaceholder", "defaultSearchQuery", "tagLabelMaxLength", "enableVirtualization", "openTagsCount", "renderAggregatedTagsLabel", "singleLine", "zIndex", "enablePortal", "groups", "renderItemAdditionalInfo", "enableGroupSelection", "data-testid-input", "large",
    // open/close state
    "open", "defaultOpen", "onOpenChange", "isListExpanded",
    // other native text input props
    "autoFocus", "defaultValue", "name", "placeholder", "value", "tabIndex", "maxDropdownWidth", "minDropdownWidth", "maxDropdownHeight", "disableScrollGradientEffect"]);
  var internalInputRef = useRootRef11(ref);
  var containerRef = useRef4(null);
  var dropdownRef = useRef4(null);
  var _useState5 = useState3([]),
    _useState6 = _slicedToArray(_useState5, 2),
    initialSelection = _useState6[0],
    setInitialSelection = _useState6[1];
  var _useValue = useValue(value, defaultValue),
    _useValue2 = _slicedToArray(_useValue, 2),
    internalValue = _useValue2[0],
    setInternalValue = _useValue2[1];
  var _useState7 = useState3(defaultSearchQuery),
    _useState8 = _slicedToArray(_useState7, 2),
    searchQuery = _useState8[0],
    setSearchQuery = _useState8[1];
  var _useState9 = useState3({}),
    _useState10 = _slicedToArray(_useState9, 2),
    internalGroups = _useState10[0],
    setInternalGroups = _useState10[1];
  var _useOptions = useOptions(options, formatOption),
    internalOptions = _useOptions.internalOptions,
    isFlat = _useOptions.isFlat;
  var _useDerivedState = useDerivedState(function () {
      return internalOptions;
    }, [internalOptions]),
    _useDerivedState2 = _slicedToArray(_useDerivedState, 2),
    dynamicInternalOptions = _useDerivedState2[0],
    setDynamicInternalOptions = _useDerivedState2[1];
  var _useControlledState5 = useControlledState3(isListExpanded !== void 0 ? isListExpanded : defaultOpen, open, onOpenChange),
    _useControlledState6 = _slicedToArray(_useControlledState5, 2),
    isOptionListShown = _useControlledState6[0],
    setIsOptionListShown = _useControlledState6[1];
  useEffect7(function () {
    if (enableFooter) {
      setInitialSelection(internalValue);
    }
  }, [enableFooter, internalValue]);
  useOnOptionListUpdate(internalOptions, dynamicInternalOptions, setInternalValue, searchQuery, isOptionListShown, preserveSelection);
  var onValueUpdate = useOnValueUpdate(setInternalValue, onSelect, onChange, name);
  useOnInternalItemGroupsUpdate(internalValue, internalOptions, setInternalGroups, groups, enableGroupSelection);
  var selectedValueToDisplay = useSelectedValueToDisplay(internalValue, internalOptions, onRenderSelectedValue);
  var handleCancelClick = useCallback10(function () {
    setInternalValue(initialSelection);
    if (enableFooter && onCancelClick) {
      onCancelClick(initialSelection);
    }
  }, [setInternalValue, initialSelection, enableFooter, onCancelClick]);
  var handleConfirmClick = useCallback10(function () {
    setInitialSelection(internalValue);
    if (enableFooter && onConfirmClick) {
      onConfirmClick(internalValue);
    }
  }, [enableFooter, onConfirmClick, internalValue]);
  var blurInput = useCallback10(function () {
    var node = internalInputRef.current;
    if (node && node.blur) {
      setTimeout(function () {
        return node.blur();
      }, 0);
    }
  }, [internalInputRef]);
  var focusOnActionItemTrigger = useCallback10(function () {
    var node = internalInputRef.current;
    if (!isOptionListShown) {
      node == null ? void 0 : node.focus();
      return;
    }
    blurInput();
  }, [blurInput, internalInputRef, isOptionListShown]);
  var onOuterClick = useCallback10(function () {
    setIsOptionListShown(false);
  }, [setIsOptionListShown]);
  useOuterClick2([containerRef, dropdownRef], onOuterClick, isOptionListShown && !enableFooter);
  useDetectEscapeKeyPressed(containerRef, setIsOptionListShown, isOptionListShown && !enableFooter);
  var onOptionListVisibilityTriggerClick = useCallback10(function () {
    if (disabled) {
      return;
    }
    setIsOptionListShown(!isOptionListShown);
    focusOnActionItemTrigger();
  }, [disabled, setIsOptionListShown, isOptionListShown, focusOnActionItemTrigger]);
  var _usePopper3 = usePopper3(dropdownRef, containerRef, {
      align: "bottom-start",
      offset: [0, 5],
      allowedAutoPlacements: ["top", "bottom"]
    }),
    panelProps = _usePopper3.panelProps,
    arrowProps = _usePopper3.arrowProps;
  var _useOverlay4 = useOverlay4(isOptionListShown, {
      zIndex: zIndex6
    }),
    realZIndex = _useOverlay4.zIndex;
  usePanelWidth(containerRef, dropdownRef, isOptionListShown);
  var onChangeProxy = useCallback10(function (newValue) {
    onChange == null ? void 0 : onChange(__spreadProps(__spreadValues({}, newValue), {
      target: __spreadProps(__spreadValues({}, newValue.target), {
        name: name
      })
    }));
  }, [onChange, name]);
  var onContainerClick = function onContainerClick(event) {
    var element = event.target;
    if (element.classList.contains("TextInput-InnerContainer")) {
      onOptionListVisibilityTriggerClick();
    }
  };
  var onToggleAll = useOnToggleAll(setInternalValue, internalOptions, internalValue, onChange, setInitialSelection);
  var onRemoveAllTags = function onRemoveAllTags() {
    return onToggleAll(false);
  };
  var isRenderedSelectedValueAsNode = isValidElement(selectedValueToDisplay);
  var isBeforeSectionRendered = multiple && !onRenderSelectedValue || isRenderedSelectedValueAsNode;
  var getTextInputValue = function getTextInputValue() {
    if (isOptionListShown && (!selectedValueToDisplay || isRenderedSelectedValueAsNode)) {
      return WHITESPACE_LABEL_VALUE;
    }
    if (isRenderedSelectedValueAsNode) {
      return EMPTY_LABEL_VALUE;
    }
    return "".concat(selectedValueToDisplay);
  };
  return {
    rootProps: restProps,
    containerProps: {
      ref: containerRef,
      disabled: disabled,
      onClick: onContainerClick
    },
    textInputProps: {
      onClick: onOptionListVisibilityTriggerClick,
      ref: internalInputRef,
      value: getTextInputValue(),
      internalValue: internalValue,
      disabled: disabled,
      error: error,
      label: label,
      name: name,
      displayMode: "block",
      isCustomRenderer: !!onRenderSelectedValue,
      isRenderedSelectedValueAsNode: isRenderedSelectedValueAsNode,
      "data-testid-input": dataTestIdInput,
      // other native props
      autoComplete: "off",
      readOnly: true,
      autoFocus: autoFocus,
      placeholder: placeholder,
      tabIndex: tabIndex,
      multiple: multiple,
      large: large,
      disableLabelEffect: isRenderedSelectedValueAsNode && !!internalValue.length
    },
    actionContainerProps: {
      large: large
    },
    portalProps: {
      enablePortal: enablePortal
    },
    listContainerProps: __spreadValues({
      ref: dropdownRef,
      zIndex: realZIndex,
      maxWidth: maxDropdownWidth,
      minWidth: minDropdownWidth
    }, panelProps),
    optionListProps: {
      disabled: disabled,
      options: options,
      multiple: multiple,
      internalValue: internalValue,
      blurInput: blurInput,
      isOptionListShown: isOptionListShown,
      setInternalValue: setInternalValue,
      setIsOptionListShown: setIsOptionListShown,
      onValueUpdate: onValueUpdate,
      onChange: onChangeProxy,
      isFlat: isFlat,
      internalOptions: internalOptions,
      dynamicInternalOptions: dynamicInternalOptions,
      enableVirtualization: enableVirtualization,
      setInternalOptions: setDynamicInternalOptions,
      setSearch: setSearchQuery,
      enableSelectAllOption: options && options.length > MAX_OPTIONS_SELECT_ALL_THRESHOLD ? false : enableSelectAllOption,
      selectAllLabel: selectAllLabel,
      enableSearchOption: enableSearchOption,
      enableFooter: enableFooter,
      onCancelClick: handleCancelClick,
      onConfirmClick: handleConfirmClick,
      footerContent: footerContent,
      internalGroups: internalGroups,
      setInternalGroups: setInternalGroups,
      searchPlaceholder: searchPlaceholder,
      defaultSearchQuery: defaultSearchQuery,
      enableAbsolutePositioning: false,
      groups: groups,
      enableGroupSelection: enableGroupSelection,
      enableOptionContentEllipsis: enableOptionContentEllipsis,
      renderItemAdditionalInfo: renderItemAdditionalInfo,
      maxDropdownHeight: maxDropdownHeight,
      enableScrollGradientEffect: !disableScrollGradientEffect
    },
    arrowProps: arrowProps,
    dropdownExpansionIndicatorProps: {
      disabled: disabled,
      error: error,
      multiple: multiple,
      displaySeparator: !multiple && isActionSeparatorDisplayed && (isOptionListShown || !!internalValue.length),
      isExpanded: isOptionListShown,
      onClick: onOptionListVisibilityTriggerClick
    },
    dropdownBeforeSectionProps: {
      disabled: disabled,
      onClick: onOptionListVisibilityTriggerClick,
      internalValue: internalValue,
      internalOptions: internalOptions,
      multiple: multiple,
      setInternalValue: setInternalValue,
      setInitialSelection: setInitialSelection,
      onSelect: onSelect,
      onChange: onChangeProxy,
      options: options,
      isFlat: isFlat,
      tagLabelMaxLength: tagLabelMaxLength,
      openTagsCount: openTagsCount,
      renderAggregatedTagsLabel: renderAggregatedTagsLabel,
      singleLine: singleLine,
      selectedValueToDisplay: selectedValueToDisplay,
      isRendered: isBeforeSectionRendered,
      isRenderedSelectedValueAsNode: isRenderedSelectedValueAsNode
    },
    clearButtonProps: {
      iconSize: "medium",
      onClick: onRemoveAllTags
    },
    disabled: disabled,
    internalValue: internalValue,
    open: isOptionListShown,
    shouldDisplayClearButton: (multiple || enableClearButton) && !disabled && !!internalValue.length
  };
};

// src/components/Dropdown/hooks/useDropdownBeforeSectionClassName.ts
import { useMemo as useMemo34 } from "react";
import { appendClassName as appendClassName8, makeBEM as makeBEM20 } from "@deliveryhero/armor-system";
var classGeneratorBasedOnComponent = function classGeneratorBasedOnComponent(_ref47) {
  var component = _ref47.component,
    classPrefix = _ref47.classPrefix,
    disabled = _ref47.disabled;
  var baseClassNames = makeBEM20(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM20(classPrefix, component, "disabled"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useDropdownBeforeSectionClassName = function useDropdownBeforeSectionClassName(classPrefix, className, disabled) {
  return useMemo34(function () {
    return {
      Root: appendClassName8(classGeneratorBasedOnComponent({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled
      }), className),
      TagsContainer: classGeneratorBasedOnComponent({
        component: "TagsContainer",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      TagsWrapper: classGeneratorBasedOnComponent({
        component: "TagsWrapper",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      ActionContainer: classGeneratorBasedOnComponent({
        component: "ActionContainer",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      ClearButton: classGeneratorBasedOnComponent({
        component: "ClearButton",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      DropdownTagRemainingItems: classGeneratorBasedOnComponent({
        component: "DropdownTagRemainingItems",
        classPrefix: classPrefix,
        disabled: disabled
      })
    };
  }, [classPrefix, className, disabled]);
};

// src/components/Dropdown/hooks/useDropdownClassName.ts
import { useMemo as useMemo35 } from "react";
import { appendClassName as appendClassName9, makeBEM as makeBEM21 } from "@deliveryhero/armor-system";
var classGeneratorBasedOnComponent2 = function classGeneratorBasedOnComponent2(_ref48) {
  var component = _ref48.component,
    classPrefix = _ref48.classPrefix,
    disabled = _ref48.disabled;
  var baseClassNames = makeBEM21(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM21(classPrefix, component, "disabled"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useDropdownClassName = function useDropdownClassName(classPrefix, className, disabled) {
  return (
    // TODO (nmelnikov 2020-07-23): this pattern is so prominent and cumbersome that we need to do something about it
    useMemo35(function () {
      return {
        Root: appendClassName9(classGeneratorBasedOnComponent2({
          component: "Root",
          classPrefix: classPrefix,
          disabled: disabled
        }), className),
        Container: classGeneratorBasedOnComponent2({
          component: "Container",
          classPrefix: classPrefix,
          disabled: disabled
        }),
        TextInput: classGeneratorBasedOnComponent2({
          component: "TextInput",
          classPrefix: classPrefix,
          disabled: disabled
        }),
        OptionListContainer: classGeneratorBasedOnComponent2({
          component: "OptionListContainer",
          classPrefix: classPrefix,
          disabled: disabled
        }),
        OptionList: classGeneratorBasedOnComponent2({
          component: "OptionList",
          classPrefix: classPrefix,
          disabled: disabled
        }),
        OptionItem: classGeneratorBasedOnComponent2({
          component: "OptionItem",
          classPrefix: classPrefix,
          disabled: disabled
        }),
        ExpansionIndicatorContainer: classGeneratorBasedOnComponent2({
          component: "ExpansionIndicatorContainer",
          classPrefix: classPrefix,
          disabled: disabled
        }),
        ExpansionIndicator: classGeneratorBasedOnComponent2({
          component: "ExpansionIndicator",
          classPrefix: classPrefix,
          disabled: disabled
        })
      };
    }, [classPrefix, className, disabled])
  );
};

// src/components/Dropdown/style.ts
import styled33, { css as css30 } from "styled-components";
import { CancelIcon as CancelIcon3 } from "@deliveryhero/armor-icons";
import { marginProps as marginProps21, widthProps as widthProps8, spacing as spacing24, propsBlocker as propsBlocker32, getComponentOverride as getComponentOverride21, focusWithin as focusWithin2, mouseCursor as mouseCursor5 } from "@deliveryhero/armor-system";

// src/components/TextInput/TextInput.tsx
import React33, { forwardRef as forwardRef21, memo as memo28 } from "react";
import PropTypes15 from "prop-types";

// src/components/TextInput/hooks/useTextInputClassNames.ts
import { useMemo as useMemo36 } from "react";
import { makeBEM as makeBEM22, makeRootClassName as makeRootClassName19 } from "@deliveryhero/armor-system";
var useTextInputClassNames = function useTextInputClassNames(classPrefix, className, disabled, large, error, isLabelInside, outlined) {
  return useMemo36(function () {
    var rootClassNames = makeRootClassName19(classPrefix, className);
    var rootStateClassNames = [];
    if (disabled) {
      rootStateClassNames.push(makeBEM22(classPrefix, "Root", "disabled"));
    }
    if (outlined) {
      rootStateClassNames.push(makeBEM22(classPrefix, "Root", "focus"));
    }
    if (large) {
      rootStateClassNames.push(makeBEM22(classPrefix, "Root", "large"));
    }
    if (error) {
      rootStateClassNames.push(makeBEM22(classPrefix, "Root", "error"));
    }
    var labelClassName = makeBEM22(classPrefix, "Label");
    if (isLabelInside) {
      labelClassName = "".concat(labelClassName, " ").concat(makeBEM22(classPrefix, "Label", "inside"));
    }
    return {
      Root: "".concat(rootClassNames, " ").concat(rootStateClassNames.join(" ")).trim(),
      InnerContainer: makeBEM22(classPrefix, "InnerContainer"),
      Input: makeBEM22(classPrefix, "Input"),
      InputTag: makeBEM22(classPrefix, "InputTag"),
      Label: labelClassName,
      LabelBackground: makeBEM22(classPrefix, "LabelBackground")
    };
  }, [classPrefix, className, disabled, outlined, large, error, isLabelInside]);
};

// src/components/TextInput/style.ts
import styled29, { css as css27 } from "styled-components";
import { color as color11, heightProps, marginProps as marginProps17, widthProps as widthProps5, getComponentOverride as getComponentOverride19, propsBlocker as propsBlocker28, focusWithin, typography as typography13, token as token24, spacing as spacing22, transition as transition12 } from "@deliveryhero/armor-system";
var borderOffsetSpacing = "1px";
var getRootDynamicStyle = function getRootDynamicStyle(props) {
  var displayMode = props.displayMode,
    enableFocusOnRootClick = props.enableFocusOnRootClick;
  var result = css27(_templateObject145 || (_templateObject145 = _taggedTemplateLiteral(["\n        display: ", ";\n    "])), displayMode === "block" ? displayMode : "inline-block");
  if (enableFocusOnRootClick) {
    result = css27(_templateObject146 || (_templateObject146 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: text;\n\n            & > * {\n                cursor: initial;\n            }\n        "])), result);
  }
  return result;
};
var TextInputRoot = styled29.div.withConfig(propsBlocker28)(_templateObject147 || (_templateObject147 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    position: relative;\n    vertical-align: middle;\n    border-radius: ", ";\n    ", ";\n    color: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), token24("control.borderRadius.small", "shape.borderRadius.soft", {
  returnUnit: "px"
}), typography13("desktop.bodyLarge", "paragraphMedium"), token24("text.color.primary", "body.color"), transition12({
  border: true
}), getRootDynamicStyle, getComponentOverride19("TextInput"), marginProps17, widthProps5, heightProps);
var getInputInnerContainerDynamicStyle = function getInputInnerContainerDynamicStyle(props) {
  var enableFocusOnRootClick = props.enableFocusOnRootClick,
    outlined = props.outlined,
    error = props.error,
    disabled = props.disabled,
    multiline = props.multiline;
  var result = css27(_templateObject148 || (_templateObject148 = _taggedTemplateLiteral(["\n        align-items: ", ";\n    "])), multiline ? "unset" : "center");
  if (enableFocusOnRootClick) {
    result = css27(_templateObject149 || (_templateObject149 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: text;\n\n            & > * {\n                cursor: initial;\n            }\n        "])), result);
  }
  if (outlined) {
    result = css27(_templateObject150 || (_templateObject150 = _taggedTemplateLiteral(["\n            ", ";\n            border-color: ", ";\n        "])), result, token24("control.color.primary.hover", "color.primary.07"));
  }
  if (error) {
    result = css27(_templateObject151 || (_templateObject151 = _taggedTemplateLiteral(["\n            ", ";\n            border-color: ", ";\n        "])), result, token24("control.color.danger.enabled", "color.error.08"));
  }
  if (disabled) {
    result = css27(_templateObject152 || (_templateObject152 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n            border-color: ", ";\n        "])), result, token24("control.color.secondary.disabled", "color.neutral.02"), token24("control.color.primary.disabled", "color.neutral.03"));
  }
  return result;
};
var TextInputInnerContainer = styled29.div.withConfig(propsBlocker28)(_templateObject153 || (_templateObject153 = _taggedTemplateLiteral(["\n    display: flex;\n    box-sizing: border-box;\n    background-color: ", ";\n    border: ", "px solid\n        ", ";\n    border-radius: ", ";\n\n    ", ";\n    ", ";\n"])), token24("control.color.secondary.enabled", "color.neutral.00"), token24("control.borderWidth.thin", 1), token24("control.color.primary.enabled", "color.neutral.03"), token24("control.borderRadius.small", "shape.borderRadius.soft", {
  returnUnit: "px"
}), function (_ref49) {
  var error = _ref49.error,
    disabled = _ref49.disabled;
  return focusWithin({
    error: error,
    disabled: disabled,
    noOutline: true
  });
}, getInputInnerContainerDynamicStyle);
var getInputDynamicStyle = function getInputDynamicStyle(props) {
  var multiline = props.multiline,
    disabled = props.disabled,
    large = props.large,
    hasBeforeSection = props.hasBeforeSection,
    hasAfterSection = props.hasAfterSection;
  var result = {};
  if (multiline) {
    result = css27(_templateObject154 || (_templateObject154 = _taggedTemplateLiteral(["\n            ", ";\n            min-width: ", ";\n            min-height: ", ";\n        "])), result, spacing22(25), spacing22(10));
  }
  if (disabled) {
    result = css27(_templateObject155 || (_templateObject155 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: not-allowed;\n        "])), result);
  }
  if (large) {
    result = css27(_templateObject156 || (_templateObject156 = _taggedTemplateLiteral(["\n            ", ";\n            padding: calc(\n                    ", " -\n                        ", "\n                )\n                ", ";\n        "])), result, spacing22("control.spacing.medium", [3]), borderOffsetSpacing, spacing22("control.spacing.large", [4]));
  }
  if (hasBeforeSection) {
    result = css27(_templateObject157 || (_templateObject157 = _taggedTemplateLiteral(["\n            ", ";\n            padding-left: ", ";\n        "])), result, spacing22("control.spacing.medium", [3]));
  }
  if (hasAfterSection) {
    result = css27(_templateObject158 || (_templateObject158 = _taggedTemplateLiteral(["\n            ", ";\n            padding-right: ", ";\n        "])), result, spacing22("control.spacing.medium", [3]));
  }
  return result;
};
var Wrapper3 = function Wrapper3(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var TextInputInput = styled29(Wrapper3).withConfig(propsBlocker28)(_templateObject159 || (_templateObject159 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    border: none;\n    outline: none;\n    appearance: none;\n    flex-grow: 1;\n    margin: 0;\n    background-color: transparent;\n    width: 100%;\n    padding: calc(\n            ", " - ", "\n        )\n        ", ";\n    border-radius: ", ";\n    color: ", ";\n    ", ";\n\n    &::placeholder {\n        color: ", ";\n    }\n\n    &:disabled {\n        color: ", ";\n    }\n\n    ", ";\n"])), spacing22("control.spacing.small", [2]), borderOffsetSpacing, spacing22("control.spacing.large", [4]), token24("control.borderRadius.small", "shape.borderRadius.soft", {
  returnUnit: "px"
}), token24("text.color.primary", "body.color"), typography13("desktop.bodyLarge", "paragraphLarge"), token24("text.color.disabled", "color.neutral.07"), token24("text.color.disabled", "color.neutral.07"), getInputDynamicStyle);
var getLabelDynamicStyle = function getLabelDynamicStyle(props) {
  var isLabelInside = props.isLabelInside,
    large = props.large;
  var result = {};
  if (isLabelInside) {
    result = css27(_templateObject160 || (_templateObject160 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            color: ", ";\n            top: ", ";\n        "])), result, typography13("desktop.bodyLarge", "paragraphMedium"), token24("text.color.disabled", "color.neutral.07"), spacing22(2));
    if (large) {
      result = css27(_templateObject161 || (_templateObject161 = _taggedTemplateLiteral(["\n                ", ";\n                top: ", ";\n            "])), result, spacing22(3));
    }
  }
  return result;
};
var TextInputLabel = styled29.label.withConfig(propsBlocker28)(_templateObject162 || (_templateObject162 = _taggedTemplateLiteral(["\n    position: absolute;\n    text-align: left;\n    overflow-x: hidden;\n    white-space: nowrap;\n    user-select: none;\n    text-overflow: ellipsis;\n    pointer-events: none;\n    ", ";\n    ", ";\n    color: ", ";\n    padding: ", " ", ";\n    top: -", ";\n    ", ";\n"])), transition12({
  top: true,
  "font-size": true,
  color: true
}), typography13("desktop.caption", "labelSmall"), token24("text.color.secondary", "color.neutral.07"), spacing22(0), spacing22("control.spacing.medium", [3]), spacing22(2), getLabelDynamicStyle);
var TextInputFooter = styled29.div.withConfig(propsBlocker28)(_templateObject163 || (_templateObject163 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    margin-top: ", ";\n"])), spacing22("control.spacing.small", [1]));
var TextInputCounter = styled29.div.withConfig(propsBlocker28)(_templateObject164 || (_templateObject164 = _taggedTemplateLiteral(["\n    margin-left: auto;\n    color: ", ";\n    ", ";\n"])), token24("text.color.disabled", "color.neutral.05"), typography13("desktop.bodySmall", "paragraphSmall"));
var getLabelBackgroundDynamicStyle = function getLabelBackgroundDynamicStyle(_ref50) {
  var disabled = _ref50.disabled;
  var result = css27(_templateObject165 || (_templateObject165 = _taggedTemplateLiteral(["\n        background: linear-gradient(\n            0,\n            ", " 88%,\n            transparent 32%\n        );\n        background: ", ";\n    "])), color11("neutral.00"), token24("label.color.enabled"));
  if (disabled) {
    result = css27(_templateObject166 || (_templateObject166 = _taggedTemplateLiteral(["\n            ", ";\n            background: linear-gradient(\n                0,\n                ", " 88%,\n                transparent 32%\n            );\n            background: ", ";\n        "])), result, color11("neutral.02"), token24("label.color.disabled"));
  }
  return result;
};
var TextInputLabelBackground = styled29.span.withConfig(propsBlocker28)(_templateObject167 || (_templateObject167 = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n    ", ";\n"])), spacing22(0), spacing22("control.spacing.xsmall", [1]), getLabelBackgroundDynamicStyle);

// src/components/TextInput/constants.ts
var TEXT_INPUT_CLASS_PREFIX = "TextInput";
var textInputRoot = "TextInputRoot";
var textInputInput = "TextInputInput";
var textInputLabel = "TextInputLabel";
var textInputLabelBackground = "TextInputLabelBackground";

// src/components/TextInput/hooks/useTextInput.ts
import { useCallback as useCallback12, useRef as useRef5, useMemo as useMemo37 } from "react";
import { generateId as generateId2, useRootRef as useRootRef12 } from "@deliveryhero/armor-system";

// src/components/TextInput/hooks/useEvents.ts
import { useCallback as useCallback11, useState as useState4, useEffect as useEffect8 } from "react";
var isControlledMode = function isControlledMode(value) {
  return value !== void 0;
};
var isLabelPositionInside = function isLabelPositionInside(_ref51) {
  var value = _ref51.value,
    placeholder = _ref51.placeholder,
    disableLabelEffect = _ref51.disableLabelEffect,
    isFocused = _ref51.isFocused,
    isEmptyUncontrolled = _ref51.isEmptyUncontrolled;
  if (placeholder || isFocused || disableLabelEffect) {
    return false;
  }
  if (isControlledMode(value)) {
    return !value && value !== 0;
  }
  return isEmptyUncontrolled;
};
var getInitialValueLength = function getInitialValueLength(_ref52) {
  var value = _ref52.value,
    defaultValue = _ref52.defaultValue;
  if (value) {
    return String(value).length;
  }
  if (defaultValue) {
    return String(defaultValue).length;
  }
  return 0;
};
var useEvents = function useEvents(_ref53) {
  var value = _ref53.value,
    defaultValue = _ref53.defaultValue,
    placeholder = _ref53.placeholder,
    disableLabelEffect = _ref53.disableLabelEffect,
    onFocus = _ref53.onFocus,
    onBlur = _ref53.onBlur,
    onMouseOver = _ref53.onMouseOver,
    onMouseOut = _ref53.onMouseOut,
    readOnly = _ref53.readOnly,
    enableCounter = _ref53.enableCounter,
    onChange = _ref53.onChange;
  var _useState11 = useState4(!defaultValue),
    _useState12 = _slicedToArray(_useState11, 2),
    isEmptyUncontrolled = _useState12[0],
    setEmptyUncontrolled = _useState12[1];
  var _useState13 = useState4(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isFocused = _useState14[0],
    setFocused = _useState14[1];
  var _useState15 = useState4(getInitialValueLength({
      value: value,
      defaultValue: defaultValue
    })),
    _useState16 = _slicedToArray(_useState15, 2),
    valueLength = _useState16[0],
    setValueLength = _useState16[1];
  var _useState17 = useState4(isLabelPositionInside({
      value: value,
      placeholder: placeholder,
      disableLabelEffect: disableLabelEffect,
      isFocused: isFocused,
      isEmptyUncontrolled: isEmptyUncontrolled
    })),
    _useState18 = _slicedToArray(_useState17, 2),
    isLabelInside = _useState18[0],
    setLabelInside = _useState18[1];
  var _useState19 = useState4(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isMouseInside = _useState20[0],
    setMouseInside = _useState20[1];
  useEffect8(function () {
    setLabelInside(isLabelPositionInside({
      value: value,
      isFocused: isFocused,
      placeholder: placeholder,
      disableLabelEffect: disableLabelEffect,
      isEmptyUncontrolled: isEmptyUncontrolled
    }));
  }, [value, defaultValue, isFocused, placeholder, disableLabelEffect, isEmptyUncontrolled, readOnly]);
  var onInputChange = useCallback11(function (event) {
    var _a, _b;
    if (onChange) {
      onChange(event);
    }
    if (enableCounter) {
      setValueLength(((_b = (_a = event.target) == null ? void 0 : _a.value) == null ? void 0 : _b.length) || 0);
    }
    if (event.isPropagationStopped()) {
      return;
    }
    if (!isControlledMode(value)) {
      setEmptyUncontrolled(!event.target.value.length);
    }
  }, [onChange, value, enableCounter]);
  var onInputFocus = useCallback11(function (event) {
    setFocused(true);
    if (onFocus) {
      onFocus(event);
    }
  }, [onFocus]);
  var onInputBlur = useCallback11(function (event) {
    setFocused(false);
    if (onBlur) {
      onBlur(event);
    }
  }, [setFocused, onBlur]);
  var onInputMouseOver = useCallback11(function (event) {
    setMouseInside(true);
    if (onMouseOver) {
      onMouseOver(event);
    }
  }, [onMouseOver]);
  var onInputMouseOut = useCallback11(function (event) {
    setMouseInside(false);
    if (onMouseOut) {
      onMouseOut(event);
    }
  }, [onMouseOut]);
  return {
    isMouseInside: isMouseInside,
    isLabelInside: isLabelInside,
    isFocused: isFocused,
    valueLength: valueLength,
    onInputMouseOver: onInputMouseOver,
    onInputMouseOut: onInputMouseOut,
    onInputFocus: onInputFocus,
    onInputBlur: onInputBlur,
    onInputChange: onInputChange
  };
};

// src/components/TextInput/hooks/useTextInput.ts
var useTextInput = function useTextInput(_a, ref) {
  var _b = _a,
    label = _b.label,
    before = _b.before,
    after = _b.after,
    disableLabelEffect = _b.disableLabelEffect,
    multiline = _b.multiline,
    onMouseOut = _b.onMouseOut,
    onMouseOver = _b.onMouseOver,
    outlined = _b.outlined,
    error = _b.error,
    large = _b.large,
    enableFocusOnRootClick = _b.enableFocusOnRootClick,
    enableRootRef = _b.enableRootRef,
    onRootClick = _b.onRootClick,
    baseId = _b.id,
    autoComplete = _b.autoComplete,
    autoFocus = _b.autoFocus,
    defaultValue = _b.defaultValue,
    disabled = _b.disabled,
    name = _b.name,
    placeholder = _b.placeholder,
    readOnly = _b.readOnly,
    rows = _b.rows,
    value = _b.value,
    onClick = _b.onClick,
    onKeyDown = _b.onKeyDown,
    onKeyUp = _b.onKeyUp,
    onFocus = _b.onFocus,
    onBlur = _b.onBlur,
    onChange = _b.onChange,
    type = _b.type,
    max = _b.max,
    maxLength = _b.maxLength,
    min = _b.min,
    minLength = _b.minLength,
    tabIndex = _b.tabIndex,
    required = _b.required,
    dataTestIdInput = _b["data-testid-input"],
    step = _b.step,
    enableCounter = _b.enableCounter,
    restRootProps = __objRest(_b, ["label", "before", "after", "disableLabelEffect", "multiline", "onMouseOut", "onMouseOver", "outlined", "error", "large", "enableFocusOnRootClick", "enableRootRef", "onRootClick",
    // input-specific props need to be passed to Input component instead
    "id", "autoComplete", "autoFocus", "defaultValue", "disabled", "name", "placeholder", "readOnly", "rows", "value", "onClick", "onKeyDown", "onKeyUp", "onFocus", "onBlur", "onChange", "type", "max", "maxLength", "min", "minLength", "tabIndex", "required", "data-testid-input", "step", "enableCounter"]);
  var id = useMemo37(function () {
    return baseId != null ? baseId : generateId2(void 0, "field-");
  }, [baseId]);
  var _useEvents = useEvents({
      value: value,
      defaultValue: defaultValue,
      placeholder: placeholder,
      disableLabelEffect: disableLabelEffect,
      onFocus: onFocus,
      onBlur: onBlur,
      onMouseOut: onMouseOut,
      onMouseOver: onMouseOver,
      onChange: onChange,
      readOnly: readOnly,
      enableCounter: enableCounter
    }),
    isMouseInside = _useEvents.isMouseInside,
    isLabelInside = _useEvents.isLabelInside,
    isFocused = _useEvents.isFocused,
    valueLength = _useEvents.valueLength,
    onInputMouseOver = _useEvents.onInputMouseOver,
    onInputMouseOut = _useEvents.onInputMouseOut,
    onInputFocus = _useEvents.onInputFocus,
    onInputBlur = _useEvents.onInputBlur,
    onInputChange = _useEvents.onInputChange;
  var internalInputRef = useRootRef12(enableRootRef ? null : ref);
  var rootRef = useRootRef12(enableRootRef ? ref : null);
  var innerContainerRef = useRef5(null);
  var onRootNodeClick = useCallback12(function (event) {
    var _a2;
    if (!enableFocusOnRootClick) {
      return;
    }
    onRootClick == null ? void 0 : onRootClick(event);
    if (event.target !== rootRef.current && event.target !== innerContainerRef.current) {
      return;
    }
    (_a2 = internalInputRef.current) == null ? void 0 : _a2.focus();
  }, [enableFocusOnRootClick, onRootClick, rootRef, internalInputRef]);
  var Tag3 = multiline ? "textarea" : "input";
  var isOutlined = isMouseInside || isFocused || outlined;
  return {
    rootProps: __spreadProps(__spreadValues({}, restRootProps), {
      onClick: onRootNodeClick,
      ref: rootRef,
      error: error,
      multiline: multiline,
      onMouseOver: onInputMouseOver,
      onMouseOut: onInputMouseOut,
      outlined: isOutlined,
      disabled: disabled,
      enableFocusOnRootClick: enableFocusOnRootClick
    }),
    innerContainerProps: {
      multiline: multiline,
      error: error,
      enableFocusOnRootClick: enableFocusOnRootClick,
      outlined: isOutlined,
      disabled: disabled,
      ref: innerContainerRef
    },
    inputProps: {
      // native
      id: id,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      defaultValue: defaultValue,
      disabled: disabled,
      name: name,
      placeholder: placeholder,
      readOnly: readOnly,
      rows: rows,
      value: value,
      onClick: onClick,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp,
      max: max,
      maxLength: maxLength,
      min: min,
      minLength: minLength,
      tabIndex: tabIndex,
      required: required,
      "data-testid": dataTestIdInput || textInputInput,
      step: step,
      // custom
      multiline: multiline,
      large: large,
      type: multiline ? void 0 : type,
      onBlur: onInputBlur,
      onFocus: onInputFocus,
      onChange: onInputChange,
      hasBeforeSection: !!before,
      hasAfterSection: !!after
    },
    inputLabelProps: {
      disabled: disabled,
      error: error,
      isLabelInside: isLabelInside,
      large: large,
      outlined: isOutlined,
      value: value,
      defaultValue: defaultValue,
      type: type,
      htmlFor: id
    },
    inputLabelBackgroundProps: {
      disabled: disabled
    },
    isLabelInside: isLabelInside,
    Tag: Tag3,
    before: before,
    after: after,
    disabled: disabled,
    outlined: isOutlined,
    large: large,
    label: label,
    error: error,
    internalInputRef: internalInputRef,
    enableCounter: enableCounter,
    valueLength: valueLength
  };
};

// src/components/TextInput/TextInput.tsx
var TextInput = forwardRef21(function TextInput2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var _useTextInput = useTextInput(restProps, ref),
    rootProps = _useTextInput.rootProps,
    innerContainerProps = _useTextInput.innerContainerProps,
    inputProps = _useTextInput.inputProps,
    inputLabelProps = _useTextInput.inputLabelProps,
    inputLabelBackgroundProps = _useTextInput.inputLabelBackgroundProps,
    Tag3 = _useTextInput.Tag,
    before = _useTextInput.before,
    after = _useTextInput.after,
    label = _useTextInput.label,
    isLabelInside = _useTextInput.isLabelInside,
    disabled = _useTextInput.disabled,
    outlined = _useTextInput.outlined,
    large = _useTextInput.large,
    error = _useTextInput.error,
    internalInputRef = _useTextInput.internalInputRef,
    enableCounter = _useTextInput.enableCounter,
    valueLength = _useTextInput.valueLength;
  var classNameComponents = useTextInputClassNames(TEXT_INPUT_CLASS_PREFIX, className, disabled, large, error, isLabelInside, outlined);
  return /* @__PURE__ */React33.createElement(TextInputRoot, __spreadProps(__spreadValues({
    "data-testid": textInputRoot
  }, rootProps), {
    className: classNameComponents.Root
  }), /* @__PURE__ */React33.createElement(TextInputInnerContainer, __spreadProps(__spreadValues({}, innerContainerProps), {
    className: classNameComponents.InnerContainer
  }), before, /* @__PURE__ */React33.createElement(TextInputInput, __spreadProps(__spreadValues({}, inputProps), {
    className: classNameComponents.Input
  }), function (forwardedProps) {
    return (
      // @ts-ignore
      /* @__PURE__ */
      React33.createElement(Tag3, __spreadProps(__spreadValues({}, forwardedProps), {
        ref: internalInputRef
      }))
    );
  }), after), !!label && /* @__PURE__ */React33.createElement(TextInputLabel, __spreadProps(__spreadValues({
    "data-testid": textInputLabel
  }, inputLabelProps), {
    className: classNameComponents.Label
  }), /* @__PURE__ */React33.createElement(TextInputLabelBackground, __spreadProps(__spreadValues({
    "data-testid": textInputLabelBackground
  }, inputLabelBackgroundProps), {
    className: classNameComponents.LabelBackground
  }), label)), enableCounter && /* @__PURE__ */React33.createElement(TextInputFooter, null, /* @__PURE__ */React33.createElement(TextInputCounter, null, "".concat(valueLength).concat(inputProps.maxLength ? "/".concat(inputProps.maxLength) : ""))));
});
TextInput.defaultProps = {
  label: "",
  disableLabelEffect: false,
  multiline: false,
  error: false,
  large: false,
  outlined: false,
  enableFocusOnRootClick: false,
  onChange: function onChange() {},
  type: "text"
};
TextInput.propTypes = {
  /** Label text */
  label: PropTypes15.string,
  /** Controls displayed before the input field */
  before: PropTypes15.oneOfType([PropTypes15.arrayOf(PropTypes15.element), PropTypes15.element]),
  /** Controls displayed after the input field */
  after: PropTypes15.oneOfType([PropTypes15.arrayOf(PropTypes15.element), PropTypes15.element]),
  /** Don't animate label */
  disableLabelEffect: PropTypes15.bool,
  /** Use textarea instead of input */
  multiline: PropTypes15.bool,
  /** Set component state to "errored" */
  error: PropTypes15.bool,
  /** Increase vertical size */
  large: PropTypes15.bool,
  outlined: PropTypes15.bool
};
var MemoizedTextInput = memo28(TextInput);

// src/components/TextInput/TextInputAction/TextInputAction.tsx
import React34, { memo as memo29 } from "react";
import PropTypes16 from "prop-types";

// src/components/TextInput/TextInputAction/hooks/useTextInputActionClassNames.ts
import { useMemo as useMemo38 } from "react";
import { makeRootClassName as makeRootClassName20 } from "@deliveryhero/armor-system";
var useTextInputActionClassNames = function useTextInputActionClassNames(classPrefix, className) {
  return useMemo38(function () {
    return {
      Root: makeRootClassName20(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/TextInput/TextInputAction/style.ts
import styled30 from "styled-components";
import { marginProps as marginProps18, propsBlocker as propsBlocker29, focus as focus5, color as color12, typography as typography14, mouseCursor as mouseCursor4 } from "@deliveryhero/armor-system";
var Wrapper4 = function Wrapper4(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var TextInputActionRoot = styled30(Wrapper4).withConfig(propsBlocker29)(_templateObject168 || (_templateObject168 = _taggedTemplateLiteral(["\n    display: inline-block;\n    color: ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), color12("primary.main"), typography14("paragraphMedium"), focus5(), mouseCursor4, marginProps18);

// src/components/TextInput/TextInputAction/constants.ts
var TEXT_INPUT_ACTION_CLASS_PREFIX = "TextInputAction";

// src/components/TextInput/TextInputAction/TextInputAction.tsx
var TextInputAction = function TextInputAction(_a) {
  var _b = _a,
    className = _b.className,
    _b$tag2 = _b.tag,
    Tag3 = _b$tag2 === void 0 ? "div" : _b$tag2,
    children = _b.children,
    restProps = __objRest(_b, ["className", "tag", "children"]);
  var classNameComponents = useTextInputActionClassNames(TEXT_INPUT_ACTION_CLASS_PREFIX, className);
  return /* @__PURE__ */React34.createElement(TextInputActionRoot, __spreadProps(__spreadValues({}, restProps), {
    tabIndex: 0,
    className: classNameComponents.Root
  }), function (forwardedProps) {
    return /* @__PURE__ */React34.createElement(Tag3, __spreadValues({}, forwardedProps), children);
  });
};
TextInputAction.defaultProps = {
  tag: "div"
};
TextInputAction.propTypes = {
  tag: PropTypes16.oneOfType([PropTypes16.elementType, PropTypes16.string])
};
var MemoizedTextInputAction = memo29(TextInputAction);

// src/components/Pack/Pack.tsx
import React37, { forwardRef as forwardRef24, memo as memo32 } from "react";
import PropTypes19 from "prop-types";

// src/components/Pack/hooks/usePackClassName.ts
import { useMemo as useMemo39 } from "react";
import { appendClassName as appendClassName10, makeBEM as makeBEM23 } from "@deliveryhero/armor-system";
var getClassNameByComponent2 = function getClassNameByComponent2(_ref54) {
  var component = _ref54.component,
    classPrefix = _ref54.classPrefix;
  var baseClassNames = makeBEM23(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var usePackClassName = function usePackClassName(classPrefix, className) {
  return useMemo39(function () {
    return {
      Root: appendClassName10(getClassNameByComponent2({
        component: "Root",
        classPrefix: classPrefix
      }), className)
    };
  }, [classPrefix, className]);
};
var usePackClassName_default = usePackClassName;

// src/components/Pack/hooks/usePackItemClassName.ts
import { useMemo as useMemo40 } from "react";
import { appendClassName as appendClassName11, makeBEM as makeBEM24 } from "@deliveryhero/armor-system";
var getClassNameByComponent3 = function getClassNameByComponent3(_ref55) {
  var component = _ref55.component,
    classPrefix = _ref55.classPrefix;
  var baseClassNames = makeBEM24(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var usePackItemClassName = function usePackItemClassName(classPrefix, className) {
  return useMemo40(function () {
    return {
      Root: appendClassName11(getClassNameByComponent3({
        component: "Root",
        classPrefix: classPrefix
      }), className)
    };
  }, [classPrefix, className]);
};
var usePackItemClassName_default = usePackItemClassName;

// src/components/Pack/constants.ts
var PACK_CLASS_PREFIX = "Pack";
var PACK_ITEM_CLASS_PREFIX = "PackItem";
var packRoot = "PackRoot";
var packItemRoot = "PackItemRoot";

// src/components/Flex/Flex.tsx
import React35, { forwardRef as forwardRef22, memo as memo30 } from "react";
import PropTypes17 from "prop-types";

// src/components/Flex/utils/useFlexClassName.ts
import { useMemo as useMemo41 } from "react";
import { makeRootClassName as makeRootClassName21 } from "@deliveryhero/armor-system";
var useFlexClassName = function useFlexClassName(classPrefix, className) {
  return useMemo41(function () {
    return {
      Root: makeRootClassName21(classPrefix, className)
    };
  }, [classPrefix, className]);
};
var useFlexClassName_default = useFlexClassName;

// src/components/Flex/utils/useFlexItemClassName.ts
import { useMemo as useMemo42 } from "react";
import { makeRootClassName as makeRootClassName22 } from "@deliveryhero/armor-system";
var useFlexClassName2 = function useFlexClassName2(classPrefix, className) {
  return useMemo42(function () {
    return {
      Root: makeRootClassName22(classPrefix, className)
    };
  }, [classPrefix, className]);
};
var useFlexItemClassName_default = useFlexClassName2;

// src/components/Flex/constants.ts
var FLEX_CLASS_PREFIX = "Flex";
var FLEX_ITEM_CLASS_PREFIX = "FlexItem";
var flexRoot = "FlexRoot";
var flexItemRoot = "FlexItemRoot";

// src/components/Flex/style.ts
import styled31, { css as css28 } from "styled-components";
import { heightProps as heightProps2, marginProps as marginProps19, paddingProps as paddingProps13, sizeProps as sizeProps6, widthProps as widthProps6, propsBlocker as propsBlocker30, gutter } from "@deliveryhero/armor-system";
var flexRootStyle = function flexRootStyle(_ref56) {
  var direction = _ref56.direction,
    justifyContent = _ref56.justifyContent,
    alignContent = _ref56.alignContent,
    alignItems = _ref56.alignItems,
    flexWrap = _ref56.flexWrap,
    gutterSpacing = _ref56.gutterSpacing;
  var result = {};
  if (direction) {
    result = css28(_templateObject169 || (_templateObject169 = _taggedTemplateLiteral(["\n            ", ";\n            flex-direction: ", ";\n        "])), result, direction);
  }
  if (justifyContent) {
    result = css28(_templateObject170 || (_templateObject170 = _taggedTemplateLiteral(["\n            ", ";\n            justify-content: ", ";\n        "])), result, justifyContent);
  }
  if (alignContent) {
    result = css28(_templateObject171 || (_templateObject171 = _taggedTemplateLiteral(["\n            ", ";\n            align-content: ", ";\n        "])), result, alignContent);
  }
  if (flexWrap) {
    result = css28(_templateObject172 || (_templateObject172 = _taggedTemplateLiteral(["\n            ", ";\n            flex-wrap: ", ";\n        "])), result, flexWrap);
  }
  if (alignItems) {
    result = css28(_templateObject173 || (_templateObject173 = _taggedTemplateLiteral(["\n            ", ";\n            align-items: ", ";\n        "])), result, alignItems);
  }
  if (gutterSpacing) {
    result = css28(_templateObject174 || (_templateObject174 = _taggedTemplateLiteral(["\n            ", ";\n            && {\n                ", ";\n            }\n        "])), result, gutter({
      spacing: gutterSpacing
    }));
  }
  return result;
};
var flexItemStyle = function flexItemStyle(_ref57) {
  var flexGrow = _ref57.flexGrow,
    flexShrink = _ref57.flexShrink,
    flexBasis = _ref57.flexBasis,
    order = _ref57.order,
    alignSelf = _ref57.alignSelf;
  var result = {};
  if (typeof flexGrow !== "undefined") {
    result = css28(_templateObject175 || (_templateObject175 = _taggedTemplateLiteral(["\n            ", ";\n            flex-grow: ", ";\n        "])), result, flexGrow);
  }
  if (typeof flexShrink !== "undefined") {
    result = css28(_templateObject176 || (_templateObject176 = _taggedTemplateLiteral(["\n            ", ";\n            flex-shrink: ", ";\n        "])), result, flexShrink);
  }
  if (typeof flexBasis !== "undefined") {
    result = css28(_templateObject177 || (_templateObject177 = _taggedTemplateLiteral(["\n            ", ";\n            flex-basis: ", ";\n        "])), result, flexBasis);
  }
  if (typeof order !== "undefined") {
    result = css28(_templateObject178 || (_templateObject178 = _taggedTemplateLiteral(["\n            ", ";\n            order: ", ";\n        "])), result, order);
  }
  if (alignSelf) {
    result = css28(_templateObject179 || (_templateObject179 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: ", ";\n        "])), result, alignSelf);
  }
  return result;
};
var FlexRoot = styled31.div.withConfig(propsBlocker30)(_templateObject180 || (_templateObject180 = _taggedTemplateLiteral(["\n    display: flex;\n\n    ", ";\n    ", ";\n    ", ";\n"])), flexRootStyle, sizeProps6, marginProps19);
var FlexItemRoot = styled31.div.withConfig(propsBlocker30)(_templateObject181 || (_templateObject181 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), flexItemStyle, paddingProps13, heightProps2, widthProps6, marginProps19);

// src/components/Flex/Flex.tsx
var Flex = forwardRef22(function Flex2(_a, ref) {
  var _b = _a,
    className = _b.className,
    direction = _b.direction,
    justifyContent = _b.justifyContent,
    alignContent = _b.alignContent,
    alignItems = _b.alignItems,
    flexWrap = _b.flexWrap,
    restProps = __objRest(_b, ["className", "direction", "justifyContent", "alignContent", "alignItems", "flexWrap"]);
  var classOverride = useFlexClassName_default(FLEX_CLASS_PREFIX, className);
  return /* @__PURE__ */React35.createElement(FlexRoot, __spreadProps(__spreadValues({
    "data-testid": flexRoot
  }, restProps), {
    className: classOverride.Root,
    direction: direction,
    flexWrap: flexWrap,
    justifyContent: justifyContent,
    alignContent: alignContent,
    ref: ref,
    alignItems: alignItems
  }));
});
Flex.defaultProps = {
  direction: "row",
  flexWrap: "nowrap"
};
Flex.propTypes = {
  direction: PropTypes17.oneOf(["row", "row-reverse", "column", "column-reverse"]),
  justifyContent: PropTypes17.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly", "start", "end", "left", "right"]),
  alignContent: PropTypes17.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly", "start", "end", "stretch", "baseline", "first baseline", "last baseline"]),
  alignItems: PropTypes17.oneOf(["stretch", "flex-start", "flex-end", "center", "baseline", "first baseline", "last baseline", "start", "end", "self-start", "self-end"]),
  flexWrap: PropTypes17.oneOf(["nowrap", "wrap", "wrap-reverse"])
};
var MemoizedFlex = memo30(Flex);

// src/components/Flex/FlexItem.tsx
import React36, { forwardRef as forwardRef23, memo as memo31 } from "react";
import PropTypes18 from "prop-types";
var FlexItem = forwardRef23(function FlexItem2(_a, ref) {
  var _b = _a,
    className = _b.className,
    flexGrow = _b.flexGrow,
    flexShrink = _b.flexShrink,
    flexBasis = _b.flexBasis,
    alignSelf = _b.alignSelf,
    order = _b.order,
    restProps = __objRest(_b, ["className", "flexGrow", "flexShrink", "flexBasis", "alignSelf", "order"]);
  var classOverride = useFlexItemClassName_default(FLEX_ITEM_CLASS_PREFIX, className);
  return /* @__PURE__ */React36.createElement(FlexItemRoot, __spreadProps(__spreadValues({
    "data-testid": flexItemRoot
  }, restProps), {
    className: classOverride.Root,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    flexBasis: flexBasis,
    alignSelf: alignSelf,
    order: order,
    ref: ref
  }));
});
FlexItem.defaultProps = {};
FlexItem.propTypes = {
  flexGrow: PropTypes18.number,
  flexShrink: PropTypes18.number,
  flexBasis: PropTypes18.string,
  order: PropTypes18.number,
  alignSelf: PropTypes18.oneOf(["auto", "flex-start", "flex-end", "center", "baseline", "stretch"])
};
var MemoizedFlexItem = memo31(FlexItem);

// src/components/Pack/Pack.tsx
var Pack = forwardRef24(function Pack2(_a, ref) {
  var _b = _a,
    className = _b.className,
    reverse = _b.reverse,
    justifyContent = _b.justifyContent,
    alignItems = _b.alignItems,
    flexWrap = _b.flexWrap,
    restProps = __objRest(_b, ["className", "reverse", "justifyContent", "alignItems", "flexWrap"]);
  var classOverride = usePackClassName_default(PACK_CLASS_PREFIX, className);
  return /* @__PURE__ */React37.createElement(Flex, __spreadProps(__spreadValues({
    "data-testid": packRoot
  }, restProps), {
    className: classOverride.Root,
    direction: reverse ? "row-reverse" : "row",
    flexWrap: flexWrap,
    justifyContent: justifyContent,
    ref: ref,
    alignItems: alignItems
  }));
});
Pack.defaultProps = {
  flexWrap: "nowrap"
};
Pack.propTypes = {
  reverse: PropTypes19.bool,
  justifyContent: PropTypes19.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly", "start", "end", "left", "right"]),
  alignItems: PropTypes19.oneOf(["stretch", "flex-start", "flex-end", "center", "baseline", "first baseline", "last baseline", "start", "end", "self-start", "self-end"]),
  flexWrap: PropTypes19.oneOf(["nowrap", "wrap", "wrap-reverse"])
};
var MemoizedPack = memo32(Pack);

// src/components/Pack/PackItem.tsx
import React38, { forwardRef as forwardRef25, memo as memo33 } from "react";
import PropTypes20 from "prop-types";
var PackItem = forwardRef25(function PackItem2(_a, ref) {
  var _b = _a,
    className = _b.className,
    flexGrow = _b.flexGrow,
    flexShrink = _b.flexShrink,
    flexBasis = _b.flexBasis,
    alignSelf = _b.alignSelf,
    order = _b.order,
    restProps = __objRest(_b, ["className", "flexGrow", "flexShrink", "flexBasis", "alignSelf", "order"]);
  var classOverride = usePackItemClassName_default(PACK_ITEM_CLASS_PREFIX, className);
  return /* @__PURE__ */React38.createElement(FlexItem, __spreadProps(__spreadValues({
    "data-testid": packItemRoot
  }, restProps), {
    className: classOverride.Root,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    flexBasis: flexBasis,
    alignSelf: alignSelf,
    order: order,
    ref: ref
  }));
});
PackItem.defaultProps = {};
PackItem.propTypes = {
  flexGrow: PropTypes20.number,
  flexShrink: PropTypes20.number,
  flexBasis: PropTypes20.string,
  order: PropTypes20.number,
  alignSelf: PropTypes20.oneOf(["auto", "flex-start", "flex-end", "center", "baseline", "stretch"])
};
var MemoizedPackItem = memo33(PackItem);

// src/components/Tag/Tag.tsx
import React39, { forwardRef as forwardRef26, memo as memo34 } from "react";
import PropTypes21 from "prop-types";

// src/components/Tag/constants.ts
var TAG_CLASS_PREFIX = "Tag";
var TAG_TYPES = {
  DEFAULT: "default",
  APPROVED: "approved",
  DENIED: "denied",
  NEW: "new",
  ON_HOLD: "on-hold"
};
var TAG_DELETE_BEHAVIOUR_OPTIONS = {
  ENABLED: "enabled",
  DISABLED: "disabled",
  ON_HOVER: "onHover"
};
var TAG_STATUS_LABELS = {
  APPROVED: "Approved",
  DENIED: "Denied",
  NEW: "New",
  ON_HOLD: "On Hold"
};
var TAG_CLEAR_BUTTON_PROPS_MAP = (_TAG_CLEAR_BUTTON_PRO = {}, _defineProperty(_TAG_CLEAR_BUTTON_PRO, TAG_DELETE_BEHAVIOUR_OPTIONS.ENABLED, {
  type: "thin",
  iconSize: "small"
}), _defineProperty(_TAG_CLEAR_BUTTON_PRO, TAG_DELETE_BEHAVIOUR_OPTIONS.ON_HOVER, {
  type: "circle-filled",
  iconSize: "large"
}), _TAG_CLEAR_BUTTON_PRO);
var tagRoot = "TagRoot";
var tagCloseIconContainer = "TagCloseIconContainer";

// src/components/Tag/utils/isStatusTag.ts
var isStatusTag = function isStatusTag(type) {
  return !!type && [TAG_TYPES.APPROVED, TAG_TYPES.DENIED, TAG_TYPES.NEW, TAG_TYPES.ON_HOLD].includes(type);
};
var isStatusTag_default = isStatusTag;

// src/components/Tag/utils/getStatusTagLabel.ts
var getStatusTagLabel = function getStatusTagLabel(type) {
  switch (type) {
    case TAG_TYPES.APPROVED:
      return TAG_STATUS_LABELS.APPROVED;
    case TAG_TYPES.DENIED:
      return TAG_STATUS_LABELS.DENIED;
    case TAG_TYPES.NEW:
      return TAG_STATUS_LABELS.NEW;
    case TAG_TYPES.ON_HOLD:
      return TAG_STATUS_LABELS.ON_HOLD;
    default:
      return void 0;
  }
};
var getStatusTagLabel_default = getStatusTagLabel;

// src/components/Tag/utils/useTagClassName.ts
import { useMemo as useMemo43 } from "react";
import { appendClassName as appendClassName12, makeBEM as makeBEM25 } from "@deliveryhero/armor-system";
var getClassNameByComponent4 = function getClassNameByComponent4(_ref58) {
  var component = _ref58.component,
    classPrefix = _ref58.classPrefix,
    deleteOption = _ref58.deleteOption,
    type = _ref58.type,
    small = _ref58.small,
    filled = _ref58.filled;
  var baseClassNames = makeBEM25(classPrefix, component);
  var stateClassNames = [];
  if (type) {
    stateClassNames.push(makeBEM25(classPrefix, component, type));
  }
  if (filled) {
    stateClassNames.push(makeBEM25(classPrefix, component, "filled"));
  }
  if (small) {
    stateClassNames.push(makeBEM25(classPrefix, component, "small"));
  }
  if (deleteOption && !isStatusTag_default(type)) {
    stateClassNames.push(makeBEM25(classPrefix, component, "delete"));
    stateClassNames.push(makeBEM25(classPrefix, component, deleteOption));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useTagClassName = function useTagClassName(classPrefix, className, deleteOption, type, small, filled) {
  return useMemo43(function () {
    return {
      Root: appendClassName12(getClassNameByComponent4({
        component: "Root",
        classPrefix: classPrefix,
        deleteOption: deleteOption,
        type: type,
        small: small,
        filled: filled
      }), className),
      Label: getClassNameByComponent4({
        component: "Label",
        classPrefix: classPrefix,
        deleteOption: deleteOption,
        type: type,
        small: small,
        filled: filled
      }),
      CloseIconContainer: getClassNameByComponent4({
        component: "CloseIconContainer",
        classPrefix: classPrefix,
        deleteOption: deleteOption,
        type: type,
        small: small,
        filled: filled
      }),
      CloseIcon: getClassNameByComponent4({
        component: "CloseIcon",
        classPrefix: classPrefix,
        deleteOption: deleteOption,
        type: type,
        small: small,
        filled: filled
      }),
      Indicator: getClassNameByComponent4({
        component: "Indicator",
        classPrefix: classPrefix
      }),
      Icon: getClassNameByComponent4({
        component: "Icon",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, deleteOption, type, small, filled, className]);
};
var useTagClassName_default = useTagClassName;

// src/components/Tag/style.ts
import styled32, { css as css29 } from "styled-components";
import { color as color13, getComponentOverride as getComponentOverride20, marginProps as marginProps20, propsBlocker as propsBlocker31, reset as reset11, spacing as spacing23, typography as typography15, transition as transition13, token as token25, widthProps as widthProps7, ellipsis } from "@deliveryhero/armor-system";
var TagText = styled32.div(_templateObject182 || (_templateObject182 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    ", ";\n"])), typography15("desktop.bodySmall", "paragraphSmall"), token25("text.color.primary", "body.color"), ellipsis);
var tagIndicatorSpacing = function tagIndicatorSpacing(_ref59) {
  var small = _ref59.small;
  var result = css29(_templateObject183 || (_templateObject183 = _taggedTemplateLiteral(["\n        margin-top: ", ";\n        margin-bottom: ", ";\n        margin-right: ", ";\n    "])), spacing23("control.spacing.xsmall", [1]), spacing23("control.spacing.xsmall", [1]), spacing23("control.spacing.small", [2]));
  if (small) {
    result = css29(_templateObject184 || (_templateObject184 = _taggedTemplateLiteral(["\n            ", ";\n            margin-top: ", ";\n            margin-bottom: ", ";\n        "])), result, spacing23("control.spacing.tiny", [0.5]), spacing23("control.spacing.tiny", [0.5]));
  }
  return result;
};
var TagIndicatorContainer = styled32.div(_templateObject185 || (_templateObject185 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-right: ", ";\n    padding-left: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    border-radius: ", ";\n    color: ", ";\n    ", ";\n    ", ";\n"])), spacing23("control.spacing.xsmall", [1]), spacing23("control.spacing.xsmall", [1]), spacing23("control.spacing.tiny", [0]), spacing23("control.spacing.tiny", [0]), token25("action.borderRadius.pill", "shape.borderRadius.pill", {
  returnUnit: "px"
}), token25("text.color.onsuccess", "color.neutral.11"), typography15("desktop.caption", "paragraphSmall"), tagIndicatorSpacing);
var tagIconSpacing = function tagIconSpacing(_ref60) {
  var small = _ref60.small;
  return css29(_templateObject186 || (_templateObject186 = _taggedTemplateLiteral(["\n        font-size: 12px;\n        margin: ", ";\n        margin-left: ", ";\n    "])), spacing23("control.spacing.xsmall", [1]), spacing23(0));
};
var tagIconColor = function tagIconColor(_ref61) {
  var disabled = _ref61.disabled;
  var iconColorToken = "icon.color.onsuccess";
  if (disabled) {
    iconColorToken = "icon.color.disabled";
  }
  return css29(_templateObject187 || (_templateObject187 = _taggedTemplateLiteral(["\n        color: ", ";\n\n        & svg {\n            color: ", ";\n        }\n    "])), token25(iconColorToken, "color.neutral.11"), token25(iconColorToken, "color.neutral.11"));
};
var TagIconContainer = styled32.div(_templateObject188 || (_templateObject188 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", ";\n    ", ";\n"])), tagIconColor, tagIconSpacing);
var statusTextColor = css29(_templateObject189 || (_templateObject189 = _taggedTemplateLiteral(["\n    ", " {\n        color: ", ";\n    }\n"])), TagText, token25("text.color.onsuccess", "body.color"));
var getRootStyle10 = function getRootStyle10(_ref62) {
  var deleteOption = _ref62.deleteOption,
    type = _ref62.type,
    small = _ref62.small,
    enableContentWrapping = _ref62.enableContentWrapping,
    filled = _ref62.filled,
    icon = _ref62.icon,
    indicator = _ref62.indicator,
    disabled = _ref62.disabled;
  var result = css29(_templateObject190 || (_templateObject190 = _taggedTemplateLiteral(["\n        height: calc(\n            ", " +\n                ", "\n        );\n        padding: ", ";\n    "])), spacing23("control.sizing.tiny", [6]), spacing23("control.spacing.xsmall", [1]), spacing23("control.spacing.xsmall", "control.spacing.medium", [1, 3]));
  if (small) {
    result = css29(_templateObject191 || (_templateObject191 = _taggedTemplateLiteral(["\n            ", ";\n            height: ", ";\n            padding: ", ";\n        "])), result, spacing23("control.sizing.tiny", [6]), spacing23("control.spacing.tiny", "control.spacing.small", [0.5, 2]));
  }
  if (enableContentWrapping === false) {
    result = css29(_templateObject192 || (_templateObject192 = _taggedTemplateLiteral(["\n            ", ";\n            overflow-y: visible;\n            white-space: nowrap;\n        "])), result);
  }
  if (disabled) {
    var backgroundColor = token25("feedback.color.disabled.low", "color.neutral.03", {
      opacity: 0.4
    });
    var textColor = token25("text.color.disabled", "color.neutral.07");
    result = css29(_templateObject193 || (_templateObject193 = _taggedTemplateLiteral(["\n            ", ";\n\n            && {\n                background-color: ", ";\n                border-color: ", ";\n                color: ", ";\n\n                ", ",\n                ", " {\n                    color: ", ";\n                }\n\n                ", " {\n                    color: ", ";\n                    background-color: ", ";\n                }\n            }\n        "])), result, backgroundColor, backgroundColor, textColor, TagText, TagIconContainer, textColor, TagIndicatorContainer, textColor, token25("base.color.lowest", "white"));
  }
  if (indicator && type !== "default") {
    result = css29(_templateObject194 || (_templateObject194 = _taggedTemplateLiteral(["\n            ", ";\n            padding-left: ", ";\n        "])), result, spacing23("control.spacing.xsmall", [1]));
    if (small) {
      result = css29(_templateObject195 || (_templateObject195 = _taggedTemplateLiteral(["\n                ", ";\n                padding-left: ", ";\n            "])), result, spacing23("control.spacing.tiny", [0.5]));
    }
  }
  if (icon) {
    result = css29(_templateObject196 || (_templateObject196 = _taggedTemplateLiteral(["\n            ", ";\n            padding-left: ", ";\n        "])), result, spacing23("control.spacing.xsmall", [1]));
  }
  switch (type) {
    case TAG_TYPES.APPROVED:
      return css29(_templateObject197 || (_templateObject197 = _taggedTemplateLiteral(["\n                ", ";\n                border: none;\n                background-color: ", ";\n                ", ";\n\n                ", " {\n                    background-color: ", ";\n                }\n            "])), result, token25("feedback.color.success.low", "color.success.light"), statusTextColor, TagIndicatorContainer, token25("feedback.color.success.high", "white"));
    case TAG_TYPES.DENIED:
      return css29(_templateObject198 || (_templateObject198 = _taggedTemplateLiteral(["\n                ", ";\n                border: none;\n                background-color: ", ";\n                ", ";\n\n                ", " {\n                    background-color: ", ";\n                    color: ", ";\n                }\n            "])), result, token25("feedback.color.danger.low", "color.error.lighter"), statusTextColor, TagIndicatorContainer, token25("feedback.color.danger.high", "white"), token25("text.color.ondanger", "body.color"));
    case TAG_TYPES.NEW:
      return css29(_templateObject199 || (_templateObject199 = _taggedTemplateLiteral(["\n                ", ";\n                border: none;\n                background-color: ", ";\n                ", ";\n\n                ", " {\n                    background-color: ", ";\n                }\n            "])), result, token25("feedback.color.warning.low", "color.warning.light"), statusTextColor, TagIndicatorContainer, token25("feedback.color.warning.high", "white"));
    case TAG_TYPES.ON_HOLD:
      return css29(_templateObject200 || (_templateObject200 = _taggedTemplateLiteral(["\n                ", ";\n                border: none;\n                background-color: ", ";\n                ", ";\n\n                ", " {\n                    background-color: ", ";\n                    color: ", ";\n                }\n            "])), result, token25("feedback.color.info.low", "color.primary.02"), statusTextColor, TagIndicatorContainer, token25("feedback.color.info.high", "white"), token25("text.color.oninfo", "body.color"));
    default:
      {
        result = css29(_templateObject201 || (_templateObject201 = _taggedTemplateLiteral(["\n                ", ";\n                background-color: ", ";\n            "])), result, token25("control.color.secondary.enabled", "color.primary.00"));
        if (filled) {
          return css29(_templateObject202 || (_templateObject202 = _taggedTemplateLiteral(["\n                    ", ";\n                    background-color: ", ";\n                "])), result, color13("primary.lightest"));
        }
        if (deleteOption === "enabled" && !disabled) {
          return css29(_templateObject203 || (_templateObject203 = _taggedTemplateLiteral(["\n                    ", ";\n                    padding-right: ", ";\n                "])), result, spacing23("control.spacing.tiny", [0.5]));
        }
        if (deleteOption === "disabled") {
          return result;
        }
        return css29(_templateObject204 || (_templateObject204 = _taggedTemplateLiteral(["\n                ", ";\n                justify-content: flex-end;\n            "])), result);
      }
  }
};
var clearButtonContainerStyle = function clearButtonContainerStyle(_ref63) {
  var deleteOption = _ref63.deleteOption,
    disabled = _ref63.disabled;
  var result = css29(_templateObject205 || (_templateObject205 = _taggedTemplateLiteral(["\n        border-radius: ", ";\n        margin-left: ", ";\n    "])), token25("action.borderRadius.pill", "shape.borderRadius.pill", {
    returnUnit: "px"
  }), spacing23("control.spacing.xsmall", [1]));
  if (deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.ENABLED) {
    return css29(_templateObject206 || (_templateObject206 = _taggedTemplateLiteral(["\n            ", ";\n            position: relative;\n            opacity: 1;\n        "])), result);
  }
  if (deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.ON_HOVER) {
    result = css29(_templateObject207 || (_templateObject207 = _taggedTemplateLiteral(["\n            ", ";\n            position: absolute;\n            background-color: ", ";\n        "])), result, token25("base.color.flat", "white"));
    if (!disabled) {
      result = css29(_templateObject208 || (_templateObject208 = _taggedTemplateLiteral(["\n                ", ";\n                transform: translateX(12px);\n            "])), result);
    }
    return result;
  }
  return result;
};
var TagClearButtonContainer = styled32.div.withConfig(propsBlocker31)(_templateObject209 || (_templateObject209 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    outline: none;\n    ", ";\n"])), clearButtonContainerStyle);
var TagRoot = styled32.div.withConfig(propsBlocker31)(_templateObject210 || (_templateObject210 = _taggedTemplateLiteral(["\n    ", ";\n    position: relative;\n    border: ", "px solid\n        ", ";\n    box-sizing: border-box;\n    cursor: default;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    width: fit-content;\n    user-select: none;\n    overflow: hidden;\n    align-items: center;\n    justify-content: center;\n    background: ", ";\n    border-radius: ", ";\n\n    &.Tag-Root--onHover:hover ", " {\n        transform: translateX(", ");\n        opacity: 1;\n        ", ";\n    }\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset11(), token25("control.borderWidth.thin", 1), token25("feedback.color.branded.high", "color.primary.lighter"), token25("control.color.secondary.enabled", "color.neutral.00"), token25("action.borderRadius.pill", "shape.borderRadius.pill", {
  returnUnit: "px"
}), TagClearButtonContainer, function (_ref64) {
  var small = _ref64.small;
  return small ? "6px" : "10px";
}, transition13({
  transform: true
}), getRootStyle10, marginProps20, widthProps7, getComponentOverride20("Tag"));

// src/components/Tag/utils/useTag.ts
import { useCallback as useCallback13 } from "react";
var useTag = function useTag(_a, ref) {
  var _b = _a,
    type = _b.type,
    label = _b.label,
    children = _b.children,
    onClose = _b.onClose,
    onDeselect = _b.onDeselect,
    code = _b.code,
    disabled = _b.disabled,
    deleteOption = _b.deleteOption,
    small = _b.small,
    filled = _b.filled,
    icon = _b.icon,
    indicator = _b.indicator,
    restRootProps = __objRest(_b, ["type", "label", "children", "onClose", "onDeselect", "code", "disabled", "deleteOption", "small", "filled", "icon", "indicator"]);
  var realLabel = isStatusTag_default(type) ? getStatusTagLabel_default(type) : label;
  var content = children !== void 0 ? children : realLabel;
  var onCloseButtonClick = useCallback13(function (event) {
    if (disabled) {
      return;
    }
    event.stopPropagation();
    onClose == null ? void 0 : onClose(event);
    onDeselect == null ? void 0 : onDeselect(code);
  }, [code, disabled, onClose, onDeselect]);
  var tagTypeStatus = isStatusTag_default(type);
  var showIndicator = Boolean(indicator && tagTypeStatus);
  var showIcon = Boolean(icon && tagTypeStatus && !indicator);
  var showClearButton = Boolean(!tagTypeStatus && !disabled && (deleteOption === "enabled" || deleteOption === "onHover"));
  var clearButtonProps = deleteOption && deleteOption in TAG_CLEAR_BUTTON_PROPS_MAP ? TAG_CLEAR_BUTTON_PROPS_MAP[deleteOption] : {};
  return {
    rootProps: __spreadProps(__spreadValues({}, restRootProps), {
      deleteOption: deleteOption,
      "data-testid": tagRoot,
      ref: ref,
      small: small,
      type: type,
      disabled: disabled,
      filled: filled,
      icon: icon,
      indicator: indicator
    }),
    tagClearButtonProps: {
      deleteOption: deleteOption,
      small: small,
      onClick: onCloseButtonClick,
      disabled: disabled,
      type: type,
      tabIndex: 0,
      "data-testid": tagCloseIconContainer
    },
    tagTextProps: {
      deleteOption: deleteOption,
      isDisabled: disabled,
      smallVerticalPadding: small
      // not to conflict with the Typography small prop
    },

    indicatorContainerProps: {
      small: small
    },
    iconContainerProps: {
      small: small,
      disabled: disabled
    },
    deleteOption: deleteOption,
    type: type,
    content: content,
    onCloseButtonClick: onCloseButtonClick,
    small: small,
    filled: filled,
    icon: icon,
    indicator: indicator,
    showIndicator: showIndicator,
    showIcon: showIcon,
    showClearButton: showClearButton,
    clearButtonProps: clearButtonProps
  };
};

// src/components/Tag/Tag.tsx
var Tag = forwardRef26(function Tag2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var _useTag = useTag(restProps, ref),
    rootProps = _useTag.rootProps,
    tagTextProps = _useTag.tagTextProps,
    tagClearButtonProps = _useTag.tagClearButtonProps,
    content = _useTag.content,
    deleteOption = _useTag.deleteOption,
    type = _useTag.type,
    small = _useTag.small,
    filled = _useTag.filled,
    indicator = _useTag.indicator,
    indicatorContainerProps = _useTag.indicatorContainerProps,
    icon = _useTag.icon,
    iconContainerProps = _useTag.iconContainerProps,
    showIndicator = _useTag.showIndicator,
    showIcon = _useTag.showIcon,
    showClearButton = _useTag.showClearButton,
    clearButtonProps = _useTag.clearButtonProps;
  var classOverride = useTagClassName_default(TAG_CLASS_PREFIX, className, deleteOption, type, small, filled);
  return /* @__PURE__ */React39.createElement(TagRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  }), showIndicator && /* @__PURE__ */React39.createElement(TagIndicatorContainer, __spreadProps(__spreadValues({}, indicatorContainerProps), {
    className: classOverride.Indicator
  }), indicator), showIcon && /* @__PURE__ */React39.createElement(TagIconContainer, __spreadProps(__spreadValues({}, iconContainerProps), {
    className: classOverride.Icon
  }), icon), /* @__PURE__ */React39.createElement(TagText, __spreadProps(__spreadValues({}, tagTextProps), {
    className: classOverride.Label
  }), content), showClearButton && /* @__PURE__ */React39.createElement(TagClearButtonContainer, __spreadProps(__spreadValues({}, tagClearButtonProps), {
    className: classOverride.CloseIconContainer
  }), /* @__PURE__ */React39.createElement(ClearButton, __spreadProps(__spreadValues({}, clearButtonProps), {
    size: small ? "medium" : void 0,
    className: classOverride.CloseIcon
  }))));
});
Tag.defaultProps = {
  deleteOption: "onHover",
  type: "default"
};
Tag.propTypes = {
  deleteOption: PropTypes21.oneOf(["disabled", "enabled", "onHover"]),
  label: PropTypes21.string,
  onClose: PropTypes21.func,
  type: PropTypes21.oneOf(["default", "approved", "denied", "new", "on-hold"]),
  small: PropTypes21.bool,
  filled: PropTypes21.bool
};
var MemoizedTag = memo34(Tag);

// src/components/Dropdown/style.ts
var DropdownRoot = styled33.div.withConfig(propsBlocker32)(_templateObject211 || (_templateObject211 = _taggedTemplateLiteral(["\n    display: inline-block;\n\n    ", ";\n    ", ";\n    ", ";\n"])), getComponentOverride21("Dropdown"), marginProps21, widthProps8);
var DropdownContainer = styled33.div.withConfig(propsBlocker32)(_templateObject212 || (_templateObject212 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    ", "\n"])), mouseCursor5);
var getOptionListContainerStyle = function getOptionListContainerStyle(_ref65) {
  var zIndex6 = _ref65.zIndex;
  return css30(_templateObject213 || (_templateObject213 = _taggedTemplateLiteral(["\n        z-index: ", ";\n    "])), zIndex6);
};
var DropdownOptionListContainer = styled33.div.withConfig(propsBlocker32)(_templateObject214 || (_templateObject214 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"])), getOptionListContainerStyle, widthProps8);
var ActionsContainer = styled33.div.withConfig(propsBlocker32)(_templateObject215 || (_templateObject215 = _taggedTemplateLiteral(["\n    display: flex;\n    align-self: flex-start;\n    align-items: center;\n    margin: ", ";\n"])), function (_ref66) {
  var large = _ref66.large;
  return spacing24(large ? 3 : 2, 3, "auto", 0);
});
var DropdownExpansionIndicator = styled33(ExpansionIndicator)(_templateObject216 || (_templateObject216 = _taggedTemplateLiteral([""])));
var dropdownTextRootStyle = function dropdownTextRootStyle(_ref67) {
  var multiple = _ref67.multiple;
  var result = {};
  if (multiple) {
    result = css30(_templateObject217 || (_templateObject217 = _taggedTemplateLiteral(["\n            ", ";\n            min-width: ", ";\n        "])), result, spacing24(70));
  }
  return result;
};
var dropdownTextInputStyle = function dropdownTextInputStyle(_ref68) {
  var multiple = _ref68.multiple,
    isCustomRenderer = _ref68.isCustomRenderer,
    internalValue = _ref68.internalValue,
    isRenderedSelectedValueAsNode = _ref68.isRenderedSelectedValueAsNode;
  var result = css30(_templateObject218 || (_templateObject218 = _taggedTemplateLiteral(["\n        ", "\n        padding-left: ", ";\n        padding-right: ", ";\n    "])), mouseCursor5, spacing24(4), spacing24(4));
  var shouldMinimizeInput = !!internalValue.length && (multiple && !isCustomRenderer || isRenderedSelectedValueAsNode);
  if (shouldMinimizeInput) {
    result = css30(_templateObject219 || (_templateObject219 = _taggedTemplateLiteral(["\n            ", ";\n            padding-right: 0;\n            padding-left: 0;\n            width: 0;\n        "])), result);
  }
  return result;
};
var DropdownTextInput = styled33(TextInput)(_templateObject220 || (_templateObject220 = _taggedTemplateLiteral(["\n    ", ";\n    ", "\n\n    .TextInput-Input {\n        ", "\n    }\n"])), function (_ref69) {
  var disabled = _ref69.disabled,
    error = _ref69.error;
  return focusWithin2({
    noOutline: true,
    disabled: disabled,
    error: error
  });
}, dropdownTextRootStyle, dropdownTextInputStyle);
var dropdownBeforeSectionContainerStyle = function dropdownBeforeSectionContainerStyle(_ref70) {
  var singleLine = _ref70.singleLine;
  var result = css30(_templateObject221 || (_templateObject221 = _taggedTemplateLiteral(["\n        ", "\n    "])), mouseCursor5);
  if (singleLine) {
    result = css30(_templateObject222 || (_templateObject222 = _taggedTemplateLiteral(["\n            ", ";\n            height: ", "px;\n        "])), result, SINGLE_LINE_MAX_ALLOWED_HEIGHT);
  }
  return result;
};
var DropdownBeforeSectionRoot = styled33(Pack)(_templateObject223 || (_templateObject223 = _taggedTemplateLiteral(["\n    padding-left: ", ";\n    min-width: ", ";\n    min-height: ", ";\n    width: 100%;\n\n    ", "\n"])), spacing24(4), spacing24(40), spacing24(10), dropdownBeforeSectionContainerStyle);
var DropdownBeforeSectionContainer = styled33(PackItem)(_templateObject224 || (_templateObject224 = _taggedTemplateLiteral(["\n    width: 100%;\n    padding-top: ", ";\n    padding-bottom: ", ";\n"])), spacing24(1), spacing24(1));
var DropdownBeforeSectionWrapper = styled33.div.withConfig(propsBlocker32)(_templateObject225 || (_templateObject225 = _taggedTemplateLiteral(["\n    width: fit-content;\n"])));
var DropdownBeforeSectionActionContainer = styled33(PackItem)(_templateObject226 || (_templateObject226 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    width: ", ";\n"])), spacing24(6));
var DropdownBeforeSectionClearButton = styled33(PackItem)(_templateObject227 || (_templateObject227 = _taggedTemplateLiteral(["\n    position: absolute;\n    border: 0 none;\n    background-color: transparent;\n    outline: none;\n    flex: 0 0 auto;\n    margin-top: ", ";\n"])), spacing24(1.75));
var DropdownTag = styled33(Tag).attrs({
  small: true
})(_templateObject228 || (_templateObject228 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    margin-right: ", ";\n    margin-bottom: ", ";\n\n    .Typography-Root {\n        margin-left: ", ";\n        margin-right: ", ";\n    }\n\n    ", "\n"])), spacing24(1), spacing24(2), spacing24(1), spacing24(1), spacing24(1), mouseCursor5);
var DropdownArrow = styled33.div(_templateObject229 || (_templateObject229 = _taggedTemplateLiteral([""])));

// src/components/OptionList/OptionList.tsx
import React52, { Fragment, memo as memo36 } from "react";
import { useSortedList as useSortedList2 } from "@deliveryhero/armor-system";

// src/components/OptionList/style.ts
import styled40, { css as css35 } from "styled-components";
import { color as color18, elevation, getComponentOverride as getComponentOverride25, propsBlocker as propsBlocker39, reset as reset13, spacing as spacing31, durationNormal as durationNormal8, typography as typography19, transition as transition15, heightProps as heightProps3, token as token28, pointerEvents as pointerEvents3 } from "@deliveryhero/armor-system";

// src/components/Search/Search.tsx
import React47, { forwardRef as forwardRef27, memo as memo35 } from "react";
import PropTypes25 from "prop-types";

// src/components/Search/hooks/useSearchClassName.ts
import { useMemo as useMemo44 } from "react";
import { appendClassName as appendClassName13, makeBEM as makeBEM26 } from "@deliveryhero/armor-system";
var getClassNameByComponent5 = function getClassNameByComponent5(_ref71) {
  var component = _ref71.component,
    classPrefix = _ref71.classPrefix,
    disabled = _ref71.disabled,
    isSuggestionsListShown = _ref71.isSuggestionsListShown;
  var baseClassNames = makeBEM26(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM26(classPrefix, component, "disabled"));
  }
  if (!isSuggestionsListShown) {
    stateClassNames.push(makeBEM26(classPrefix, component, "hidden_suggestions"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useSearchClassName = function useSearchClassName(classPrefix, className, disabled, isSuggestionsListShown) {
  return useMemo44(function () {
    return {
      Root: appendClassName13(getClassNameByComponent5({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled,
        isSuggestionsListShown: isSuggestionsListShown
      }), className),
      SuggestionsContainer: getClassNameByComponent5({
        component: "SuggestionsContainer",
        classPrefix: classPrefix,
        disabled: disabled,
        isSuggestionsListShown: isSuggestionsListShown
      }),
      SuggestionsItem: getClassNameByComponent5({
        component: "SuggestionsItem",
        classPrefix: classPrefix,
        disabled: disabled,
        isSuggestionsListShown: isSuggestionsListShown
      }),
      SuggestionsItemIcon: getClassNameByComponent5({
        component: "SuggestionsItemIcon",
        classPrefix: classPrefix,
        disabled: disabled,
        isSuggestionsListShown: isSuggestionsListShown
      }),
      SuggestionsItemLabel: getClassNameByComponent5({
        component: "SuggestionsItemLabel",
        classPrefix: classPrefix,
        disabled: disabled,
        isSuggestionsListShown: isSuggestionsListShown
      }),
      SuggestionsItemAction: getClassNameByComponent5({
        component: "SuggestionsItemAction",
        classPrefix: classPrefix,
        disabled: disabled,
        isSuggestionsListShown: isSuggestionsListShown
      }),
      SearchSuggestionsList: getClassNameByComponent5({
        component: "SearchSuggestionsList",
        classPrefix: classPrefix,
        disabled: disabled,
        isSuggestionsListShown: isSuggestionsListShown
      }),
      TextInput: getClassNameByComponent5({
        component: "TextInput",
        classPrefix: classPrefix,
        disabled: disabled,
        isSuggestionsListShown: isSuggestionsListShown
      }),
      ListItemGroup: makeBEM26(classPrefix, "ListItemGroup")
    };
  }, [classPrefix, disabled, isSuggestionsListShown, className]);
};

// src/components/Search/constants.ts
var SEARCH_CLASS_PREFIX = "Search";
var searchRoot = "SearchRoot";
var INITIAL_CURSOR_POSITION2 = 0;
var SEARCH_ITEM_FOCUSED_CLASS = "Search-SuggestionsItem-focused";

// src/components/Search/style.ts
import styled34, { css as css31 } from "styled-components";
import { marginProps as marginProps22, widthProps as widthProps9, reset as reset12, spacing as spacing25, getComponentOverride as getComponentOverride22, propsBlocker as propsBlocker33, zIndexSearchSuggestionsList, durationNormal as durationNormal7, focusWithin as focusWithin3, transition as transition14, token as token26, color as color14, typography as typography16 } from "@deliveryhero/armor-system";
var searchSuggestionsContainerStyle = function searchSuggestionsContainerStyle(_ref72) {
  var searchQuery = _ref72.searchQuery,
    suggestionListHeight = _ref72.suggestionListHeight;
  var result = css31(_templateObject230 || (_templateObject230 = _taggedTemplateLiteral(["\n        box-shadow: ", ";\n        margin-top: ", ";\n        margin-bottom: ", ";\n    "])), token26("elevation.medium"), spacing25(1), spacing25(1));
  if (suggestionListHeight) {
    result = css31(_templateObject231 || (_templateObject231 = _taggedTemplateLiteral(["\n            ", ";\n            max-height: ", ";\n        "])), result, spacing25(Number(suggestionListHeight)));
  }
  if (searchQuery && searchQuery.length) {
    result = css31(_templateObject232 || (_templateObject232 = _taggedTemplateLiteral(["\n            ", ";\n            height: fit-content;\n            ", ";\n        "])), result, transition14({
      "max-height": true
    }));
  }
  return result;
};
var SearchRoot = styled34.div.withConfig(propsBlocker33)(_templateObject233 || (_templateObject233 = _taggedTemplateLiteral(["\n    ", ";\n    cursor: default;\n    display: inline-block;\n    flex-flow: row nowrap;\n    position: relative;\n    ", ";\n    ", ";\n    ", ";\n    .TextInput-InnerContainer {\n        padding: ", ";\n    }\n"])), reset12, getComponentOverride22("Search"), marginProps22, widthProps9, spacing25("control.spacing.none", "control.spacing.medium", [0, 3]));
var SearchSuggestionsContainer = styled34.div.withConfig(propsBlocker33)(_templateObject234 || (_templateObject234 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-sizing: border-box;\n    flex-direction: column;\n    height: 0;\n    left: 0;\n    width: 100%;\n    overflow: auto;\n    position: absolute;\n    transition: ", "ms;\n    z-index: ", ";\n    ", ";\n"])), color14("neutral.00"), durationNormal7, zIndexSearchSuggestionsList, searchSuggestionsContainerStyle);
var SearchSuggestionsListContainer = styled34.div.withConfig(propsBlocker33)(_templateObject235 || (_templateObject235 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"])));
var SearchTextInput = styled34(TextInput)(_templateObject236 || (_templateObject236 = _taggedTemplateLiteral(["\n    .TextInput-Input {\n        ", ";\n        padding-left: ", ";\n    }\n\n    ", ";\n"])), typography16("desktop.bodyMedium", "paragraphMedium"), spacing25("control.spacing.small", [2]), function (_ref73) {
  var disabled = _ref73.disabled,
    error = _ref73.error;
  return focusWithin3({
    disabled: disabled,
    error: error,
    noOutline: true
  });
});
var LoadingContainer = styled34.div(_templateObject237 || (_templateObject237 = _taggedTemplateLiteral(["\n    padding: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    ", ";\n"])), spacing25(4), typography16("paragraphSmall"));

// src/components/Search/hooks/useSearch.tsx
import { useCallback as useCallback14, useEffect as useEffect9, useMemo as useMemo45, useRef as useRef6, useState as useState5 } from "react";
import { useDetectClickOutsideComponent, useControlledState as useControlledState4, useRootRef as useRootRef13, useScrollToNode, useNavigationControl, getWindow } from "@deliveryhero/armor-system";
var useSearch = function useSearch(_a, ref) {
  var _b = _a,
    _b$defaultQuery = _b.defaultQuery,
    defaultQuery = _b$defaultQuery === void 0 ? "" : _b$defaultQuery,
    query = _b.query,
    _b$disabled = _b.disabled,
    disabled = _b$disabled === void 0 ? false : _b$disabled,
    _b$disableClearAction = _b.disableClearAction,
    disableClearAction = _b$disableClearAction === void 0 ? false : _b$disableClearAction,
    _b$isLoading = _b.isLoading,
    isLoading = _b$isLoading === void 0 ? false : _b$isLoading,
    _b$placeholder = _b.placeholder,
    placeholder = _b$placeholder === void 0 ? "Search" : _b$placeholder,
    _b$icon = _b.icon,
    icon = _b$icon === void 0 ? null : _b$icon,
    renderItemIcon = _b.renderItemIcon,
    error = _b.error,
    autoFocus = _b.autoFocus,
    name = _b.name,
    onChange = _b.onChange,
    onQueryChange = _b.onQueryChange,
    onItemSelect = _b.onItemSelect,
    options = _b.options,
    groups = _b.groups,
    _b$suggestionListHeig = _b.suggestionListHeight,
    suggestionListHeight = _b$suggestionListHeig === void 0 ? 100 : _b$suggestionListHeig,
    _b$enableSuggestions = _b.enableSuggestions,
    enableSuggestions = _b$enableSuggestions === void 0 ? true : _b$enableSuggestions,
    noResultsLabel = _b.noResultsLabel,
    additionalInfo = _b.additionalInfo,
    renderItemAdditionalInfo = _b.renderItemAdditionalInfo,
    large = _b.large,
    loadingPlaceholder = _b.loadingPlaceholder,
    restProps = __objRest(_b, ["defaultQuery", "query", "disabled", "disableClearAction", "isLoading", "placeholder", "icon", "renderItemIcon", "error", "autoFocus", "name", "onChange", "onQueryChange", "onItemSelect", "options", "groups", "suggestionListHeight", "enableSuggestions", "noResultsLabel", "additionalInfo", "renderItemAdditionalInfo", "large", "loadingPlaceholder"]);
  var _useState21 = useState5(INITIAL_CURSOR_POSITION2),
    _useState22 = _slicedToArray(_useState21, 2),
    cursorPosition = _useState22[0],
    setCursorPosition = _useState22[1];
  var _useControlledState7 = useControlledState4(defaultQuery, query, onQueryChange),
    _useControlledState8 = _slicedToArray(_useControlledState7, 2),
    searchQuery = _useControlledState8[0],
    setSearchQuery = _useControlledState8[1];
  var _useState23 = useState5(!!options),
    _useState24 = _slicedToArray(_useState23, 2),
    isSuggestionsListShown = _useState24[0],
    setIsSuggestionsListShown = _useState24[1];
  var internalInputRef = useRootRef13(ref);
  var containerRef = useRef6(null);
  useEffect9(function () {
    setIsSuggestionsListShown(!!options);
  }, [options]);
  useEffect9(function () {
    setSearchQuery(defaultQuery);
  }, [defaultQuery, setSearchQuery]);
  var setIsOptionsListShown = useCallback14(function () {
    var isShow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setIsSuggestionsListShown(function (isShowing) {
      if (!isShowing) {
        setCursorPosition(INITIAL_CURSOR_POSITION2);
      }
      return isShow;
    });
  }, []);
  useDetectClickOutsideComponent(containerRef, setIsOptionsListShown, true);
  var scrollToCurrent = useScrollToNode({
    className: SEARCH_ITEM_FOCUSED_CLASS
  });
  useEffect9(function () {
    if (searchQuery && searchQuery.length) {
      scrollToCurrent();
    }
  }, [cursorPosition]);
  var handleEnterClick = useCallback14(function () {
    var win2 = getWindow();
    if (!win2) {
      return;
    }
    var focusedElement = document.querySelector(".".concat(SEARCH_ITEM_FOCUSED_CLASS));
    var selectedLabel = focusedElement == null ? void 0 : focusedElement.textContent;
    if ((options == null ? void 0 : options.length) && selectedLabel) {
      setSearchQuery(selectedLabel);
      setIsSuggestionsListShown(false);
      var selectedOption = options.find(function (option) {
        return option.label === selectedLabel;
      });
      if (selectedOption) {
        onItemSelect == null ? void 0 : onItemSelect(selectedOption);
      }
      setIsOptionsListShown();
    }
  }, [options, setSearchQuery, onItemSelect, setIsOptionsListShown]);
  useNavigationControl({
    yLength: (options == null ? void 0 : options.length) || 0,
    setCursorY: setCursorPosition,
    targetElement: internalInputRef,
    onEnterKeyPress: handleEnterClick,
    onNavigationKeyPress: function onNavigationKeyPress() {
      return setIsOptionsListShown(true);
    },
    onEscapeKeyPress: function onEscapeKeyPress() {
      return setIsOptionsListShown();
    },
    onOtherKeysPress: function onOtherKeysPress() {
      return setIsOptionsListShown(true);
    },
    disabled: disabled
  });
  var handleChange = useCallback14(function (event) {
    var _a2;
    var currentQuery = ((_a2 = event == null ? void 0 : event.target) == null ? void 0 : _a2.value) || "";
    setSearchQuery(currentQuery);
    if (onChange) {
      onChange(event);
    }
  }, [setSearchQuery, onChange]);
  var handleClick = useCallback14(function () {
    setIsSuggestionsListShown(!!(options && options.length));
  }, [setIsSuggestionsListShown, options]);
  var handleClearQuery = useCallback14(function (event) {
    event.stopPropagation();
    setSearchQuery("");
    if (onChange) {
      onChange({
        target: {
          value: ""
        }
      });
    }
  }, [setSearchQuery, onChange]);
  var handleSuggestionClick = useCallback14(function (_, suggestionOption) {
    var currentQuery = suggestionOption.label || "";
    setSearchQuery(currentQuery);
    if (onItemSelect) {
      onItemSelect(suggestionOption);
    }
    setIsOptionsListShown();
  }, [onItemSelect, setIsOptionsListShown, setSearchQuery]);
  var groupIndex = useMemo45(function () {
    if (!groups || !groups.length) {
      return {};
    }
    return groups.reduce(function (result, group) {
      result[group.id] = group;
      return result;
    }, {});
  }, [groups]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: containerRef
    }),
    textInputProps: {
      disabled: disabled,
      error: error,
      name: name,
      onChange: handleChange,
      onClick: handleClick,
      placeholder: placeholder,
      ref: internalInputRef,
      value: searchQuery,
      wide: true,
      autoFocus: autoFocus,
      large: large
    },
    searchIconProps: {
      disabled: disabled
    },
    searchClearActionProps: {
      disableClearAction: disabled || disableClearAction,
      handleClearQuery: handleClearQuery,
      searchQuery: searchQuery,
      disabled: disabled
    },
    suggestionsContainerProps: {
      searchQuery: searchQuery,
      suggestionListHeight: suggestionListHeight
    },
    suggestionListContainerProps: {},
    suggestionListProps: {
      additionalInfo: additionalInfo,
      renderItemAdditionalInfo: renderItemAdditionalInfo,
      options: options,
      groups: groups,
      groupIndex: groupIndex,
      handleSuggestionClick: handleSuggestionClick,
      icon: icon,
      renderItemIcon: renderItemIcon,
      cursorPosition: cursorPosition,
      searchQuery: searchQuery,
      noResultsLabel: noResultsLabel
    },
    disabled: disabled,
    isSuggestionsListShown: (isSuggestionsListShown || isLoading) && enableSuggestions,
    isLoading: isLoading,
    loadingPlaceholder: loadingPlaceholder
  };
};

// src/components/Search/SearchSuggestionsList/SearchSuggestionsList.tsx
import React44 from "react";
import PropTypes22 from "prop-types";
import { useSortedList } from "@deliveryhero/armor-system";

// src/components/Search/SearchEmptySuggestionsList/SearchEmptySuggestionsList.tsx
import React41 from "react";

// src/components/Search/SearchSuggestionItem/style.ts
import styled35, { css as css32 } from "styled-components";
import { color as color15, spacing as spacing26, typography as typography17, getComponentOverride as getComponentOverride23, propsBlocker as propsBlocker34, token as token27 } from "@deliveryhero/armor-system";
var maxLabelWidthInPercent = "70%";
var minLabelWidthInPx = "140px";
var maxSpacingAllocatedToIcon = 6;
var defaultLabelColor = color15("neutral.07");
var defaultLabelColorHover = color15("neutral.11");
var defaultActionColor = color15("neutral.05");
var SearchSuggestionItemRoot = styled35.div.withConfig(propsBlocker34)(_templateObject238 || (_templateObject238 = _taggedTemplateLiteral(["\n    .Search-SuggestionsItemIcon {\n        color: ", ";\n    }\n\n    .Search-LabelTypography {\n        color: ", ";\n    }\n\n    .Search-SuggestionsItemAction {\n        color: ", ";\n    }\n\n    &:hover {\n        .Search-SuggestionsItemIcon {\n            color: ", ";\n        }\n\n        .Search-LabelTypography {\n            color: ", ";\n        }\n\n        .Search-SuggestionsItemAction {\n            color: ", ";\n        }\n    }\n"])), defaultLabelColor, defaultLabelColor, defaultActionColor, defaultLabelColorHover, defaultLabelColorHover, defaultActionColor);
var searchSuggestionsItemStyle = function searchSuggestionsItemStyle(_ref74) {
  var isHighlighted = _ref74.isHighlighted;
  var result = {};
  if (isHighlighted) {
    result = css32(_templateObject239 || (_templateObject239 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n        "])), result, color15("primary.lightest"));
  }
  return result;
};
var SearchSuggestionItemContainer = styled35.div.withConfig(propsBlocker34)(_templateObject240 || (_templateObject240 = _taggedTemplateLiteral(["\n    align-items: center;\n    box-sizing: border-box;\n    display: flex;\n    height: 40px;\n    justify-content: space-between;\n    cursor: pointer;\n    &:hover {\n        background-color: ", ";\n    }\n\n    padding-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-top: ", ";\n\n    ", "\n    ", ";\n"])), color15("primary.lightest"), spacing26(2), spacing26(4), spacing26(4), spacing26(2), searchSuggestionsItemStyle, getComponentOverride23("SearchSuggestionItem"));
var SearchSuggestionItemLabelTypography = styled35(Typography)(_templateObject241 || (_templateObject241 = _taggedTemplateLiteral(["\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])));
var SearchEmptySuggestionsEmptyItemLabelTypography = styled35(Typography)(_templateObject242 || (_templateObject242 = _taggedTemplateLiteral(["\n    text-align: center;\n"])));
var searchSuggestionsItemIconStyle = function searchSuggestionsItemIconStyle(_ref75) {
  var icon = _ref75.icon,
    renderItemIcon = _ref75.renderItemIcon;
  var result = css32(_templateObject243 || (_templateObject243 = _taggedTemplateLiteral(["\n        padding-left: 2px;\n        padding-right: ", ";\n    "])), spacing26(3));
  if (!(icon || renderItemIcon)) {
    result = css32(_templateObject244 || (_templateObject244 = _taggedTemplateLiteral(["\n            ", ";\n            padding-right: ", ";\n        "])), result, spacing26(maxSpacingAllocatedToIcon));
  }
  return result;
};
var SearchSuggestionsItemIcon = styled35.div.withConfig(propsBlocker34)(_templateObject245 || (_templateObject245 = _taggedTemplateLiteral(["\n    align-items: center;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n\n    ", "\n"])), searchSuggestionsItemIconStyle);
var searchSuggestionsItemLabelStyle = function searchSuggestionsItemLabelStyle(_ref76) {
  var renderItemAdditionalInfo = _ref76.renderItemAdditionalInfo;
  return renderItemAdditionalInfo ? css32(_templateObject246 || (_templateObject246 = _taggedTemplateLiteral(["\n              max-width: max(", ", ", ");\n          "])), maxLabelWidthInPercent, minLabelWidthInPx) : css32(_templateObject247 || (_templateObject247 = _taggedTemplateLiteral(["\n              min-width: ", ";\n          "])), minLabelWidthInPx);
};
var SearchSuggestionsItemLabel = styled35.div.withConfig(propsBlocker34)(_templateObject248 || (_templateObject248 = _taggedTemplateLiteral(["\n    padding-right: ", ";\n    box-sizing: border-box;\n    flex-grow: 1;\n\n    ", "\n"])), spacing26(2), searchSuggestionsItemLabelStyle);
var searchSuggestionsItemActionStyle = function searchSuggestionsItemActionStyle(_ref77) {
  var renderItemAdditionalInfo = _ref77.renderItemAdditionalInfo;
  return renderItemAdditionalInfo ? css32(_templateObject249 || (_templateObject249 = _taggedTemplateLiteral(["\n              width: calc(\n                  100% - max(", ", ", ") -\n                      ", "\n              );\n          "])), maxLabelWidthInPercent, minLabelWidthInPx, spacing26(maxSpacingAllocatedToIcon)) : css32(_templateObject250 || (_templateObject250 = _taggedTemplateLiteral([""])));
};
var SearchSuggestionsItemAction = styled35.div.withConfig(propsBlocker34)(_templateObject251 || (_templateObject251 = _taggedTemplateLiteral(["\n    align-items: flex-start;\n    box-sizing: border-box;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: right;\n    padding-left: ", ";\n    ", ";\n    color: ", ";\n    ", ";\n"])), spacing26(2), typography17("paragraphMedium"), token27("body.color"), searchSuggestionsItemActionStyle);

// src/components/Search/SearchEmptySuggestionsList/hooks/useSearchEmptySuggestionsListClassName.ts
import { useMemo as useMemo46 } from "react";
import { appendClassName as appendClassName14, makeBEM as makeBEM27 } from "@deliveryhero/armor-system";
var getClassNameByComponent6 = function getClassNameByComponent6(_ref78) {
  var component = _ref78.component,
    classPrefix = _ref78.classPrefix;
  return makeBEM27(classPrefix, component);
};
var useSearchEmptySuggestionsListClassName = function useSearchEmptySuggestionsListClassName(classPrefix, className) {
  return useMemo46(function () {
    return {
      Root: appendClassName14(getClassNameByComponent6({
        component: "Root",
        classPrefix: classPrefix
      }), className),
      ItemIcon: getClassNameByComponent6({
        component: "ItemIcon",
        classPrefix: classPrefix
      }),
      ItemLabel: getClassNameByComponent6({
        component: "ItemLabel",
        classPrefix: classPrefix
      }),
      ItemAction: getClassNameByComponent6({
        component: "ItemAction",
        classPrefix: classPrefix
      }),
      ItemLabelTypography: getClassNameByComponent6({
        component: "ItemLabelTypography",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};

// src/components/Search/SearchEmptySuggestionsList/constants.ts
var SEARCH_EMPTY_SUGGESTIONS_LIST_CLASS_PREFIX = "SearchEmptySuggestionsList";

// src/components/Search/SearchEmptySuggestionsList/style.ts
import styled36 from "styled-components";
import { colorGrey00, getComponentOverride as getComponentOverride24, spacing as spacing27, propsBlocker as propsBlocker35 } from "@deliveryhero/armor-system";
var SearchEmptySuggestionsListRoot = styled36.div.withConfig(propsBlocker35)(_templateObject252 || (_templateObject252 = _taggedTemplateLiteral(["\n    align-items: center;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n\n    padding-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-top: ", ";\n    cursor: default;\n    height: auto;\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    ", ";\n"])), spacing27(2), spacing27(4), spacing27(4), spacing27(2), colorGrey00, getComponentOverride24("SearchEmptySuggestionsList"));
var SearchEmptySuggestionsItemLabel = styled36.div.withConfig(propsBlocker35)(_templateObject253 || (_templateObject253 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    flex-grow: 1;\n    min-width: ", ";\n"])), spacing27(33));

// src/components/Search/SearchEmptySuggestionsList/SearchEmptySuggestionsList.tsx
var SearchEmptySuggestionsList = function SearchEmptySuggestionsList(_ref79) {
  var _ref79$noResultsLabel = _ref79.noResultsLabel,
    noResultsLabel = _ref79$noResultsLabel === void 0 ? "No results found" : _ref79$noResultsLabel,
    className = _ref79.className;
  var classOverride = useSearchEmptySuggestionsListClassName(SEARCH_EMPTY_SUGGESTIONS_LIST_CLASS_PREFIX, className);
  return /* @__PURE__ */React41.createElement(SearchEmptySuggestionsListRoot, {
    className: classOverride.Root
  }, /* @__PURE__ */React41.createElement(SearchEmptySuggestionsItemLabel, {
    className: classOverride.ItemLabel
  }, /* @__PURE__ */React41.createElement(SearchEmptySuggestionsEmptyItemLabelTypography, {
    className: classOverride.ItemLabelTypography,
    paragraph: true,
    medium: true
  }, noResultsLabel)));
};

// src/components/Search/SearchSuggestionItem/SearchSuggestionItem.tsx
import React43 from "react";

// src/components/Search/SearchSuggestionItem/hooks/useSearchSuggestionItemClassName.ts
import { useMemo as useMemo47 } from "react";
import { appendClassName as appendClassName15, makeBEM as makeBEM28 } from "@deliveryhero/armor-system";
var getClassNameByComponent7 = function getClassNameByComponent7(_ref80) {
  var component = _ref80.component,
    classPrefix = _ref80.classPrefix;
  return makeBEM28(classPrefix, component);
};
var useSearchSuggestionItemClassName = function useSearchSuggestionItemClassName(classPrefix, className, isFocused) {
  return useMemo47(function () {
    var suggestionsItemClassName = appendClassName15(getClassNameByComponent7({
      component: "SuggestionsItem",
      classPrefix: classPrefix
    }), isFocused ? SEARCH_ITEM_FOCUSED_CLASS : "");
    return {
      SuggestionsItem: appendClassName15(suggestionsItemClassName, className),
      SuggestionItemContainer: getClassNameByComponent7({
        component: "SuggestionItemContainer",
        classPrefix: classPrefix
      }),
      SuggestionsItemIcon: getClassNameByComponent7({
        component: "SuggestionsItemIcon",
        classPrefix: classPrefix
      }),
      SuggestionsItemLabel: getClassNameByComponent7({
        component: "SuggestionsItemLabel",
        classPrefix: classPrefix
      }),
      SuggestionsItemAction: getClassNameByComponent7({
        component: "SuggestionsItemAction",
        classPrefix: classPrefix
      }),
      LabelTypography: getClassNameByComponent7({
        component: "LabelTypography",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, isFocused, className]);
};

// src/components/Search/utils/highlightMatch.tsx
import React42 from "react";
var highlightMatch = function highlightMatch(label, searchQuery) {
  if (!label || !searchQuery || typeof searchQuery !== "string") {
    return "";
  }
  var index = label.toLowerCase().indexOf(searchQuery.toLowerCase());
  if (index !== -1) {
    var highlightPortion = label.substring(index, index + searchQuery.length);
    var prefix = "";
    var suffix = "";
    if (index === 0) {
      suffix = label.substring(searchQuery.length);
      return /* @__PURE__ */React42.createElement(React42.Fragment, null, /* @__PURE__ */React42.createElement("strong", null, highlightPortion), suffix);
    }
    prefix = label.substring(0, index);
    suffix = label.substring(index + searchQuery.length);
    return /* @__PURE__ */React42.createElement(React42.Fragment, null, prefix, /* @__PURE__ */React42.createElement("strong", null, highlightPortion), suffix);
  }
  return label;
};

// src/components/Search/SearchSuggestionItem/SearchSuggestionItem.tsx
var SearchSuggestionItem = function SearchSuggestionItem(_ref81) {
  var className = _ref81.className,
    option = _ref81.option,
    optionIndex = _ref81.optionIndex,
    suggestionIndex = _ref81.suggestionIndex,
    handleSuggestionClick = _ref81.handleSuggestionClick,
    additionalInfo = _ref81.additionalInfo,
    renderItemAdditionalInfo = _ref81.renderItemAdditionalInfo,
    icon = _ref81.icon,
    renderItemIcon = _ref81.renderItemIcon,
    cursorPosition = _ref81.cursorPosition,
    searchQuery = _ref81.searchQuery;
  var classOverride = useSearchSuggestionItemClassName(SEARCH_CLASS_PREFIX, className, cursorPosition === suggestionIndex);
  var handleOnClick = function handleOnClick(selectedOption) {
    return function (event) {
      handleSuggestionClick == null ? void 0 : handleSuggestionClick(event, selectedOption);
    };
  };
  return /* @__PURE__ */React43.createElement(SearchSuggestionItemRoot, {
    className: classOverride.SuggestionsItem
  }, /* @__PURE__ */React43.createElement(SearchSuggestionItemContainer, {
    isHighlighted: cursorPosition === suggestionIndex,
    className: classOverride.SuggestionItemContainer
  }, !!(icon || renderItemIcon) && /* @__PURE__ */React43.createElement(SearchSuggestionsItemIcon, {
    icon: icon,
    renderItemIcon: renderItemIcon,
    className: classOverride.SuggestionsItemIcon
  }, renderItemIcon && renderItemIcon(option, optionIndex) || icon), /* @__PURE__ */React43.createElement(SearchSuggestionsItemLabel, {
    renderItemAdditionalInfo: renderItemAdditionalInfo,
    onClick: handleOnClick(option),
    className: classOverride.SuggestionsItemLabel
  }, /* @__PURE__ */React43.createElement(SearchSuggestionItemLabelTypography, {
    className: classOverride.LabelTypography,
    paragraph: true,
    medium: true
  }, highlightMatch(option.label, searchQuery))), (renderItemAdditionalInfo || additionalInfo) && /* @__PURE__ */React43.createElement(SearchSuggestionsItemAction, {
    renderItemAdditionalInfo: renderItemAdditionalInfo,
    className: classOverride.SuggestionsItemAction
  }, renderItemAdditionalInfo && renderItemAdditionalInfo(option) || additionalInfo)));
};

// src/components/Search/SearchSuggestionsList/style.ts
import styled37, { css as css33 } from "styled-components";
import { color as color16, pixelToRem as pixelToRem3, propsBlocker as propsBlocker36, spacing as spacing28, typography as typography18 } from "@deliveryhero/armor-system";
var getSearchSuggestionListGroupDynamicStyle = function getSearchSuggestionListGroupDynamicStyle(_ref82) {
  var enableSeparator = _ref82.enableSeparator;
  var result = {};
  if (enableSeparator) {
    result = css33(_templateObject254 || (_templateObject254 = _taggedTemplateLiteral(["\n            border-top: 1px solid ", ";\n            padding-top: ", ";\n        "])), color16("neutral.02"), spacing28(10));
  }
  return result;
};
var SearchSuggestionListGroup = styled37.div.withConfig(propsBlocker36)(_templateObject255 || (_templateObject255 = _taggedTemplateLiteral(["\n    padding: ", ";\n    ", ";\n    color: ", ";\n    font-size: ", ";\n    ", ";\n"])), spacing28(6, 4, 2), typography18("labelMedium"), color16("neutral.07"), pixelToRem3(14), getSearchSuggestionListGroupDynamicStyle);

// src/components/Search/SearchSuggestionsList/SearchSuggestionsList.tsx
var SearchSuggestionsList = function SearchSuggestionsList(_ref83) {
  var options = _ref83.options,
    groupIndex = _ref83.groupIndex,
    handleSuggestionClick = _ref83.handleSuggestionClick,
    additionalInfo = _ref83.additionalInfo,
    renderItemAdditionalInfo = _ref83.renderItemAdditionalInfo,
    icon = _ref83.icon,
    renderItemIcon = _ref83.renderItemIcon,
    cursorPosition = _ref83.cursorPosition,
    searchQuery = _ref83.searchQuery,
    noResultsLabel = _ref83.noResultsLabel,
    groupClassName = _ref83.groupClassName;
  var sortedOptions = useSortedList(options != null ? options : [], "groupId");
  if (!options || !options.length) {
    return /* @__PURE__ */React44.createElement(SearchEmptySuggestionsList, {
      noResultsLabel: noResultsLabel
    });
  }
  var displayedGroups = {};
  return sortedOptions.map(function (option, index) {
    var label = option.label,
      groupId = option.groupId;
    var group = null;
    if (groupIndex && groupId && groupId in groupIndex && !displayedGroups[groupId]) {
      group = groupIndex[groupId];
      displayedGroups[groupId] = true;
    }
    return /* @__PURE__ */React44.createElement(React44.Fragment, {
      key: "".concat(!!group && group.label, "-").concat(label)
    }, !!group && /* @__PURE__ */React44.createElement(SearchSuggestionListGroup, {
      className: groupClassName,
      enableSeparator: index > 0
    }, group.label), /* @__PURE__ */React44.createElement(SearchSuggestionItem, {
      option: option,
      optionIndex: index,
      suggestionIndex: index,
      handleSuggestionClick: handleSuggestionClick,
      additionalInfo: additionalInfo,
      renderItemAdditionalInfo: renderItemAdditionalInfo,
      icon: icon,
      renderItemIcon: renderItemIcon,
      cursorPosition: cursorPosition,
      searchQuery: searchQuery
    }));
  });
};
SearchSuggestionsList.propTypes = {
  handleSuggestionClick: PropTypes22.func.isRequired,
  /**
   * @deprecated
   * Use renderItemAdditionalInfo
   */
  additionalInfo: PropTypes22.element,
  renderItemAdditionalInfo: PropTypes22.func,
  icon: PropTypes22.element,
  cursorPosition: PropTypes22.number,
  searchQuery: PropTypes22.string,
  options: PropTypes22.arrayOf(PropTypes22.shape({
    value: PropTypes22.oneOfType([PropTypes22.number, PropTypes22.string]).isRequired,
    label: PropTypes22.string.isRequired
  }).isRequired)
};

// src/components/Search/SearchIcon/SearchIcon.tsx
import React45 from "react";
import PropTypes23 from "prop-types";

// src/components/Search/SearchIcon/style.ts
import styled38, { css as css34 } from "styled-components";
import { SearchIcon } from "@deliveryhero/armor-icons";
import { propsBlocker as propsBlocker37, color as color17 } from "@deliveryhero/armor-system";
var SearchIconRoot = styled38.div.withConfig(propsBlocker37)(_templateObject256 || (_templateObject256 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    flex: 0 0 auto;\n"])));
var SearchInputSearchIcon = styled38(SearchIcon).attrs({
  small: true
})(function (_ref84) {
  var disabled = _ref84.disabled;
  return css34(_templateObject257 || (_templateObject257 = _taggedTemplateLiteral(["\n        color: ", ";\n    "])), disabled ? color17("neutral.05") : color17("neutral.11"));
});

// src/components/Search/SearchIcon/constants.ts
var SEARCH_ICON_CLASS_PREFIX = "SearchIcon";

// src/components/Search/SearchIcon/hooks/useSearchIconClassName.ts
import { useMemo as useMemo48 } from "react";
import { appendClassName as appendClassName16, makeBEM as makeBEM29 } from "@deliveryhero/armor-system";
var getClassNameByComponent8 = function getClassNameByComponent8(_ref85) {
  var component = _ref85.component,
    classPrefix = _ref85.classPrefix,
    disabled = _ref85.disabled;
  var baseClassNames = makeBEM29(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM29(classPrefix, component, "disabled"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useSearchIconClassName = function useSearchIconClassName(classPrefix, className, disabled) {
  return useMemo48(function () {
    return {
      BeforeIcon: appendClassName16(getClassNameByComponent8({
        component: "BeforeIcon",
        classPrefix: classPrefix,
        disabled: disabled
      }), className),
      BeforeIconContainer: getClassNameByComponent8({
        component: "BeforeIconContainer",
        classPrefix: classPrefix,
        disabled: disabled
      })
    };
  }, [classPrefix, className, disabled]);
};

// src/components/Search/SearchIcon/SearchIcon.tsx
var SearchIcon2 = function SearchIcon2(_ref86) {
  var className = _ref86.className,
    disabled = _ref86.disabled;
  var classOverride = useSearchIconClassName(SEARCH_ICON_CLASS_PREFIX, className, disabled);
  return /* @__PURE__ */React45.createElement(SearchIconRoot, {
    className: classOverride.BeforeIconContainer
  }, /* @__PURE__ */React45.createElement(SearchInputSearchIcon, {
    className: classOverride.BeforeIcon,
    disabled: disabled
  }));
};
SearchIcon2.propTypes = {
  disabled: PropTypes23.bool
};

// src/components/Search/SearchClearAction/SearchClearAction.tsx
import React46 from "react";
import PropTypes24 from "prop-types";

// src/components/Search/SearchClearAction/constants.ts
var SEARCH_CLEAR_ACTION_CLASS_PREFIX = "SearchClearAction";
var searchInputClearIcon = "SearchInputClearIcon";

// src/components/Search/SearchClearAction/hooks/useSearchClearActionClassName.ts
import { useMemo as useMemo49 } from "react";
import { appendClassName as appendClassName17, makeBEM as makeBEM30 } from "@deliveryhero/armor-system";
var getClassNameByComponent9 = function getClassNameByComponent9(_ref87) {
  var component = _ref87.component,
    classPrefix = _ref87.classPrefix,
    disabled = _ref87.disabled;
  var baseClassNames = makeBEM30(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM30(classPrefix, component, "disabled"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useSearchClearActionClassName = function useSearchClearActionClassName(classPrefix, className, disabled) {
  return useMemo49(function () {
    return {
      AfterIcon: appendClassName17(getClassNameByComponent9({
        component: "AfterIcon",
        classPrefix: classPrefix,
        disabled: disabled
      }), className),
      AfterIconContainer: getClassNameByComponent9({
        component: "AfterIconContainer",
        classPrefix: classPrefix,
        disabled: disabled
      })
    };
  }, [classPrefix, className, disabled]);
};

// src/components/Search/SearchClearAction/style.ts
import styled39 from "styled-components";
import { propsBlocker as propsBlocker38 } from "@deliveryhero/armor-system";
var ClearIconRoot = styled39.div.withConfig(propsBlocker38)(_templateObject258 || (_templateObject258 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));

// src/components/Search/SearchClearAction/SearchClearAction.tsx
var SearchClearAction = function SearchClearAction(_ref88) {
  var className = _ref88.className,
    disableClearAction = _ref88.disableClearAction,
    handleClearQuery = _ref88.handleClearQuery,
    disabled = _ref88.disabled,
    searchQuery = _ref88.searchQuery;
  var classOverride = useSearchClearActionClassName(SEARCH_CLEAR_ACTION_CLASS_PREFIX, className, disabled);
  if (disableClearAction || !searchQuery) {
    return null;
  }
  return /* @__PURE__ */React46.createElement(ClearIconRoot, {
    className: classOverride.AfterIconContainer,
    onClick: handleClearQuery
  }, /* @__PURE__ */React46.createElement(ClearButton, {
    iconSize: "medium",
    state: disabled ? "disabled" : void 0,
    className: classOverride.AfterIcon,
    "data-testid": searchInputClearIcon
  }));
};
SearchClearAction.propTypes = {
  disabled: PropTypes24.bool,
  disableClearAction: PropTypes24.bool,
  handleClearQuery: PropTypes24.func,
  searchQuery: PropTypes24.string
};

// src/components/Search/Search.tsx
var Search = forwardRef27(function Search2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var _useSearch = useSearch(restProps, ref),
    rootProps = _useSearch.rootProps,
    textInputProps = _useSearch.textInputProps,
    searchIconProps = _useSearch.searchIconProps,
    searchClearActionProps = _useSearch.searchClearActionProps,
    suggestionsContainerProps = _useSearch.suggestionsContainerProps,
    suggestionListContainerProps = _useSearch.suggestionListContainerProps,
    suggestionListProps = _useSearch.suggestionListProps,
    disabled = _useSearch.disabled,
    isSuggestionsListShown = _useSearch.isSuggestionsListShown,
    isLoading = _useSearch.isLoading,
    loadingPlaceholder = _useSearch.loadingPlaceholder;
  var classOverride = useSearchClassName(SEARCH_CLASS_PREFIX, className, disabled, isSuggestionsListShown);
  return /* @__PURE__ */React47.createElement(SearchRoot, __spreadProps(__spreadValues({
    "data-testid": searchRoot
  }, rootProps), {
    className: classOverride.Root,
    disabled: disabled
  }), /* @__PURE__ */React47.createElement(SearchTextInput, __spreadProps(__spreadValues({}, textInputProps), {
    before: /* @__PURE__ */React47.createElement(SearchIcon2, __spreadValues({}, searchIconProps)),
    after: /* @__PURE__ */React47.createElement(SearchClearAction, __spreadValues({}, searchClearActionProps)),
    className: classOverride.TextInput
  })), isSuggestionsListShown ? /* @__PURE__ */React47.createElement(SearchSuggestionsContainer, __spreadProps(__spreadValues({}, suggestionsContainerProps), {
    className: classOverride.SuggestionsContainer
  }), isLoading ? /* @__PURE__ */React47.createElement(LoadingContainer, null, loadingPlaceholder || "Loading results...") : /* @__PURE__ */React47.createElement(SearchSuggestionsListContainer, __spreadProps(__spreadValues({}, suggestionListContainerProps), {
    className: classOverride.SearchSuggestionsList
  }), /* @__PURE__ */React47.createElement(SearchSuggestionsList, __spreadProps(__spreadValues({}, suggestionListProps), {
    groupClassName: classOverride.ListItemGroup
  })))) : null);
});
Search.propTypes = {
  // onClose: PropTypes.func,
  defaultQuery: PropTypes25.string,
  disabled: PropTypes25.bool,
  disableClearAction: PropTypes25.bool,
  /**
   * @deprecated
   * Use renderItemAdditionalInfo
   */
  additionalInfo: PropTypes25.element,
  renderItemAdditionalInfo: PropTypes25.func,
  /**
   * @deprecated
   * Use renderItemIcon
   */
  icon: PropTypes25.element,
  renderItemIcon: PropTypes25.func,
  onChange: PropTypes25.func,
  onItemSelect: PropTypes25.func,
  options: PropTypes25.arrayOf(PropTypes25.shape({
    value: PropTypes25.oneOfType([PropTypes25.number, PropTypes25.string]).isRequired,
    label: PropTypes25.string.isRequired
    // groupId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired),
  groups: PropTypes25.arrayOf(PropTypes25.shape({
    id: PropTypes25.oneOfType([PropTypes25.number, PropTypes25.string]).isRequired,
    label: PropTypes25.string.isRequired
  }).isRequired),
  placeholder: PropTypes25.string,
  enableSuggestions: PropTypes25.bool,
  isLoading: PropTypes25.bool,
  /**
   * height of the list in in 4px unit increments
   */
  suggestionListHeight: PropTypes25.oneOfType([PropTypes25.string, PropTypes25.number])
};
var MemoizedSearch = memo35(Search);

// src/components/OptionList/style.ts
var getOptionListStyle = function getOptionListStyle(_ref89) {
  var isOptionListShown = _ref89.isOptionListShown,
    enableAbsolutePositioning = _ref89.enableAbsolutePositioning;
  var result = css35(_templateObject259 || (_templateObject259 = _taggedTemplateLiteral(["\n        height: ", ";\n    "])), isOptionListShown ? "auto" : "0");
  if (enableAbsolutePositioning !== false) {
    result = css35(_templateObject260 || (_templateObject260 = _taggedTemplateLiteral(["\n            ", ";\n            position: absolute;\n            top: ", ";\n            left: 0;\n            right: 0;\n        "])), result, spacing31(1));
  }
  return result;
};
var OptionListRoot = styled40.div.withConfig(propsBlocker39)(_templateObject261 || (_templateObject261 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    background-color: ", ";\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 0;\n    padding-top: 0;\n    transition: ", "ms;\n    box-shadow: ", ";\n    ", ";\n    ", ";\n"])), reset13, typography19("paragraphMedium"), token28("body.color"), color18("neutral.00"), durationNormal8, elevation("large"), getOptionListStyle, getComponentOverride25("OptionList"));
var OptionListContainer = styled40.div.withConfig(propsBlocker39)(_templateObject262 || (_templateObject262 = _taggedTemplateLiteral(["\n    position: relative;\n    height: fit-content;\n    max-height: ", ";\n    ", ";\n"])), spacing31(100), heightProps3);
var OptionListContent = styled40.div.withConfig(propsBlocker39)(_templateObject263 || (_templateObject263 = _taggedTemplateLiteral(["\n    overflow: auto;\n    max-height: inherit;\n"])));
var getGradientEffectStyle = function getGradientEffectStyle(_ref90) {
  var isShown = _ref90.isShown;
  var result = css35(_templateObject264 || (_templateObject264 = _taggedTemplateLiteral(["\n        position: absolute;\n        width: 100%;\n        height: ", ";\n        opacity: 0;\n        z-index: 1;\n        ", "\n        ", ";\n    "])), spacing31(13), pointerEvents3({
    disabled: true
  }), transition15({
    opacity: true
  }));
  if (isShown) {
    result = css35(_templateObject265 || (_templateObject265 = _taggedTemplateLiteral(["\n            ", ";\n            opacity: 1;\n        "])), result);
  }
  return result;
};
var TopGradientEffect = styled40.div.withConfig(propsBlocker39)(_templateObject266 || (_templateObject266 = _taggedTemplateLiteral(["\n    ", ";\n    top: 0;\n    background: linear-gradient(\n        180deg,\n        ", " 0%,\n        ", " 80%\n    );\n"])), getGradientEffectStyle, color18("neutral.00"), color18("neutral.00", 0));
var BottomGradientEffect = styled40.div.withConfig(propsBlocker39)(_templateObject267 || (_templateObject267 = _taggedTemplateLiteral(["\n    ", ";\n    bottom: 0;\n    background: linear-gradient(\n        180deg,\n        ", " 0%,\n        ", " 80%\n    );\n"])), getGradientEffectStyle, color18("neutral.00", 0), color18("neutral.00"));
var OptionListBeforeSectionContainer = styled40.div.withConfig(propsBlocker39)(_templateObject268 || (_templateObject268 = _taggedTemplateLiteral(["\n    top: 0;\n    background: ", ";\n"])), color18("neutral.00"));
var OptionListSearchContainer = styled40.div.withConfig(propsBlocker39)(_templateObject269 || (_templateObject269 = _taggedTemplateLiteral(["\n    padding: ", ";\n"])), spacing31(4));
var OptionListSearch = styled40(Search).attrs({
  enableSuggestions: false
})(_templateObject270 || (_templateObject270 = _taggedTemplateLiteral(["\n    width: 100%;\n"])));
var OptionListFooterContainer = styled40.div.attrs({
  enableSuggestions: false
})(_templateObject271 || (_templateObject271 = _taggedTemplateLiteral(["\n    padding: ", ";\n    display: flex;\n    justify-content: space-between;\n    background-color: ", ";\n    border-top: 1px solid ", ";\n"])), spacing31(3), color18("neutral.01"), color18("neutral.03"));
var focusedHoverState = css35(_templateObject272 || (_templateObject272 = _taggedTemplateLiteral(["\n    background-color: ", ";\n\n    .Checkbox-Checkmark:before {\n        border-color: ", ";\n    }\n"])), color18("primary.01"), color18("primary.08"));
var optionItemStyle = function optionItemStyle(_ref91) {
  var disabled = _ref91.item.disabled,
    isFocused = _ref91.isFocused,
    isSelected = _ref91.isSelected,
    multiple = _ref91.multiple;
  var isActive = isSelected && !disabled && !multiple;
  var result = css35(_templateObject273 || (_templateObject273 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        min-height: ", ";\n\n        ", "\n        &:hover {\n            ", "\n        }\n    "])), color18("neutral.00"), spacing31(10), transition15({
    "background-color": true
  }), focusedHoverState);
  if (isFocused) {
    result = css35(_templateObject274 || (_templateObject274 = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, focusedHoverState);
  }
  if (isActive) {
    result = css35(_templateObject275 || (_templateObject275 = _taggedTemplateLiteral(["\n            ", ";\n\n            position: relative;\n\n            ", "\n            &:hover {\n                background-color: ", ";\n            }\n\n            &::before {\n                content: '';\n\n                position: absolute;\n                top: 0;\n                left: 0;\n                bottom: 0;\n\n                width: ", ";\n                background: ", ";\n            }\n        "])), result, pointerEvents3({
      disabled: true
    }), color18("neutral.00"), spacing31(0.5), color18("primary.07"));
  }
  if (disabled) {
    result = css35(_templateObject276 || (_templateObject276 = _taggedTemplateLiteral(["\n            ", ";\n\n            background-color: ", ";\n\n            color: ", ";\n\n            cursor: not-allowed;\n\n            &:hover {\n                background-color: ", ";\n\n                .Checkbox-Checkmark:before {\n                    border-color: ", ";\n                }\n            }\n        "])), result, isFocused ? color18("primary.01") : color18("neutral.02"), color18("neutral.05"), color18("neutral.02"), color18("neutral.03"));
  }
  return result;
};
var OptionListItem = styled40.div.withConfig(propsBlocker39)(_templateObject277 || (_templateObject277 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    cursor: pointer;\n\n    ", ";\n    ", ";\n\n    &.OptionList-SelectAllItem {\n        border-bottom: 1px solid ", ";\n    }\n\n    & .ListItem-Root {\n        &:hover {\n            background-color: transparent;\n        }\n    }\n"])), optionItemStyle, getComponentOverride25("OptionListItem"), color18("neutral.03"));
var OptionListItemLabelContainer = styled40.div.withConfig(propsBlocker39)(_templateObject278 || (_templateObject278 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    padding: ", ";\n"])), spacing31(2, 4));
var OptionListItemTypography = styled40(Typography)(_templateObject279 || (_templateObject279 = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    ", ";\n"])), function (_ref92) {
  var enableContentEllipsis = _ref92.enableContentEllipsis;
  return enableContentEllipsis !== false ? css35(_templateObject280 || (_templateObject280 = _taggedTemplateLiteral(["\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n              "]))) : "";
});
var OptionListItemGroupTypography = styled40(Typography)(_templateObject281 || (_templateObject281 = _taggedTemplateLiteral(["\n    color: ", ";\n    ", "\n"])), color18("neutral.07"), function (_ref93) {
  var enableContentEllipsis = _ref93.enableContentEllipsis;
  var result = css35(_templateObject282 || (_templateObject282 = _taggedTemplateLiteral([""])));
  if (enableContentEllipsis !== false) {
    result = css35(_templateObject283 || (_templateObject283 = _taggedTemplateLiteral(["\n                ", ";\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            "])), result);
  }
  return result;
});
var getSearchSuggestionListGroupDynamicStyle2 = function getSearchSuggestionListGroupDynamicStyle2(_ref94) {
  var enableSeparator = _ref94.enableSeparator,
    enableGroupSelection = _ref94.enableGroupSelection;
  var result = {};
  if (enableSeparator || enableGroupSelection) {
    result = css35(_templateObject284 || (_templateObject284 = _taggedTemplateLiteral(["\n            border-top: 1px solid ", ";\n        "])), color18("neutral.02"));
  }
  return result;
};
var getOptionListItemGroupRootStyle = function getOptionListItemGroupRootStyle(_ref95) {
  var multiple = _ref95.multiple,
    enableGroupSelection = _ref95.enableGroupSelection;
  var result = css35(_templateObject285 || (_templateObject285 = _taggedTemplateLiteral(["\n        padding: ", ";\n    "])), spacing31(6, 4, 2));
  if (multiple && enableGroupSelection) {
    result = css35(_templateObject286 || (_templateObject286 = _taggedTemplateLiteral(["\n            ", ";\n\n            padding: ", ";\n            text-transform: uppercase;\n            align-items: center;\n            box-sizing: border-box;\n            cursor: pointer;\n            display: flex;\n\n            &:hover {\n                background-color: ", ";\n            }\n        "])), result, spacing31(3, 4), color18("primary.lightest"));
  }
  return result;
};
var OptionListItemGroupRoot = styled40.div.withConfig(propsBlocker39)(_templateObject287 || (_templateObject287 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    ", ";\n    ", ";\n    ", "\n"])), typography19("labelSmall"), color18("neutral.07"), getOptionListItemGroupRootStyle, getSearchSuggestionListGroupDynamicStyle2, getComponentOverride25("OptionListItemGroup"));
var OptionListVirtualPadding = styled40.div.withConfig(propsBlocker39)(_templateObject288 || (_templateObject288 = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    font-size: 0;\n    line-height: 0;\n    height: ", "px;\n"])), function (_ref96) {
  var height = _ref96.height;
  return height;
});
var OptionListItemAdditionalInfo = styled40.div.withConfig(propsBlocker39)(_templateObject289 || (_templateObject289 = _taggedTemplateLiteral([""])));

// src/components/OptionList/OptionListItem.tsx
import React48 from "react";

// src/components/OptionList/hooks/useOptionListItem.ts
import { useCallback as useCallback15 } from "react";
var useOptionListItem = function useOptionListItem(_a) {
  var _b = _a,
    isSelected = _b.isSelected,
    onOptionSelect = _b.onOptionSelect,
    item = _b.item,
    multiple = _b.multiple,
    checkedIcon = _b.checkedIcon,
    enableContentEllipsis = _b.enableContentEllipsis,
    renderItemAdditionalInfo = _b.renderItemAdditionalInfo,
    cursorPosition = _b.cursorPosition,
    optionIndex = _b.optionIndex,
    restProps = __objRest(_b, ["isSelected", "onOptionSelect", "item", "multiple", "checkedIcon", "enableContentEllipsis", "renderItemAdditionalInfo", "cursorPosition", "optionIndex"]);
  var handleItemClick = useCallback15(function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (onOptionSelect && !(item == null ? void 0 : item.disabled)) {
      onOptionSelect(item);
    }
  }, [onOptionSelect, item]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      isSelected: isSelected,
      item: item,
      onClick: handleItemClick,
      isFocused: cursorPosition === optionIndex,
      multiple: multiple
    }),
    checkboxProps: {
      checked: isSelected,
      marginRight: 4,
      checkedIcon: checkedIcon,
      disabled: item == null ? void 0 : item.disabled
    },
    typographyProps: {
      paragraph: true,
      tag: "div",
      maxLines: 2,
      disabled: item == null ? void 0 : item.disabled,
      enableContentEllipsis: enableContentEllipsis
    },
    multiple: multiple,
    label: item.label,
    showAdditionalInfo: !!renderItemAdditionalInfo,
    getAdditionalInfo: function getAdditionalInfo() {
      return renderItemAdditionalInfo ? renderItemAdditionalInfo(item) : null;
    }
  };
};

// src/components/OptionList/hooks/useOptionListItemClassName.ts
import { useMemo as useMemo50 } from "react";
import { appendClassName as appendClassName18, makeBEM as makeBEM31 } from "@deliveryhero/armor-system";
var useOptionListItemClassName = function useOptionListItemClassName(classPrefix, className, isFocused) {
  return useMemo50(function () {
    var rootClassName = appendClassName18(makeBEM31(classPrefix, "Root"), isFocused ? OPTION_LIST_ITEM_FOCUSED_CLASS : "");
    return {
      Root: appendClassName18(rootClassName, className),
      Checkbox: makeBEM31(classPrefix, "Checkbox"),
      Typography: makeBEM31(classPrefix, "Typography"),
      AdditionalInfo: makeBEM31(classPrefix, "AdditionalInfo"),
      LabelContainer: makeBEM31(classPrefix, "LabelContainer")
    };
  }, [classPrefix, className, isFocused]);
};

// src/components/OptionList/OptionListItem.tsx
var OptionListItem2 = function OptionListItem2(_a) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var _useOptionListItem = useOptionListItem(props),
    rootProps = _useOptionListItem.rootProps,
    checkboxProps = _useOptionListItem.checkboxProps,
    typographyProps = _useOptionListItem.typographyProps,
    multiple = _useOptionListItem.multiple,
    label = _useOptionListItem.label,
    showAdditionalInfo = _useOptionListItem.showAdditionalInfo,
    getAdditionalInfo = _useOptionListItem.getAdditionalInfo;
  var classOverride = useOptionListItemClassName(OPTION_LIST_ITEM_CLASS_PREFIX, className, rootProps.isFocused);
  return /* @__PURE__ */React48.createElement(OptionListItem, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  }), typeof label === "string" ? /* @__PURE__ */React48.createElement(OptionListItemLabelContainer, {
    className: classOverride.LabelContainer
  }, multiple && /* @__PURE__ */React48.createElement(Checkbox, __spreadProps(__spreadValues({}, checkboxProps), {
    className: classOverride.Checkbox
  })), /* @__PURE__ */React48.createElement(OptionListItemTypography, __spreadProps(__spreadValues({}, typographyProps), {
    className: classOverride.Typography
  }), label), showAdditionalInfo && /* @__PURE__ */React48.createElement(OptionListItemAdditionalInfo, {
    className: classOverride.AdditionalInfo
  }, getAdditionalInfo())) : label);
};

// src/components/OptionList/hooks/useOptionList.ts
import { useCallback as useCallback19, useEffect as useEffect11, useMemo as useMemo51, useRef as useRef7, useState as useState7 } from "react";
import { useVirtualization, useScrollToNode as useScrollToNode2, useNavigationControl as useNavigationControl2, getWindow as getWindow2 } from "@deliveryhero/armor-system";

// src/components/OptionList/hooks/useShowGradientEffectOnScroll.ts
import { useState as useState6, useCallback as useCallback16, useEffect as useEffect10 } from "react";
import { useScrollObserver, durationNormal as durationNormal9 } from "@deliveryhero/armor-system";
var useShowGradientEffectOnScroll = function useShowGradientEffectOnScroll(enabled, containerRef) {
  var _useState25 = useState6(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isOverflowing = _useState26[0],
    setIsOverflowing = _useState26[1];
  var _useState27 = useState6(false),
    _useState28 = _slicedToArray(_useState27, 2),
    isTopGradientEffectShown = _useState28[0],
    setIsTopGradientEffectShown = _useState28[1];
  var _useState29 = useState6(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isBottomGradientEffectShown = _useState30[0],
    setIsBottomGradientEffectShown = _useState30[1];
  useEffect10(function () {
    if (containerRef == null ? void 0 : containerRef.current) {
      var listElement = containerRef.current;
      var isContentOverflowing = listElement.clientHeight < listElement.scrollHeight;
      setIsOverflowing(isContentOverflowing);
    }
  }, [containerRef == null ? void 0 : containerRef.current]);
  var handleScrollChange = useCallback16(function (scrollHeight) {
    var listElement = containerRef == null ? void 0 : containerRef.current;
    if (!listElement) {
      return;
    }
    var isScrollAtTop = scrollHeight === 0;
    var isScrollAtBottom = scrollHeight && scrollHeight >= listElement.scrollHeight - listElement.clientHeight;
    setIsTopGradientEffectShown(!isScrollAtTop);
    setIsBottomGradientEffectShown(!isScrollAtBottom);
  }, [containerRef]);
  useScrollObserver(enabled && isOverflowing, handleScrollChange, {
    enableInitialCall: true,
    containerRef: containerRef,
    throttleDelay: durationNormal9
  });
  return {
    isTopGradientEffectShown: isTopGradientEffectShown,
    isBottomGradientEffectShown: isBottomGradientEffectShown
  };
};

// src/components/OptionList/hooks/useOnSearchQueryChange.ts
import { useCallback as useCallback17 } from "react";
import { stripHTMLTagsMemoized as stripHTMLTags3 } from "@deliveryhero/armor-system";
var checkMatchQuery = function checkMatchQuery(query) {
  return function (option) {
    var label = stripHTMLTags3(option.label).toLowerCase();
    var value = "".concat(option.value).toLowerCase();
    return label.includes(query) || value.includes(query);
  };
};
var useOnSearchQueryChange = function useOnSearchQueryChange(internalOptions, setInternalOptions, setSearchQuery, defaultSearchQuery, enableSearchOption) {
  return useCallback17(function () {
    var searchQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSearchQuery;
    if (!enableSearchOption) {
      return function () {};
    }
    if (!searchQuery) {
      setInternalOptions == null ? void 0 : setInternalOptions(internalOptions);
      return function () {};
    }
    var query = searchQuery.toLowerCase();
    setSearchQuery == null ? void 0 : setSearchQuery(query);
    var matchingOptions = internalOptions.filter(checkMatchQuery(query));
    setInternalOptions == null ? void 0 : setInternalOptions(matchingOptions);
    return function () {};
  }, [defaultSearchQuery, enableSearchOption, setSearchQuery, internalOptions, setInternalOptions]);
};

// src/components/Dropdown/hooks/useOnToggleGroup.ts
import { useCallback as useCallback18 } from "react";
var getAllGroupMembers = function getAllGroupMembers(groupId, options) {
  var allGroupMemberOptions = [];
  options.forEach(function (option) {
    if (option.groupId === groupId && !option.disabled) {
      allGroupMemberOptions.push(option.value);
    }
  });
  return allGroupMemberOptions;
};
var isUnique = function isUnique(value, index, options) {
  return options.indexOf(value) === index;
};
var useOnToggleGroup = function useOnToggleGroup(setInternalValue, internalOptions, internalValue, internalGroups, onChange) {
  return useCallback18(function (groupId) {
    var preselectedDisabledOptionItems = [];
    internalOptions.forEach(function (option) {
      if (option.disabled && internalValue.includes(option.value)) {
        preselectedDisabledOptionItems.push(option.value);
      }
    });
    var updatedOptionValues = [].concat(preselectedDisabledOptionItems, _toConsumableArray(internalValue));
    if (internalGroups && groupId in internalGroups) {
      if (internalGroups[groupId].totalItemsCount === internalGroups[groupId].selectedItemsCount) {
        updatedOptionValues = updatedOptionValues.filter(function (value) {
          return !internalGroups[groupId].selectedItemIds.includes(value);
        });
      } else {
        var allGroupMemberOptions = getAllGroupMembers(groupId, internalOptions);
        updatedOptionValues = [].concat(_toConsumableArray(updatedOptionValues), _toConsumableArray(allGroupMemberOptions));
      }
    } else {
      var _allGroupMemberOptions = getAllGroupMembers(groupId, internalOptions);
      updatedOptionValues = [].concat(_toConsumableArray(updatedOptionValues), _toConsumableArray(_allGroupMemberOptions));
    }
    updatedOptionValues = updatedOptionValues.filter(isUnique);
    handleOnChange(updatedOptionValues, onChange);
    setInternalValue == null ? void 0 : setInternalValue(updatedOptionValues);
  }, [internalOptions, internalValue, internalGroups, onChange, setInternalValue]);
};

// src/components/OptionList/hooks/useOptionList.ts
var useOptionList = function useOptionList(_a) {
  var _b = _a,
    disabled = _b.disabled,
    options = _b.options,
    multiple = _b.multiple,
    internalValue = _b.internalValue,
    blurInput = _b.blurInput,
    setIsOptionListShown = _b.setIsOptionListShown,
    onValueUpdate = _b.onValueUpdate,
    onChange = _b.onChange,
    setInternalValue = _b.setInternalValue,
    internalOptions = _b.internalOptions,
    internalGroups = _b.internalGroups,
    _b$dynamicInternalOpt = _b.dynamicInternalOptions,
    dynamicInternalOptions = _b$dynamicInternalOpt === void 0 ? internalOptions : _b$dynamicInternalOpt,
    setInternalOptions = _b.setInternalOptions,
    setSearch = _b.setSearch,
    enableSelectAllOption = _b.enableSelectAllOption,
    _b$selectAllLabel = _b.selectAllLabel,
    selectAllLabel = _b$selectAllLabel === void 0 ? "Select all" : _b$selectAllLabel,
    enableSearchOption = _b.enableSearchOption,
    _b$searchPlaceholder = _b.searchPlaceholder,
    searchPlaceholder = _b$searchPlaceholder === void 0 ? "Search" : _b$searchPlaceholder,
    enableFooter = _b.enableFooter,
    onCancelClick = _b.onCancelClick,
    onConfirmClick = _b.onConfirmClick,
    footerContent = _b.footerContent,
    _b$defaultSearchQuery = _b.defaultSearchQuery,
    defaultSearchQuery = _b$defaultSearchQuery === void 0 ? "" : _b$defaultSearchQuery,
    _b$enableVirtualizati = _b.enableVirtualization,
    enableVirtualization = _b$enableVirtualizati === void 0 ? false : _b$enableVirtualizati,
    isFlat = _b.isFlat,
    groups = _b.groups,
    enableGroupSelection = _b.enableGroupSelection,
    enableOptionContentEllipsis = _b.enableOptionContentEllipsis,
    renderItemAdditionalInfo = _b.renderItemAdditionalInfo,
    autoFocus = _b.autoFocus,
    enableScrollGradientEffect = _b.enableScrollGradientEffect,
    maxDropdownHeight = _b.maxDropdownHeight,
    restProps = __objRest(_b, ["disabled", "options", "multiple", "internalValue", "blurInput", "setIsOptionListShown", "onValueUpdate", "onChange", "setInternalValue", "internalOptions", "internalGroups", "dynamicInternalOptions", "setInternalOptions", "setSearch", "enableSelectAllOption", "selectAllLabel", "enableSearchOption", "searchPlaceholder", "enableFooter", "onCancelClick", "onConfirmClick", "footerContent", "defaultSearchQuery", "enableVirtualization", "isFlat", "groups", "enableGroupSelection", "enableOptionContentEllipsis", "renderItemAdditionalInfo", "autoFocus", "enableScrollGradientEffect", "maxDropdownHeight"]);
  var _useState31 = useState7(INITIAL_CURSOR_POSITION),
    _useState32 = _slicedToArray(_useState31, 2),
    cursorPosition = _useState32[0],
    setCursorPosition = _useState32[1];
  var _useState33 = useState7(defaultSearchQuery),
    _useState34 = _slicedToArray(_useState33, 2),
    searchQuery = _useState34[0],
    setSearchQuery = _useState34[1];
  var listContentRef = useRef7(null);
  var listRef = useRef7(null);
  var searchInputRef = useRef7(null);
  var isSelectAllOptionRendered = enableSelectAllOption && multiple && !searchQuery;
  var _useVirtualization = useVirtualization(enableVirtualization, listRef, dynamicInternalOptions, {
      itemSelector: ".OptionListItem-Root",
      parentContainerRef: listContentRef
    }),
    virtualData = _useVirtualization.data,
    virtualBottomOffset = _useVirtualization.bottomOffset,
    virtualTopOffset = _useVirtualization.topOffset;
  useEffect11(function () {
    if (!autoFocus) {
      return;
    }
    var element = searchInputRef.current;
    element == null ? void 0 : element.focus({
      preventScroll: true
    });
  }, [autoFocus]);
  useEffect11(function () {
    setSearch == null ? void 0 : setSearch(searchQuery);
  }, [searchQuery, setSearch]);
  var onSearchChange = useOnSearchQueryChange(internalOptions, setInternalOptions, setSearch, searchQuery, enableSearchOption);
  var resetListState = useCallback19(function () {
    setSearchQuery("");
    onSearchChange();
  }, [onSearchChange]);
  var onOptionSelect = useCallback19(function (item) {
    if (internalOptions) {
      onValueUpdate(internalValue, multiple, item, item.value, options, isFlat);
    }
    if (!multiple) {
      setIsOptionListShown(false);
      resetListState();
    }
    if (blurInput) {
      blurInput();
    }
  }, [internalOptions, multiple, blurInput, onValueUpdate, internalValue, options, isFlat, setIsOptionListShown, resetListState]);
  var onToggleAll = useOnToggleAll(setInternalValue, internalOptions, internalValue, onChange);
  var onToggleGroup = useOnToggleGroup(setInternalValue, internalOptions, internalValue, internalGroups, onChange);
  useEffect11(function () {
    return onSearchChange();
  }, [onSearchChange, searchQuery]);
  var handleToggleAll = function handleToggleAll() {
    return onToggleAll();
  };
  var handleSearchChange = useCallback19(function (event) {
    var newSearchQuery = event.target.value || "";
    setSearchQuery(newSearchQuery);
    setCursorPosition(INITIAL_CURSOR_POSITION);
  }, [setSearchQuery]);
  var handleToggleGroup = useCallback19(function (event, groupId) {
    if (!enableGroupSelection) {
      return;
    }
    onToggleGroup(groupId);
  }, [enableGroupSelection, onToggleGroup]);
  var selectAllCheckedIcon = internalOptions.filter(function (option) {
    return !(option == null ? void 0 : option.disabled) || !!(option == null ? void 0 : option.disabled) && internalValue.includes(option.value);
  }).length === internalValue.length ? "tick" : "dash";
  var groupIndex = useMemo51(function () {
    if (!groups || !groups.length) {
      return {};
    }
    return groups.reduce(function (result, group) {
      result[group.id] = group;
      return result;
    }, {});
  }, [groups]);
  var handleCancelButtonClick = function handleCancelButtonClick() {
    setIsOptionListShown(false);
    if (onCancelClick) {
      onCancelClick();
    }
  };
  var handleConfirmButtonClick = function handleConfirmButtonClick() {
    setIsOptionListShown(false);
    if (onConfirmClick) {
      onConfirmClick();
    }
  };
  var selectAllItem = useMemo51(function () {
    return {
      value: -1,
      label: selectAllLabel
    };
  }, [selectAllLabel]);
  var scrollToCurrent = useScrollToNode2({
    className: OPTION_LIST_ITEM_FOCUSED_CLASS
  });
  var handleEnterPress = useCallback19(function () {
    var win2 = getWindow2();
    if (!win2) {
      return;
    }
    var focusedElement = document.querySelector(".".concat(OPTION_LIST_ITEM_FOCUSED_CLASS));
    var selectedLabel = focusedElement == null ? void 0 : focusedElement.textContent;
    if (selectedLabel === selectAllLabel) {
      onToggleAll();
    } else if ((options == null ? void 0 : options.length) && selectedLabel) {
      var selectedOption = options.find(function (option) {
        return option.label === selectedLabel;
      });
      if (selectedOption && !selectedOption.disabled) {
        onOptionSelect(selectedOption);
      }
    }
  }, [selectAllLabel, options, onToggleAll, onOptionSelect]);
  useEffect11(function () {
    scrollToCurrent();
  }, [cursorPosition]);
  useNavigationControl2({
    yLength: isSelectAllOptionRendered ? ((options == null ? void 0 : options.length) || 0) + 1 : (options == null ? void 0 : options.length) || 0,
    setCursorY: setCursorPosition,
    targetElement: searchInputRef,
    onEnterKeyPress: handleEnterPress
  });
  var _useShowGradientEffec = useShowGradientEffectOnScroll(!!enableScrollGradientEffect, listContentRef),
    isTopGradientEffectShown = _useShowGradientEffec.isTopGradientEffectShown,
    isBottomGradientEffectShown = _useShowGradientEffec.isBottomGradientEffectShown;
  return {
    rootProps: restProps,
    getOptionItemProps: function getOptionItemProps(option) {
      return {
        "data-testid": OPTION_LIST_ITEM,
        isSelected: internalValue.includes(option.value),
        item: option,
        key: option.value,
        onOptionSelect: onOptionSelect,
        multiple: multiple,
        enableContentEllipsis: enableOptionContentEllipsis,
        renderItemAdditionalInfo: renderItemAdditionalInfo,
        cursorPosition: cursorPosition
      };
    },
    getSelectAllItemProps: function getSelectAllItemProps() {
      return {
        item: selectAllItem,
        checkedIcon: selectAllCheckedIcon,
        isSelected: internalValue.length > 0,
        onOptionSelect: handleToggleAll,
        multiple: multiple,
        cursorPosition: cursorPosition
      };
    },
    getOptionListSearchProps: function getOptionListSearchProps() {
      return {
        placeholder: searchPlaceholder,
        onChange: handleSearchChange,
        defaultQuery: searchQuery,
        ref: searchInputRef
      };
    },
    listContentProps: {
      ref: listContentRef
    },
    listContainerProps: {
      maxHeight: maxDropdownHeight
    },
    optionListItemGroupProps: function optionListItemGroupProps(group) {
      return {
        multiple: multiple,
        enableGroupSelection: enableGroupSelection,
        enableContentEllipsis: enableOptionContentEllipsis,
        onClick: function onClick(event) {
          return handleToggleGroup(event, group.id);
        },
        internalGroup: internalGroups ? internalGroups[group.id] : {}
      };
    },
    listProps: {
      ref: listRef
    },
    enableVirtualization: enableVirtualization,
    getVirtualTopSpaceProps: function getVirtualTopSpaceProps() {
      return {
        height: virtualTopOffset
      };
    },
    getVirtualBottomSpaceProps: function getVirtualBottomSpaceProps() {
      return {
        height: virtualBottomOffset
      };
    },
    internalOptions: internalOptions,
    dynamicInternalOptions: enableVirtualization && virtualData && virtualData.length ? virtualData : dynamicInternalOptions,
    disabled: disabled,
    internalValue: internalValue,
    multiple: multiple,
    enableSelectAllOption: enableSelectAllOption,
    enableSearchOption: enableSearchOption,
    isOptionListHeaderRendered: enableSelectAllOption || enableSearchOption,
    isFooterRendered: enableFooter || footerContent,
    optionListFooterProps: {
      footerContent: footerContent,
      onCancelClick: handleCancelButtonClick,
      onConfirmClick: handleConfirmButtonClick
    },
    isSelectAllOptionRendered: isSelectAllOptionRendered,
    groupIndex: groupIndex,
    getTopGradientProps: function getTopGradientProps() {
      return {
        isShown: isTopGradientEffectShown
      };
    },
    getBottomGradientProps: function getBottomGradientProps() {
      return {
        isShown: isBottomGradientEffectShown
      };
    }
  };
};

// src/components/OptionList/hooks/useOptionListClassName.ts
import { useMemo as useMemo52 } from "react";
import { appendClassName as appendClassName19, makeBEM as makeBEM32 } from "@deliveryhero/armor-system";
var classGeneratorBasedOnComponent3 = function classGeneratorBasedOnComponent3(_ref97) {
  var component = _ref97.component,
    classPrefix = _ref97.classPrefix,
    disabled = _ref97.disabled;
  var baseClassNames = makeBEM32(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM32(classPrefix, component, "disabled"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useOptionListClassName = function useOptionListClassName(classPrefix, className, disabled) {
  return useMemo52(function () {
    return {
      Root: appendClassName19(classGeneratorBasedOnComponent3({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled
      }), className),
      Item: classGeneratorBasedOnComponent3({
        component: "Item",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      ItemGroup: makeBEM32(classPrefix, "ItemGroup"),
      SelectAllItem: classGeneratorBasedOnComponent3({
        component: "SelectAllItem",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      OptionListContainer: classGeneratorBasedOnComponent3({
        component: "OptionListContainer",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      OptionListContent: classGeneratorBasedOnComponent3({
        component: "OptionListContent",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      VirtualPaddingTop: classGeneratorBasedOnComponent3({
        component: "VirtualPaddingTop",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      VirtualPaddingBottom: classGeneratorBasedOnComponent3({
        component: "VirtualPaddingBottom",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      BeforeSectionContainer: classGeneratorBasedOnComponent3({
        component: "BeforeSectionContainer",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      SearchContainer: classGeneratorBasedOnComponent3({
        component: "SearchContainer",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      Search: classGeneratorBasedOnComponent3({
        component: "Search",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      Footer: classGeneratorBasedOnComponent3({
        component: "Footer",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      TopGradient: classGeneratorBasedOnComponent3({
        component: "TopGradient",
        classPrefix: classPrefix,
        disabled: disabled
      }),
      BottomGradient: classGeneratorBasedOnComponent3({
        component: "BottomGradient",
        classPrefix: classPrefix,
        disabled: disabled
      })
    };
  }, [classPrefix, className, disabled]);
};

// src/components/OptionList/OptionListFooter.tsx
import React50 from "react";

// src/components/OptionList/hooks/useOptionListFooterClassName.ts
import { useMemo as useMemo53 } from "react";
import { appendClassName as appendClassName20, makeBEM as makeBEM33 } from "@deliveryhero/armor-system";
var useOptionListFooterClassName = function useOptionListFooterClassName(classPrefix, className) {
  return useMemo53(function () {
    return {
      Root: appendClassName20(makeBEM33(classPrefix, "Root"), className),
      CancelButton: makeBEM33(classPrefix, "CancelButton"),
      ConfirmButton: makeBEM33(classPrefix, "ConfirmButton")
    };
  }, [classPrefix, className]);
};

// src/components/OptionList/hooks/useOptionListFooter.ts
var useOptionListFooter = function useOptionListFooter(_a) {
  var _b = _a,
    footerContent = _b.footerContent,
    onCancelClick = _b.onCancelClick,
    onConfirmClick = _b.onConfirmClick,
    restProps = __objRest(_b, ["footerContent", "onCancelClick", "onConfirmClick"]);
  return {
    rootProps: restProps,
    footerContent: footerContent,
    footerCancelButtonProps: {
      onClick: onCancelClick
    },
    footerConfirmButtonProps: {
      onClick: onConfirmClick
    }
  };
};

// src/components/OptionList/OptionListFooter.tsx
var OptionListFooter = function OptionListFooter(_a) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classOverride = useOptionListFooterClassName(OPTION_LIST_FOOTER_CLASS_PREFIX, className);
  var _useOptionListFooter = useOptionListFooter(props),
    rootProps = _useOptionListFooter.rootProps,
    footerContent = _useOptionListFooter.footerContent,
    footerCancelButtonProps = _useOptionListFooter.footerCancelButtonProps,
    footerConfirmButtonProps = _useOptionListFooter.footerConfirmButtonProps;
  return /* @__PURE__ */React50.createElement(OptionListFooterContainer, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  }), footerContent || /* @__PURE__ */React50.createElement(React50.Fragment, null, /* @__PURE__ */React50.createElement(Button, __spreadProps(__spreadValues({
    tertiary: true,
    paddingX: 1
  }, footerCancelButtonProps), {
    className: classOverride.CancelButton
  }), "Cancel"), /* @__PURE__ */React50.createElement(Button, __spreadProps(__spreadValues({}, footerConfirmButtonProps), {
    className: classOverride.ConfirmButton
  }), "Confirm")));
};

// src/components/OptionList/OptionListItemGroup.tsx
import React51 from "react";

// src/components/OptionList/hooks/useOptionListItemGroupClassName.ts
import { useMemo as useMemo54 } from "react";
import { appendClassName as appendClassName21, makeBEM as makeBEM34 } from "@deliveryhero/armor-system";
var useOptionListItemGroupClassName = function useOptionListItemGroupClassName(classPrefix, className) {
  return useMemo54(function () {
    return {
      Root: appendClassName21(makeBEM34(classPrefix, "Root"), className),
      Checkbox: makeBEM34(classPrefix, "Checkbox"),
      Typography: makeBEM34(classPrefix, "Typography")
    };
  }, [classPrefix, className]);
};

// src/components/OptionList/hooks/useOptionListItemGroup.ts
var useOptionListItemGroup = function useOptionListItemGroup(_a) {
  var _b = _a,
    enableSeparator = _b.enableSeparator,
    multiple = _b.multiple,
    enableGroupSelection = _b.enableGroupSelection,
    enableContentEllipsis = _b.enableContentEllipsis,
    _onClick = _b.onClick,
    internalGroup = _b.internalGroup,
    restProps = __objRest(_b, ["enableSeparator", "multiple", "enableGroupSelection", "enableContentEllipsis", "onClick", "internalGroup"]);
  var handleClick = function handleClick(event) {
    _onClick == null ? void 0 : _onClick(event);
  };
  var selectedItemsCount = internalGroup == null ? void 0 : internalGroup.selectedItemsCount;
  var totalItemsCount = internalGroup == null ? void 0 : internalGroup.totalItemsCount;
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      enableSeparator: enableSeparator,
      multiple: multiple,
      onClick: handleClick,
      enableGroupSelection: enableGroupSelection,
      checked: (selectedItemsCount != null ? selectedItemsCount : 0) > 0
    }),
    checkboxProps: {
      marginRight: 4,
      checked: (selectedItemsCount != null ? selectedItemsCount : 0) > 0,
      checkedIcon: totalItemsCount === selectedItemsCount ? "tick" : "dash",
      onClick: function onClick(event) {
        event.stopPropagation();
        event.preventDefault();
        _onClick == null ? void 0 : _onClick(event);
      }
    },
    typographyProps: {
      paragraph: true,
      small: true,
      tag: "div",
      maxLines: 2,
      enableContentEllipsis: enableContentEllipsis
    },
    multiple: multiple,
    enableGroupSelection: enableGroupSelection
  };
};

// src/components/OptionList/OptionListItemGroup.tsx
var OptionListItemGroup = function OptionListItemGroup(_a) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var classOverride = useOptionListItemGroupClassName(OPTION_LIST_ITEM_GROUP_CLASS_PREFIX, className);
  var _useOptionListItemGro = useOptionListItemGroup(props),
    rootProps = _useOptionListItemGro.rootProps,
    checkboxProps = _useOptionListItemGro.checkboxProps,
    typographyProps = _useOptionListItemGro.typographyProps,
    multiple = _useOptionListItemGro.multiple,
    enableGroupSelection = _useOptionListItemGro.enableGroupSelection;
  return /* @__PURE__ */React51.createElement(OptionListItemGroupRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  }), multiple && enableGroupSelection && /* @__PURE__ */React51.createElement(Checkbox, __spreadProps(__spreadValues({}, checkboxProps), {
    className: classOverride.Checkbox
  })), /* @__PURE__ */React51.createElement(OptionListItemGroupTypography, __spreadProps(__spreadValues({}, typographyProps), {
    className: classOverride.Typography
  }), children));
};

// src/components/OptionList/OptionList.tsx
var OptionList = memo36(function (_a) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var _useOptionList = useOptionList(props),
    rootProps = _useOptionList.rootProps,
    getOptionItemProps = _useOptionList.getOptionItemProps,
    getSelectAllItemProps = _useOptionList.getSelectAllItemProps,
    getOptionListSearchProps = _useOptionList.getOptionListSearchProps,
    listContentProps = _useOptionList.listContentProps,
    listProps = _useOptionList.listProps,
    optionListItemGroupProps = _useOptionList.optionListItemGroupProps,
    listContainerProps = _useOptionList.listContainerProps,
    enableVirtualization = _useOptionList.enableVirtualization,
    getVirtualTopSpaceProps = _useOptionList.getVirtualTopSpaceProps,
    getVirtualBottomSpaceProps = _useOptionList.getVirtualBottomSpaceProps,
    internalOptions = _useOptionList.internalOptions,
    dynamicInternalOptions = _useOptionList.dynamicInternalOptions,
    disabled = _useOptionList.disabled,
    enableSearchOption = _useOptionList.enableSearchOption,
    isOptionListHeaderRendered = _useOptionList.isOptionListHeaderRendered,
    isFooterRendered = _useOptionList.isFooterRendered,
    optionListFooterProps = _useOptionList.optionListFooterProps,
    isSelectAllOptionRendered = _useOptionList.isSelectAllOptionRendered,
    groupIndex = _useOptionList.groupIndex,
    getTopGradientProps = _useOptionList.getTopGradientProps,
    getBottomGradientProps = _useOptionList.getBottomGradientProps;
  var classOverride = useOptionListClassName(OPTION_LIST_CLASS_PREFIX, className, disabled);
  var sortedOptions = useSortedList2(dynamicInternalOptions, "groupId");
  var displayedGroups = {};
  return internalOptions.length ? /* @__PURE__ */React52.createElement(OptionListRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  }), isOptionListHeaderRendered && /* @__PURE__ */React52.createElement(OptionListBeforeSectionContainer, {
    className: classOverride.BeforeSectionContainer
  }, enableSearchOption && /* @__PURE__ */React52.createElement(OptionListSearchContainer, {
    className: classOverride.SearchContainer
  }, /* @__PURE__ */React52.createElement(OptionListSearch, __spreadProps(__spreadValues({}, getOptionListSearchProps()), {
    className: classOverride.Search
  })))), /* @__PURE__ */React52.createElement(OptionListContainer, __spreadValues({
    className: classOverride.OptionListContainer
  }, listContainerProps), /* @__PURE__ */React52.createElement(TopGradientEffect, __spreadProps(__spreadValues({}, getTopGradientProps()), {
    className: classOverride.TopGradient
  })), /* @__PURE__ */React52.createElement(BottomGradientEffect, __spreadProps(__spreadValues({}, getBottomGradientProps()), {
    className: classOverride.BottomGradient
  })), /* @__PURE__ */React52.createElement(OptionListContent, __spreadValues({
    className: classOverride.OptionListContent
  }, listContentProps), isSelectAllOptionRendered && /* @__PURE__ */React52.createElement(OptionListItem2, __spreadProps(__spreadValues({}, getSelectAllItemProps()), {
    optionIndex: 0,
    className: classOverride.SelectAllItem
  })), /* @__PURE__ */React52.createElement("div", __spreadValues({}, listProps), enableVirtualization && /* @__PURE__ */React52.createElement(OptionListVirtualPadding, __spreadProps(__spreadValues({}, getVirtualTopSpaceProps()), {
    className: classOverride.VirtualPaddingTop
  })), sortedOptions.map(function (option, index) {
    var value = option.value,
      groupId = option.groupId;
    var group = null;
    if (groupId && groupId in groupIndex && !displayedGroups[groupId]) {
      group = groupIndex[groupId];
      displayedGroups[groupId] = true;
    }
    var optionItemProps = getOptionItemProps(option);
    var isSelected = optionItemProps.isSelected;
    return /* @__PURE__ */React52.createElement(Fragment, {
      key: value
    }, !!group && /* @__PURE__ */React52.createElement(OptionListItemGroup, __spreadProps(__spreadValues({}, optionListItemGroupProps(group)), {
      enableSeparator: index > 0,
      className: classOverride.ItemGroup
    }), group.label), /* @__PURE__ */React52.createElement(OptionListItem2, __spreadProps(__spreadValues({}, optionItemProps), {
      optionIndex: isSelectAllOptionRendered ? index + 1 : index,
      className: "".concat(classOverride.Item, " ").concat(isSelected ? "active" : "")
    })));
  }), enableVirtualization && /* @__PURE__ */React52.createElement(OptionListVirtualPadding, __spreadProps(__spreadValues({}, getVirtualBottomSpaceProps()), {
    className: classOverride.VirtualPaddingBottom
  }))))), isFooterRendered && /* @__PURE__ */React52.createElement(OptionListFooter, __spreadProps(__spreadValues({}, optionListFooterProps), {
    className: classOverride.Footer
  }))) : null;
});
OptionList.displayName = OPTION_LIST_CLASS_PREFIX;

// src/components/Dropdown/DropdownBeforeSection.tsx
import React54, { forwardRef as forwardRef28, memo as memo38 } from "react";

// src/components/Dropdown/hooks/useDropdownBeforeSection.ts
import { useCallback as useCallback21, useRef as useRef8, useState as useState8 } from "react";
import { stringEllipsisAtMaxCharacters, useRootRef as useRootRef14, stripHTMLTagsMemoized as stripHTMLTags4 } from "@deliveryhero/armor-system";

// src/components/Dropdown/hooks/useSelectedTagsToDisplay.ts
import { useMemo as useMemo55 } from "react";
var useSelectedTagsToDisplay = function useSelectedTagsToDisplay(internalValue, internalOptions) {
  return useMemo55(function () {
    if (!internalValue.length) {
      return [];
    }
    var internalOptionValues = internalOptions.map(function (option) {
      return option.value;
    });
    var matchingOptions = [];
    internalValue.forEach(function (value) {
      var matchedIndex = internalOptionValues.indexOf(value);
      if (matchedIndex > -1) {
        matchingOptions.push(internalOptions[matchedIndex]);
      }
    });
    return matchingOptions;
  }, [internalValue, internalOptions]);
};

// src/components/Dropdown/hooks/useOnRemoveMultiple.ts
import { useCallback as useCallback20 } from "react";
var useOnRemoveMultiple = function useOnRemoveMultiple(setInternalValue, internalValue, onChange) {
  return useCallback20(function (tagValuesToRemove) {
    var nextValue = internalValue.filter(function (value) {
      return !tagValuesToRemove.includes(value);
    });
    handleOnChange(nextValue, onChange);
    setInternalValue(nextValue);
  }, [internalValue, onChange, setInternalValue]);
};

// src/components/Dropdown/hooks/useOnPopulateTagsAutomatically.ts
import { useEffect as useEffect12 } from "react";
import { RESIZE_OBSERVER_SUPPORTED as RESIZE_OBSERVER_SUPPORTED2 } from "@deliveryhero/armor-system";
var useOnPopulateTagsAutomatically = function useOnPopulateTagsAutomatically(selectedTagsToDisplay, beforeSectionContainerRef, beforeSectionWrapperRef, isMaxWidthReached, setIsMaxWidthReached, internalOpenTagsCount, setInternalOpenTagsCount, singleLine) {
  return useEffect12(function () {
    var observer = null;
    if (RESIZE_OBSERVER_SUPPORTED2 && singleLine && beforeSectionContainerRef.current) {
      observer = new ResizeObserver(function (entries) {
        var _entries = _slicedToArray(entries, 2),
          tagContainer = _entries[0],
          tagWrapper = _entries[1];
        if (!tagContainer || !tagWrapper) {
          return;
        }
        var _tagContainer$target$ = tagContainer.target.getBoundingClientRect(),
          containerNodeWidth = _tagContainer$target$.width;
        var _tagWrapper$target$ge = tagWrapper.target.getBoundingClientRect(),
          wrapperNodeWidth = _tagWrapper$target$ge.width,
          wrapperNodeHeight = _tagWrapper$target$ge.height;
        var cumulativeMaxWidth = wrapperNodeWidth + BUFFER_TAGS_WIDTH * 2;
        if (!isMaxWidthReached && cumulativeMaxWidth <= containerNodeWidth) {
          setInternalOpenTagsCount(internalOpenTagsCount + 1);
        } else if (!isMaxWidthReached && cumulativeMaxWidth > containerNodeWidth || wrapperNodeHeight > SINGLE_LINE_MAX_ALLOWED_HEIGHT) {
          setIsMaxWidthReached(true);
          setInternalOpenTagsCount(internalOpenTagsCount - 1);
        }
        if (!isMaxWidthReached && cumulativeMaxWidth > containerNodeWidth) {
          setIsMaxWidthReached(true);
        }
      });
      observer.observe(beforeSectionContainerRef.current);
      observer.observe(beforeSectionWrapperRef.current);
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [selectedTagsToDisplay.length, internalOpenTagsCount, isMaxWidthReached, singleLine, beforeSectionContainerRef, beforeSectionWrapperRef, setInternalOpenTagsCount, setIsMaxWidthReached]);
};

// src/components/Dropdown/hooks/useDropdownBeforeSection.ts
var useDropdownBeforeSection = function useDropdownBeforeSection(_a, ref) {
  var _b = _a,
    disabled = _b.disabled,
    onClick = _b.onClick,
    internalValue = _b.internalValue,
    setInternalValue = _b.setInternalValue,
    onSelect = _b.onSelect,
    onChange = _b.onChange,
    internalOptions = _b.internalOptions,
    options = _b.options,
    isFlat = _b.isFlat,
    multiple = _b.multiple,
    tagLabelMaxLength = _b.tagLabelMaxLength,
    _b$openTagsCount2 = _b.openTagsCount,
    openTagsCount = _b$openTagsCount2 === void 0 ? 1 : _b$openTagsCount2,
    renderAggregatedTagsLabel = _b.renderAggregatedTagsLabel,
    singleLine = _b.singleLine,
    isRendered = _b.isRendered,
    isRenderedSelectedValueAsNode = _b.isRenderedSelectedValueAsNode,
    selectedValueToDisplay = _b.selectedValueToDisplay,
    restProps = __objRest(_b, ["disabled", "onClick", "internalValue", "setInternalValue", "onSelect", "onChange", "internalOptions", "options", "isFlat", "multiple", "tagLabelMaxLength", "openTagsCount", "renderAggregatedTagsLabel", "singleLine", "isRendered", "isRenderedSelectedValueAsNode", "selectedValueToDisplay"]);
  var containerRef = useRootRef14(ref);
  var beforeSectionContainerRef = useRef8(null);
  var beforeSectionWrapperRef = useRef8(null);
  var _useState35 = useState8(false),
    _useState36 = _slicedToArray(_useState35, 2),
    isMaxWidthReached = _useState36[0],
    setIsMaxWidthReached = _useState36[1];
  var _useState37 = useState8(singleLine ? 1 : openTagsCount),
    _useState38 = _slicedToArray(_useState37, 2),
    internalOpenTagsCount = _useState38[0],
    setInternalOpenTagsCount = _useState38[1];
  var selectedTagsToDisplay = useSelectedTagsToDisplay(internalValue, internalOptions);
  var onValueUpdate = useOnValueUpdate(setInternalValue, onSelect, onChange);
  var onRemoveMultiple = useOnRemoveMultiple(setInternalValue, internalValue, onChange);
  useOnPopulateTagsAutomatically(selectedTagsToDisplay, beforeSectionContainerRef, beforeSectionWrapperRef, isMaxWidthReached, setIsMaxWidthReached, internalOpenTagsCount, setInternalOpenTagsCount, singleLine);
  var handleRemoveTag = function handleRemoveTag(option) {
    return function () {
      return onValueUpdate(internalValue, multiple, option, option.value, options, isFlat);
    };
  };
  var handleRemoveRemainingTags = function handleRemoveRemainingTags(tagValuesToRemove) {
    return function () {
      return onRemoveMultiple(tagValuesToRemove);
    };
  };
  var getAggregatedTagsLabel = useCallback21(function (remainingItemsCount) {
    if (renderAggregatedTagsLabel) {
      return renderAggregatedTagsLabel(remainingItemsCount);
    }
    return "+".concat(remainingItemsCount, " item").concat(remainingItemsCount === 1 ? "" : "s");
  }, [renderAggregatedTagsLabel]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      onClick: onClick,
      disabled: disabled,
      ref: containerRef,
      singleLine: singleLine
    }),
    getDropdownTagProps: function getDropdownTagProps(option) {
      var label = stringEllipsisAtMaxCharacters(stripHTMLTags4(option.label), tagLabelMaxLength);
      return {
        deleteOption: "enabled",
        disabled: disabled,
        label: label,
        onClose: handleRemoveTag(option),
        key: option.value
      };
    },
    getDropdownRemainingTagsProps: function getDropdownRemainingTagsProps(remainingItemsCount, tagsValues) {
      return {
        key: "remaining_items",
        disabled: disabled,
        label: getAggregatedTagsLabel(remainingItemsCount),
        onClose: handleRemoveRemainingTags(tagsValues)
      };
    },
    dropdownBeforeSectionContainerProps: {
      ref: beforeSectionContainerRef
    },
    dropdownBeforeSectionWrapperProps: {
      ref: beforeSectionWrapperRef
    },
    dropdownTagsProps: {
      disabled: disabled,
      key: "expanded_tags"
    },
    disabled: disabled,
    isRendered: isRendered,
    isRenderedSelectedValueAsNode: isRenderedSelectedValueAsNode,
    selectedTagsToDisplay: selectedTagsToDisplay,
    internalOpenTagsCount: internalOpenTagsCount,
    selectedValueToDisplay: selectedValueToDisplay
  };
};

// src/components/Dropdown/DropdownTags.tsx
import React53, { memo as memo37 } from "react";
import PropTypes26 from "prop-types";

// src/components/Dropdown/hooks/useDropdownTagsClassName.ts
import { useMemo as useMemo56 } from "react";
import { appendClassName as appendClassName22, makeBEM as makeBEM35 } from "@deliveryhero/armor-system";
var classGeneratorBasedOnComponent4 = function classGeneratorBasedOnComponent4(_ref98) {
  var component = _ref98.component,
    classPrefix = _ref98.classPrefix,
    disabled = _ref98.disabled;
  var baseClassNames = makeBEM35(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM35(classPrefix, component, "disabled"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useDropdownTagsClassName = function useDropdownTagsClassName(classPrefix, className, disabled) {
  return useMemo56(function () {
    return {
      Root: appendClassName22(classGeneratorBasedOnComponent4({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled
      }), className)
    };
  }, [classPrefix, className, disabled]);
};

// src/components/Dropdown/DropdownTags.tsx
var DropdownTags = memo37(function (_ref99) {
  var className = _ref99.className,
    disabled = _ref99.disabled,
    tagsToDisplay = _ref99.tagsToDisplay,
    propsFn = _ref99.propsFn;
  var classOverride = useDropdownTagsClassName(DROPDOWN_TAGS_CLASS_PREFIX, className, disabled);
  return /* @__PURE__ */React53.createElement(React53.Fragment, null, tagsToDisplay.map(function (option) {
    return /* @__PURE__ */React53.createElement(DropdownTag, __spreadProps(__spreadValues({}, propsFn(option)), {
      className: classOverride.Root,
      key: option.value,
      deleteOption: (option == null ? void 0 : option.disabled) ? "disabled" : "enabled",
      small: true
    }));
  }));
});
DropdownTags.propTypes = {
  tagsToDisplay: PropTypes26.array.isRequired,
  propsFn: PropTypes26.func.isRequired
};
DropdownTags.displayName = DROPDOWN_TAGS_CLASS_PREFIX;

// src/components/Dropdown/DropdownBeforeSection.tsx
var DropdownBeforeSection = memo38(forwardRef28(function DropdownBeforeSection2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var _useDropdownBeforeSec = useDropdownBeforeSection(props, ref),
    rootProps = _useDropdownBeforeSec.rootProps,
    getDropdownTagProps = _useDropdownBeforeSec.getDropdownTagProps,
    getDropdownRemainingTagsProps = _useDropdownBeforeSec.getDropdownRemainingTagsProps,
    dropdownBeforeSectionContainerProps = _useDropdownBeforeSec.dropdownBeforeSectionContainerProps,
    dropdownBeforeSectionWrapperProps = _useDropdownBeforeSec.dropdownBeforeSectionWrapperProps,
    dropdownTagsProps = _useDropdownBeforeSec.dropdownTagsProps,
    disabled = _useDropdownBeforeSec.disabled,
    isRendered = _useDropdownBeforeSec.isRendered,
    isRenderedSelectedValueAsNode = _useDropdownBeforeSec.isRenderedSelectedValueAsNode,
    selectedTagsToDisplay = _useDropdownBeforeSec.selectedTagsToDisplay,
    internalOpenTagsCount = _useDropdownBeforeSec.internalOpenTagsCount,
    selectedValueToDisplay = _useDropdownBeforeSec.selectedValueToDisplay;
  var classOverride = useDropdownBeforeSectionClassName(DROPDOWN_BEFORE_SECTION_CLASS_PREFIX, className, disabled);
  if (!isRendered) {
    return null;
  }
  var renderTags = function renderTags() {
    if (internalOpenTagsCount > 0) {
      var remainingItemsCount = selectedTagsToDisplay.length - internalOpenTagsCount;
      var tagsToRender = selectedTagsToDisplay.slice(0, internalOpenTagsCount);
      var remainingTagsValues = selectedTagsToDisplay.slice(internalOpenTagsCount).map(function (option) {
        return option.value;
      });
      var openTags = /* @__PURE__ */React54.createElement(DropdownTags, __spreadProps(__spreadValues({}, dropdownTagsProps), {
        className: className,
        tagsToDisplay: tagsToRender,
        propsFn: getDropdownTagProps
      }));
      var remainingItemsTag = /* @__PURE__ */React54.createElement(DropdownTag, __spreadProps(__spreadValues({}, getDropdownRemainingTagsProps(remainingItemsCount, remainingTagsValues)), {
        className: classOverride.DropdownTagRemainingItems
      }));
      return [openTags, remainingItemsCount > 0 ? remainingItemsTag : null];
    }
    return /* @__PURE__ */React54.createElement(DropdownTags, __spreadProps(__spreadValues({}, dropdownTagsProps), {
      className: className,
      tagsToDisplay: selectedTagsToDisplay,
      propsFn: getDropdownTagProps
    }));
  };
  return /* @__PURE__ */React54.createElement(DropdownBeforeSectionRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  }), /* @__PURE__ */React54.createElement(DropdownBeforeSectionContainer, __spreadProps(__spreadValues({}, dropdownBeforeSectionContainerProps), {
    className: classOverride.TagsContainer
  }), /* @__PURE__ */React54.createElement(DropdownBeforeSectionWrapper, __spreadProps(__spreadValues({}, dropdownBeforeSectionWrapperProps), {
    className: classOverride.TagsWrapper
  }), isRenderedSelectedValueAsNode ? selectedValueToDisplay : renderTags())));
}));
DropdownBeforeSection.displayName = DROPDOWN_BEFORE_SECTION_CLASS_PREFIX;

// src/components/Dropdown/Dropdown.tsx
var Dropdown = forwardRef29(function Dropdown2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var _useDropdown = useDropdown(props, ref),
    rootProps = _useDropdown.rootProps,
    containerProps = _useDropdown.containerProps,
    textInputProps = _useDropdown.textInputProps,
    portalProps = _useDropdown.portalProps,
    listContainerProps = _useDropdown.listContainerProps,
    arrowProps = _useDropdown.arrowProps,
    optionListProps = _useDropdown.optionListProps,
    dropdownExpansionIndicatorProps = _useDropdown.dropdownExpansionIndicatorProps,
    dropdownBeforeSectionProps = _useDropdown.dropdownBeforeSectionProps,
    disabled = _useDropdown.disabled,
    internalValue = _useDropdown.internalValue,
    open = _useDropdown.open,
    clearButtonProps = _useDropdown.clearButtonProps,
    shouldDisplayClearButton = _useDropdown.shouldDisplayClearButton,
    actionContainerProps = _useDropdown.actionContainerProps;
  var classOverride = useDropdownClassName(DROPDOWN_CLASS_PREFIX, className, disabled);
  var renderActionItem = /* @__PURE__ */React55.createElement(ActionsContainer, __spreadValues({
    className: classOverride.ExpansionIndicatorContainer
  }, actionContainerProps), shouldDisplayClearButton ? /* @__PURE__ */React55.createElement(ClearButton, __spreadValues({}, clearButtonProps)) : null, /* @__PURE__ */React55.createElement(DropdownExpansionIndicator, __spreadProps(__spreadValues({}, dropdownExpansionIndicatorProps), {
    className: classOverride.ExpansionIndicator
  })));
  return (
    // @ts-ignore todo: the fix is only available with loose of backward compatibility
    /* @__PURE__ */
    React55.createElement(DropdownRoot, __spreadProps(__spreadValues({}, rootProps), {
      className: classOverride.Root
    }), /* @__PURE__ */React55.createElement(DropdownContainer, __spreadProps(__spreadValues({}, containerProps), {
      className: classOverride.Container
    }), /* @__PURE__ */React55.createElement(DropdownTextInput, __spreadProps(__spreadValues({}, textInputProps), {
      before: internalValue.length ? /* @__PURE__ */React55.createElement(DropdownBeforeSection, __spreadValues({}, dropdownBeforeSectionProps)) : null,
      after: renderActionItem,
      className: classOverride.TextInput
    })), /* @__PURE__ */React55.createElement(PortalToBody4, __spreadValues({}, portalProps), open && /* @__PURE__ */React55.createElement(DropdownOptionListContainer, __spreadProps(__spreadValues({
      "data-testid": DROPDOWN_OPTION_LIST_CONTAINER
    }, listContainerProps), {
      className: classOverride.OptionListContainer
    }), /* @__PURE__ */React55.createElement(OptionList, __spreadProps(__spreadValues({}, optionListProps), {
      className: classOverride.OptionList,
      autoFocus: true
    })), /* @__PURE__ */React55.createElement(DropdownArrow, __spreadValues({}, arrowProps))))))
  );
});
var MemoizedDropdown = memo39(Dropdown);

// src/components/FileCard/FileCard.tsx
import React62, { forwardRef as forwardRef36, memo as memo46 } from "react";
import PropTypes32 from "prop-types";

// src/components/IconButton/IconButton.tsx
import React56, { forwardRef as forwardRef30, memo as memo40 } from "react";
import PropTypes27 from "prop-types";

// src/components/IconButton/hooks/useIconButtonClassNames.ts
import { useMemo as useMemo57 } from "react";
import { makeRootClassName as makeRootClassName23 } from "@deliveryhero/armor-system";
var useIconButtonClassNames = function useIconButtonClassNames(classPrefix, className) {
  return useMemo57(function () {
    return {
      Root: makeRootClassName23(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/IconButton/style.ts
import styled41, { css as css36 } from "styled-components";
import { marginProps as marginProps23, spacing as spacing32, token as token29, propsBlocker as propsBlocker40, getComponentOverride as getComponentOverride26, colorProps as colorProps3, focus as focus6, transition as transition16 } from "@deliveryhero/armor-system";
var getRootStyle11 = function getRootStyle11(_ref100) {
  var visible = _ref100.visible,
    small = _ref100.small,
    disabled = _ref100.disabled;
  var result = css36(_templateObject290 || (_templateObject290 = _taggedTemplateLiteral(["\n        &:hover {\n            background-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n        }\n\n        svg {\n            width: 100%;\n            height: 100%;\n        }\n    "])), token29("action.color.tertiary.hover", "color.neutral.02"), token29("action.color.tertiary.pressed", "color.neutral.03"));
  if (visible === false) {
    result = css36(_templateObject291 || (_templateObject291 = _taggedTemplateLiteral(["\n            ", ";\n            visibility: hidden;\n        "])), result);
  }
  if (disabled) {
    result = css36(_templateObject292 || (_templateObject292 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: not-allowed;\n\n            &:hover,\n            &:active {\n                background-color: transparent;\n            }\n\n            svg {\n                color: ", ";\n            }\n        "])), result, token29("icon.color.disabled", "color.neutral.05"));
  }
  if (small) {
    result = css36(_templateObject293 || (_templateObject293 = _taggedTemplateLiteral(["\n            ", ";\n            width: ", ";\n            min-width: ", ";\n            height: ", ";\n            min-height: ", ";\n        "])), result, spacing32("action.sizing.mini", [5]), spacing32("action.sizing.mini", [5]), spacing32("action.sizing.mini", [5]), spacing32("action.sizing.mini", [5]));
  }
  return result;
};
var IconButtonRoot = styled41.button.withConfig(propsBlocker40)(_templateObject294 || (_templateObject294 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    border-radius: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    appearance: none;\n    border: 0 none;\n    padding: ", ";\n    width: ", ";\n    min-width: ", ";\n    height: ", ";\n    min-height: ", ";\n\n    background-color: transparent;\n    color: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), token29("action.borderRadius.pill", "shape.borderRadius.pill", {
  returnUnit: "px"
}), spacing32(1), spacing32("action.sizing.tiny", [6]), spacing32("action.sizing.tiny", [6]), spacing32("action.sizing.tiny", [6]), spacing32("action.sizing.tiny", [6]), token29("icon.color.primary", "body.color"), transition16({
  "background-color": true
}), getRootStyle11, getComponentOverride26("IconButton"), focus6(), marginProps23, colorProps3);

// src/components/IconButton/constants.ts
var ICON_BUTTON_CLASS_PREFIX = "IconButton";

// src/components/IconButton/IconButton.tsx
var IconButton = forwardRef30(function IconButton2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useIconButtonClassNames(ICON_BUTTON_CLASS_PREFIX, className);
  return /* @__PURE__ */React56.createElement(IconButtonRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }));
});
IconButton.defaultProps = {
  type: "button",
  light: false,
  medium: true,
  disabled: false
};
IconButton.propTypes = {
  light: PropTypes27.bool,
  medium: PropTypes27.bool,
  small: PropTypes27.bool,
  disabled: PropTypes27.bool
};
var MemoizedIconButton = memo40(IconButton);

// src/components/FileCard/hooks/useFileCardClassNames.ts
import { useMemo as useMemo58 } from "react";
import { makeRootClassName as makeRootClassName24, makeBEM as makeBEM36 } from "@deliveryhero/armor-system";
var useFileCardClassNames = function useFileCardClassNames(classPrefix, className) {
  return useMemo58(function () {
    return {
      Root: makeRootClassName24(classPrefix, className),
      Body: makeBEM36(classPrefix, "Body"),
      LeftPortion: makeBEM36(classPrefix, "LeftPortion"),
      RightPortion: makeBEM36(classPrefix, "RightPortion"),
      FormFieldErrorMessage: makeBEM36(classPrefix, "FormFieldErrorMessage"),
      FileIcon: makeBEM36(classPrefix, "FileIcon"),
      FileImageContainer: makeBEM36(classPrefix, "FileImageContainer"),
      FileImage: makeBEM36(classPrefix, "FileImage"),
      CancelIcon: makeBEM36(classPrefix, "CancelIcon"),
      DeleteIcon: makeBEM36(classPrefix, "DeleteIcon"),
      CancelButton: makeBEM36(classPrefix, "CancelButton"),
      DeleteButton: makeBEM36(classPrefix, "DeleteButton"),
      FileName: makeBEM36(classPrefix, "FileName"),
      FileExtension: makeBEM36(classPrefix, "FileExtension"),
      FileSize: makeBEM36(classPrefix, "FileSize"),
      UploadBar: makeBEM36(classPrefix, "UploadBar")
    };
  }, [classPrefix, className]);
};

// src/components/FileCard/hooks/useFileCard.ts
import { useState as useState10, useEffect as useEffect14, useMemo as useMemo64 } from "react";
import { useRootRef as useRootRef16 } from "@deliveryhero/armor-system";

// src/components/ProgressBar/constants.ts
var PROGRESSBAR_CLASS_PREFIX = "ProgressBar";
var ProgressBarLevels = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  FILE_UPLOAD: "fileUpload"
};

// src/components/FileCard/utils/extractFileNameExtension.ts
var reg = /(.*)\.(\w+)$/;
function extractFileNameExtension() {
  var fullName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var _ref101 = reg.exec(fullName) || [],
    _ref102 = _slicedToArray(_ref101, 3),
    _ref102$ = _ref102[1],
    fileName = _ref102$ === void 0 ? fullName : _ref102$,
    _ref102$2 = _ref102[2],
    fileExtension = _ref102$2 === void 0 ? "" : _ref102$2;
  return {
    fileName: fileName,
    fileExtension: fileExtension
  };
}

// src/components/FileCard/utils/formatBytesToSize.ts
function formatBytesToSize() {
  var bytes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  if (bytes === 0) return "0 Bytes";
  var k = 1024;
  var decimals = 2;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes4 = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return "".concat(parseFloat((bytes / __pow(k, i)).toFixed(dm)), " ").concat(sizes4[i]);
}

// src/components/FileCard/style.ts
import styled47, { css as css41 } from "styled-components";
import { marginProps as marginProps28, propsBlocker as propsBlocker46, getComponentOverride as getComponentOverride32, reset as reset15, typography as typography24, spacing as spacing38, color as color21, borderRadius as borderRadius4, widthProps as widthProps12, token as token34 } from "@deliveryhero/armor-system";
import { CancelIcon as CancelIconArmor, DeleteIcon as DeleteIconArmor, FileCommonTextIcon, FileImagePortraitIcon, FilePDFIcon as FilePDFIconArmor, FileCSVIcon as FileCSVIconArmor } from "@deliveryhero/armor-icons";

// src/components/ProgressBar/ProgressBar.tsx
import React57, { forwardRef as forwardRef31, memo as memo41 } from "react";
import PropTypes28 from "prop-types";

// src/components/ProgressBar/hooks/useProgressBar.ts
import { useState as useState9, useEffect as useEffect13 } from "react";
import { durationNormal as durationNormal10, useRootRef as useRootRef15 } from "@deliveryhero/armor-system";
var correctProgressValue = function correctProgressValue(progress) {
  if (!progress || progress < 0) {
    return 0;
  }
  if (progress > 100) {
    return 100;
  }
  return progress;
};
var useProgressBar = function useProgressBar(_a, ref) {
  var _b = _a,
    color52 = _b.color,
    height = _b.height,
    progress = _b.progress,
    preset = _b.preset,
    duration = _b.duration,
    reverse = _b.reverse,
    onFinish = _b.onFinish,
    isPaused = _b.isPaused,
    restProps = __objRest(_b, ["color", "height", "progress", "preset", "duration", "reverse", "onFinish", "isPaused"]);
  var _useState39 = useState9(0),
    _useState40 = _slicedToArray(_useState39, 2),
    internalProgress = _useState40[0],
    setInternalProgress = _useState40[1];
  var innerRef = useRootRef15(ref);
  var isAutoRunMode = Boolean(duration);
  useEffect13(function () {
    var interval;
    if (isAutoRunMode && duration && !isPaused) {
      interval = setInterval(function () {
        setInternalProgress(function (curProgress) {
          return curProgress < 100 ? curProgress + 1 : curProgress;
        });
      }, duration / 100);
    }
    return function () {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isAutoRunMode, duration, isPaused]);
  useEffect13(function () {
    var isFinished = isAutoRunMode && internalProgress >= 100;
    if (isFinished && onFinish) {
      setTimeout(function () {
        return onFinish();
      }, durationNormal10);
    }
  }, [isAutoRunMode, internalProgress, onFinish]);
  var realProgress = reverse ? 100 - internalProgress : internalProgress;
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: innerRef,
      preset: preset
    }),
    getProgressProps: function getProgressProps() {
      return {
        color: color52,
        height: height,
        progress: isAutoRunMode ? realProgress : correctProgressValue(progress),
        preset: preset
      };
    }
  };
};

// src/components/ProgressBar/hooks/useProgressBarClassNames.ts
import { useMemo as useMemo59 } from "react";
import { makeRootClassName as makeRootClassName25, makeBEM as makeBEM37 } from "@deliveryhero/armor-system";
var useProgressBarClassNames = function useProgressBarClassNames(classPrefix, className) {
  return useMemo59(function () {
    return {
      Root: makeRootClassName25(classPrefix, className),
      Indicator: makeBEM37(classPrefix, "Indicator")
    };
  }, [classPrefix, className]);
};

// src/components/ProgressBar/style.ts
import styled42, { css as css37 } from "styled-components";
import { marginProps as marginProps24, widthProps as widthProps10, heightProps as heightProps4, propsBlocker as propsBlocker41, getComponentOverride as getComponentOverride27, reset as reset14, color as color19, spacing as spacing33, transition as transition17, colorProps as colorProps4, token as token30 } from "@deliveryhero/armor-system";
var presetProgressIndicatorColorMap = (_presetProgressIndica = {}, _defineProperty(_presetProgressIndica, ProgressBarLevels.SUCCESS, "success.10"), _defineProperty(_presetProgressIndica, ProgressBarLevels.INFO, "primary.06"), _defineProperty(_presetProgressIndica, ProgressBarLevels.WARNING, "warning.10"), _defineProperty(_presetProgressIndica, ProgressBarLevels.ERROR, "error.10"), _defineProperty(_presetProgressIndica, ProgressBarLevels.FILE_UPLOAD, "primary.06"), _presetProgressIndica);
var getRootStyle12 = function getRootStyle12(_ref103) {
  var preset = _ref103.preset;
  var result = css37(_templateObject295 || (_templateObject295 = _taggedTemplateLiteral(["\n        width: 100%;\n        background-color: ", ";\n    "])), token30("loadingspinner.color.secondary.branded", "color.neutral.03"));
  if (preset && preset !== ProgressBarLevels.FILE_UPLOAD) {
    result = css37(_templateObject296 || (_templateObject296 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: unset;\n        "])), result);
  }
  return result;
};
var getProgressIndicatorStyle = function getProgressIndicatorStyle(_ref104) {
  var preset = _ref104.preset,
    progress = _ref104.progress,
    backgroundColor = _ref104.color;
  var result = css37(_templateObject297 || (_templateObject297 = _taggedTemplateLiteral(["\n        height: ", ";\n        width: ", "%;\n        background-color: ", ";\n    "])), spacing33(1), progress, backgroundColor || token30("motion.color.primary.branded", "color.primary.06"));
  if (preset) {
    result = css37(_templateObject298 || (_templateObject298 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n        "])), result, color19(presetProgressIndicatorColorMap[preset]));
  }
  return result;
};
var ProgressBarRoot = styled42.div.withConfig(propsBlocker41)(_templateObject299 || (_templateObject299 = _taggedTemplateLiteral(["\n    ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset14, getRootStyle12, getComponentOverride27("ProgressBar"), colorProps4, marginProps24, widthProps10);
var ProgressBarIndicator = styled42.div.withConfig(propsBlocker41)(_templateObject300 || (_templateObject300 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset14, transition17({
  width: true,
  backgroundColor: true
}), getProgressIndicatorStyle, heightProps4);

// src/components/ProgressBar/ProgressBar.tsx
var ProgressBar = forwardRef31(function ProgressBar2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNames = useProgressBarClassNames(PROGRESSBAR_CLASS_PREFIX, className);
  var _useProgressBar = useProgressBar(props, ref),
    rootProps = _useProgressBar.rootProps,
    getProgressProps = _useProgressBar.getProgressProps;
  return /* @__PURE__ */React57.createElement(ProgressBarRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), /* @__PURE__ */React57.createElement(ProgressBarIndicator, __spreadProps(__spreadValues({}, getProgressProps()), {
    className: classNames.Indicator
  })));
});
ProgressBar.defaultProps = {
  reverse: false
};
ProgressBar.propTypes = {
  /** The ProgressBar's progress, a value between 0-100 (%) */
  progress: PropTypes28.number,
  /** Some presets: 'success', 'info', 'error', 'warning', 'fileUpload' */
  preset: PropTypes28.oneOf([ProgressBarLevels.SUCCESS, ProgressBarLevels.INFO, ProgressBarLevels.WARNING, ProgressBarLevels.ERROR, ProgressBarLevels.FILE_UPLOAD]),
  /** If set, the ProgressBar will run automatically within the given duration */
  duration: PropTypes28.number,
  /** If true and the `duration` is set, the ProgressBar will start from 100% and finish at 0% */
  reverse: PropTypes28.bool,
  /** A callback is fired whenever the ProgressBar reaches 100% (or 0% in Reverse mode). */
  onFinish: PropTypes28.func,
  /** Put the ProgressBar in Auto Run mode on hold */
  isPaused: PropTypes28.bool
};
var MemoizedProgressBar = memo41(ProgressBar);

// src/components/FormField/FormField.tsx
import React58, { forwardRef as forwardRef32, memo as memo42 } from "react";
import PropTypes29 from "prop-types";
import { getCompatiblePropValue } from "@deliveryhero/armor-system";

// src/components/FormField/hooks/useFormFieldClassNames.ts
import { useMemo as useMemo60 } from "react";
import { makeRootClassName as makeRootClassName26 } from "@deliveryhero/armor-system";
var useFormFieldClassNames = function useFormFieldClassNames(classPrefix, className) {
  return useMemo60(function () {
    return {
      Root: makeRootClassName26(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/FormField/style.ts
import styled43, { css as css38 } from "styled-components";
import { getComponentOverride as getComponentOverride28, marginProps as marginProps25, propsBlocker as propsBlocker42, spacing as spacing34, token as token31, typography as typography20, widthProps as widthProps11 } from "@deliveryhero/armor-system";
var getRootStyle13 = function getRootStyle13(_ref105) {
  var enableVerticalOuterSpacing = _ref105.enableVerticalOuterSpacing;
  if (enableVerticalOuterSpacing) {
    return css38(_templateObject301 || (_templateObject301 = _taggedTemplateLiteral(["\n            &:not(:last-child) {\n                margin-bottom: ", ";\n            }\n        "])), spacing34(2));
  }
  return "";
};
var FormFieldRoot = styled43.div.withConfig(propsBlocker42)(_templateObject302 || (_templateObject302 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    box-sizing: border-box;\n    position: relative;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), typography20("paragraphMedium"), token31("body.color"), getRootStyle13, getComponentOverride28("FormField"), marginProps25, widthProps11);

// src/components/FormField/constants.ts
var FORM_FIELD_CLASS_PREFIX = "FormField";

// src/components/FormField/FormField.tsx
var FormField = forwardRef32(function FormField2(_a, ref) {
  var _b = _a,
    className = _b.className,
    autoMargin = _b.autoMargin,
    enableVerticalOuterSpacing = _b.enableVerticalOuterSpacing,
    restProps = __objRest(_b, ["className", "autoMargin", "enableVerticalOuterSpacing"]);
  var classNameComponents = useFormFieldClassNames(FORM_FIELD_CLASS_PREFIX, className);
  return /* @__PURE__ */React58.createElement(FormFieldRoot, __spreadProps(__spreadValues({}, restProps), {
    enableVerticalOuterSpacing: getCompatiblePropValue(enableVerticalOuterSpacing, autoMargin),
    className: classNameComponents.Root,
    ref: ref
  }));
});
FormField.defaultProps = {
  enableVerticalOuterSpacing: false
};
FormField.propTypes = {
  autoMargin: PropTypes29.bool
};
var MemoizedFormField = memo42(FormField);

// src/components/FormField/FormFieldTooltip/FormFieldTooltip.tsx
import React60, { forwardRef as forwardRef34, memo as memo44 } from "react";
import PropTypes30 from "prop-types";

// src/components/FormField/FormFieldTooltip/hooks/useFormFieldTooltipClassNames.ts
import { useMemo as useMemo61 } from "react";
import { makeBEM as makeBEM38, makeRootClassName as makeRootClassName27 } from "@deliveryhero/armor-system";
var useFormFieldTooltipClassNames = function useFormFieldTooltipClassNames(classPrefix, className) {
  return useMemo61(function () {
    return {
      Root: makeRootClassName27(classPrefix, className),
      Indicator: makeBEM38(classPrefix, "Indicator")
    };
  }, [classPrefix, className]);
};

// src/components/FormField/FormFieldTooltip/style.ts
import styled45, { css as css39 } from "styled-components";
import { getComponentOverride as getComponentOverride30, spacing as spacing36 } from "@deliveryhero/armor-system";

// src/components/Indicator/Indicator.tsx
import React59, { forwardRef as forwardRef33, memo as memo43 } from "react";

// src/components/Indicator/hooks/useIndicatorClassNames.ts
import { useMemo as useMemo62 } from "react";
import { makeRootClassName as makeRootClassName28 } from "@deliveryhero/armor-system";
var useIndicatorClassNames = function useIndicatorClassNames(classPrefix, className) {
  return useMemo62(function () {
    return {
      Root: makeRootClassName28(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/Indicator/style.ts
import styled44 from "styled-components";
import { spacing as spacing35, marginProps as marginProps26, propsBlocker as propsBlocker43, typography as typography21, round, getComponentOverride as getComponentOverride29, token as token32 } from "@deliveryhero/armor-system";
var IndicatorRoot = styled44.div.withConfig(propsBlocker43)(_templateObject303 || (_templateObject303 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    background-color: ", ";\n    width: ", ";\n    height: ", ";\n    box-sizing: border-box;\n    position: relative;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    user-select: none;\n    ", ";\n    border-radius: ", "px;\n\n    &:before {\n        content: '!';\n    }\n\n    ", ";\n    ", ";\n"])), typography21("desktop.bodySmall", "labelSmall"), token32("text.color.ondanger", "color.neutral.00"), token32("text.color.danger", "color.error.main"), spacing35("control.sizing.tiny", [4]), spacing35("control.sizing.tiny", [4]), round, token32("action.borderRadius.pill"), getComponentOverride29("Indicator"), marginProps26);

// src/components/Indicator/constants.ts
var INDICATOR_CLASS_PREFIX = "Indicator";

// src/components/Indicator/Indicator.tsx
var Indicator = forwardRef33(function Indicator2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useIndicatorClassNames(INDICATOR_CLASS_PREFIX, className);
  return /* @__PURE__ */React59.createElement(IndicatorRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }));
});
Indicator.defaultProps = {};
Indicator.propTypes = {};
var MemoizedIndicator = memo43(Indicator);

// src/components/FormField/FormFieldTooltip/style.ts
var FormFieldTooltipRoot = styled45(Tooltip)(_templateObject304 || (_templateObject304 = _taggedTemplateLiteral(["\n    ", ";\n"])), getComponentOverride30("FormFieldTooltip"));
var getIndicatorDynamicStyle = function getIndicatorDynamicStyle(_ref106) {
  var visible = _ref106.visible;
  return visible ? "" : css39(_templateObject305 || (_templateObject305 = _taggedTemplateLiteral(["\n              opacity: 0;\n              pointer-events: none;\n          "])));
};
var FormFieldTooltipIndicator = styled45(Indicator)(_templateObject306 || (_templateObject306 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    ", ";\n"])), spacing36(-2), spacing36(-2), getIndicatorDynamicStyle);

// src/components/FormField/FormFieldTooltip/constants.ts
var FORM_FIELD_TOOLTIP_CLASS_PREFIX = "FormFieldTooltip";

// src/components/FormField/FormFieldTooltip/FormFieldTooltip.tsx
var FormFieldTooltip = forwardRef34(function FormFieldTooltip2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    visible = _b.visible,
    restProps = __objRest(_b, ["className", "children", "visible"]);
  var classNameComponents = useFormFieldTooltipClassNames(FORM_FIELD_TOOLTIP_CLASS_PREFIX, className);
  return /* @__PURE__ */React60.createElement(FormFieldTooltipRoot, __spreadProps(__spreadValues({}, restProps), {
    align: "top-end",
    className: classNameComponents.Root,
    ref: ref,
    content: children,
    error: true
  }), /* @__PURE__ */React60.createElement(FormFieldTooltipIndicator, {
    visible: visible,
    className: classNameComponents.Indicator
  }));
});
FormFieldTooltip.defaultProps = {
  visible: false
};
FormFieldTooltip.propTypes = {
  /** Example description */
  visible: PropTypes30.bool
};
var MemoizedFormFieldTooltip = memo44(FormFieldTooltip);

// src/components/FormField/FormFieldMessage/FormFieldMessage.tsx
import React61, { forwardRef as forwardRef35, memo as memo45 } from "react";
import PropTypes31 from "prop-types";

// src/components/FormField/FormFieldMessage/hooks/useFormFieldMessageClassNames.ts
import { useMemo as useMemo63 } from "react";
import { makeBEM as makeBEM39, makeRootClassName as makeRootClassName29 } from "@deliveryhero/armor-system";
var useFormFieldMessageClassNames = function useFormFieldMessageClassNames(classPrefix, className, error) {
  return useMemo63(function () {
    var rootClassNames = makeRootClassName29(classPrefix, className);
    var rootStateClassNames = [];
    if (error) {
      rootStateClassNames.push(makeBEM39(classPrefix, "Root", "error"));
    }
    return {
      Root: "".concat(rootClassNames, " ").concat(rootStateClassNames.join(" ")).trim()
    };
  }, [classPrefix, className, error]);
};

// src/components/FormField/FormFieldMessage/style.ts
import styled46, { css as css40 } from "styled-components";
import { getComponentOverride as getComponentOverride31, marginProps as marginProps27, propsBlocker as propsBlocker45, typography as typography23, token as token33 } from "@deliveryhero/armor-system";

// src/compatibility.ts
import { makeTheme, makeDefaultTheme, colorGrey90, colorGrey80, colorGrey70, colorGrey60, colorGrey50, colorGrey40, colorGrey30, colorGrey20, colorGrey10, colorGrey05, colorGrey01, colorGrey00 as colorGrey002, colorBlue90, colorBlue80, colorBlue70, colorBlue60, colorBlue50, colorBlue40, colorBlue30, colorBlue20, colorBlue10, colorBlue05, colorTurquoise90, colorTurquoise80, colorTurquoise70, colorTurquoise60, colorTurquoise50, colorTurquoise40, colorTurquoise30, colorTurquoise20, colorTurquoise10, colorTurquoise05, colorYellow90, colorYellow80, colorYellow70, colorYellow60, colorYellow50, colorYellow40, colorYellow30, colorYellow20, colorYellow10, colorYellow05, colorGreen90, colorGreen80, colorGreen70, colorGreen60, colorGreen50, colorGreen40, colorGreen30, colorGreen20, colorGreen10, colorGreen05, colorRed90, colorRed80, colorRed70, colorRed60, colorRed50, colorRed40, colorRed30, colorRed20, colorRed10, colorRed05, colorPurple50, colorPurple20, borderRadius01, borderRadius02, borderRadius04, borderRadiusPill, boxShadowSmall, boxShadowMedium, boxShadowLarge, durationNormal as durationNormal11, fontFamilyRoboto as fontFamilyRoboto2, fontSize01, fontSize02 as fontSize022, fontSize03, fontSize04, fontSize05, fontWeightRegular as fontWeightRegular2, fontWeightMedium, fontWeightBold, letterSpacingNone, letterSpacingSmall, letterSpacingMedium, letterSpacingLarge, lineHeight01, lineHeight02, lineHeight03, lineHeight04, lineHeight05, componentSpacing01, componentSpacing02, componentSpacing03, componentSpacing04, componentSpacing05, componentSpacing06, componentSpacing07, componentSpacing08, componentSpacing09, layoutSpacing01, layoutSpacing02, layoutSpacing03, layoutSpacing04, layoutSpacing05, zIndexTableHeader, zIndexModal, zIndexSearchSuggestionsList as zIndexSearchSuggestionsList2, color as color20, spacing as spacing37, typography as typography22, pixelToRem as pixelToRem4, borderRadius as borderRadius3, propsBlocker as propsBlocker44 } from "@deliveryhero/armor-system";

// src/components/FormField/FormFieldMessage/style.ts
var getRootDynamicStyle2 = function getRootDynamicStyle2(_ref107) {
  var error = _ref107.error,
    oneLine = _ref107.oneLine;
  var result = {};
  if (oneLine) {
    result = css40(_templateObject307 || (_templateObject307 = _taggedTemplateLiteral(["\n            ", ";\n            white-space: nowrap;\n            overflow-x: hidden;\n            text-overflow: ellipsis;\n        "])), result);
  }
  if (error) {
    result = css40(_templateObject308 || (_templateObject308 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, token33("text.color.error", "color.error.08"));
  }
  return result;
};
var FormFieldMessageRoot = styled46.div.withConfig(propsBlocker45)(_templateObject309 || (_templateObject309 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    position: relative;\n    ", ";\n    color: ", ";\n    margin-top: ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), typography23("paragraphSmall"), token33("text.color.secondary", "color.neutral.07"), spacing37(2), getRootDynamicStyle2, getComponentOverride31("FormFieldMessage"), marginProps27);
var FormFieldMessageFakeChildren = styled46.div.withConfig(propsBlocker45)(_templateObject310 || (_templateObject310 = _taggedTemplateLiteral(["\n    opacity: 0;\n\n    &:before {\n        content: '1';\n    }\n"])));

// src/components/FormField/FormFieldMessage/constants.ts
var FORM_FIELD_MESSAGE_CLASS_PREFIX = "FormFieldMessage";

// src/components/FormField/FormFieldMessage/FormFieldMessage.tsx
var FormFieldMessage = forwardRef35(function FormFieldMessage2(_a, ref) {
  var _b = _a,
    className = _b.className,
    error = _b.error,
    oneLine = _b.oneLine,
    children = _b.children,
    restProps = __objRest(_b, ["className", "error", "oneLine", "children"]);
  var classNameComponents = useFormFieldMessageClassNames(FORM_FIELD_MESSAGE_CLASS_PREFIX, className, error);
  return /* @__PURE__ */React61.createElement(FormFieldMessageRoot, __spreadProps(__spreadValues({}, restProps), {
    error: error,
    oneLine: oneLine,
    className: classNameComponents.Root,
    ref: ref
  }), children || !!oneLine && /* @__PURE__ */React61.createElement(FormFieldMessageFakeChildren, null));
});
FormFieldMessage.defaultProps = {
  error: false,
  oneLine: false
};
FormFieldMessage.propTypes = {
  /** Show message as an error */
  error: PropTypes31.bool,
  /** Reserve just one line for the message, cut the rest */
  oneLine: PropTypes31.bool
};
var MemoizedFormFieldMessage = memo45(FormFieldMessage);

// src/components/FileCard/style.ts
var getBodyStyle = function getBodyStyle(_ref108) {
  var error = _ref108.error,
    uploadProgress = _ref108.uploadProgress;
  var result = {};
  if (error) {
    result = css41(_templateObject311 || (_templateObject311 = _taggedTemplateLiteral(["\n            ", ";\n            border-color: ", ";\n        "])), result, color21("error.07"));
  }
  if (uploadProgress || uploadProgress === 0) {
    result = css41(_templateObject312 || (_templateObject312 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n        "])), result, color21("neutral.02"));
  }
  return result;
};
var getImageContainerStyle = function getImageContainerStyle(_ref109) {
  var isUploading = _ref109.isUploading;
  var result = {};
  if (isUploading) {
    return css41(_templateObject313 || (_templateObject313 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n            svg {\n                color: ", ";\n            }\n        "])), result, color21("neutral.03"), color21("neutral.05"));
  }
  return result;
};
var FileCardRoot = styled47.div.withConfig(propsBlocker46)(_templateObject314 || (_templateObject314 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset15, getComponentOverride32("FileCard"), marginProps28, widthProps12);
var FileCardBody = styled47.div.withConfig(propsBlocker46)(_templateObject315 || (_templateObject315 = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n    border-radius: ", ";\n    display: flex;\n    justify-content: space-between;\n    padding: ", ";\n    white-space: nowrap;\n    position: relative;\n    overflow: hidden;\n\n    ", ";\n"])), color21("neutral.03"), borderRadius4("soft"), spacing38(2), getBodyStyle);
var FileCardLeftPortion = styled47.div.withConfig(propsBlocker46)(_templateObject316 || (_templateObject316 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    display: flex;\n    align-items: center;\n    min-width: 80%;\n"])), typography24("paragraphLarge"), token34("body.color"));
var FileCardRightPortion = styled47.div.withConfig(propsBlocker46)(_templateObject317 || (_templateObject317 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));
var getIconStyles = function getIconStyles(colorText) {
  return css41(_templateObject318 || (_templateObject318 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), color21(colorText));
};
var leftIconStyles = css41(_templateObject319 || (_templateObject319 = _taggedTemplateLiteral(["\n    ", ";\n"])), getIconStyles("neutral.11"));
var getRightIconStyles = function getRightIconStyles(colorText) {
  return css41(_templateObject320 || (_templateObject320 = _taggedTemplateLiteral(["\n    ", ";\n"])), getIconStyles(colorText));
};
var FileTextIcon = styled47(FileCommonTextIcon)(_templateObject321 || (_templateObject321 = _taggedTemplateLiteral(["\n    ", "\n"])), leftIconStyles);
var FileImageIcon = styled47(FileImagePortraitIcon)(_templateObject322 || (_templateObject322 = _taggedTemplateLiteral(["\n    ", ";\n"])), leftIconStyles);
var FilePDFIcon = styled47(FilePDFIconArmor)(_templateObject323 || (_templateObject323 = _taggedTemplateLiteral(["\n    ", ";\n"])), leftIconStyles);
var FileCSVIcon = styled47(FileCSVIconArmor)(_templateObject324 || (_templateObject324 = _taggedTemplateLiteral(["\n    ", ";\n"])), leftIconStyles);
var FileImageContainer = styled47.div.withConfig(propsBlocker46)(_templateObject325 || (_templateObject325 = _taggedTemplateLiteral(["\n    display: flex;\n    flex: 0 0 auto;\n    align-items: center;\n    justify-content: center;\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n    border-radius: ", ";\n    ", "\n"])), spacing38(10), spacing38(10), spacing38(3), borderRadius4("soft"), getImageContainerStyle);
var FileImage = styled47.img.withConfig(propsBlocker46)(_templateObject326 || (_templateObject326 = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    object-fit: cover;\n    border-radius: ", ";\n"])), spacing38(10), spacing38(10), borderRadius4("soft"));
var CancelIcon4 = styled47(CancelIconArmor)(_templateObject327 || (_templateObject327 = _taggedTemplateLiteral(["\n    ", ";\n"])), getRightIconStyles("primary.07"));
var DeleteIcon = styled47(DeleteIconArmor)(_templateObject328 || (_templateObject328 = _taggedTemplateLiteral(["\n    ", ";\n"])), getRightIconStyles("error.07"));
var FormFieldErrorMessage = styled47(FormFieldMessage).withConfig(propsBlocker46)(_templateObject329 || (_templateObject329 = _taggedTemplateLiteral(["\n    margin-left: 0;\n    color: ", ";\n"])), color21("error.07"));
var FileName = styled47.div.withConfig(propsBlocker46)(_templateObject330 || (_templateObject330 = _taggedTemplateLiteral(["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 0 1 auto;\n"])));
var FileExtension = styled47.div.withConfig(propsBlocker46)(_templateObject331 || (_templateObject331 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n"])), spacing38(2));
var FileSize = styled47.div.withConfig(propsBlocker46)(_templateObject332 || (_templateObject332 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n"])), typography24("paragraphMedium"), color21("neutral.07"));
var UploadBar = styled47(ProgressBar)(_templateObject333 || (_templateObject333 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n"])));

// src/components/FileCard/utils/getFileIconByExtension.tsx
var FileImageExtensions = ["gif", "jpg", "jpeg", "jfif", "pjpeg", "pjp", "png", "svg", "webp", "bmp", "ico", "cur", "tif", "tiff"];
var getFileIconByExtension = function getFileIconByExtension() {
  var extension = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var extensionLowerCase = extension.toLowerCase();
  if (extensionLowerCase === "csv") {
    return FileCSVIcon;
  }
  if (extensionLowerCase === "pdf") {
    return FilePDFIcon;
  }
  if (FileImageExtensions.includes(extensionLowerCase)) {
    return FileImageIcon;
  }
  return FileTextIcon;
};

// src/components/FileCard/utils/convertBlobToBase64.ts
var convertBlobToBase64 = function convertBlobToBase64(blob) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = function () {
      var _a;
      return resolve(((_a = reader.result) == null ? void 0 : _a.toString()) || "");
    };
    reader.onerror = function (error) {
      return reject(error);
    };
  });
};

// src/components/FileCard/constants.ts
var FILECARD_CLASS_PREFIX = "FileCard";
var FILECARD_NAME_ELLIPSIS_POINT = 3;

// src/components/FileCard/utils/getFileNamesWithEllipsisSplit.ts
var getFileNamesWithEllipsisSplit = function getFileNamesWithEllipsisSplit(fileName, fileExtension) {
  if (fileName.length > FILECARD_NAME_ELLIPSIS_POINT) {
    var splitIndex = fileName.length - FILECARD_NAME_ELLIPSIS_POINT;
    var nameFirstPart = fileName.substring(0, splitIndex);
    var nameLastPart = fileName.slice(splitIndex);
    return {
      nameFirstPart: nameFirstPart,
      nameLastPart: "".concat(nameLastPart, ".").concat(fileExtension)
    };
  }
  return {
    nameFirstPart: fileName,
    nameLastPart: ".".concat(fileExtension)
  };
};

// src/components/FileCard/hooks/useFileCard.ts
var useFileCard = function useFileCard(_a, ref) {
  var _b = _a,
    fileId = _b.fileId,
    fileNameFull = _b.fileName,
    fileSize = _b.fileSize,
    uploadProgress = _b.uploadProgress,
    imageSrc = _b.imageSrc,
    error = _b.error,
    errorMessage = _b.errorMessage,
    onCancelButtonClick = _b.onCancelButtonClick,
    onDeleteButtonClick = _b.onDeleteButtonClick,
    hideCancelButton = _b.hideCancelButton,
    restProps = __objRest(_b, ["fileId", "fileName", "fileSize", "uploadProgress", "imageSrc", "error", "errorMessage", "onCancelButtonClick", "onDeleteButtonClick", "hideCancelButton"]);
  var _useState41 = useState10(""),
    _useState42 = _slicedToArray(_useState41, 2),
    internalImageSrc = _useState42[0],
    setInternalImageSrc = _useState42[1];
  var innerRef = useRootRef16(ref);
  var _useMemo4 = useMemo64(function () {
      return extractFileNameExtension(fileNameFull);
    }, [fileNameFull]),
    fileName = _useMemo4.fileName,
    fileExtension = _useMemo4.fileExtension;
  var _useMemo5 = useMemo64(function () {
      return getFileNamesWithEllipsisSplit(fileName, fileExtension);
    }, [fileName, fileExtension]),
    nameFirstPart = _useMemo5.nameFirstPart,
    nameLastPart = _useMemo5.nameLastPart;
  useEffect14(function () {
    if (!imageSrc) {
      return;
    }
    if (imageSrc instanceof Blob) {
      (function () {
        return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var imageSrcBase64;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return convertBlobToBase64(imageSrc);
                case 3:
                  imageSrcBase64 = _context.sent;
                  setInternalImageSrc(imageSrcBase64);
                  _context.next = 10;
                  break;
                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);
                  setInternalImageSrc("");
                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 7]]);
        }));
      })();
    } else {
      setInternalImageSrc(imageSrc);
    }
  }, [imageSrc]);
  var isUploading = (!!uploadProgress || uploadProgress === 0) && !error;
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      error: error,
      uploadProgress: uploadProgress
    }),
    bodyProps: {
      error: error,
      uploadProgress: uploadProgress,
      ref: innerRef
    },
    error: error,
    errorMessage: errorMessage,
    isUploading: isUploading,
    fileSize: Boolean(fileSize) && formatBytesToSize(fileSize),
    fileName: nameFirstPart,
    fileExtension: nameLastPart,
    imageSrc: internalImageSrc,
    FileIcon: getFileIconByExtension(fileExtension),
    getCancelButtonProps: function getCancelButtonProps() {
      return {
        onClick: function onClick() {
          return fileId && (onCancelButtonClick == null ? void 0 : onCancelButtonClick(fileId));
        },
        marginLeft: 2
      };
    },
    getDeleteButtonProps: function getDeleteButtonProps() {
      return {
        onClick: function onClick() {
          return fileId && (onDeleteButtonClick == null ? void 0 : onDeleteButtonClick(fileId));
        },
        marginLeft: 2
      };
    },
    getUploadBarProps: function getUploadBarProps() {
      return {
        progress: uploadProgress,
        preset: ProgressBarLevels.FILE_UPLOAD
      };
    },
    showCancelButton: Boolean(isUploading && !hideCancelButton),
    showDeleteButton: Boolean(!isUploading || error)
  };
};

// src/components/FileCard/FileCard.tsx
var FileCard = forwardRef36(function FileCard2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNames = useFileCardClassNames(FILECARD_CLASS_PREFIX, className);
  var _useFileCard = useFileCard(props, ref),
    rootProps = _useFileCard.rootProps,
    bodyProps = _useFileCard.bodyProps,
    error = _useFileCard.error,
    errorMessage = _useFileCard.errorMessage,
    isUploading = _useFileCard.isUploading,
    fileSize = _useFileCard.fileSize,
    fileName = _useFileCard.fileName,
    fileExtension = _useFileCard.fileExtension,
    imageSrc = _useFileCard.imageSrc,
    FileIcon = _useFileCard.FileIcon,
    getUploadBarProps = _useFileCard.getUploadBarProps,
    getCancelButtonProps = _useFileCard.getCancelButtonProps,
    getDeleteButtonProps = _useFileCard.getDeleteButtonProps,
    showCancelButton = _useFileCard.showCancelButton,
    showDeleteButton = _useFileCard.showDeleteButton;
  return /* @__PURE__ */React62.createElement(FileCardRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), /* @__PURE__ */React62.createElement(FileCardBody, __spreadProps(__spreadValues({}, bodyProps), {
    className: classNames.Body
  }), /* @__PURE__ */React62.createElement(FileCardLeftPortion, {
    className: classNames.LeftPortion
  }, imageSrc ? /* @__PURE__ */React62.createElement(FileImageContainer, {
    className: classNames.FileImageContainer,
    isUploading: isUploading
  }, isUploading ? /* @__PURE__ */React62.createElement(FileImageIcon, {
    large: true,
    className: classNames.FileIcon
  }) : /* @__PURE__ */React62.createElement(FileImage, {
    className: classNames.FileImage,
    src: imageSrc,
    alt: fileName
  })) : /* @__PURE__ */React62.createElement(FileImageContainer, {
    className: classNames.FileImageContainer
  }, /* @__PURE__ */React62.createElement(FileIcon, {
    large: true,
    className: classNames.FileIcon
  })), /* @__PURE__ */React62.createElement(FileName, {
    className: classNames.FileName
  }, fileName), /* @__PURE__ */React62.createElement(FileExtension, {
    className: classNames.FileExtension
  }, fileExtension), fileSize && /* @__PURE__ */React62.createElement(FileSize, {
    className: classNames.FileSize
  }, fileSize)), /* @__PURE__ */React62.createElement(FileCardRightPortion, {
    className: classNames.RightPortion
  }, showCancelButton && /* @__PURE__ */React62.createElement(IconButton, __spreadProps(__spreadValues({}, getCancelButtonProps()), {
    className: classNames.CancelButton,
    "data-testid": classNames.CancelButton
  }), /* @__PURE__ */React62.createElement(CancelIcon4, {
    small: true,
    className: classNames.CancelIcon
  })), showDeleteButton && /* @__PURE__ */React62.createElement(IconButton, __spreadProps(__spreadValues({}, getDeleteButtonProps()), {
    className: classNames.DeleteButton,
    "data-testid": classNames.DeleteButton
  }), /* @__PURE__ */React62.createElement(DeleteIcon, {
    medium: true,
    className: classNames.DeleteIcon
  }))), isUploading && /* @__PURE__ */React62.createElement(UploadBar, __spreadProps(__spreadValues({}, getUploadBarProps()), {
    className: classNames.UploadBar
  }))), error && !!errorMessage && /* @__PURE__ */React62.createElement(FormFieldErrorMessage, {
    oneLine: true,
    className: classNames.FormFieldErrorMessage
  }, errorMessage));
});
FileCard.defaultProps = {
  error: false,
  fileSize: 0
};
FileCard.propTypes = {
  id: PropTypes32.string,
  uploadProgress: PropTypes32.number,
  error: PropTypes32.bool,
  errorMessage: PropTypes32.string,
  fileName: PropTypes32.string,
  fileSize: PropTypes32.number,
  imageSrc: PropTypes32.string,
  onCancelButtonClick: PropTypes32.func,
  onDeleteButtonClick: PropTypes32.func
};
var MemoizedFileCard = memo46(FileCard);

// src/components/Grid/Grid.tsx
import React64, { forwardRef as forwardRef37, useMemo as useMemo66, memo as memo47 } from "react";
import PropTypes33 from "prop-types";
import { useTheme as useTheme2 } from "@deliveryhero/armor-system";

// src/components/Grid/utils/useGridClassName.ts
import { useMemo as useMemo65 } from "react";
import { appendClassName as appendClassName23, makeBEM as makeBEM40 } from "@deliveryhero/armor-system";
var getClassNameByComponent10 = function getClassNameByComponent10(_ref110) {
  var component = _ref110.component,
    classPrefix = _ref110.classPrefix,
    spacing71 = _ref110.spacing;
  var baseClassNames = makeBEM40(classPrefix, component);
  var stateClassNames = [];
  if (spacing71 && spacing71 > 0) {
    stateClassNames.push(makeBEM40(classPrefix, component, "spacing-".concat(spacing71)));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useGridClassName = function useGridClassName(classPrefix, className, spacing71) {
  return useMemo65(function () {
    return {
      Root: appendClassName23(getClassNameByComponent10({
        component: "Root",
        classPrefix: classPrefix,
        spacing: spacing71
      }), className)
    };
  }, [classPrefix, className, spacing71]);
};
var useGridClassName_default = useGridClassName;

// src/components/Grid/constants.ts
var GRID_CLASS_PREFIX = "Grid";
var gridRoot = "GridRoot";
var GRID_RESOLUTION = 12;

// src/components/Grid/utils/GridContext.ts
import * as React63 from "react";
var GridContext = React63.createContext({});

// src/components/Grid/style.ts
import styled48, { css as css42 } from "styled-components";
import { marginProps as marginProps29, propsBlocker as propsBlocker47, sizeProps as sizeProps7 } from "@deliveryhero/armor-system";
var setHorizontalMargin = function setHorizontalMargin(value, spacing71) {
  var marginValue = spacing71(value);
  return css42(_templateObject334 || (_templateObject334 = _taggedTemplateLiteral(["\n        margin-right: calc(", " * 0.5);\n        margin-left: calc(", " * 0.5);\n    "])), marginValue, marginValue);
};
var setVerticalMargin = function setVerticalMargin(value, spacing71) {
  var marginValue = spacing71(value);
  return css42(_templateObject335 || (_templateObject335 = _taggedTemplateLiteral(["\n        margin-top: calc(", " * 0.5);\n        margin-bottom: calc(", " * 0.5);\n    "])), marginValue, marginValue);
};
var gridRootStyle = function gridRootStyle(_ref111) {
  var gutterSpacing = _ref111.gutterSpacing,
    gutterSpacingVertical = _ref111.gutterSpacingVertical,
    gutterSpacingHorizontal = _ref111.gutterSpacingHorizontal,
    theme = _ref111.theme;
  var spacing71 = theme.armor.spacing;
  var result = {};
  var gutterSpacingX = gutterSpacingHorizontal || gutterSpacing;
  var gutterSpacingY = gutterSpacingVertical || gutterSpacing;
  if (gutterSpacingX && gutterSpacingX > 0) {
    result = css42(_templateObject336 || (_templateObject336 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n        "])), result, setHorizontalMargin(-gutterSpacingX, spacing71));
  }
  if (gutterSpacingY && gutterSpacingY > 0) {
    result = css42(_templateObject337 || (_templateObject337 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n        "])), result, setVerticalMargin(-gutterSpacingY, spacing71));
  }
  return result;
};
var GridRoot = styled48.div.withConfig(propsBlocker47)(_templateObject338 || (_templateObject338 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: wrap;\n    ", ";\n    ", ";\n    ", ";\n"])), gridRootStyle, sizeProps7, marginProps29);

// src/components/Grid/Grid.tsx
var Grid = forwardRef37(function Grid2(_a, ref) {
  var _b = _a,
    className = _b.className,
    gutterSpacing = _b.gutterSpacing,
    gutterSpacingVertical = _b.gutterSpacingVertical,
    gutterSpacingHorizontal = _b.gutterSpacingHorizontal,
    restProps = __objRest(_b, ["className", "gutterSpacing", "gutterSpacingVertical", "gutterSpacingHorizontal"]);
  var theme = useTheme2();
  var classOverride = useGridClassName_default(GRID_CLASS_PREFIX, className);
  var contextValue = useMemo66(function () {
    return {
      gutterSpacing: gutterSpacing,
      gutterSpacingVertical: gutterSpacingVertical,
      gutterSpacingHorizontal: gutterSpacingHorizontal
    };
  }, [gutterSpacing, gutterSpacingVertical, gutterSpacingHorizontal]);
  return /* @__PURE__ */React64.createElement(GridContext.Provider, {
    value: contextValue
  }, /* @__PURE__ */React64.createElement(GridRoot, __spreadProps(__spreadValues({
    "data-testid": gridRoot,
    theme: theme
  }, restProps), {
    className: classOverride.Root,
    gutterSpacing: gutterSpacing,
    gutterSpacingVertical: gutterSpacingVertical,
    gutterSpacingHorizontal: gutterSpacingHorizontal,
    ref: ref
  })));
});
Grid.defaultProps = {
  gutterSpacing: 0
};
Grid.propTypes = {
  // TODO (nmelnikov 2020-10-23): there is currently no upper cap on spacing.
  //  Didn't want to set something like 10, since there might be gaps e.g. of 60px between content sections.
  //  Check w/Sergei on what he thinks
  gutterSpacing: PropTypes33.number,
  gutterSpacingVertical: PropTypes33.number,
  gutterSpacingHorizontal: PropTypes33.number
};
var MemoizedGrid = memo47(Grid);

// src/components/Grid/GridItem/GridItem.tsx
import React65, { forwardRef as forwardRef38, useContext as useContext3, memo as memo48 } from "react";
import PropTypes34 from "prop-types";
import { useTheme as useTheme3 } from "@deliveryhero/armor-system";

// src/components/Grid/GridItem/constants.ts
var GRID_ITEM_CLASS_PREFIX = "GridItem";
var gridItemRoot = "GridItemRoot";

// src/components/Grid/GridItem/hooks/useGridItemClassName.ts
import { useMemo as useMemo67 } from "react";
import { appendClassName as appendClassName24, makeBEM as makeBEM41 } from "@deliveryhero/armor-system";
var getClassNameByComponent11 = function getClassNameByComponent11(_ref112) {
  var component = _ref112.component,
    classPrefix = _ref112.classPrefix,
    gutterSpacing = _ref112.gutterSpacing;
  var baseClassNames = makeBEM41(classPrefix, component);
  var stateClassNames = [];
  if (gutterSpacing && gutterSpacing > 0) {
    stateClassNames.push(makeBEM41(classPrefix, component, "spacing-".concat(gutterSpacing)));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useGridItemClassName = function useGridItemClassName(classPrefix, className, spacing71) {
  return useMemo67(function () {
    return {
      Root: appendClassName24(getClassNameByComponent11({
        component: "Root",
        classPrefix: classPrefix,
        gutterSpacing: spacing71
      }), className)
    };
  }, [classPrefix, className, spacing71]);
};

// src/components/Grid/GridItem/hooks/useGridItem.ts
import { useRootRef as useRootRef17 } from "@deliveryhero/armor-system";
var useGridItem = function useGridItem(_a, ref) {
  var _b = _a,
    xxl = _b.xxl,
    restProps = __objRest(_b, ["xxl"]);
  var rootRef = useRootRef17(ref);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      "2xl": xxl,
      // need to use 'xxl' because using a leading number name for a component prop is not allowed
      ref: rootRef
    })
  };
};

// src/components/Grid/GridItem/style.ts
import styled49, { css as css43 } from "styled-components";
import { paddingProps as paddingProps14, propsBlocker as propsBlocker48 } from "@deliveryhero/armor-system";
var setMediaStyle = function setMediaStyle(size, spacing71, gutterSpacingX) {
  var width = 100 / GRID_RESOLUTION * size;
  if (gutterSpacingX && gutterSpacingX > 0) {
    return css43(_templateObject339 || (_templateObject339 = _taggedTemplateLiteral(["\n            width: calc(", "% - ", ");\n        "])), width, spacing71(gutterSpacingX));
  }
  return css43(_templateObject340 || (_templateObject340 = _taggedTemplateLiteral(["\n        width: ", "%;\n    "])), width);
};
var gridItemRootStyle = function gridItemRootStyle(_a) {
  var _b = _a,
    gutterSpacing = _b.gutterSpacing,
    gutterSpacingVertical = _b.gutterSpacingVertical,
    gutterSpacingHorizontal = _b.gutterSpacingHorizontal,
    _b$theme$armor = _b.theme.armor,
    breakpoints = _b$theme$armor.breakpoints,
    spacing71 = _b$theme$armor.spacing,
    restProps = __objRest(_b, ["gutterSpacing", "gutterSpacingVertical", "gutterSpacingHorizontal", "theme"]);
  var result = {};
  var gutterSpacingX = gutterSpacingHorizontal || gutterSpacing;
  var gutterSpacingY = gutterSpacingVertical || gutterSpacing;
  if (gutterSpacingX && gutterSpacingX > 0) {
    result = css43(_templateObject341 || (_templateObject341 = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, setHorizontalMargin(gutterSpacingX, spacing71));
  }
  if (gutterSpacingY && gutterSpacingY > 0) {
    result = css43(_templateObject342 || (_templateObject342 = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, setVerticalMargin(gutterSpacingY, spacing71));
  }
  breakpoints.keys.forEach(function (key) {
    if (restProps[key]) {
      result = css43(_templateObject343 || (_templateObject343 = _taggedTemplateLiteral(["\n                ", ";\n                ", " {\n                    ", "\n                }\n            "])), result, breakpoints.up(key), setMediaStyle(restProps[key], spacing71, gutterSpacingX));
    }
  });
  return result;
};
var GridItemRoot = styled49.div.withConfig(propsBlocker48)(_templateObject344 || (_templateObject344 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    width: 100%;\n\n    ", "\n    ", "\n"])), gridItemRootStyle, paddingProps14);

// src/components/Grid/GridItem/GridItem.tsx
var GridItem = forwardRef38(function GridItem2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var theme = useTheme3();
  var _useContext3 = useContext3(GridContext),
    gutterSpacing = _useContext3.gutterSpacing,
    gutterSpacingVertical = _useContext3.gutterSpacingVertical,
    gutterSpacingHorizontal = _useContext3.gutterSpacingHorizontal;
  var classOverride = useGridItemClassName(GRID_ITEM_CLASS_PREFIX, className, gutterSpacing);
  var _useGridItem = useGridItem(restProps, ref),
    rootProps = _useGridItem.rootProps;
  return /* @__PURE__ */React65.createElement(GridItemRoot, __spreadProps(__spreadValues({
    "data-testid": gridItemRoot,
    theme: theme
  }, rootProps), {
    className: classOverride.Root,
    gutterSpacing: gutterSpacing,
    gutterSpacingVertical: gutterSpacingVertical,
    gutterSpacingHorizontal: gutterSpacingHorizontal
  }));
});
GridItem.defaultProps = {};
GridItem.propTypes = {
  xs: PropTypes34.oneOf([
  // todo: discuss the real purpose of this, because it seems to be defeating the 12-column concept
  // true,
  // false,
  // 'auto',
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes34.oneOf([
  // todo: discuss the real purpose of this, because it seems to be defeating the 12-column concept
  // true,
  // false,
  // 'auto',
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes34.oneOf([
  // todo: discuss the real purpose of this, because it seems to be defeating the 12-column concept
  // true,
  // false,
  // 'auto',
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  lg: PropTypes34.oneOf([
  // todo: discuss the real purpose of this, because it seems to be defeating the 12-column concept
  // true,
  // false,
  // 'auto',
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xl: PropTypes34.oneOf([
  // todo: discuss the real purpose of this, because it seems to be defeating the 12-column concept
  // true,
  // false,
  // 'auto',
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xxl: PropTypes34.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
};
var MemoizedGridItem = memo48(GridItem);

// src/components/HeaderNavigation/HeaderNavigation.tsx
import React78, { forwardRef as forwardRef43, memo as memo57 } from "react";
import PropTypes41 from "prop-types";

// src/components/HeaderNavigation/constants.ts
var HEADER_NAVIGATION_CLASS_PREFIX = "HeaderNavigation";
var headerNavigationRoot = "HeaderNavigationRoot";

// src/components/HeaderNavigation/style.ts
import styled50 from "styled-components";
import { getComponentOverride as getComponentOverride33, marginProps as marginProps30, color as color22, spacing as spacing39, propsBlocker as propsBlocker49, typography as typography25, token as token35 } from "@deliveryhero/armor-system";
var HeaderNavigationRoot = styled50.div.withConfig(propsBlocker49)(_templateObject345 || (_templateObject345 = _taggedTemplateLiteral(["\n    display: block;\n    min-height: ", ";\n    border-bottom: 1px solid ", ";\n    background-color: ", ";\n    padding-left: ", ";\n    padding-right: 0;\n    ", ";\n    color: ", ";\n    ", ";\n    ", ";\n"])), spacing39(12), color22("neutral.03"), color22("neutral.02"), spacing39(4), typography25("labelLarge"), token35("body.color"), getComponentOverride33("HeaderNavigation"), marginProps30);
var HeaderNavigationTitleRoot = styled50.div.withConfig(propsBlocker49)(_templateObject346 || (_templateObject346 = _taggedTemplateLiteral([""])));
var HeaderNavigationContent = styled50.div.withConfig(propsBlocker49)(_templateObject347 || (_templateObject347 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n"])));
var HeaderNavigationContentItem = styled50.div.withConfig(propsBlocker49)(_templateObject348 || (_templateObject348 = _taggedTemplateLiteral([""])));
var HeaderNavigationContentLeft = styled50.div.withConfig(propsBlocker49)(_templateObject349 || (_templateObject349 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n"])));
var HeaderNavigationContentRight = styled50.div.withConfig(propsBlocker49)(_templateObject350 || (_templateObject350 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n"])));

// src/components/HeaderNavigation/hooks/useHeaderNavigationClassName.ts
import { useMemo as useMemo68 } from "react";
import { appendClassName as appendClassName25, makeBEM as makeBEM42 } from "@deliveryhero/armor-system";
var getClassNameByComponent12 = function getClassNameByComponent12(_ref113) {
  var component = _ref113.component,
    classPrefix = _ref113.classPrefix;
  var baseClassNames = makeBEM42(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useHeaderNavigationClassName = function useHeaderNavigationClassName(classPrefix, className) {
  return useMemo68(function () {
    return {
      Root: appendClassName25(getClassNameByComponent12({
        component: "Root",
        classPrefix: classPrefix
      }), className),
      HeaderNavigationContent: getClassNameByComponent12({
        component: "HeaderNavigationContent",
        classPrefix: classPrefix
      }),
      HeaderNavigationContentItem: getClassNameByComponent12({
        component: "HeaderNavigationContentItem",
        classPrefix: classPrefix
      }),
      HeaderNavigationContentLeft: getClassNameByComponent12({
        component: "HeaderNavigationContentLeft",
        classPrefix: classPrefix
      }),
      NavigationTitle: getClassNameByComponent12({
        component: "NavigationTitle",
        classPrefix: classPrefix
      }),
      HeaderNavigationItem: getClassNameByComponent12({
        component: "HeaderNavigationItem",
        classPrefix: classPrefix
      }),
      HeaderNavigationContentRight: getClassNameByComponent12({
        component: "HeaderNavigationContentRight",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};
var useHeaderNavigationClassName_default = useHeaderNavigationClassName;

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenu.tsx
import React70, { forwardRef as forwardRef39, memo as memo50 } from "react";
import PropTypes35 from "prop-types";

// src/components/HeaderNavigation/HeaderNavigationMenu/constants.ts
var HEADER_NAVIGATION_MENU_CLASS_PREFIX = "HeaderNavigationMenu";
var headerNavigationMenuRoot = "HeaderNavigationMenuRoot";

// src/components/HeaderNavigation/HeaderNavigationMenu/hooks/useHeaderNavigationMenuClassName.ts
import { useMemo as useMemo69 } from "react";
import { appendClassName as appendClassName26, makeBEM as makeBEM43 } from "@deliveryhero/armor-system";
var getClassNameByComponent13 = function getClassNameByComponent13(_ref114) {
  var component = _ref114.component,
    classPrefix = _ref114.classPrefix;
  var baseClassNames = makeBEM43(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useHeaderNavigationMenuClassName = function useHeaderNavigationMenuClassName(classPrefix, className) {
  return useMemo69(function () {
    return {
      NavigationMenuItem: appendClassName26(getClassNameByComponent13({
        component: "NavigationMenuItem",
        classPrefix: classPrefix
      }), className),
      NavigationMenu: getClassNameByComponent13({
        component: "NavigationMenu",
        classPrefix: classPrefix
      }),
      NavigationMenuContentContainer: getClassNameByComponent13({
        component: "NavigationMenuContentContainer",
        classPrefix: classPrefix
      }),
      MenuExpansionIndicator: getClassNameByComponent13({
        component: "MenuExpansionIndicator",
        classPrefix: classPrefix
      }),
      TitleContainer: getClassNameByComponent13({
        component: "TitleContainer",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};
var useHeaderNavigationMenuClassName_default = useHeaderNavigationMenuClassName;

// src/components/HeaderNavigation/HeaderNavigationMenu/style.ts
import styled51, { css as css44 } from "styled-components";
import { color as color23, getComponentOverride as getComponentOverride34, propsBlocker as propsBlocker50, spacing as spacing40, token as token36, transition as transition18 } from "@deliveryhero/armor-system";
var HeaderNavigationMenuRoot = styled51.div(_templateObject351 || (_templateObject351 = _taggedTemplateLiteral(["\n    cursor: pointer;\n"])));
var getContentContainerStyle = function getContentContainerStyle(_ref115) {
  var isExpanded = _ref115.isExpanded;
  if (isExpanded) {
    return css44(_templateObject352 || (_templateObject352 = _taggedTemplateLiteral(["\n            ", ";\n            opacity: 1;\n        "])), transition18({
      all: true
    }));
  }
  return "";
};
var HeaderNavigationMenuContentContainer = styled51.div.withConfig(propsBlocker50)(_templateObject353 || (_templateObject353 = _taggedTemplateLiteral(["\n    position: absolute;\n    opacity: 0;\n    z-index: 2048;\n    background-color: ", ";\n    box-shadow: ", ";\n    margin-top: ", ";\n    ", ";\n"])), color23("neutral.00"), token36("elevation.large"), spacing40(5), getContentContainerStyle);
var MenuExpansionIndicatorItem = styled51.div.withConfig(propsBlocker50)(_templateObject354 || (_templateObject354 = _taggedTemplateLiteral(["\n    outline: none;\n    height: ", ";\n"])), spacing40(5));
var HeaderNavigationMenuTitleContainer = styled51.div.withConfig(propsBlocker50)(_templateObject355 || (_templateObject355 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));
var HeaderNavigationMenuTitle = styled51.div.withConfig(propsBlocker50)(_templateObject356 || (_templateObject356 = _taggedTemplateLiteral([""])));
var MenuExpansionIndicator = styled51(ExpansionIndicator)(_templateObject357 || (_templateObject357 = _taggedTemplateLiteral(["\n    .ExpansionIndicator-Content {\n        background-color: ", ";\n        width: 40px;\n    }\n    ", ";\n"])), color23("neutral.02"), getComponentOverride34("HeaderNavigationMenu"));

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentContext.ts
import * as React66 from "react";
var HeaderNavigationMenuContentContext = React66.createContext({
  isExpanded: void 0,
  setIsExpanded: void 0
});
var HeaderNavigationMenuContentContext_default = HeaderNavigationMenuContentContext;

// src/components/HeaderNavigation/HeaderNavigationMenu/DHLogoImage.tsx
import React67 from "react";
import { colorGrey90 as colorGrey902 } from "@deliveryhero/armor-system";
var DHLogoImage = function DHLogoImage(_ref116) {
  var _ref116$color = _ref116.color,
    color52 = _ref116$color === void 0 ? colorGrey902 : _ref116$color;
  return /* @__PURE__ */React67.createElement("div", {
    style: {
      width: "24px",
      height: "24px"
    }
  }, /* @__PURE__ */React67.createElement("svg", {
    width: "30px",
    height: "30px",
    viewBox: "5 -8 20 38",
    version: "1.1"
  }, /* @__PURE__ */React67.createElement("title", null, "_100_login_logo_dh.svg"), /* @__PURE__ */React67.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */React67.createElement("g", {
    transform: "translate(-16.000000, -16.000000)",
    fill: color52
  }, /* @__PURE__ */React67.createElement("path", {
    d: "M34.4263064,16.4785913 C31.6316143,15.4277201 28.4639332,16.1418239 26.4225998,18.2829008 L18.7929369,26.0801752 C18.7459008,26.1152103 18.7253364,26.1746443 18.7409626,26.2303885 C18.7565888,26.2861327 18.8052764,26.3270245 18.8640156,26.3337385 L20.8948346,26.4532292 C20.9547119,26.4468493 21.0117624,26.4796791 21.0351016,26.5339461 C21.0584408,26.5882132 21.0425213,26.6510187 20.9959612,26.6883626 L16.0279146,31.8017544 C15.992846,31.8438521 15.9906014,31.9035758 16.0224155,31.9480744 C16.0542296,31.992573 16.1123842,32.011051 16.1648913,31.9933446 L23.2584593,29.8550687 C23.314772,29.8261163 23.3837397,29.835765 23.4294799,29.8789946 C23.4752201,29.9222241 23.4873974,29.9892667 23.4596762,30.0452411 L22.5114081,31.6452014 C22.4927168,31.6948589 22.5012844,31.7504079 22.5341228,31.7924742 C22.5669611,31.8345405 22.6195164,31.8572911 22.6734592,31.8527911 L32.9007054,29.6782629 C35.408551,29.3178419 37.5358271,27.6911698 38.4970625,25.3988757 C39.9565583,21.8637738 38.1308934,17.869544 34.4263064,16.4785913 Z M35.5612856,23.5192263 C35.5554833,23.5212515 35.5521676,23.524897 35.5474014,23.5267197 L33.2635589,24.4164191 L33.1933091,24.445988 L32.6366989,26.8732694 C32.6171671,26.9131294 32.5787383,26.9409773 32.5340383,26.947664 C32.4893382,26.9543507 32.4441458,26.9390116 32.4133088,26.9066863 L30.7484516,25.028252 L30.7395409,25.0231889 L21.3540484,28.8669413 C21.3458111,28.8705181 21.3369464,28.8725121 21.3279379,28.8728312 C21.3112001,28.8731964 21.2950122,28.8669641 21.2830378,28.8555281 C21.2710634,28.8440921 21.2643194,28.8284193 21.2643194,28.8120566 C21.2648857,28.7931119 21.2744654,28.7755106 21.2902227,28.7644629 L29.4054171,22.9693665 L28.3784029,20.7326627 C28.3553736,20.68412 28.3643873,20.6268129 28.4012712,20.5872713 C28.4381552,20.5477297 28.4957105,20.5336711 28.5472924,20.5516039 L31.0340097,21.1362982 L32.9647384,19.4958327 C33.0022241,19.4667931 33.0525827,19.4591809 33.0972936,19.4757957 C33.1420045,19.4924104 33.1744663,19.530799 33.1827406,19.5768433 L33.3715238,22.0401745 L35.5975502,23.2828777 C35.6435394,23.3097665 35.668371,23.3611278 35.6604236,23.4129239 C35.6524762,23.4647199 35.6133219,23.5067037 35.5612856,23.5192263 Z",
    id: "_100_login_logo_dh.svg"
  })))));
};

// src/components/HeaderNavigation/HeaderNavigationMenu/hooks/useHeaderNavigationMenu.ts
import { useCallback as useCallback22, useEffect as useEffect15, useState as useState11, useRef as useRef9 } from "react";
import { useRootRef as useRootRef18, useDetectEscapeKeyPressed as useDetectEscapeKeyPressed2, useDetectClickOutsideComponent as useDetectClickOutsideComponent2 } from "@deliveryhero/armor-system";
var useHeaderNavigationMenu = function useHeaderNavigationMenu(_ref117, ref) {
  var isMenuExpanded = _ref117.isMenuExpanded,
    defaultExpanded = _ref117.defaultExpanded;
  var _useState43 = useState11(defaultExpanded || isMenuExpanded),
    _useState44 = _slicedToArray(_useState43, 2),
    isExpanded = _useState44[0],
    setIsExpanded = _useState44[1];
  var menuRootRef = useRootRef18(ref);
  var menuTitleRef = useRef9(null);
  var handleMenuClick = useCallback22(function (event) {
    event.preventDefault();
    event.stopPropagation();
    setIsExpanded(function (expanded) {
      return !expanded;
    });
  }, []);
  var handleMenuKeyPress = useCallback22(function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      setIsExpanded(function (expanded) {
        return !expanded;
      });
    }
  }, []);
  useEffect15(function () {
    var internalRefCurrent = menuTitleRef == null ? void 0 : menuTitleRef.current;
    internalRefCurrent == null ? void 0 : internalRefCurrent.addEventListener("click", handleMenuClick);
    return function () {
      internalRefCurrent == null ? void 0 : internalRefCurrent.removeEventListener("click", handleMenuClick);
    };
  }, [menuTitleRef, isExpanded, handleMenuClick]);
  useDetectEscapeKeyPressed2(menuTitleRef, setIsExpanded, isExpanded);
  useDetectClickOutsideComponent2(menuRootRef, setIsExpanded, isExpanded);
  return {
    menuTitleRef: menuTitleRef,
    menuRootRef: menuRootRef,
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded,
    handleMenuKeyPress: handleMenuKeyPress
  };
};

// src/components/HeaderNavigation/HeaderNavigationItem/HeaderNavigationItem.tsx
import React69, { memo as memo49 } from "react";

// src/components/HeaderNavigation/HeaderNavigationItem/style.ts
import styled52 from "styled-components";
import { propsBlocker as propsBlocker51, getComponentOverride as getComponentOverride35, spacing as spacing41 } from "@deliveryhero/armor-system";
var HeaderNavigationItemRoot = styled52.div.withConfig(propsBlocker51)(_templateObject358 || (_templateObject358 = _taggedTemplateLiteral(["\n    white-space: nowrap;\n    padding: ", ";\n    ", ";\n"])), spacing41(3, 2), getComponentOverride35("HeaderNavigationItem"));

// src/components/HeaderNavigation/HeaderNavigationItem/constants.ts
var HEADER_NAVIGATION_ITEM_CLASS_PREFIX = "HeaderNavigationItem";
var headerNavigationItemRoot = "HeaderNavigationItemRoot";

// src/components/HeaderNavigation/HeaderNavigationItem/hooks/useHeaderNavigationItemClassName.ts
import { useMemo as useMemo70 } from "react";
import { makeRootClassName as makeRootClassName30 } from "@deliveryhero/armor-system";
var useHeaderNavigationItemClassName = function useHeaderNavigationItemClassName(classPrefix, className) {
  return useMemo70(function () {
    return {
      Root: makeRootClassName30(classPrefix, className)
    };
  }, [classPrefix, className]);
};
var useHeaderNavigationItemClassName_default = useHeaderNavigationItemClassName;

// src/components/HeaderNavigation/HeaderNavigationItem/HeaderNavigationItem.tsx
var HeaderNavigationItem = function HeaderNavigationItem(_a) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classOverride = useHeaderNavigationItemClassName_default(HEADER_NAVIGATION_ITEM_CLASS_PREFIX, className);
  return /* @__PURE__ */React69.createElement(HeaderNavigationItemRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationItemRoot
  }, restProps), {
    className: classOverride.Root
  }));
};
var MemoizedHeaderNavigationItem = memo49(HeaderNavigationItem);

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenu.tsx
var HeaderNavigationMenu = forwardRef39(function HeaderNavigationMenu2(_a, ref) {
  var _b = _a,
    className = _b.className,
    _b$headerTitle = _b.headerTitle,
    headerTitle = _b$headerTitle === void 0 ? /* @__PURE__ */React70.createElement(DHLogoImage, {
      color: "currentColor"
    }) : _b$headerTitle,
    headerContent = _b.headerContent,
    _b$tabIndex = _b.tabIndex,
    tabIndex = _b$tabIndex === void 0 ? 0 : _b$tabIndex,
    restProps = __objRest(_b, ["className", "headerTitle", "headerContent", "tabIndex"]);
  var classOverride = useHeaderNavigationMenuClassName_default(HEADER_NAVIGATION_MENU_CLASS_PREFIX, className);
  var _useHeaderNavigationM = useHeaderNavigationMenu(restProps, ref),
    menuTitleRef = _useHeaderNavigationM.menuTitleRef,
    menuRootRef = _useHeaderNavigationM.menuRootRef,
    isExpanded = _useHeaderNavigationM.isExpanded,
    setIsExpanded = _useHeaderNavigationM.setIsExpanded,
    handleMenuKeyPress = _useHeaderNavigationM.handleMenuKeyPress;
  var contextValue = {
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded
  };
  return /* @__PURE__ */React70.createElement(HeaderNavigationMenuContentContext_default.Provider, {
    value: contextValue
  }, /* @__PURE__ */React70.createElement(HeaderNavigationItem, {
    className: classOverride.NavigationMenuItem
  }, /* @__PURE__ */React70.createElement(HeaderNavigationMenuRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationMenuRoot
  }, restProps), {
    className: classOverride.NavigationMenu,
    ref: menuRootRef
  }), /* @__PURE__ */React70.createElement(HeaderNavigationMenuTitleContainer, {
    ref: menuTitleRef,
    className: classOverride.TitleContainer
  }, /* @__PURE__ */React70.createElement(HeaderNavigationMenuTitle, {
    className: classOverride.NavigationMenuItem
  }, headerTitle), headerContent && /* @__PURE__ */React70.createElement(MenuExpansionIndicatorItem, {
    className: classOverride.NavigationMenuItem,
    tabIndex: tabIndex,
    onKeyPress: handleMenuKeyPress
  }, /* @__PURE__ */React70.createElement(MenuExpansionIndicator, {
    displaySeparator: false,
    isExpanded: isExpanded,
    className: classOverride.MenuExpansionIndicator
  }))), /* @__PURE__ */React70.createElement(HeaderNavigationMenuContentContainer, {
    isExpanded: isExpanded,
    className: classOverride.NavigationMenuContentContainer
  }, isExpanded && headerContent))));
});
HeaderNavigationMenu.defaultProps = {
  tabIndex: 0,
  defaultExpanded: false
};
HeaderNavigationMenu.propTypes = {
  headerTitle: PropTypes35.node,
  headerContent: PropTypes35.node,
  /**
   * @deprecated
   * Use defaultExpanded instead
   */
  isMenuExpanded: PropTypes35.bool,
  defaultExpanded: PropTypes35.bool,
  tabIndex: PropTypes35.number
};
var MemoizedHeaderNavigationMenu = memo50(HeaderNavigationMenu);

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContent.tsx
import React71, { forwardRef as forwardRef40, memo as memo51 } from "react";
import { useRootRef as useRootRef19 } from "@deliveryhero/armor-system";

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/constants.ts
var HEADER_NAVIGATION_MENU_CONTENT_CLASS_PREFIX = "HeaderNavigationMenuContent";
var headerNavigationMenuContentRoot = "HeaderNavigationMenuContentRoot";

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/style.ts
import styled53 from "styled-components";
import { propsBlocker as propsBlocker52 } from "@deliveryhero/armor-system";
var HeaderNavigationMenuContentRoot = styled53.div.withConfig(propsBlocker52)(_templateObject359 || (_templateObject359 = _taggedTemplateLiteral(["\n    min-width: 280px;\n    max-width: 360px;\n    cursor: default;\n    outline: none;\n    user-select: none;\n"])));

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/hooks/useHeaderNavigationMenuContentClassName.ts
import { useMemo as useMemo71 } from "react";
import { makeRootClassName as makeRootClassName31 } from "@deliveryhero/armor-system";
var useHeaderNavigationMenuContentClassName = function useHeaderNavigationMenuContentClassName(classPrefix, className) {
  return useMemo71(function () {
    return {
      Root: makeRootClassName31(classPrefix, className)
    };
  }, [classPrefix, className]);
};
var useHeaderNavigationMenuContentClassName_default = useHeaderNavigationMenuContentClassName;

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContent.tsx
var HeaderNavigationMenuContent = forwardRef40(function HeaderNavigationMenuContent2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var menuContentRef = useRootRef19(ref);
  var classOverride = useHeaderNavigationMenuContentClassName_default(HEADER_NAVIGATION_MENU_CONTENT_CLASS_PREFIX, className);
  return /* @__PURE__ */React71.createElement(HeaderNavigationMenuContentRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationMenuContentRoot
  }, restProps), {
    className: classOverride.Root,
    ref: menuContentRef
  }), children);
});
HeaderNavigationMenuContent.defaultProps = {};
HeaderNavigationMenuContent.propTypes = {};
var MemoizedHeaderNavigationMenuContent = memo51(HeaderNavigationMenuContent);

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentLogistics.tsx
import React72 from "react";
import styled54 from "styled-components";
var menuContentBodyOptions = [{
  value: "value_0",
  label: "Arara"
}, {
  value: "value_1",
  label: "Rooster"
}, {
  value: "value_2",
  label: "DPS"
}, {
  value: "value_3",
  label: "Delivery Area Service"
}, {
  value: "value_4",
  label: "Tweety"
}, {
  value: "value_5",
  label: "TES"
}, {
  value: "value_6",
  label: "Hurrier"
}];
var Drawing = styled54.div(_templateObject360 || (_templateObject360 = _taggedTemplateLiteral(["\n    background-image: url(data:image/png;base64,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);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-attachment: scroll;\n    height: 42px;\n    width: 42px;\n"])));
var HeaderNavigationMenuContentLogistics = function HeaderNavigationMenuContentLogistics(_a) {
  var restProps = __objRest(_a, []);
  return /* @__PURE__ */React72.createElement(HeaderNavigationMenuContent, __spreadValues({}, restProps), /* @__PURE__ */React72.createElement(HeaderNavigationMenuContentHeader, {
    title: "Logistics",
    image: /* @__PURE__ */React72.createElement(Drawing, null)
  }), /* @__PURE__ */React72.createElement(HeaderNavigationMenuContentBody, {
    options: menuContentBodyOptions
  }));
};
HeaderNavigationMenuContentLogistics.propTypes = {};

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentHeader/HeaderNavigationMenuContentHeader.tsx
import React73, { memo as memo52 } from "react";
import PropTypes36 from "prop-types";

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentHeader/constants.ts
var HEADER_NAVIGATION_MENU_CONTENT_HEADER_CLASS_PREFIX = "HeaderNavigationMenuContentHeader";
var headerNavigationMenuContentHeaderRoot = "HeaderNavigationMenuContentHeaderRoot";

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentHeader/style.ts
import styled55 from "styled-components";
import { color as color24, spacing as spacing42, propsBlocker as propsBlocker53, getComponentOverride as getComponentOverride36 } from "@deliveryhero/armor-system";
var HeaderNavigationMenuContentHeaderRoot = styled55.div.withConfig(propsBlocker53)(_templateObject361 || (_templateObject361 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    height: 64px;\n    background-color: ", ";\n    padding: ", ";\n    ", ";\n"])), color24("neutral.02"), spacing42(2, 4), getComponentOverride36("HeaderNavigationMenuContentHeader"));
var MenuContentHeader = styled55.div.withConfig(propsBlocker53)(_templateObject362 || (_templateObject362 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    height: 100%;\n"])));
var MenuContentHeaderItem = styled55.div.withConfig(propsBlocker53)(_templateObject363 || (_templateObject363 = _taggedTemplateLiteral(["\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var MenuContentHeaderTitle = styled55(Typography)(_templateObject364 || (_templateObject364 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n    color: ", ";\n"])), spacing42(1), color24("neutral.07"));
var MenuContentHeaderLabel = styled55(Typography)(_templateObject365 || (_templateObject365 = _taggedTemplateLiteral(["\n    margin: 0;\n"])));

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentHeader/hooks/useHeaderNavigationMenuContentHeaderClassName.ts
import { useMemo as useMemo72 } from "react";
import { appendClassName as appendClassName27, makeBEM as makeBEM44 } from "@deliveryhero/armor-system";
var getClassNameByComponent14 = function getClassNameByComponent14(_ref118) {
  var component = _ref118.component,
    classPrefix = _ref118.classPrefix;
  var baseClassNames = makeBEM44(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useHeaderNavigationMenuContentHeaderClassName = function useHeaderNavigationMenuContentHeaderClassName(classPrefix, className) {
  return useMemo72(function () {
    return {
      Root: appendClassName27(getClassNameByComponent14({
        component: "Root",
        classPrefix: classPrefix
      }), className),
      Title: getClassNameByComponent14({
        component: "Title",
        classPrefix: classPrefix
      }),
      Label: getClassNameByComponent14({
        component: "Label",
        classPrefix: classPrefix
      }),
      HeaderNavigationMenuContentHeader: getClassNameByComponent14({
        component: "HeaderNavigationMenuContentHeader",
        classPrefix: classPrefix
      }),
      HeaderNavigationMenuContentHeaderItem: getClassNameByComponent14({
        component: "HeaderNavigationMenuContentHeaderItem",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};
var useHeaderNavigationMenuContentHeaderClassName_default = useHeaderNavigationMenuContentHeaderClassName;

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentHeader/HeaderNavigationMenuContentHeader.tsx
var HeaderNavigationMenuContentHeader = function HeaderNavigationMenuContentHeader(_a) {
  var _b = _a,
    className = _b.className,
    title = _b.title,
    label = _b.label,
    image = _b.image,
    restProps = __objRest(_b, ["className", "title", "label", "image"]);
  var classOverride = useHeaderNavigationMenuContentHeaderClassName_default(HEADER_NAVIGATION_MENU_CONTENT_HEADER_CLASS_PREFIX, className);
  return /* @__PURE__ */React73.createElement(HeaderNavigationMenuContentHeaderRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationMenuContentHeaderRoot
  }, restProps), {
    className: classOverride.Root
  }), /* @__PURE__ */React73.createElement(MenuContentHeader, {
    className: classOverride.HeaderNavigationMenuContentHeader
  }, /* @__PURE__ */React73.createElement(MenuContentHeaderItem, {
    className: classOverride.HeaderNavigationMenuContentHeaderItem
  }, title ? /* @__PURE__ */React73.createElement(MenuContentHeaderTitle, {
    label: true,
    small: true,
    className: classOverride.Title
  }, title) : null, label ? /* @__PURE__ */React73.createElement(MenuContentHeaderLabel, {
    paragraph: true,
    medium: true,
    className: classOverride.Label
  }, label) : null), /* @__PURE__ */React73.createElement(MenuContentHeaderItem, {
    className: classOverride.HeaderNavigationMenuContentHeaderItem
  }, image || null)));
};
HeaderNavigationMenuContentHeader.defaultProps = {};
HeaderNavigationMenuContentHeader.propTypes = {
  title: PropTypes36.string,
  label: PropTypes36.string,
  image: PropTypes36.node
};
var MemoizedHeaderNavigationMenuContentHeader = memo52(HeaderNavigationMenuContentHeader);

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBody/HeaderNavigationMenuContentBody.tsx
import React77, { memo as memo56 } from "react";
import PropTypes40 from "prop-types";

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBody/style.ts
import styled56 from "styled-components";

// src/components/Stack/Stack.tsx
import React74, { forwardRef as forwardRef41, memo as memo53 } from "react";
import PropTypes37 from "prop-types";

// src/components/Stack/hooks/useStackClassName.ts
import { useMemo as useMemo73 } from "react";
import { appendClassName as appendClassName28, makeBEM as makeBEM45 } from "@deliveryhero/armor-system";
var getClassNameByComponent15 = function getClassNameByComponent15(_ref119) {
  var component = _ref119.component,
    classPrefix = _ref119.classPrefix;
  var baseClassNames = makeBEM45(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useStackClassName = function useStackClassName(classPrefix, className) {
  return useMemo73(function () {
    return {
      Root: appendClassName28(getClassNameByComponent15({
        component: "Root",
        classPrefix: classPrefix
      }), className)
    };
  }, [classPrefix, className]);
};
var useStackClassName_default = useStackClassName;

// src/components/Stack/hooks/useStackItemClassName.ts
import { useMemo as useMemo74 } from "react";
import { appendClassName as appendClassName29, makeBEM as makeBEM46 } from "@deliveryhero/armor-system";
var getClassNameByComponent16 = function getClassNameByComponent16(_ref120) {
  var component = _ref120.component,
    classPrefix = _ref120.classPrefix;
  var baseClassNames = makeBEM46(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useStackItemClassName = function useStackItemClassName(classPrefix, className) {
  return useMemo74(function () {
    return {
      Root: appendClassName29(getClassNameByComponent16({
        component: "Root",
        classPrefix: classPrefix
      }), className)
    };
  }, [classPrefix, className]);
};
var useStackItemClassName_default = useStackItemClassName;

// src/components/Stack/constants.ts
var STACK_CLASS_PREFIX = "Stack";
var STACK_ITEM_CLASS_PREFIX = "StackItem";
var stackRoot = "StackRoot";
var stackItemRoot = "StackItemRoot";

// src/components/Stack/Stack.tsx
var Stack = forwardRef41(function Stack2(_a, ref) {
  var _b = _a,
    className = _b.className,
    reverse = _b.reverse,
    justifyContent = _b.justifyContent,
    alignItems = _b.alignItems,
    flexWrap = _b.flexWrap,
    restProps = __objRest(_b, ["className", "reverse", "justifyContent", "alignItems", "flexWrap"]);
  var classOverride = useStackClassName_default(STACK_CLASS_PREFIX, className);
  return /* @__PURE__ */React74.createElement(Flex, __spreadProps(__spreadValues({
    "data-testid": stackRoot
  }, restProps), {
    className: classOverride.Root,
    direction: reverse ? "column-reverse" : "column",
    flexWrap: flexWrap,
    justifyContent: justifyContent,
    ref: ref,
    alignItems: alignItems
  }));
});
Stack.defaultProps = {
  flexWrap: "nowrap"
};
Stack.propTypes = {
  reverse: PropTypes37.bool,
  justifyContent: PropTypes37.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly", "start", "end", "left", "right"]),
  alignItems: PropTypes37.oneOf(["stretch", "flex-start", "flex-end", "center", "baseline", "first baseline", "last baseline", "start", "end", "self-start", "self-end"]),
  flexWrap: PropTypes37.oneOf(["nowrap", "wrap", "wrap-reverse"])
};
var MemoizedStack = memo53(Stack);

// src/components/Stack/StackItem.tsx
import React75, { forwardRef as forwardRef42, memo as memo54 } from "react";
import PropTypes38 from "prop-types";
var StackItem = forwardRef42(function StackItem2(_a, ref) {
  var _b = _a,
    className = _b.className,
    flexGrow = _b.flexGrow,
    flexShrink = _b.flexShrink,
    flexBasis = _b.flexBasis,
    alignSelf = _b.alignSelf,
    order = _b.order,
    restProps = __objRest(_b, ["className", "flexGrow", "flexShrink", "flexBasis", "alignSelf", "order"]);
  var classOverride = useStackItemClassName_default(STACK_ITEM_CLASS_PREFIX, className);
  return /* @__PURE__ */React75.createElement(FlexItem, __spreadProps(__spreadValues({
    "data-testid": stackItemRoot
  }, restProps), {
    className: classOverride.Root,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    flexBasis: flexBasis,
    alignSelf: alignSelf,
    order: order,
    ref: ref
  }));
});
StackItem.defaultProps = {};
StackItem.propTypes = {
  flexGrow: PropTypes38.number,
  flexShrink: PropTypes38.number,
  flexBasis: PropTypes38.string,
  order: PropTypes38.number,
  alignSelf: PropTypes38.oneOf(["auto", "flex-start", "flex-end", "center", "baseline", "stretch"])
};
var MemoizedStackItem = memo54(StackItem);

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBody/style.ts
var HeaderNavigationMenuContentBodyRoot = styled56.div(_templateObject366 || (_templateObject366 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    max-height: 400px;\n    overflow-y: auto;\n"])));
var HeaderNavigationMenuContentBodyOptionsRoot = styled56(Stack)(_templateObject367 || (_templateObject367 = _taggedTemplateLiteral([""])));

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBodyOptions/HeaderNavigationMenuContentBodyOptions.tsx
import React76, { useContext as useContext4, memo as memo55 } from "react";
import PropTypes39 from "prop-types";

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBodyOptions/style.ts
import styled57, { css as css45 } from "styled-components";
import { color as color25, getComponentOverride as getComponentOverride37, spacing as spacing43, token as token37, typography as typography26 } from "@deliveryhero/armor-system";
var getContentBodyOptionsItemStyle = function getContentBodyOptionsItemStyle(_ref121) {
  var isActive = _ref121.isActive;
  if (isActive) {
    return css45(_templateObject368 || (_templateObject368 = _taggedTemplateLiteral(["\n            border-left-width: 2px;\n            border-left-style: solid;\n            padding-left: 14px;\n            border-left-color: ", ";\n            background-color: ", ";\n            color: ", ";\n        "])), color25("primary.main"), color25("primary.lightest"), color25("neutral.11"));
  }
  return "";
};
var HeaderNavigationMenuContentBodyOptionsItem = styled57(StackItem)(_templateObject369 || (_templateObject369 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    box-sizing: border-box;\n    ", ";\n    color: ", ";\n    padding: ", ";\n    &:hover {\n        border-left-color: ", ";\n        background-color: ", ";\n    }\n    ", ";\n"])), typography26("paragraphMedium"), color25("neutral.07"), spacing43(2, 4), color25("primary.main"), color25("primary.lightest"), getContentBodyOptionsItemStyle);
var HeaderNavigationMenuContentBodyOptionsRoot2 = styled57(Stack)(_templateObject370 || (_templateObject370 = _taggedTemplateLiteral(["\n    padding-top: ", ";\n    padding-bottom: ", ";\n    ", ";\n"])), spacing43(6), spacing43(6), getComponentOverride37("HeaderNavigationMenuContentBodyOptions"));
var HeaderNavigationMenuContentBodyOptionsCategory = styled57(StackItem)(_templateObject371 || (_templateObject371 = _taggedTemplateLiteral(["\n    cursor: default;\n    text-transform: uppercase;\n    ", ";\n    color: ", ";\n    padding: ", ";\n"])), typography26("labelSmall"), token37("body.color"), spacing43(2, 4));

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBodyOptions/constants.ts
var HEADER_NAVIGATION_MENU_CONTENT_BODY_OPTIONS_CLASS_PREFIX = "HeaderNavigationMenuContentBodyOptions";
var headerNavigationMenuContentBodyOptionsRoot = "HeaderNavigationMenuContentBodyOptionsRoot";
var headerNavigationMenuContentBodyOptionsItem = "HeaderNavigationMenuContentBodyOptionsItem";
var headerNavigationMenuContentBodyOptionsCategory = "HeaderNavigationMenuContentBodyOptionsCategory";

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBodyOptions/hooks/useHeaderNavigationMenuContentBodyOptionsClassName.ts
import { useMemo as useMemo75 } from "react";
import { appendClassName as appendClassName30, makeBEM as makeBEM47 } from "@deliveryhero/armor-system";
var getClassNameByComponent17 = function getClassNameByComponent17(_ref122) {
  var component = _ref122.component,
    classPrefix = _ref122.classPrefix;
  var baseClassNames = makeBEM47(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useHeaderNavigationMenuContentBodyOptionsClassName = function useHeaderNavigationMenuContentBodyOptionsClassName(classPrefix, className) {
  return useMemo75(function () {
    return {
      Root: appendClassName30(getClassNameByComponent17({
        component: "Root",
        classPrefix: classPrefix
      }), className),
      Item: getClassNameByComponent17({
        component: "Item",
        classPrefix: classPrefix
      }),
      Category: getClassNameByComponent17({
        component: "Category",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBodyOptions/HeaderNavigationMenuContentBodyOptions.tsx
var setActiveClass = function setActiveClass(isActive) {
  return isActive ? "active" : "";
};
var HeaderNavigationMenuContentBodyOptions = function HeaderNavigationMenuContentBodyOptions(_a) {
  var _b = _a,
    className = _b.className,
    options = _b.options,
    selectedValue = _b.selectedValue,
    onOptionSelect = _b.onOptionSelect,
    restProps = __objRest(_b, ["className", "options", "selectedValue", "onOptionSelect"]);
  var _useContext4 = useContext4(HeaderNavigationMenuContentContext_default),
    isExpanded = _useContext4.isExpanded,
    setIsExpanded = _useContext4.setIsExpanded;
  var classOverride = useHeaderNavigationMenuContentBodyOptionsClassName(HEADER_NAVIGATION_MENU_CONTENT_BODY_OPTIONS_CLASS_PREFIX, className);
  var handleClick = function handleClick(_ref123) {
    var selectedOption = _ref123.selectedOption;
    onOptionSelect == null ? void 0 : onOptionSelect(selectedOption);
    if (isExpanded && setIsExpanded) {
      setTimeout(function () {
        return setIsExpanded(false);
      }, 0);
    }
  };
  var handleOnClick = function handleOnClick(selectedOption) {
    return function (event) {
      return handleClick({
        event: event,
        selectedOption: selectedOption
      });
    };
  };
  return /* @__PURE__ */React76.createElement(HeaderNavigationMenuContentBodyOptionsRoot2, __spreadProps(__spreadValues({
    "data-testid": headerNavigationMenuContentBodyOptionsRoot
  }, restProps), {
    className: classOverride.Root
  }),
  // @ts-ignore todo: fix this somehow
  options.map(function (option) {
    if (!option.category) {
      var value2 = option.value,
        label2 = option.label;
      return /* @__PURE__ */React76.createElement(HeaderNavigationMenuContentBodyOptionsItem, {
        className: "".concat(classOverride.Item, " ").concat(setActiveClass(selectedValue === value2)),
        key: value2,
        "data-testid": headerNavigationMenuContentBodyOptionsItem,
        onClick: handleOnClick(option),
        isActive: selectedValue === value2
      }, label2);
    }
    var value = option.value,
      label = option.label,
      items = option.options;
    var optionItems = [];
    var categoryItem = /* @__PURE__ */React76.createElement(HeaderNavigationMenuContentBodyOptionsCategory, {
      className: classOverride.Category,
      key: value,
      "data-testid": headerNavigationMenuContentBodyOptionsCategory
    }, label);
    if (items) {
      optionItems = items.map(function (item) {
        var optionValue = item.value,
          optionLabel = item.label;
        return /* @__PURE__ */React76.createElement(HeaderNavigationMenuContentBodyOptionsItem, {
          className: "".concat(classOverride.Item, " ").concat(setActiveClass(selectedValue === optionValue)),
          key: optionValue,
          "data-testid": headerNavigationMenuContentBodyOptionsItem,
          onClick: handleOnClick(item),
          isActive: selectedValue === optionValue
        }, optionLabel);
      });
    }
    return [categoryItem].concat(_toConsumableArray(optionItems));
  }));
};
HeaderNavigationMenuContentBodyOptions.defaultProps = {};
HeaderNavigationMenuContentBodyOptions.propTypes = {
  selectedValue: PropTypes39.oneOfType([PropTypes39.string, PropTypes39.number]),
  onOptionSelect: PropTypes39.func
  // options: PropTypes.oneOfType([
  //     PropTypes.arrayOf(
  //         PropTypes.shape({
  //             value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  //                 .isRequired,
  //             label: PropTypes.string.isRequired,
  //         }).isRequired,
  //     ),
  //     PropTypes.arrayOf(
  //         PropTypes.shape({
  //             category: PropTypes.string.isRequired,
  //             value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  //                 .isRequired,
  //             label: PropTypes.string.isRequired,
  //             options: PropTypes.arrayOf(
  //                 PropTypes.shape({
  //                     value: PropTypes.oneOfType([
  //                         PropTypes.number,
  //                         PropTypes.string,
  //                     ]).isRequired,
  //                     label: PropTypes.string.isRequired,
  //                 }).isRequired,
  //             ),
  //         }).isRequired,
  //     ),
  // ]),
};

var MemoizedHeaderNavigationMenuContentBodyOptions = memo55(HeaderNavigationMenuContentBodyOptions);

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBody/hooks/useHeaderNavigationMenuContentBodyClassName.ts
import { useMemo as useMemo76 } from "react";
import { makeRootClassName as makeRootClassName32 } from "@deliveryhero/armor-system";
var useHeaderNavigationMenuContentBodyClassName = function useHeaderNavigationMenuContentBodyClassName(classPrefix, className) {
  return useMemo76(function () {
    return {
      Root: makeRootClassName32(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBody/constants.ts
var HEADER_NAVIGATION_MENU_CONTENT_BODY_CLASS_PREFIX = "HeaderNavigationMenuContentBody";
var headerNavigationMenuContentBodyRoot = "HeaderNavigationMenuContentBodyRoot";

// src/components/HeaderNavigation/HeaderNavigationMenu/HeaderNavigationMenuContent/HeaderNavigationMenuContentBody/HeaderNavigationMenuContentBody.tsx
var HeaderNavigationMenuContentBody = function HeaderNavigationMenuContentBody(_a) {
  var _b = _a,
    className = _b.className,
    options = _b.options,
    selectedValue = _b.selectedValue,
    onOptionSelect = _b.onOptionSelect,
    restProps = __objRest(_b, ["className", "options", "selectedValue", "onOptionSelect"]);
  var classOverride = useHeaderNavigationMenuContentBodyClassName(HEADER_NAVIGATION_MENU_CONTENT_BODY_CLASS_PREFIX, className);
  return /* @__PURE__ */React77.createElement(HeaderNavigationMenuContentBodyRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationMenuContentBodyRoot
  }, restProps), {
    className: classOverride.Root
  }), options ? /* @__PURE__ */React77.createElement(HeaderNavigationMenuContentBodyOptions, {
    options: options,
    selectedValue: selectedValue,
    onOptionSelect: onOptionSelect
  }) : null);
};
HeaderNavigationMenuContentBody.defaultProps = {};
HeaderNavigationMenuContentBody.propTypes = {
  selectedValue: PropTypes40.oneOfType([PropTypes40.string, PropTypes40.number]),
  onOptionSelect: PropTypes40.func,
  options: PropTypes40.oneOfType([PropTypes40.arrayOf(PropTypes40.shape({
    value: PropTypes40.oneOfType([PropTypes40.number, PropTypes40.string]).isRequired,
    label: PropTypes40.string.isRequired
  }).isRequired), PropTypes40.arrayOf(PropTypes40.shape({
    category: PropTypes40.string.isRequired,
    value: PropTypes40.oneOfType([PropTypes40.number, PropTypes40.string]).isRequired,
    label: PropTypes40.string.isRequired,
    options: PropTypes40.arrayOf(PropTypes40.shape({
      value: PropTypes40.oneOfType([PropTypes40.number, PropTypes40.string]).isRequired,
      label: PropTypes40.string.isRequired
    }).isRequired)
  }).isRequired)])
};
var MemoizedHeaderNavigationMenuContentBody = memo56(HeaderNavigationMenuContentBody);

// src/components/HeaderNavigation/HeaderNavigation.tsx
var HeaderNavigation = forwardRef43(function HeaderNavigation2(_a, ref) {
  var _b = _a,
    className = _b.className,
    isMenuExpanded = _b.isMenuExpanded,
    defaultExpanded = _b.defaultExpanded,
    navigationMenuTitle = _b.navigationMenuTitle,
    navigationMenuContent = _b.navigationMenuContent,
    navigationAction = _b.navigationAction,
    links = _b.links,
    selector = _b.selector,
    title = _b.title,
    search = _b.search,
    restProps = __objRest(_b, ["className",
    /**
     * @deprecated
     * Use defaultExpanded instead
     */
    "isMenuExpanded", "defaultExpanded", "navigationMenuTitle", "navigationMenuContent", "navigationAction", "links", "selector", "title", "search"]);
  var classOverride = useHeaderNavigationClassName_default(HEADER_NAVIGATION_CLASS_PREFIX, className);
  return /* @__PURE__ */React78.createElement(HeaderNavigationRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationRoot
  }, restProps), {
    className: classOverride.Root,
    ref: ref
  }), /* @__PURE__ */React78.createElement(HeaderNavigationContent, {
    className: classOverride.HeaderNavigationContent
  }, /* @__PURE__ */React78.createElement(HeaderNavigationContentItem, {
    className: classOverride.HeaderNavigationContentItem
  }, /* @__PURE__ */React78.createElement(HeaderNavigationContentLeft, {
    className: classOverride.HeaderNavigationContentLeft
  }, (navigationMenuTitle || navigationMenuContent) && /* @__PURE__ */React78.createElement(MemoizedHeaderNavigationMenu, {
    headerTitle: navigationMenuTitle,
    headerContent: navigationMenuContent,
    isMenuExpanded: isMenuExpanded,
    defaultExpanded: defaultExpanded
  }), title && /* @__PURE__ */React78.createElement(MemoizedHeaderNavigationItem, {
    className: classOverride.HeaderNavigationItem
  }, /* @__PURE__ */React78.createElement(HeaderNavigationTitleRoot, {
    className: classOverride.NavigationTitle
  }, title)), links)), /* @__PURE__ */React78.createElement(HeaderNavigationContentItem, {
    className: classOverride.HeaderNavigationContentItem
  }, /* @__PURE__ */React78.createElement(HeaderNavigationContentRight, {
    className: classOverride.HeaderNavigationContentRight
  }, search, selector, navigationAction))));
});
HeaderNavigation.defaultProps = {
  justifyContent: "space-between"
};
HeaderNavigation.propTypes = {
  title: PropTypes41.node,
  search: PropTypes41.node,
  /**
   * @deprecated
   * Use defaultExpanded instead
   */
  isMenuExpanded: PropTypes41.bool,
  defaultExpanded: PropTypes41.bool,
  justifyContent: PropTypes41.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly", "start", "end", "left", "right"]),
  navigationMenuTitle: PropTypes41.node,
  navigationMenuContent: PropTypes41.node,
  navigationAction: PropTypes41.node,
  links: PropTypes41.node,
  selector: PropTypes41.node
};
var MemoizedHeaderNavigation = memo57(HeaderNavigation);

// src/components/HeaderNavigation/HeaderNavigationAction/HeaderNavigationAction.tsx
import React79, { forwardRef as forwardRef44, memo as memo58 } from "react";
import PropTypes42 from "prop-types";

// src/components/HeaderNavigation/HeaderNavigationAction/hooks/useHeaderNavigationActionClassName.ts
import { useMemo as useMemo77 } from "react";
import { appendClassName as appendClassName31, makeBEM as makeBEM48 } from "@deliveryhero/armor-system";
var getClassNameByComponent18 = function getClassNameByComponent18(_ref124) {
  var component = _ref124.component,
    classPrefix = _ref124.classPrefix;
  var baseClassNames = makeBEM48(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useHeaderNavigationActionClassName = function useHeaderNavigationActionClassName(classPrefix, className) {
  return useMemo77(function () {
    return {
      Action: appendClassName31(getClassNameByComponent18({
        component: "NavigationAction",
        classPrefix: classPrefix
      }), className),
      NavigationActionItem: getClassNameByComponent18({
        component: "NavigationActionItem",
        classPrefix: classPrefix
      }),
      ActionContainer: getClassNameByComponent18({
        component: "NavigationActionContainer",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};
var useHeaderNavigationActionClassName_default = useHeaderNavigationActionClassName;

// src/components/HeaderNavigation/HeaderNavigationAction/style.ts
import styled58 from "styled-components";
import { color as color26, getComponentOverride as getComponentOverride38, propsBlocker as propsBlocker54, spacing as spacing44, token as token38 } from "@deliveryhero/armor-system";
var HeaderNavigationActionRoot = styled58(HeaderNavigationItem)(_templateObject372 || (_templateObject372 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    height: 48px;\n    padding: 0 ", ";\n"])), spacing44(2));
var HeaderNavigationActionContainer = styled58.div.withConfig(propsBlocker54)(_templateObject373 || (_templateObject373 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n"])));
var HeaderNavigationActionItemRoot = styled58.div.withConfig(propsBlocker54)(_templateObject374 || (_templateObject374 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    padding: ", ";\n    margin: 0 ", ";\n\n    &:hover {\n        background: ", ";\n        border-radius: ", ";\n    }\n\n    /*\n    *\n    * @note this is a hack after fixing the icon size\n    * @see https://jira.deliveryhero.com/browse/LD-81\n    *\n    */\n    & > svg[class*='Icon'] {\n        margin-top: -8px;\n    }\n\n    ", ";\n"])), spacing44(2, 2, 0, 2), spacing44(2), color26("primary.lightest"), token38("shape.borderRadius.soft"), getComponentOverride38("HeaderNavigationActionItem"));

// src/components/HeaderNavigation/HeaderNavigationAction/constants.ts
var HEADER_NAVIGATION_ACTION_CLASS_PREFIX = "HeaderNavigationAction";
var headerNavigationActionRoot = "HeaderNavigationActionRoot";
var headerNavigationActionItemRoot = "HeaderNavigationActionItemRoot";

// src/components/HeaderNavigation/HeaderNavigationAction/HeaderNavigationAction.tsx
var HeaderNavigationAction = forwardRef44(function HeaderNavigationAction2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var classOverride = useHeaderNavigationActionClassName_default(HEADER_NAVIGATION_ACTION_CLASS_PREFIX, className);
  return /* @__PURE__ */React79.createElement(HeaderNavigationActionRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationActionRoot
  }, restProps), {
    className: classOverride.Action
  }), /* @__PURE__ */React79.createElement(HeaderNavigationActionContainer, {
    className: classOverride.ActionContainer
  }, children));
});
HeaderNavigationAction.defaultProps = {};
HeaderNavigationAction.propTypes = {
  children: PropTypes42.oneOfType([PropTypes42.arrayOf(PropTypes42.element), PropTypes42.element])
};
var MemoizedHeaderNavigationAction = memo58(HeaderNavigationAction);

// src/components/HeaderNavigation/HeaderNavigationAction/HeaderNavigationActionItem.tsx
import React80, { forwardRef as forwardRef45, memo as memo59 } from "react";
import PropTypes43 from "prop-types";
var HeaderNavigationActionItem = forwardRef45(function HeaderNavigationActionItem2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    _b$tabIndex2 = _b.tabIndex,
    tabIndex = _b$tabIndex2 === void 0 ? 0 : _b$tabIndex2,
    restProps = __objRest(_b, ["className", "children", "tabIndex"]);
  var classOverride = useHeaderNavigationActionClassName_default(HEADER_NAVIGATION_ACTION_CLASS_PREFIX, className);
  return /* @__PURE__ */React80.createElement(HeaderNavigationActionItemRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationActionItemRoot
  }, restProps), {
    className: classOverride.NavigationActionItem,
    ref: ref,
    tabIndex: tabIndex
  }), children);
});
HeaderNavigationActionItem.defaultProps = {};
HeaderNavigationActionItem.propTypes = {
  children: PropTypes43.element
};
var MemoizedHeaderNavigationActionItem = memo59(HeaderNavigationActionItem);

// src/components/HeaderNavigation/HeaderNavigationAction/HeaderNavigationActionLogisticsSignOutButton.tsx
import React81 from "react";
import { LogoutIcon } from "@deliveryhero/armor-icons";
import { getWindow as getWindow3 } from "@deliveryhero/armor-system";
var setURL = function setURL() {
  var win2 = getWindow3();
  if (win2) {
    win2.location.assign("/users/sign_out");
  }
};
var HeaderNavigationActionLogisticsSignOutButton = function HeaderNavigationActionLogisticsSignOutButton(_a) {
  var restProps = __objRest(_a, []);
  return /* @__PURE__ */React81.createElement(HeaderNavigationActionItem, __spreadProps(__spreadValues({}, restProps), {
    onClick: setURL
  }), /* @__PURE__ */React81.createElement(LogoutIcon, null));
};
HeaderNavigationActionLogisticsSignOutButton.propTypes = {};

// src/components/HeaderNavigation/HeaderNavigationLinks/HeaderNavigationLink/HeaderNavigationLink.tsx
import React83, { forwardRef as forwardRef46, useContext as useContext5, memo as memo60 } from "react";
import PropTypes44 from "prop-types";

// src/components/HeaderNavigation/HeaderNavigationLinks/HeaderNavigationLink/style.ts
import styled59, { css as css46 } from "styled-components";
import { color as color27, getComponentOverride as getComponentOverride39, propsBlocker as propsBlocker55, spacing as spacing45, typography as typography27 } from "@deliveryhero/armor-system";
var HeaderNavigationLinkRootWrapper = function HeaderNavigationLinkRootWrapper(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var getRootStyle14 = function getRootStyle14(_ref125) {
  var isActive = _ref125.isActive;
  if (isActive) {
    return css46(_templateObject375 || (_templateObject375 = _taggedTemplateLiteral(["\n            position: relative;\n            &:before {\n                content: '';\n                position: absolute;\n                bottom: 0;\n                left: 0;\n                right: 0;\n                height: 2px;\n                background-color: ", ";\n            }\n        "])), color27("primary.main"));
  }
  return "";
};
var HeaderNavigationLinkRoot = styled59(HeaderNavigationLinkRootWrapper).withConfig(propsBlocker55)(_templateObject376 || (_templateObject376 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    border: none;\n    box-sizing: border-box;\n    display: inline-flex;\n    padding: ", ";\n    text-decoration: none;\n    color: ", ";\n    background-color: transparent;\n    ", ";\n\n    &:visited,\n    &:active,\n    &:focus,\n    &:hover {\n        text-decoration: none;\n        color: ", ";\n    }\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    ", ";\n    ", ";\n"])), spacing45(3, 4), color27("neutral.11"), typography27("paragraphMedium"), color27("neutral.11"), color27("primary.lightest"), getRootStyle14, getComponentOverride39("HeaderNavigationLink"));

// src/components/HeaderNavigation/HeaderNavigationLinks/HeaderNavigationLink/constants.ts
var HEADER_NAVIGATION_LINK_CLASS_PREFIX = "HeaderNavigationLink";
var headerNavigationLinkRoot = "HeaderNavigationLinkRoot";

// src/components/HeaderNavigation/HeaderNavigationLinks/HeaderNavigationLinksContext.ts
import * as React82 from "react";
var HeaderNavigationLinksContext = React82.createContext({
  onLinkClick: void 0
});
var HeaderNavigationLinksContext_default = HeaderNavigationLinksContext;

// src/components/HeaderNavigation/HeaderNavigationLinks/HeaderNavigationLink/hooks/useHeaderNavigationLinkClassName.ts
import { useMemo as useMemo78 } from "react";
import { appendClassName as appendClassName32, makeBEM as makeBEM49 } from "@deliveryhero/armor-system";
var getClassNameByComponent19 = function getClassNameByComponent19(_ref126) {
  var component = _ref126.component,
    classPrefix = _ref126.classPrefix;
  var baseClassNames = makeBEM49(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useHeaderNavigationLinkClassName = function useHeaderNavigationLinkClassName(classPrefix, className) {
  return useMemo78(function () {
    return {
      Root: appendClassName32(getClassNameByComponent19({
        component: "Root",
        classPrefix: classPrefix
      }), className),
      Link: getClassNameByComponent19({
        component: "Link",
        classPrefix: classPrefix
      }),
      Href: getClassNameByComponent19({
        component: "Href",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};
var useHeaderNavigationLinkClassName_default = useHeaderNavigationLinkClassName;

// src/components/HeaderNavigation/HeaderNavigationLinks/HeaderNavigationLink/hooks/useHeaderNavigationLink.ts
import { useCallback as useCallback23 } from "react";
import { getWindow as getWindow4 } from "@deliveryhero/armor-system";
var useHeaderNavigationLink = function useHeaderNavigationLink(_a) {
  var _b = _a,
    headerNavigationLinksContext = _b.headerNavigationLinksContext,
    name = _b.name,
    onClick = _b.onClick,
    to = _b.to,
    href = _b.href,
    isActive = _b.isActive,
    restProps = __objRest(_b, ["headerNavigationLinksContext", "name", "onClick", "to", "href", "isActive"]);
  var onLinkClick = headerNavigationLinksContext.onLinkClick,
    locationTracking = headerNavigationLinksContext.locationTracking,
    pathname = headerNavigationLinksContext.pathname;
  var handleLinkClick = useCallback23(function (event) {
    if (onClick) {
      onClick(event);
      if (event.isPropagationStopped()) {
        return;
      }
    }
    if (onLinkClick && name) {
      onLinkClick(name);
    }
  }, [onClick, onLinkClick, name]);
  var url = to || href;
  var isReallyActive = false;
  if (isActive !== void 0) {
    if (typeof isActive === "function") {
      isReallyActive = isActive();
    } else {
      isReallyActive = isActive;
    }
  } else if (locationTracking && url) {
    var win2 = getWindow4();
    var currentPathname = pathname;
    if (currentPathname === void 0 && win2) {
      currentPathname = win2.location.pathname;
    }
    if (currentPathname) {
      isReallyActive = currentPathname.startsWith(url);
    }
  }
  return {
    isActive: isReallyActive,
    onClick: handleLinkClick,
    restRootProps: __spreadValues({
      to: to,
      href: href
    }, restProps)
  };
};

// src/components/HeaderNavigation/HeaderNavigationLinks/HeaderNavigationLink/HeaderNavigationLink.tsx
var HeaderNavigationLink = forwardRef46(function HeaderNavigationLink2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    _b$tag3 = _b.tag,
    Tag3 = _b$tag3 === void 0 ? "span" : _b$tag3,
    restProps = __objRest(_b, ["className", "children", "tag"]);
  var headerNavigationLinksContext = useContext5(HeaderNavigationLinksContext_default);
  var classOverride = useHeaderNavigationLinkClassName_default(HEADER_NAVIGATION_LINK_CLASS_PREFIX, className);
  var _useHeaderNavigationL = useHeaderNavigationLink(__spreadValues({
      headerNavigationLinksContext: headerNavigationLinksContext
    }, restProps)),
    isActive = _useHeaderNavigationL.isActive,
    onClick = _useHeaderNavigationL.onClick,
    restRootProps = _useHeaderNavigationL.restRootProps;
  return /* @__PURE__ */React83.createElement(HeaderNavigationLinkRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationLinkRoot
  }, restRootProps), {
    className: classOverride.Root,
    isActive: isActive,
    onClick: onClick
  }), function (forwardedProps) {
    return /* @__PURE__ */React83.createElement(Tag3, __spreadProps(__spreadValues({}, forwardedProps), {
      ref: ref
    }), children);
  });
});
HeaderNavigationLink.defaultProps = {};
HeaderNavigationLink.propTypes = {
  isActive: PropTypes44.bool,
  name: PropTypes44.string,
  to: PropTypes44.string,
  tag: PropTypes44.oneOfType([PropTypes44.elementType, PropTypes44.string]),
  href: PropTypes44.string,
  target: PropTypes44.string,
  rel: PropTypes44.string
};
var MemoizedHeaderNavigationLink = memo60(HeaderNavigationLink);

// src/components/HeaderNavigation/HeaderNavigationLinks/HeaderNavigationLinks.tsx
import React84, { forwardRef as forwardRef47, memo as memo61 } from "react";
import PropTypes45 from "prop-types";

// src/components/HeaderNavigation/HeaderNavigationLinks/style.ts
import styled60 from "styled-components";
import { propsBlocker as propsBlocker56, spacing as spacing46, token as token39, typography as typography28 } from "@deliveryhero/armor-system";
var HeaderNavigationLinksRoot = styled60(HeaderNavigationItem)(_templateObject377 || (_templateObject377 = _taggedTemplateLiteral(["\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: ", ";\n    ", ";\n    color: ", ";\n"])), spacing46(6), typography28("paragraphMedium"), token39("body.color"));
var HeaderNavigationLinksContainer = styled60.div.withConfig(propsBlocker56)(_templateObject378 || (_templateObject378 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n"])));

// src/components/HeaderNavigation/HeaderNavigationLinks/constants.ts
var HEADER_NAVIGATION_LINKS_CLASS_PREFIX = "HeaderNavigationLinks";
var headerNavigationLinksRoot = "HeaderNavigationLinksRoot";

// src/components/HeaderNavigation/HeaderNavigationLinks/hooks/useHeaderNavigationLinksClassName.ts
import { useMemo as useMemo79 } from "react";
import { appendClassName as appendClassName33, makeBEM as makeBEM50 } from "@deliveryhero/armor-system";
var getClassNameByComponent20 = function getClassNameByComponent20(_ref127) {
  var component = _ref127.component,
    classPrefix = _ref127.classPrefix;
  var baseClassNames = makeBEM50(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useHeaderNavigationLinksClassName = function useHeaderNavigationLinksClassName(classPrefix, className) {
  return useMemo79(function () {
    return {
      Root: appendClassName33(getClassNameByComponent20({
        component: "LinksRoot",
        classPrefix: classPrefix
      }), className),
      Container: getClassNameByComponent20({
        component: "Container",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};
var useHeaderNavigationLinksClassName_default = useHeaderNavigationLinksClassName;

// src/components/HeaderNavigation/HeaderNavigationLinks/hooks/useHeaderNavigationLinks.ts
import { useMemo as useMemo80 } from "react";
var useHeaderNavigationLinks = function useHeaderNavigationLinks(_a) {
  var _b = _a,
    onLinkClick = _b.onLinkClick,
    locationTracking = _b.locationTracking,
    pathname = _b.pathname,
    restProps = __objRest(_b, ["onLinkClick", "locationTracking", "pathname"]);
  var headerNavigationLinksContextValue = useMemo80(function () {
    return {
      onLinkClick: onLinkClick,
      locationTracking: locationTracking,
      pathname: pathname
    };
  }, [onLinkClick, locationTracking, pathname]);
  return {
    result: {
      headerNavigationLinksContextValue: headerNavigationLinksContextValue
    },
    restProps: restProps
  };
};

// src/components/HeaderNavigation/HeaderNavigationLinks/HeaderNavigationLinks.tsx
var HeaderNavigationLinks = forwardRef47(function HeaderNavigationLinks2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var classOverride = useHeaderNavigationLinksClassName_default(HEADER_NAVIGATION_LINKS_CLASS_PREFIX, className);
  var _useHeaderNavigationL2 = useHeaderNavigationLinks(restProps),
    result = _useHeaderNavigationL2.result,
    restRootProps = _useHeaderNavigationL2.restProps;
  return /* @__PURE__ */React84.createElement(HeaderNavigationLinksContext_default.Provider, {
    value: result.headerNavigationLinksContextValue
  }, /* @__PURE__ */React84.createElement(HeaderNavigationLinksRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationLinksRoot
  }, restRootProps), {
    className: classOverride.Root
  }), /* @__PURE__ */React84.createElement(HeaderNavigationLinksContainer, {
    className: classOverride.Container
  }, children)));
});
HeaderNavigationLinks.defaultProps = {
  locationTracking: true
};
HeaderNavigationLinks.propTypes = {
  onLinkClick: PropTypes45.func
};
var MemoizedHeaderNavigationLinks = memo61(HeaderNavigationLinks);

// src/components/HeaderNavigation/HeaderNavigationSearch/HeaderNavigationSearch.tsx
import React85, { forwardRef as forwardRef48, memo as memo62 } from "react";
import PropTypes46 from "prop-types";

// src/components/HeaderNavigation/HeaderNavigationSearch/style.ts
import styled61, { css as css47 } from "styled-components";
import { color as color28, spacing as spacing47, getComponentOverride as getComponentOverride40 } from "@deliveryhero/armor-system";
var packItemSearchStyle = function packItemSearchStyle(_ref128) {
  var separator = _ref128.separator;
  var result = css47(_templateObject379 || (_templateObject379 = _taggedTemplateLiteral(["\n        border-right-color: ", ";\n    "])), color28("neutral.03"));
  if (!separator) {
    result = css47(_templateObject380 || (_templateObject380 = _taggedTemplateLiteral(["\n            ", ";\n            border-right: none;\n        "])), result);
  }
  return result;
};
var NavigationItemSearch = styled61(HeaderNavigationItem)(_templateObject381 || (_templateObject381 = _taggedTemplateLiteral(["\n    padding-top: 0;\n    padding-bottom: 0;\n    height: 48px;\n    border-right-width: 1px;\n    border-right-style: solid;\n    padding-right: ", ";\n    padding-left: ", ";\n\n    ", "\n    ", ";\n"])), spacing47(4), spacing47(4), packItemSearchStyle, getComponentOverride40("HeaderNavigationSearch"));
var HeaderNavigationSearchRoot = styled61(Search)(_templateObject382 || (_templateObject382 = _taggedTemplateLiteral(["\n    .TextInput-Root {\n        margin-top: 4px;\n        height: 40px;\n    }\n\n    .TextInput-Input {\n        height: 38px;\n    }\n"])));

// src/components/HeaderNavigation/HeaderNavigationSearch/constants.ts
var HEADER_NAVIGATION_SEARCH_CLASS_PREFIX = "HeaderNavigationSearch";
var headerNavigationSearchRoot = "HeaderNavigationSearchRoot";

// src/components/HeaderNavigation/HeaderNavigationSearch/hooks/useHeaderNavigationSearchClassName.ts
import { useMemo as useMemo81 } from "react";
import { appendClassName as appendClassName34, makeBEM as makeBEM51 } from "@deliveryhero/armor-system";
var getClassNameByComponent21 = function getClassNameByComponent21(_ref129) {
  var component = _ref129.component,
    classPrefix = _ref129.classPrefix;
  var baseClassNames = makeBEM51(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useHeaderNavigationSearchClassName = function useHeaderNavigationSearchClassName(classPrefix, className) {
  return useMemo81(function () {
    return {
      ItemSearch: appendClassName34(getClassNameByComponent21({
        component: "ItemSearch",
        classPrefix: classPrefix
      }), className),
      NavigationSearchRoot: getClassNameByComponent21({
        component: "NavigationSearchRoot",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};

// src/components/HeaderNavigation/HeaderNavigationSearch/HeaderNavigationSearch.tsx
var HeaderNavigationSearch = forwardRef48(function HeaderNavigationSearch2(_a, ref) {
  var _b = _a,
    className = _b.className,
    options = _b.options,
    onChange = _b.onChange,
    onItemSelect = _b.onItemSelect,
    separator = _b.separator,
    restProps = __objRest(_b, ["className", "options", "onChange", "onItemSelect", "separator"]);
  var classOverride = useHeaderNavigationSearchClassName(HEADER_NAVIGATION_SEARCH_CLASS_PREFIX, className);
  return /* @__PURE__ */React85.createElement(NavigationItemSearch, {
    className: classOverride.ItemSearch,
    separator: separator
  }, /* @__PURE__ */React85.createElement(HeaderNavigationSearchRoot, __spreadProps(__spreadValues({
    "data-testid": headerNavigationSearchRoot
  }, restProps), {
    options: options,
    onChange: onChange,
    onItemSelect: onItemSelect,
    className: classOverride.NavigationSearchRoot,
    ref: ref
  })));
});
HeaderNavigationSearch.defaultProps = {
  separator: true
};
HeaderNavigationSearch.propTypes = {
  options: PropTypes46.arrayOf(PropTypes46.shape({
    value: PropTypes46.oneOfType([PropTypes46.number, PropTypes46.string]).isRequired,
    label: PropTypes46.string.isRequired
  }).isRequired),
  onChange: PropTypes46.func,
  onItemSelect: PropTypes46.func,
  separator: PropTypes46.bool
};
var MemoizedHeaderNavigationSearch = memo62(HeaderNavigationSearch);

// src/components/HeaderNavigation/HeaderNavigationSelector/HeaderNavigationSelector.tsx
import React86, { forwardRef as forwardRef49, memo as memo63 } from "react";
import PropTypes47 from "prop-types";
import { PortalToBody as PortalToBody5 } from "@deliveryhero/armor-system";

// src/components/HeaderNavigation/HeaderNavigationSelector/style.ts
import styled62, { css as css48 } from "styled-components";
import { color as color29, spacing as spacing48, getComponentOverride as getComponentOverride41, propsBlocker as propsBlocker57, zIndex as zIndex4 } from "@deliveryhero/armor-system";
var HeaderNavigationSelectorWrapper = styled62(Stack)(_templateObject383 || (_templateObject383 = _taggedTemplateLiteral([""])));
var itemSelectorStyle = function itemSelectorStyle(_ref130) {
  var separator = _ref130.separator;
  var result = css48(_templateObject384 || (_templateObject384 = _taggedTemplateLiteral(["\n        border-right-color: ", ";\n    "])), color29("neutral.03"));
  if (!separator) {
    result = css48(_templateObject385 || (_templateObject385 = _taggedTemplateLiteral(["\n            ", ";\n            border-right: none;\n        "])), result);
  }
  return result;
};
var SelectorDropdownOptionListContainer = styled62.div.withConfig(propsBlocker57)(_templateObject386 || (_templateObject386 = _taggedTemplateLiteral(["\n    ", ";\n"])), zIndex4);
var SelectorDropdownOptionList = styled62(OptionList)(_templateObject387 || (_templateObject387 = _taggedTemplateLiteral(["\n    width: 100%;\n    min-width: fit-content;\n\n    right: -", ";\n    left: auto;\n    top: ", ";\n\n    .HeaderNavigationSelector-OptionList {\n        width: 100%;\n    }\n"])), spacing48(4), spacing48(3.25));
var HeaderNavigationSelectorRoot = styled62(HeaderNavigationItem)(_templateObject388 || (_templateObject388 = _taggedTemplateLiteral(["\n    padding-top: 0;\n    padding-right: ", ";\n    padding-bottom: 0;\n    padding-left: ", ";\n    height: ", ";\n    border-right-width: 1px;\n    border-right-style: solid;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    :focus:not(:focus-visible) {\n        outline: 0;\n    }\n\n    ", ";\n    ", ";\n"])), spacing48(4), spacing48(4), spacing48(12), itemSelectorStyle, getComponentOverride41("HeaderNavigationSelector"));
var SelectedOptions = styled62(StackItem)(_templateObject389 || (_templateObject389 = _taggedTemplateLiteral([""])));
var SelectorLabel2 = styled62(PackItem)(_templateObject390 || (_templateObject390 = _taggedTemplateLiteral(["\n    max-width: 200px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n"])));
var SelectorExpansionIndicator = styled62(ExpansionIndicator)(_templateObject391 || (_templateObject391 = _taggedTemplateLiteral([""])));

// src/components/HeaderNavigation/HeaderNavigationSelector/constants.ts
var HEADER_NAVIGATION_SELECTOR_CLASS_PREFIX = "HeaderNavigationSelector";
var headerNavigationSelectorRoot = "HeaderNavigationSelectorRoot";

// src/components/HeaderNavigation/HeaderNavigationSelector/hooks/useHeaderNavigationSelectorClassName.ts
import { useMemo as useMemo82 } from "react";
import { appendClassName as appendClassName35, makeBEM as makeBEM52 } from "@deliveryhero/armor-system";
var getClassNameByComponent22 = function getClassNameByComponent22(_ref131) {
  var component = _ref131.component,
    classPrefix = _ref131.classPrefix;
  var baseClassNames = makeBEM52(classPrefix, component);
  return "".concat(baseClassNames).trim();
};
var useHeaderNavigationSelectorClassName = function useHeaderNavigationSelectorClassName(classPrefix, className) {
  return useMemo82(function () {
    return {
      Root: appendClassName35(getClassNameByComponent22({
        component: "Root",
        classPrefix: classPrefix
      }), className),
      Wrapper: getClassNameByComponent22({
        component: "Wrapper",
        classPrefix: classPrefix
      }),
      SelectedOptions: getClassNameByComponent22({
        component: "SelectedOptions",
        classPrefix: classPrefix
      }),
      SelectedOptionsContainer: getClassNameByComponent22({
        component: "SelectedOptionsContainer",
        classPrefix: classPrefix
      }),
      SelectedOptionsValues: getClassNameByComponent22({
        component: "SelectedOptionsValues",
        classPrefix: classPrefix
      }),
      SelectedOptionsExpansionIndicatorContainer: getClassNameByComponent22({
        component: "SelectedOptionsExpansionIndicatorContainer",
        classPrefix: classPrefix
      }),
      SelectedOptionsExpansionIndicator: getClassNameByComponent22({
        component: "SelectedOptionsExpansionIndicator",
        classPrefix: classPrefix
      }),
      OptionListContainer: getClassNameByComponent22({
        component: "OptionListContainer",
        classPrefix: classPrefix
      }),
      OptionList: getClassNameByComponent22({
        component: "OptionList",
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};

// src/components/HeaderNavigation/HeaderNavigationSelector/hooks/useHeaderNavigationSelector.ts
import { useCallback as useCallback24, useState as useState12, useRef as useRef10, useEffect as useEffect16 } from "react";
import { useOverlay as useOverlay5, usePopper as usePopper4, useRootRef as useRootRef20, useDetectEscapeKeyPressed as useDetectEscapeKeyPressed3, useOuterClick as useOuterClick3 } from "@deliveryhero/armor-system";
var useHeaderNavigationSelector = function useHeaderNavigationSelector(_a, ref) {
  var _b = _a,
    _b$navigationSelector = _b.navigationSelectorParams,
    _b$navigationSelector2 = _b$navigationSelector.label,
    label = _b$navigationSelector2 === void 0 ? "Country" : _b$navigationSelector2,
    value = _b$navigationSelector.value,
    defaultValue = _b$navigationSelector.defaultValue,
    options = _b$navigationSelector.options,
    formatOption = _b$navigationSelector.formatOption,
    isMultiselect = _b$navigationSelector.isMultiselect,
    isExpanded = _b$navigationSelector.isExpanded,
    disabled = _b$navigationSelector.disabled,
    onOptionSelect = _b.onOptionSelect,
    _b$separator = _b.separator,
    separator = _b$separator === void 0 ? true : _b$separator,
    onChange = _b.onChange,
    onRenderSelectedValue = _b.onRenderSelectedValue,
    onClick = _b.onClick,
    enableSelectAllOption = _b.enableSelectAllOption,
    enableSearchOption = _b.enableSearchOption,
    enablePortal = _b.enablePortal,
    zIndex6 = _b.zIndex,
    maxDropdownHeight = _b.maxDropdownHeight,
    restProps = __objRest(_b, ["navigationSelectorParams", "onOptionSelect", "separator", "onChange", "onRenderSelectedValue", "onClick", "enableSelectAllOption", "enableSearchOption", "enablePortal", "zIndex", "maxDropdownHeight"]);
  var dropdownRef = useRef10(null);
  var containerRef = useRootRef20(ref);
  var _useValue3 = useValue(value, defaultValue),
    _useValue4 = _slicedToArray(_useValue3, 2),
    internalValue = _useValue4[0],
    setInternalValue = _useValue4[1];
  var _useOptions2 = useOptions(options, formatOption),
    isFlat = _useOptions2.isFlat,
    internalOptions = _useOptions2.internalOptions,
    dynamicInternalOptions = _useOptions2.dynamicInternalOptions,
    setDynamicInternalOptions = _useOptions2.setDynamicInternalOptions;
  var onValueUpdate = useOnValueUpdate(setInternalValue, onOptionSelect, onChange);
  var selectedValueToDisplay = useSelectedValueToDisplay(internalValue, internalOptions, onRenderSelectedValue);
  var _useState45 = useState12(isExpanded),
    _useState46 = _slicedToArray(_useState45, 2),
    isOptionListShown = _useState46[0],
    setIsOptionListShown = _useState46[1];
  var _usePopper4 = usePopper4(dropdownRef, containerRef, {
      align: "bottom-end",
      offset: [0, 0],
      allowedAutoPlacements: ["bottom"]
    }),
    panelProps = _usePopper4.panelProps;
  var _useOverlay5 = useOverlay5(isOptionListShown, {
      zIndex: zIndex6
    }),
    realZIndex = _useOverlay5.zIndex;
  var onOuterClick = useCallback24(function () {
    setIsOptionListShown(false);
  }, []);
  useOuterClick3([containerRef, dropdownRef], onOuterClick, isOptionListShown);
  useDetectEscapeKeyPressed3(containerRef, setIsOptionListShown, isOptionListShown);
  var handleClick = useCallback24(function (event) {
    setIsOptionListShown(function (isShown) {
      return !isShown;
    });
    onClick == null ? void 0 : onClick(event);
  }, [onClick]);
  var handleEnterKeyDown = useCallback24(function (event) {
    var key = event.key;
    if (key === "Enter") {
      setIsOptionListShown(function (isShown) {
        return !isShown;
      });
    }
  }, []);
  useEffect16(function () {
    var _a2;
    var container = (_a2 = containerRef.current) == null ? void 0 : _a2.parentElement;
    var dropdown = dropdownRef.current;
    if (!dropdown || !container) {
      return;
    }
    dropdown.style.width = "".concat(container.offsetWidth, "px");
  });
  return {
    rootProps: restProps,
    optionListProps: {
      multiple: isMultiselect,
      formatOption: formatOption,
      internalValue: internalValue,
      setInternalValue: setInternalValue,
      onValueUpdate: onValueUpdate,
      isFlat: isFlat,
      options: options,
      internalOptions: internalOptions,
      isOptionListShown: isOptionListShown,
      setIsOptionListShown: setIsOptionListShown,
      disabled: disabled,
      enableSelectAllOption: enableSelectAllOption,
      enableSearchOption: enableSearchOption,
      dynamicInternalOptions: dynamicInternalOptions,
      setInternalOptions: setDynamicInternalOptions,
      autoFocus: true,
      enableScrollGradientEffect: true,
      maxDropdownHeight: maxDropdownHeight
    },
    expansionIndicatorProps: {
      isExpanded: isOptionListShown
    },
    selectorProps: {
      separator: separator,
      onKeyDown: handleEnterKeyDown,
      tabIndex: 0,
      isOptionListShown: isOptionListShown
    },
    selectedOptionsProps: {
      onClick: handleClick
    },
    containerRef: containerRef,
    label: label,
    selectedValueToDisplay: selectedValueToDisplay,
    portalProps: {
      enablePortal: enablePortal
    },
    listContainerProps: __spreadValues({
      ref: dropdownRef,
      zIndex: realZIndex,
      containerRef: containerRef
    }, panelProps),
    isOpen: isOptionListShown
  };
};

// src/components/HeaderNavigation/HeaderNavigationSelector/HeaderNavigationSelector.tsx
var HeaderNavigationSelector = forwardRef49(function HeaderNavigationSelector2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classOverride = useHeaderNavigationSelectorClassName(HEADER_NAVIGATION_SELECTOR_CLASS_PREFIX, className);
  var _useHeaderNavigationS = useHeaderNavigationSelector(restProps, ref),
    rootProps = _useHeaderNavigationS.rootProps,
    selectorProps = _useHeaderNavigationS.selectorProps,
    optionListProps = _useHeaderNavigationS.optionListProps,
    expansionIndicatorProps = _useHeaderNavigationS.expansionIndicatorProps,
    listContainerProps = _useHeaderNavigationS.listContainerProps,
    portalProps = _useHeaderNavigationS.portalProps,
    containerRef = _useHeaderNavigationS.containerRef,
    label = _useHeaderNavigationS.label,
    selectedValueToDisplay = _useHeaderNavigationS.selectedValueToDisplay,
    isOpen = _useHeaderNavigationS.isOpen,
    selectedOptionsProps = _useHeaderNavigationS.selectedOptionsProps;
  return /* @__PURE__ */React86.createElement(HeaderNavigationSelectorRoot, __spreadProps(__spreadValues({}, selectorProps), {
    className: classOverride.Root
  }), /* @__PURE__ */React86.createElement(HeaderNavigationSelectorWrapper, __spreadProps(__spreadValues({
    "data-testid": headerNavigationSelectorRoot
  }, rootProps), {
    className: classOverride.Wrapper,
    ref: containerRef
  }), /* @__PURE__ */React86.createElement(SelectedOptions, __spreadValues({
    className: classOverride.SelectedOptionsContainer
  }, selectedOptionsProps), /* @__PURE__ */React86.createElement(Pack, {
    className: classOverride.SelectedOptions
  }, /* @__PURE__ */React86.createElement(SelectorLabel2, {
    className: classOverride.SelectedOptionsValues
  }, selectedValueToDisplay || label), /* @__PURE__ */React86.createElement(PackItem, {
    className: classOverride.SelectedOptionsExpansionIndicatorContainer
  }, /* @__PURE__ */React86.createElement(SelectorExpansionIndicator, __spreadProps(__spreadValues({}, expansionIndicatorProps), {
    marginLeft: 4,
    className: classOverride.SelectedOptionsExpansionIndicator
  }))))), /* @__PURE__ */React86.createElement(PortalToBody5, __spreadValues({}, portalProps), /* @__PURE__ */React86.createElement(SelectorDropdownOptionListContainer, __spreadValues({
    className: classOverride.OptionListContainer
  }, listContainerProps), isOpen && /* @__PURE__ */React86.createElement(SelectorDropdownOptionList, __spreadProps(__spreadValues({}, optionListProps), {
    className: classOverride.OptionList
  }))))));
});
HeaderNavigationSelector.defaultProps = {
  navigationSelectorParams: {
    label: "Country",
    isMultiselect: false
  },
  separator: true
};
HeaderNavigationSelector.propTypes = {
  onOptionSelect: PropTypes47.func,
  separator: PropTypes47.bool
  // TODO (nmelnikov 2020-09-24): tighten
  // navigationSelectorParams: PropTypes.shape({
  //     label: PropTypes.string,
  //     isMultiselect: PropTypes.bool,
  //     isExpanded: PropTypes.bool,
  //     defaultValue: PropTypes.oneOfType([
  //             PropTypes.arrayOf(PropTypes.number),
  //             PropTypes.number,
  //         ]),
  //     onSelect: PropTypes.func,
  //     onChange: PropTypes.func,
  //     options: PropTypes.array,
  // }),
};

var MemoizedHeaderNavigationSelector = memo63(HeaderNavigationSelector);

// src/components/HeaderNavigation/HeaderNavigationTitle/HeaderNavigationTitle.tsx
import React87, { forwardRef as forwardRef50, memo as memo64 } from "react";
import PropTypes48 from "prop-types";

// src/components/HeaderNavigation/HeaderNavigationTitle/constants.ts
var HEADER_NAVIGATION_TITLE_CLASS_PREFIX = "HeaderNavigationTitle";
var headerNavigationTitleRoot = "HeaderNavigationTitleRoot";

// src/components/HeaderNavigation/HeaderNavigationTitle/hooks/useHeaderNavigationTitle.ts
import { useCallback as useCallback25 } from "react";
var useHeaderNavigationTitle = function useHeaderNavigationTitle(_a) {
  var _b = _a,
    onLinkClick = _b.onLinkClick,
    name = _b.name,
    restProps = __objRest(_b, ["onLinkClick", "name"]);
  var handleLinkClick = useCallback25(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function (event) {
    if (onLinkClick && name) {
      onLinkClick(name);
    }
  }, [onLinkClick, name]);
  return {
    onClick: handleLinkClick,
    restRootProps: restProps
  };
};

// src/components/HeaderNavigation/HeaderNavigationTitle/hooks/useHeaderNavigationTitleClassName.ts
import { useMemo as useMemo83 } from "react";
import { makeRootClassName as makeRootClassName33 } from "@deliveryhero/armor-system";
var useHeaderNavigationTitleClassName = function useHeaderNavigationTitleClassName(classPrefix, className) {
  return useMemo83(function () {
    return {
      Root: makeRootClassName33(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/HeaderNavigation/HeaderNavigationTitle/style.ts
import styled63 from "styled-components";
import { fontSize03 as fontSize032, fontWeightMedium as fontWeightMedium2, color as color30, getComponentOverride as getComponentOverride42 } from "@deliveryhero/armor-system";
var HeaderNavigationTitleRootWrapper = function HeaderNavigationTitleRootWrapper(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var HeaderNavigationTitleRoot2 = styled63(HeaderNavigationTitleRootWrapper)(_templateObject392 || (_templateObject392 = _taggedTemplateLiteral(["\n    outline: none;\n    cursor: pointer;\n    text-decoration: none;\n    padding: 0;\n    font-weight: ", ";\n    border: none;\n    box-sizing: border-box;\n    display: inline-flex;\n\n    &:hover,\n    &:visited,\n    &:active,\n    &:focus {\n        text-decoration: none;\n    }\n\n    background-color: transparent;\n    color: ", ";\n    font-size: ", ";\n    &:hover {\n        background: ", ";\n    }\n\n    ", ";\n"])), fontWeightMedium2, color30("neutral.11"), fontSize032, color30("neutral.02"), getComponentOverride42("HeaderNavigationTitle"));

// src/components/HeaderNavigation/HeaderNavigationTitle/HeaderNavigationTitle.tsx
var HeaderNavigationTitle = forwardRef50(function HeaderNavigationTitle2(_a, ref) {
  var _b = _a,
    className = _b.className,
    to = _b.to,
    _b$tag4 = _b.tag,
    Tag3 = _b$tag4 === void 0 ? "span" : _b$tag4,
    href = _b.href,
    target = _b.target,
    rel = _b.rel,
    name = _b.name,
    children = _b.children,
    onLinkClick = _b.onLinkClick,
    restProps = __objRest(_b, ["className", "to", "tag", "href", "target", "rel", "name", "children", "onLinkClick"]);
  var classOverride = useHeaderNavigationTitleClassName(HEADER_NAVIGATION_TITLE_CLASS_PREFIX, className);
  var _useHeaderNavigationT = useHeaderNavigationTitle(__spreadValues({
      onLinkClick: onLinkClick,
      name: name
    }, restProps)),
    onClick = _useHeaderNavigationT.onClick,
    restRootProps = _useHeaderNavigationT.restRootProps;
  return /* @__PURE__ */React87.createElement(HeaderNavigationLinksContext_default.Provider, {
    value: {
      onLinkClick: onLinkClick
    }
  }, /* @__PURE__ */React87.createElement(HeaderNavigationTitleRoot2, __spreadProps(__spreadValues({
    "data-testid": headerNavigationTitleRoot
  }, restRootProps), {
    className: classOverride.Root,
    to: to,
    href: href,
    target: target,
    rel: rel,
    name: name,
    onClick: onClick
  }), function (forwardedProps) {
    return /* @__PURE__ */React87.createElement(Tag3, __spreadProps(__spreadValues({}, forwardedProps), {
      ref: ref
    }), children);
  }));
});
HeaderNavigationTitle.defaultProps = {};
HeaderNavigationTitle.propTypes = {
  isActive: PropTypes48.bool,
  name: PropTypes48.string,
  to: PropTypes48.string,
  tag: PropTypes48.oneOfType([PropTypes48.elementType, PropTypes48.string]),
  href: PropTypes48.string,
  target: PropTypes48.string,
  rel: PropTypes48.string,
  onLinkClick: PropTypes48.func
};
var MemoizedHeaderNavigationTitle = memo64(HeaderNavigationTitle);

// src/components/List/List.tsx
import React88, { forwardRef as forwardRef51, memo as memo65 } from "react";
import PropTypes49 from "prop-types";

// src/components/List/hooks/useListClassNames.ts
import { useMemo as useMemo84 } from "react";
import { makeRootClassName as makeRootClassName34 } from "@deliveryhero/armor-system";
var useListClassNames = function useListClassNames(classPrefix, className) {
  return useMemo84(function () {
    return {
      Root: makeRootClassName34(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/List/style.ts
import styled64, { css as css49 } from "styled-components";
import { marginProps as marginProps31, propsBlocker as propsBlocker58, getComponentOverride as getComponentOverride43, widthProps as widthProps13, reset as reset16, typography as typography29, pixelToRem as pixelToRem5, token as token40 } from "@deliveryhero/armor-system";
var getRootStyle15 = function getRootStyle15(_ref132) {
  var small = _ref132.small;
  var result = {};
  if (small) {
    result = css49(_templateObject393 || (_templateObject393 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            color: ", ";\n            font-size: ", ";\n        "])), result, typography29("paragraphSmall"), token40("body.color"), pixelToRem5(14));
  } else {
    result = css49(_templateObject394 || (_templateObject394 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            color: ", ";\n            font-size: ", ";\n        "])), result, typography29("paragraphMedium"), token40("body.color"), pixelToRem5(16));
  }
  return result;
};
var ListRoot = styled64.div.withConfig(propsBlocker58)(_templateObject395 || (_templateObject395 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset16, typography29("paragraphMedium"), token40("body.color"), getRootStyle15, getComponentOverride43("List"), marginProps31, widthProps13);

// src/components/List/constants.ts
var LIST_CLASS_PREFIX = "List";

// src/components/List/List.tsx
var List = forwardRef51(function List2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useListClassNames(LIST_CLASS_PREFIX, className);
  return /* @__PURE__ */React88.createElement(ListRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }));
});
List.defaultProps = {
  small: false
};
List.propTypes = {
  small: PropTypes49.bool
};
var MemoizedList = memo65(List);

// src/components/List/ListItem/ListItem.tsx
import React91, { forwardRef as forwardRef54, memo as memo67 } from "react";
import PropTypes52 from "prop-types";

// src/components/List/ListItem/hooks/useListItemClassNames.ts
import { useMemo as useMemo85 } from "react";
import { makeRootClassName as makeRootClassName35, makeBEM as makeBEM53 } from "@deliveryhero/armor-system";
var useListItemClassNames = function useListItemClassNames(classPrefix, className) {
  return useMemo85(function () {
    return {
      Root: makeRootClassName35(classPrefix, className),
      PrimaryListItem: makeBEM53(classPrefix, "PrimaryListItem"),
      SecondaryListItem: makeBEM53(classPrefix, "SecondaryListItem"),
      PrimaryIconContainer: makeBEM53(classPrefix, "PrimaryIconContainer"),
      PrimaryListItemContainer: makeBEM53(classPrefix, "PrimaryListItemContainer"),
      PrimaryLeadSubtitle: makeBEM53(classPrefix, "PrimaryLeadSubtitle"),
      ActionsContainer: makeBEM53(classPrefix, "ActionsContainer"),
      PrimaryIconWrapper: makeBEM53(classPrefix, "PrimaryIconWrapper")
    };
  }, [classPrefix, className]);
};

// src/components/List/ListItem/hooks/useListItem.ts
import { useRootRef as useRootRef21 } from "@deliveryhero/armor-system";
var useListItem = function useListItem(_a, ref) {
  var _b = _a,
    children = _b.children,
    disabled = _b.disabled,
    inactive = _b.inactive,
    tag = _b.tag,
    to = _b.to,
    primaryIcon = _b.primaryIcon,
    actions = _b.actions,
    _b$secondaryItemText = _b.secondaryItemText,
    secondaryItemText = _b$secondaryItemText === void 0 ? inactive ? "Inactive" : "" : _b$secondaryItemText,
    size = _b.size,
    href = _b.href,
    target = _b.target,
    rel = _b.rel,
    primaryIconBackgroundColor = _b.primaryIconBackgroundColor,
    divider = _b.divider,
    lead = _b.lead,
    subtitle = _b.subtitle,
    enableLink = _b.enableLink,
    enableSecondaryItem = _b.enableSecondaryItem,
    restProps = __objRest(_b, ["children", "disabled", "inactive", "tag", "to", "primaryIcon", "actions", "secondaryItemText", "size", "href", "target", "rel", "primaryIconBackgroundColor", "divider", "lead", "subtitle", "enableLink", "enableSecondaryItem"]);
  var innerRef = useRootRef21(ref);
  var Tag3 = enableLink && (!disabled || inactive) ? tag != null ? tag : "a" : "div";
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      size: size,
      lead: lead,
      subtitle: subtitle,
      divider: divider,
      disabled: disabled,
      ref: ref,
      enableLink: enableLink,
      inactive: inactive
    }),
    primaryListProps: {
      disabled: disabled,
      inactive: inactive
    },
    actionsContainerProps: {
      disabled: disabled,
      inactive: inactive
    },
    secondaryListProps: {
      lead: lead,
      subtitle: subtitle,
      disabled: disabled,
      inactive: inactive
    },
    primaryLeadSubtitle: {
      lead: lead,
      subtitle: subtitle,
      disabled: disabled,
      inactive: inactive
    },
    renderSubtitle: !!subtitle && !lead,
    renderLead: !!lead,
    lead: lead,
    subtitle: subtitle,
    secondaryItemText: secondaryItemText,
    actions: actions,
    children: children,
    enablePrimaryIcon: !!primaryIcon,
    primaryIcon: primaryIcon,
    enableSecondaryItem: enableSecondaryItem,
    tagProps: {
      ref: innerRef,
      href: href,
      target: target,
      rel: rel,
      to: to
    },
    Tag: Tag3,
    primaryIconBackgroundColor: primaryIconBackgroundColor,
    primaryIconWrapper: (lead || subtitle) && primaryIconBackgroundColor,
    primaryIconWrapperProps: {
      disabled: disabled,
      primaryIconBackgroundColor: primaryIconBackgroundColor,
      primaryIcon: primaryIcon
    }
  };
};

// src/components/List/ListItem/style.ts
import styled65, { css as css50 } from "styled-components";
import { marginProps as marginProps32, propsBlocker as propsBlocker59, getComponentOverride as getComponentOverride44, color as color31, reset as reset17, typography as typography30, spacing as spacing49, pixelToRem as pixelToRem6, token as token41 } from "@deliveryhero/armor-system";
var getRootStyle16 = function getRootStyle16(_ref133) {
  var disabled = _ref133.disabled,
    inactive = _ref133.inactive,
    size = _ref133.size,
    lead = _ref133.lead,
    subtitle = _ref133.subtitle;
  var result = {};
  if (disabled || inactive) {
    result = css50(_templateObject396 || (_templateObject396 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n            cursor: ", ";\n        "])), result, color31("neutral.05"), inactive ? "pointer" : "not-allowed");
  } else {
    result = css50(_templateObject397 || (_templateObject397 = _taggedTemplateLiteral(["\n            ", ";\n\n            &:hover {\n                background-color: ", ";\n\n                .PrimaryIconWrapper-Root {\n                    border: 1px solid ", ";\n                    box-sizing: border-box;\n                    border-radius: ", ";\n                }\n            }\n        "])), result, color31("primary.07", 0.04), color31("primary.lighter"), spacing49(2));
  }
  if (size === "small") {
    result = css50(_templateObject398 || (_templateObject398 = _taggedTemplateLiteral(["\n            ", ";\n            min-height: ", ";\n            padding: ", ";\n        "])), result, spacing49(6), spacing49(2, 4));
  } else if (size === "medium") {
    result = css50(_templateObject399 || (_templateObject399 = _taggedTemplateLiteral(["\n            ", ";\n            min-height: ", ";\n            padding: ", ";\n        "])), result, spacing49(6), spacing49(3, 4));
  } else if (size === "large") {
    result = css50(_templateObject400 || (_templateObject400 = _taggedTemplateLiteral(["\n            ", ";\n            min-height: ", ";\n            padding: ", ";\n            ", ";\n        "])), result, spacing49(10), spacing49(4), typography30("paragraphLarge"));
  }
  if (lead || subtitle) {
    result = css50(_templateObject401 || (_templateObject401 = _taggedTemplateLiteral(["\n            ", ";\n            min-height: ", ";\n        "])), result, spacing49(15.5));
  }
  return result;
};
var getSecondaryListStyle = function getSecondaryListStyle(_ref134) {
  var lead = _ref134.lead,
    disabled = _ref134.disabled,
    inactive = _ref134.inactive;
  var result = {};
  if (lead) {
    result = css50(_templateObject402 || (_templateObject402 = _taggedTemplateLiteral(["\n            ", ";\n            display: flex;\n            align-self: flex-end;\n        "])), result);
  }
  if (disabled || inactive) {
    result = css50(_templateObject403 || (_templateObject403 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n            cursor: ", ";\n        "])), result, inactive ? color31("neutral.07") : color31("neutral.05"), inactive ? "pointer" : "not-allowed");
  } else {
    result = css50(_templateObject404 || (_templateObject404 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color31("neutral.07"));
  }
  return result;
};
var getLeadSubtitleStyle = function getLeadSubtitleStyle(_ref135) {
  var disabled = _ref135.disabled,
    inactive = _ref135.inactive;
  var result = {};
  if (disabled || inactive) {
    result = css50(_templateObject405 || (_templateObject405 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: ", ";\n            color: ", ";\n        "])), result, inactive ? "pointer" : "not-allowed", inactive ? color31("neutral.07") : color31("neutral.05"));
  } else {
    result = css50(_templateObject406 || (_templateObject406 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color31("neutral.07"));
  }
  return result;
};
var getActionsContainerStyle = function getActionsContainerStyle(_ref136) {
  var disabled = _ref136.disabled,
    inactive = _ref136.inactive;
  var result = css50(_templateObject407 || (_templateObject407 = _taggedTemplateLiteral(["\n        color: ", ";\n    "])), color31("neutral.07"));
  if (disabled || inactive) {
    result = css50(_templateObject408 || (_templateObject408 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, inactive ? color31("neutral.07") : color31("neutral.05"));
  }
  return result;
};
var getPrimaryListStyle = function getPrimaryListStyle(_ref137) {
  var lead = _ref137.lead,
    disabled = _ref137.disabled,
    inactive = _ref137.inactive;
  var result = {};
  if (lead) {
    result = css50(_templateObject409 || (_templateObject409 = _taggedTemplateLiteral(["\n            ", ";\n            margin-top: 0;\n        "])), result);
  }
  if (disabled || inactive) {
    result = css50(_templateObject410 || (_templateObject410 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n            cursor: ", ";\n        "])), result, inactive ? color31("neutral.11") : color31("neutral.05"), inactive ? "pointer" : "not-allowed");
  } else {
    result = css50(_templateObject411 || (_templateObject411 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n        "])), result, color31("neutral.11"));
  }
  return result;
};
var Wrapper5 = function Wrapper5(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var ListItemRoot = styled65(Wrapper5).withConfig(propsBlocker59)(_templateObject412 || (_templateObject412 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    display: flex;\n    text-decoration: none;\n    flex-direction: row;\n    align-items: center;\n    align-content: center;\n    justify-content: space-between;\n    max-height: fit-content;\n    font-size: inherit;\n    border-radius: 0;\n    background: ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset17, typography30("paragraphMedium"), token41("body.color"), color31("neutral.00"), getRootStyle16, getComponentOverride44("ListItem"), marginProps32);
var PrimaryListItem = styled65.div.withConfig(propsBlocker59)(_templateObject413 || (_templateObject413 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-self: center;\n    line-height: ", ";\n    padding: 0 ", " 0 0;\n    ", ";\n    ", ";\n"])), pixelToRem6(24), spacing49(2), getPrimaryListStyle, getComponentOverride44("ListItemPrimarySection"));
var SecondaryListItem = styled65.div.withConfig(propsBlocker59)(_templateObject414 || (_templateObject414 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    align-self: flex-start;\n    align-items: center;\n    justify-content: center;\n    line-height: ", ";\n    color: ", ";\n    ", ";\n"])), pixelToRem6(24), color31("neutral.07"), getSecondaryListStyle);
var PrimaryIconContainer = styled65.div.withConfig(propsBlocker59)(_templateObject415 || (_templateObject415 = _taggedTemplateLiteral(["\n    display: flex;\n    margin-right: ", ";\n    min-height: fit-content;\n"])), spacing49(4));
var ActionsContainer2 = styled65.div.withConfig(propsBlocker59)(_templateObject416 || (_templateObject416 = _taggedTemplateLiteral(["\n    display: flex;\n    margin-left: ", ";\n    ", "\n"])), spacing49(2), getActionsContainerStyle);
var PrimaryLeadSubtitle = styled65.div.withConfig(propsBlocker59)(_templateObject417 || (_templateObject417 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-self: flex-start;\n    font-size: ", ";\n    line-height: ", ";\n    ", "\n"])), pixelToRem6(14), pixelToRem6(20), getLeadSubtitleStyle);
var PrimaryListItemContainer = styled65.div.withConfig(propsBlocker59)(_templateObject418 || (_templateObject418 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"])));

// src/components/List/ListItem/contants.ts
var LIST_ITEM_CLASS_PREFIX = "ListItem";

// src/components/List/PrimaryIconWrapper/PrimaryIconWrapper.tsx
import React89, { forwardRef as forwardRef52 } from "react";
import PropTypes50 from "prop-types";

// src/components/List/PrimaryIconWrapper/style.ts
import styled66, { css as css51 } from "styled-components";
import { marginProps as marginProps33, propsBlocker as propsBlocker60, getComponentOverride as getComponentOverride45, widthProps as widthProps14, reset as reset18, typography as typography31, color as color32, spacing as spacing50, borderRadius as borderRadius5, token as token42 } from "@deliveryhero/armor-system";
var getRootStyle17 = function getRootStyle17(_ref138) {
  var primaryIconBackgroundColor = _ref138.primaryIconBackgroundColor,
    disabled = _ref138.disabled;
  var result = css51(_templateObject419 || (_templateObject419 = _taggedTemplateLiteral(["\n         {\n            background-color: ", ";\n        }\n    "])), primaryIconBackgroundColor);
  if (disabled) {
    result = css51(_templateObject420 || (_templateObject420 = _taggedTemplateLiteral(["\n            background-color: ", ";\n            color: ", ";\n        "])), color32("neutral.02"), color32("neutral.05"));
  }
  return result;
};
var PrimaryIconWrapperRoot = styled66.div.withConfig(propsBlocker60)(_templateObject421 || (_templateObject421 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-self: center;\n    align-items: center;\n    border-radius: ", ";\n    height: ", ";\n    width: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset18, typography31("paragraphMedium"), token42("body.color"), borderRadius5("round"), spacing50(11), spacing50(11), getRootStyle17, getComponentOverride45("PrimaryIconWrapper"), marginProps33, widthProps14);

// src/components/List/PrimaryIconWrapper/constants.ts
var PRIMARY_ICON_WRAPPER_CLASS_PREFIX = "PrimaryIconWrapper";

// src/components/List/PrimaryIconWrapper/hooks/usePrimaryIconWrapperClassNames.ts
import { useMemo as useMemo86 } from "react";
import { makeRootClassName as makeRootClassName36 } from "@deliveryhero/armor-system";
var usePrimaryIconWrapperClassNames = function usePrimaryIconWrapperClassNames(classPrefix, className) {
  return useMemo86(function () {
    return {
      Root: makeRootClassName36(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/List/PrimaryIconWrapper/PrimaryIconWrapper.tsx
var PrimaryIconWrapper = forwardRef52(function PrimaryIconWrapper2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var classNameComponents = usePrimaryIconWrapperClassNames(PRIMARY_ICON_WRAPPER_CLASS_PREFIX, className);
  return /* @__PURE__ */React89.createElement(PrimaryIconWrapperRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }), children);
});
PrimaryIconWrapper.defaultProps = {
  disabled: false
};
PrimaryIconWrapper.propTypes = {
  disabled: PropTypes50.bool
};

// src/components/Divider/Divider.tsx
import React90, { forwardRef as forwardRef53, memo as memo66 } from "react";
import PropTypes51 from "prop-types";

// src/components/Divider/hooks/useDividerClassNames.ts
import { useMemo as useMemo87 } from "react";
import { makeRootClassName as makeRootClassName37, makeBEM as makeBEM54 } from "@deliveryhero/armor-system";
var useDividerClassNames = function useDividerClassNames(classPrefix, className, props) {
  var _ref139 = props || {},
    horizontal = _ref139.horizontal,
    vertical = _ref139.vertical;
  return useMemo87(function () {
    var baseClassNames = makeRootClassName37(classPrefix, className);
    var stateClassNames = [];
    if (horizontal) {
      stateClassNames.push(makeBEM54(classPrefix, "Root", "horizontal"));
    }
    if (vertical) {
      stateClassNames.push(makeBEM54(classPrefix, "Root", "vertical"));
    }
    return {
      Root: "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim()
    };
  }, [classPrefix, className, horizontal, vertical]);
};

// src/components/Divider/hooks/useDivider.ts
import { useRootRef as useRootRef22 } from "@deliveryhero/armor-system";
var useDivider = function useDivider(_a, ref) {
  var _b = _a,
    horizontal = _b.horizontal,
    vertical = _b.vertical,
    restProps = __objRest(_b, ["horizontal", "vertical"]);
  var innerRef = useRootRef22(ref);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      horizontal: horizontal,
      vertical: vertical,
      ref: innerRef
    })
  };
};

// src/components/Divider/style.ts
import styled67, { css as css52 } from "styled-components";
import { marginProps as marginProps34, propsBlocker as propsBlocker61, token as token43, reset as reset19 } from "@deliveryhero/armor-system";
var getOrientationStyle = function getOrientationStyle(_ref140) {
  var vertical = _ref140.vertical;
  if (vertical) {
    return css52(_templateObject422 || (_templateObject422 = _taggedTemplateLiteral(["\n            width: 1px;\n            height: 100%;\n        "])));
  }
  return css52(_templateObject423 || (_templateObject423 = _taggedTemplateLiteral(["\n        height: 1px;\n    "])));
};
var DividerRoot = styled67.div.withConfig(propsBlocker61)(_templateObject424 || (_templateObject424 = _taggedTemplateLiteral(["\n    ", ";\n    background-color: ", ";\n    ", ";\n    ", ";\n"])), reset19, token43("border.color.high", "color.neutral.03"), getOrientationStyle, marginProps34);

// src/components/Divider/constants.ts
var DIVIDER_CLASS_PREFIX = "Divider";

// src/components/Divider/Divider.tsx
var Divider = forwardRef53(function Divider2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var classNames = useDividerClassNames(DIVIDER_CLASS_PREFIX, className, props);
  var _useDivider = useDivider(props, ref),
    rootProps = _useDivider.rootProps;
  return /* @__PURE__ */React90.createElement(DividerRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), children);
});
Divider.defaultProps = {
  horizontal: true
};
Divider.propTypes = {
  horizontal: PropTypes51.bool,
  vertical: PropTypes51.bool
};
var MemoizedDivider = memo66(Divider);

// src/components/List/ListItem/ListItem.tsx
var ListItem = forwardRef54(function ListItem2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNames = useListItemClassNames(LIST_ITEM_CLASS_PREFIX, className);
  var _useListItem = useListItem(props, ref),
    rootProps = _useListItem.rootProps,
    primaryListProps = _useListItem.primaryListProps,
    primaryLeadSubtitle = _useListItem.primaryLeadSubtitle,
    secondaryListProps = _useListItem.secondaryListProps,
    actionsContainerProps = _useListItem.actionsContainerProps,
    renderSubtitle = _useListItem.renderSubtitle,
    renderLead = _useListItem.renderLead,
    enableSecondaryItem = _useListItem.enableSecondaryItem,
    children = _useListItem.children,
    secondaryItemText = _useListItem.secondaryItemText,
    actions = _useListItem.actions,
    lead = _useListItem.lead,
    subtitle = _useListItem.subtitle,
    primaryIcon = _useListItem.primaryIcon,
    Tag3 = _useListItem.Tag,
    tagProps = _useListItem.tagProps,
    primaryIconWrapper = _useListItem.primaryIconWrapper,
    primaryIconWrapperProps = _useListItem.primaryIconWrapperProps;
  var divider = rootProps.divider;
  return /* @__PURE__ */React91.createElement(ListItemRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), function (forwardedProps) {
    return /* @__PURE__ */React91.createElement(React91.Fragment, null, /* @__PURE__ */React91.createElement(Tag3, __spreadValues(__spreadValues({}, forwardedProps), tagProps), /* @__PURE__ */React91.createElement(PrimaryListItem, __spreadProps(__spreadValues({}, primaryListProps), {
      className: classNames.PrimaryListItem
    }), primaryIcon && /* @__PURE__ */React91.createElement(PrimaryIconContainer, {
      className: classNames.PrimaryIconContainer
    }, !primaryIconWrapper ? primaryIcon : /* @__PURE__ */React91.createElement(PrimaryIconWrapper, __spreadProps(__spreadValues({}, primaryIconWrapperProps), {
      className: classNames.PrimaryIconWrapper
    }), primaryIcon)), /* @__PURE__ */React91.createElement(PrimaryListItemContainer, {
      className: classNames.PrimaryListItemContainer
    }, renderLead && /* @__PURE__ */React91.createElement(PrimaryLeadSubtitle, __spreadProps(__spreadValues({}, primaryLeadSubtitle), {
      className: classNames.PrimaryLeadSubtitle
    }), lead), children, renderSubtitle && /* @__PURE__ */React91.createElement(PrimaryLeadSubtitle, __spreadProps(__spreadValues({}, primaryLeadSubtitle), {
      className: classNames.PrimaryLeadSubtitle
    }), subtitle))), !!enableSecondaryItem && /* @__PURE__ */React91.createElement(SecondaryListItem, __spreadProps(__spreadValues({}, secondaryListProps), {
      className: classNames.SecondaryListItem
    }), secondaryItemText, !!actions && /* @__PURE__ */React91.createElement(ActionsContainer2, __spreadProps(__spreadValues({}, actionsContainerProps), {
      className: classNames.ActionsContainer
    }), actions))), divider && /* @__PURE__ */React91.createElement(Divider, {
      marginX: 4
    }));
  });
});
ListItem.defaultProps = {
  disabled: false,
  size: "medium",
  divider: false,
  enableSecondaryItem: true,
  enableLink: false,
  primaryIconWrapper: false
};
ListItem.propTypes = {
  disabled: PropTypes52.bool,
  primaryIcon: PropTypes52.node,
  secondaryItemText: PropTypes52.oneOfType([PropTypes52.node, PropTypes52.string]),
  divider: PropTypes52.bool,
  lead: PropTypes52.string,
  subtitle: PropTypes52.string,
  enableSecondaryItem: PropTypes52.bool,
  enableLink: PropTypes52.bool,
  actions: PropTypes52.node,
  primaryIconBackgroundColor: PropTypes52.string,
  primaryIconWrapper: PropTypes52.bool
};
var MemoizedListItem = memo67(ListItem);

// src/components/LoginPage/LoginPage.tsx
import React92, { forwardRef as forwardRef55, memo as memo68 } from "react";

// src/components/LoginPage/hooks/useLoginPageClassNames.ts
import { useMemo as useMemo88 } from "react";
import { makeRootClassName as makeRootClassName38, makeBEM as makeBEM55 } from "@deliveryhero/armor-system";
var useLoginPageClassNames = function useLoginPageClassNames(classPrefix, className) {
  return useMemo88(function () {
    return {
      Root: makeRootClassName38(classPrefix, className),
      Wrapper: makeBEM55(classPrefix, "Wrapper"),
      Container: makeBEM55(classPrefix, "Container"),
      Header: makeBEM55(classPrefix, "Header"),
      Title: makeBEM55(classPrefix, "Title"),
      GreetingContainer: makeBEM55(classPrefix, "GreetingContainer"),
      GreetingTitle: makeBEM55(classPrefix, "GreetingTitle"),
      GreetingDescription: makeBEM55(classPrefix, "GreetingDescription"),
      FormContainer: makeBEM55(classPrefix, "FormContainer"),
      EmailField: makeBEM55(classPrefix, "EmailField"),
      EmailFormField: makeBEM55(classPrefix, "EmailFormField"),
      FormFieldMessage: makeBEM55(classPrefix, "FormFieldMessage"),
      PasswordFormField: makeBEM55(classPrefix, "PasswordFormField"),
      SeparatorContainer: makeBEM55(classPrefix, "SeparatorContainer"),
      SeparatorTypography: makeBEM55(classPrefix, "SeparatorTypography"),
      PasswordField: makeBEM55(classPrefix, "PasswordField"),
      Button: makeBEM55(classPrefix, "Button"),
      Divider: makeBEM55(classPrefix, "Divider"),
      OfferContainer: makeBEM55(classPrefix, "OfferContainer"),
      OfferSupportiveText: makeBEM55(classPrefix, "OfferSupportiveText"),
      OfferLink: makeBEM55(classPrefix, "OfferLink"),
      SignInContainer: makeBEM55(classPrefix, "SignInContainer")
    };
  }, [classPrefix, className]);
};

// src/components/LoginPage/hooks/useLoginPage.ts
import { useRootRef as useRootRef23, useControlledState as useControlledState5 } from "@deliveryhero/armor-system";
var useLoginPage = function useLoginPage(_a, ref) {
  var _b = _a,
    header = _b.header,
    title = _b.title,
    enableLoginForm = _b.enableLoginForm,
    _b$greetingTitle = _b.greetingTitle,
    greetingTitle = _b$greetingTitle === void 0 ? "Welcome" : _b$greetingTitle,
    _b$greetingDescriptio = _b.greetingDescription,
    greetingDescription = _b$greetingDescriptio === void 0 ? enableLoginForm ? "Enter your email and password" : "Sign in with your Google account" : _b$greetingDescriptio,
    _b$emailPlaceholder = _b.emailPlaceholder,
    emailPlaceholder = _b$emailPlaceholder === void 0 ? "Email" : _b$emailPlaceholder,
    _b$passwordPlaceholde = _b.passwordPlaceholder,
    passwordPlaceholder = _b$passwordPlaceholde === void 0 ? "Password" : _b$passwordPlaceholde,
    emailInputProps = _b.emailInputProps,
    passwordInputProps = _b.passwordInputProps,
    enableRegistration = _b.enableRegistration,
    registrationHref = _b.registrationHref,
    registrationTag = _b.registrationTag,
    registrationTo = _b.registrationTo,
    registrationTarget = _b.registrationTarget,
    onSubmit = _b.onSubmit,
    oAuth2Buttons = _b.oAuth2Buttons,
    errorEmail = _b.errorEmail,
    errorPassword = _b.errorPassword,
    restProps = __objRest(_b, ["header", "title", "enableLoginForm", "greetingTitle", "greetingDescription", "emailPlaceholder", "passwordPlaceholder", "emailInputProps", "passwordInputProps", "enableRegistration", "registrationHref", "registrationTag", "registrationTo", "registrationTarget", "onSubmit", "oAuth2Buttons", "errorEmail", "errorPassword"]);
  var innerRef = useRootRef23(ref);
  var isError = !!(errorEmail || errorPassword);
  var _useControlledState9 = useControlledState5(emailInputProps == null ? void 0 : emailInputProps.defaultValue, emailInputProps == null ? void 0 : emailInputProps.value),
    _useControlledState10 = _slicedToArray(_useControlledState9, 2),
    internalEmail = _useControlledState10[0],
    setInternalEmail = _useControlledState10[1];
  var _useControlledState11 = useControlledState5(passwordInputProps == null ? void 0 : passwordInputProps.defaultValue, passwordInputProps == null ? void 0 : passwordInputProps.value),
    _useControlledState12 = _slicedToArray(_useControlledState11, 2),
    internalPassword = _useControlledState12[0],
    setInternalPassword = _useControlledState12[1];
  var handleSubmit = function handleSubmit() {
    onSubmit == null ? void 0 : onSubmit({
      email: internalEmail,
      password: internalPassword
    });
  };
  var handleChangeEmail = function handleChangeEmail(event) {
    var _a2;
    (_a2 = emailInputProps == null ? void 0 : emailInputProps.onChange) == null ? void 0 : _a2.call(emailInputProps, event);
    setInternalEmail(event.target.value);
  };
  var handleChangePassword = function handleChangePassword(event) {
    var _a2;
    (_a2 = passwordInputProps == null ? void 0 : passwordInputProps.onChange) == null ? void 0 : _a2.call(passwordInputProps, event);
    setInternalPassword(event.target.value);
  };
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: innerRef
    }),
    emailFieldProps: __spreadProps(__spreadValues({
      label: emailPlaceholder,
      wide: true
    }, emailInputProps), {
      onChange: handleChangeEmail,
      isError: isError
    }),
    emailFormFieldProps: {
      isError: isError,
      wide: true
    },
    passwordFieldProps: __spreadProps(__spreadValues({
      label: passwordPlaceholder,
      wide: true
    }, passwordInputProps), {
      onChange: handleChangePassword,
      type: "password",
      isError: isError
    }),
    passwordFormFieldProps: {
      isError: isError,
      wide: true,
      enableVerticalOuterSpacing: true
    },
    loginButtonProps: {
      wide: true,
      onClick: handleSubmit,
      type: "submit"
    },
    separatorTypographyProps: {
      marginX: 4
    },
    registrationLinkProps: {
      paragraph: true,
      small: true,
      href: registrationHref,
      tag: registrationTag,
      to: registrationTo,
      target: registrationTarget
    },
    header: header,
    title: title,
    greetingTitle: greetingTitle,
    greetingDescription: greetingDescription,
    enableRegistration: enableRegistration,
    enableLoginForm: enableLoginForm,
    errorEmail: errorEmail,
    errorPassword: errorPassword,
    oAuth2Buttons: oAuth2Buttons
  };
};

// src/components/LoginPage/style.ts
import styled68 from "styled-components";
import { getComponentOverride as getComponentOverride46, marginProps as marginProps35, pixelToRem as pixelToRem7, propsBlocker as propsBlocker62, reset as reset20, spacing as spacing51, typography as typography32, fontWeightBold as fontWeightBold2, fontWeightMedium as fontWeightMedium3, focusWithin as focusWithin4, borderRadius as borderRadius6, token as token44, color as color33 } from "@deliveryhero/armor-system";
var LoginPageRoot = styled68.div.withConfig(propsBlocker62)(_templateObject425 || (_templateObject425 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    min-height: ", ";\n    min-width: ", ";\n    height: 100%;\n    width: 100%;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    background: color('neutral.00');\n    background-size: cover;\n    ", ";\n    ", ";\n"])), reset20, typography32("paragraphMedium"), token44("body.color"), spacing51(192), spacing51(256), getComponentOverride46("LoginPage"), marginProps35);
var LoginPageWrapper = styled68.div.withConfig(propsBlocker62)(_templateObject426 || (_templateObject426 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: auto;\n"])));
var LoginPageContainer = styled68(Card).withConfig(propsBlocker62)(_templateObject427 || (_templateObject427 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    max-width: ", ";\n    padding: ", ";\n    border-radius: ", ";\n    border: solid 1px ", ";\n"])), spacing51(108), spacing51(13, 22), borderRadius6("round"), color33("neutral.03"));
var LoginPageHeader = styled68.div(_templateObject428 || (_templateObject428 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), pixelToRem7(44), pixelToRem7(52), fontWeightBold2);
var LoginPageTitle = styled68.div(_templateObject429 || (_templateObject429 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n"])), pixelToRem7(20), pixelToRem7(28), fontWeightMedium3);
var LoginPageGreetingContainer = styled68.div(_templateObject430 || (_templateObject430 = _taggedTemplateLiteral(["\n    padding: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"])), spacing51(8, 0, 0, 0));
var LoginPageGreetingTitle = styled68.div(_templateObject431 || (_templateObject431 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    margin: 0;\n"])), typography32("sectionTitle"), token44("body.color"));
var LoginPageGreetingDescription = styled68.div(_templateObject432 || (_templateObject432 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    margin: ", ";\n"])), typography32("paragraphLarge"), token44("body.color"), spacing51(2, 0, 1));
var LoginPageFormContainer = styled68.div(_templateObject433 || (_templateObject433 = _taggedTemplateLiteral(["\n    padding: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n"])), spacing51(4, 0));
var SeparatorContainer = styled68.div(_templateObject434 || (_templateObject434 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    width: 100%;\n"])));
var SeparatorDivider = styled68(Divider)(_templateObject435 || (_templateObject435 = _taggedTemplateLiteral(["\n    width: inherit;\n"])));
var OAuth2SignInContainer = styled68.div(_templateObject436 || (_templateObject436 = _taggedTemplateLiteral(["\n    margin: ", ";\n    border-radius: ", ";\n    ", ";\n"])), spacing51(4, 0), borderRadius6("sharp"), focusWithin4());
var RegistrationOfferContainer = styled68.div(_templateObject437 || (_templateObject437 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n"])));
var RegistrationOfferSupportiveText = styled68.div(_templateObject438 || (_templateObject438 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    margin: ", ";\n"])), typography32("paragraphSmall"), token44("body.color"), spacing51(0, 2, 0, 0));
var RegistrationOfferLink = styled68(Link)(_templateObject439 || (_templateObject439 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    &:focus {\n        border: none;\n    }\n"])), pixelToRem7(12));

// src/components/LoginPage/constants.ts
var LOGINPAGE_CLASS_PREFIX = "LoginPage";

// src/components/LoginPage/LoginPage.tsx
var LoginPage = forwardRef55(function LoginPage2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNames = useLoginPageClassNames(LOGINPAGE_CLASS_PREFIX, className);
  var _useLoginPage = useLoginPage(props, ref),
    rootProps = _useLoginPage.rootProps,
    emailFieldProps = _useLoginPage.emailFieldProps,
    emailFormFieldProps = _useLoginPage.emailFormFieldProps,
    passwordFieldProps = _useLoginPage.passwordFieldProps,
    passwordFormFieldProps = _useLoginPage.passwordFormFieldProps,
    loginButtonProps = _useLoginPage.loginButtonProps,
    separatorTypographyProps = _useLoginPage.separatorTypographyProps,
    registrationLinkProps = _useLoginPage.registrationLinkProps,
    header = _useLoginPage.header,
    title = _useLoginPage.title,
    greetingTitle = _useLoginPage.greetingTitle,
    greetingDescription = _useLoginPage.greetingDescription,
    enableRegistration = _useLoginPage.enableRegistration,
    enableLoginForm = _useLoginPage.enableLoginForm,
    errorEmail = _useLoginPage.errorEmail,
    errorPassword = _useLoginPage.errorPassword,
    oAuth2Buttons = _useLoginPage.oAuth2Buttons;
  return /* @__PURE__ */React92.createElement(LoginPageRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), /* @__PURE__ */React92.createElement(LoginPageWrapper, {
    className: classNames.Wrapper
  }, /* @__PURE__ */React92.createElement(LoginPageContainer, {
    className: classNames.Container
  }, !!header && /* @__PURE__ */React92.createElement(LoginPageHeader, {
    className: classNames.Header
  }, header), !!title && /* @__PURE__ */React92.createElement(LoginPageTitle, {
    className: classNames.Title
  }, title), /* @__PURE__ */React92.createElement(LoginPageGreetingContainer, {
    className: classNames.GreetingContainer
  }, /* @__PURE__ */React92.createElement(LoginPageGreetingTitle, {
    className: classNames.GreetingTitle
  }, greetingTitle), /* @__PURE__ */React92.createElement(LoginPageGreetingDescription, {
    className: classNames.GreetingDescription
  }, greetingDescription)), !!enableLoginForm && /* @__PURE__ */React92.createElement(React92.Fragment, null, /* @__PURE__ */React92.createElement(LoginPageFormContainer, {
    className: classNames.FormContainer
  }, /* @__PURE__ */React92.createElement(FormField, __spreadValues({
    className: classNames.EmailFormField,
    marginTop: 4,
    marginBottom: 3
  }, emailFormFieldProps), /* @__PURE__ */React92.createElement(TextInput, __spreadValues({
    className: classNames.EmailField
  }, emailFieldProps)), !!errorEmail && /* @__PURE__ */React92.createElement(FormFieldMessage, {
    className: classNames.FormFieldMessage,
    error: true
  }, errorEmail)), /* @__PURE__ */React92.createElement(FormField, __spreadValues({
    marginTop: 2,
    marginBottom: 3,
    className: classNames.PasswordFormField
  }, passwordFormFieldProps), /* @__PURE__ */React92.createElement(TextInput, __spreadValues({
    marginBottom: 0.75,
    className: classNames.PasswordField
  }, passwordFieldProps)), !!errorPassword && /* @__PURE__ */React92.createElement(FormFieldMessage, {
    className: classNames.FormFieldMessage,
    error: true
  }, errorPassword)), /* @__PURE__ */React92.createElement(Button, __spreadValues({
    className: classNames.Button,
    marginTop: 2
  }, loginButtonProps), "Login")), /* @__PURE__ */React92.createElement(SeparatorContainer, {
    className: classNames.SeparatorContainer
  }, /* @__PURE__ */React92.createElement(SeparatorDivider, {
    className: classNames.Divider
  }), /* @__PURE__ */React92.createElement(Typography, __spreadValues({
    className: classNames.SeparatorTypography
  }, separatorTypographyProps), "or"), /* @__PURE__ */React92.createElement(SeparatorDivider, {
    className: classNames.Divider
  }))), /* @__PURE__ */React92.createElement(OAuth2SignInContainer, {
    className: classNames.SignInContainer
  }, oAuth2Buttons), !!enableRegistration && /* @__PURE__ */React92.createElement(RegistrationOfferContainer, {
    className: classNames.OfferContainer
  }, /* @__PURE__ */React92.createElement(RegistrationOfferSupportiveText, {
    className: classNames.OfferSupportiveText
  }, "Don't have an account?"), /* @__PURE__ */React92.createElement(RegistrationOfferLink, __spreadValues({
    className: classNames.OfferLink
  }, registrationLinkProps), "Register now")))));
});
LoginPage.defaultProps = {
  // exampleProperty: true,
};
LoginPage.propTypes = {
  /** Example description */
  // exampleProperty: PropTypes.bool,
};
var MemoizedLoginPage = memo68(LoginPage);

// src/components/Message/Message.tsx
import React93, { forwardRef as forwardRef56, memo as memo69 } from "react";
import PropTypes53 from "prop-types";

// src/components/Message/utils/useMessageClassNames.ts
import { useMemo as useMemo89 } from "react";
import { makeBEM as makeBEM56, makeRootClassName as makeRootClassName39 } from "@deliveryhero/armor-system";
var useMessageClassNames = function useMessageClassNames(classPrefix, className) {
  return useMemo89(function () {
    return {
      Root: makeRootClassName39(classPrefix, className),
      Icon: makeBEM56(classPrefix, "Icon"),
      Content: makeBEM56(classPrefix, "Content"),
      CloseButton: makeBEM56(classPrefix, "CloseButton"),
      Central: makeBEM56(classPrefix, "Central"),
      Actions: makeBEM56(classPrefix, "Actions"),
      Extra: makeBEM56(classPrefix, "Extra")
    };
  }, [classPrefix, className]);
};

// src/components/Message/style.ts
import styled70, { css as css53 } from "styled-components";
import { spacing as spacing52, typography as typography34, getComponentOverride as getComponentOverride47, marginProps as marginProps37, propsBlocker as propsBlocker64, token as token46, widthProps as widthProps15 } from "@deliveryhero/armor-system";

// src/components/Message/MessageAction/style.ts
import styled69 from "styled-components";
import { marginProps as marginProps36, propsBlocker as propsBlocker63, focus as focus7, token as token45, typography as typography33 } from "@deliveryhero/armor-system";
var Wrapper6 = function Wrapper6(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var MessageActionRoot = styled69(Wrapper6).withConfig(propsBlocker63)(_templateObject440 || (_templateObject440 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: inline-block;\n    cursor: pointer;\n    ", ";\n    ", ";\n    color: ", ";\n    ", ";\n"])), focus7(), typography33("desktop.subtitleMedium", "labelMedium"), token45("action.color.primary.enabled", "color.primary.main"), marginProps36);

// src/components/Message/constants.ts
var MESSAGE_CLASS_PREFIX = "Message";
var messageLevels = {
  info: "info",
  success: "success",
  warning: "warning",
  error: "error"
};

// src/components/Message/style.ts
var getColorTokenNameByMessageLevel = function getColorTokenNameByMessageLevel(_ref141) {
  var level = _ref141.level,
    error = _ref141.error,
    success = _ref141.success,
    warning = _ref141.warning;
  if (level === messageLevels.error || error) {
    return ["icon.color.danger", "color.error.08"];
  }
  if (level === messageLevels.success || success) {
    return ["icon.color.success", "color.success.06"];
  }
  if (level === messageLevels.warning || warning) {
    return ["feedback.color.warning.high", "color.warning.07"];
  }
  return ["icon.color.info", "color.primary.03"];
};
var getRootDynamicStyle3 = function getRootDynamicStyle3(props) {
  var _getColorTokenNameByM = getColorTokenNameByMessageLevel(props),
    _getColorTokenNameByM2 = _slicedToArray(_getColorTokenNameByM, 2),
    newToken = _getColorTokenNameByM2[0],
    oldToken = _getColorTokenNameByM2[1];
  return css53(_templateObject441 || (_templateObject441 = _taggedTemplateLiteral(["\n        border-color: ", ";\n    "])), token46(newToken, oldToken));
};
var MessageRoot = styled70.div.withConfig(propsBlocker64)(_templateObject442 || (_templateObject442 = _taggedTemplateLiteral(["\n    ", ";\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    position: relative;\n    border: 1px solid ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n    padding: ", ";\n\n    ", ":not(:first-child) {\n        margin-left: ", ";\n    }\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), typography34("desktop.bodyMedium", "paragraphMedium"), token46("feedback.color.info.high", "color.primary.03"), token46("base.borderRadius.small", "shape.borderRadius.soft", {
  returnUnit: "px"
}), token46("base.color.flat", "color.neutral.00"), token46("text.color.primary", "body.color"), spacing52("base.spacing.large", [4]), MessageActionRoot, spacing52("base.spacing.large", [4]), getRootDynamicStyle3, getComponentOverride47("Message"), marginProps37, widthProps15);
var MessageCentral = styled70.div.withConfig(propsBlocker64)(_templateObject443 || (_templateObject443 = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    align-self: center;\n    display: flex;\n"])));
var MessageContent = styled70.div.withConfig(propsBlocker64)(_templateObject444 || (_templateObject444 = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    ", ";\n    color: ", ";\n\n    ", " {\n        margin: 0 0 ", ";\n\n        &:first-child {\n            margin-top: ", ";\n        }\n        &:last-child {\n            margin: 0;\n        }\n    }\n"])), typography34("desktop.bodyMedium", "paragraphMedium"), token46("text.color.primary", "color.neutral.11"), TypographyRoot, spacing52("base.spacing.xsmall", [1]), spacing52("base.spacing.xsmall", [1]));
var MessageActions = styled70.div.withConfig(propsBlocker64)(_templateObject445 || (_templateObject445 = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    align-self: flex-start;\n    margin-left: ", ";\n"])), spacing52("base.spacing.large", [4]));
var MessageExtra = styled70.div.withConfig(propsBlocker64)(_templateObject446 || (_templateObject446 = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    align-self: flex-start;\n    margin-left: ", ";\n"])), spacing52("base.spacing.large", [4]));
var MessageIconWrapper = function MessageIconWrapper(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var getIconDynamicStyle = function getIconDynamicStyle(props) {
  var _getColorTokenNameByM3 = getColorTokenNameByMessageLevel(props),
    _getColorTokenNameByM4 = _slicedToArray(_getColorTokenNameByM3, 2),
    newToken = _getColorTokenNameByM4[0],
    oldToken = _getColorTokenNameByM4[1];
  return css53(_templateObject447 || (_templateObject447 = _taggedTemplateLiteral(["\n        color: ", ";\n    "])), token46(newToken, oldToken));
};
var MessageIcon = styled70(MessageIconWrapper)(_templateObject448 || (_templateObject448 = _taggedTemplateLiteral(["\n    flex: 0 0 auto;\n    margin-right: ", ";\n    ", ";\n"])), spacing52("base.spacing.small", [2]), getIconDynamicStyle);
var MessageCloseButtonContainer = styled70.div(_templateObject449 || (_templateObject449 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n"])), spacing52("base.spacing.large", [2]));

// src/components/Message/hooks/useMessage.ts
import { useRootRef as useRootRef24 } from "@deliveryhero/armor-system";

// src/components/Message/hooks/useIconComponent.ts
import { CancelCircleFilledIcon as CancelCircleFilledIcon2, InfoIcon, WarningIcon, TickCircleFilledIcon } from "@deliveryhero/armor-icons";
var useIconComponent = function useIconComponent(_ref142) {
  var level = _ref142.level,
    warning = _ref142.warning,
    success = _ref142.success,
    error = _ref142.error,
    iconTag = _ref142.iconTag;
  if (iconTag) {
    return iconTag;
  }
  if (warning || level === messageLevels.warning) {
    return WarningIcon;
  }
  if (error || level === messageLevels.error) {
    return CancelCircleFilledIcon2;
  }
  if (success || level === messageLevels.success) {
    return TickCircleFilledIcon;
  }
  return InfoIcon;
};

// src/components/Message/hooks/useMessage.ts
var useMessage = function useMessage(_a, ref) {
  var _b = _a,
    level = _b.level,
    error = _b.error,
    warning = _b.warning,
    info = _b.info,
    success = _b.success,
    iconTag = _b.iconTag,
    disableCloseButton = _b.disableCloseButton,
    disableIcon = _b.disableIcon,
    actions = _b.actions,
    extra = _b.extra,
    onClose = _b.onClose,
    restProps = __objRest(_b, ["level", "error", "warning", "info", "success", "iconTag", "disableCloseButton", "disableIcon", "actions", "extra", "onClose"]);
  var innerRef = useRootRef24(ref);
  var IconTag = useIconComponent({
    level: level,
    error: error,
    warning: warning,
    info: info,
    success: success,
    iconTag: iconTag
  });
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: innerRef,
      disableCloseButton: disableCloseButton,
      level: level,
      error: error,
      warning: warning,
      info: info,
      success: success
    }),
    getIconProps: function getIconProps() {
      return {
        level: level,
        error: error,
        warning: warning,
        info: info,
        success: success,
        medium: true
      };
    },
    IconTag: IconTag,
    showIcon: !disableIcon,
    showActions: !!actions,
    actions: actions,
    showExtra: !!extra,
    extra: extra,
    showCloseButton: !disableCloseButton,
    getCloseButtonProps: function getCloseButtonProps() {
      return {
        onClick: onClose,
        tabIndex: -1
      };
    }
  };
};

// src/components/Message/Message.tsx
var Message = forwardRef56(function Message2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var classNameComponents = useMessageClassNames(MESSAGE_CLASS_PREFIX, className);
  var _useMessage = useMessage(props, ref),
    rootProps = _useMessage.rootProps,
    getIconProps = _useMessage.getIconProps,
    IconTag = _useMessage.IconTag,
    showIcon = _useMessage.showIcon,
    showActions = _useMessage.showActions,
    actions = _useMessage.actions,
    showExtra = _useMessage.showExtra,
    extra = _useMessage.extra,
    showCloseButton = _useMessage.showCloseButton,
    getCloseButtonProps = _useMessage.getCloseButtonProps;
  return /* @__PURE__ */React93.createElement(MessageRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root
  }), showIcon && /* @__PURE__ */React93.createElement(MessageIcon, __spreadValues({
    className: classNameComponents.Icon
  }, getIconProps()), function (forwardedProps) {
    return /* @__PURE__ */React93.createElement(IconTag, __spreadValues({}, forwardedProps), children);
  }), /* @__PURE__ */React93.createElement(MessageCentral, {
    className: classNameComponents.Central
  }, /* @__PURE__ */React93.createElement(MessageContent, {
    className: classNameComponents.Content
  }, children), showActions && /* @__PURE__ */React93.createElement(MessageActions, {
    className: classNameComponents.Actions
  }, actions), showExtra && /* @__PURE__ */React93.createElement(MessageExtra, {
    className: classNameComponents.Extra
  }, extra)), showCloseButton && /* @__PURE__ */React93.createElement(MessageCloseButtonContainer, null, /* @__PURE__ */React93.createElement(CloseButton, __spreadProps(__spreadValues({}, getCloseButtonProps()), {
    className: classNameComponents.CloseButton,
    "data-testid": classNameComponents.CloseButton
  }))));
});
Message.defaultProps = {
  disableCloseButton: false,
  disableIcon: false,
  error: false,
  warning: false,
  info: false,
  success: false
};
Message.propTypes = {
  /** Disable close button */
  disableCloseButton: PropTypes53.bool,
  /** Disable icon */
  disableIcon: PropTypes53.bool,
  /** Actions to be shown on the right side */
  actions: PropTypes53.element,
  /** Extra data to be shown on the right side */
  extra: PropTypes53.element,
  /** Message level */
  level: PropTypes53.oneOf(["info", "warning", "error", "success"]),
  /** Message level: error */
  error: PropTypes53.bool,
  /** Message level: warning */
  warning: PropTypes53.bool,
  /** Message level: info */
  info: PropTypes53.bool,
  /** Message level: success */
  success: PropTypes53.bool,
  /** A callback that is called when a user tries to close the message */
  onClose: PropTypes53.func
};
var MemoizedMessage = memo69(Message);

// src/components/Message/MessageAction/MessageAction.tsx
import React94, { memo as memo70 } from "react";
import PropTypes54 from "prop-types";

// src/components/Message/MessageAction/hooks/useMessageActionClassNames.ts
import { useMemo as useMemo90 } from "react";
import { makeRootClassName as makeRootClassName40 } from "@deliveryhero/armor-system";
var useMessageActionClassNames = function useMessageActionClassNames(classPrefix, className) {
  return useMemo90(function () {
    return {
      Root: makeRootClassName40(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/Message/MessageAction/constants.ts
var MESSAGE_ACTION_CLASS_PREFIX = "MessageAction";

// src/components/Message/MessageAction/MessageAction.tsx
var MessageAction = function MessageAction(_a) {
  var _b = _a,
    className = _b.className,
    _b$tag5 = _b.tag,
    Tag3 = _b$tag5 === void 0 ? "div" : _b$tag5,
    children = _b.children,
    restProps = __objRest(_b, ["className", "tag", "children"]);
  var classNameComponents = useMessageActionClassNames(MESSAGE_ACTION_CLASS_PREFIX, className);
  return /* @__PURE__ */React94.createElement(MessageActionRoot, __spreadProps(__spreadValues({}, restProps), {
    className: classNameComponents.Root,
    tabIndex: 0
  }), function (forwardedProps) {
    return /* @__PURE__ */React94.createElement(Tag3, __spreadValues({}, forwardedProps), children);
  });
};
MessageAction.defaultProps = {
  tag: "div"
};
MessageAction.propTypes = {
  /** Tag name or component */
  tag: PropTypes54.oneOfType([PropTypes54.elementType, PropTypes54.string])
};
var MemoizedMessageAction = memo70(MessageAction);

// src/components/Radio/Radio.tsx
import React97, { forwardRef as forwardRef57, memo as memo72 } from "react";
import PropTypes56 from "prop-types";
import { generateId as generateId3 } from "@deliveryhero/armor-system";

// src/components/Radio/utils/extendChildrenWithProps.ts
import React96, { Children as Children2 } from "react";
import { getElementName } from "@deliveryhero/armor-system";

// src/components/Radio/constants.ts
var RADIO_CLASS_PREFIX = "Radio";
var radioIdPrefix = "radio-id-";
var radioRoot = "RadioRoot";

// src/components/Radio/RadioGroup.tsx
import React95, { Children, memo as memo71 } from "react";
import PropTypes55 from "prop-types";
var RADIO_GROUP_CLASS_PREFIX = "RadioGroup";
var RadioGroup = function RadioGroup(_a) {
  var _b = _a,
    children = _b.children,
    name = _b.name,
    onChange = _b.onChange,
    selectedValue = _b.selectedValue,
    typographyProps = _b.typographyProps,
    restProps = __objRest(_b, ["children", "name", "onChange", "selectedValue", "typographyProps"]);
  if (Children.count(children) === 0) {
    console.error("".concat(RADIO_GROUP_CLASS_PREFIX, " should contain at least a single Radio component as a child"));
    return null;
  }
  if (!name) {
    console.error("A 'name' property must be supplied to ".concat(RADIO_GROUP_CLASS_PREFIX));
    return null;
  }
  var additionalProps = __spreadValues({
    name: name,
    onChange: onChange,
    selectedValue: selectedValue,
    typographyProps: typographyProps
  }, restProps);
  var childrenWithExtendedProps = extendChildrenWithProps(children, additionalProps);
  return /* @__PURE__ */React95.createElement(React95.Fragment, null, childrenWithExtendedProps);
};
RadioGroup.displayName = RADIO_GROUP_CLASS_PREFIX;
RadioGroup.defaultProps = {
  checked: false,
  disabled: false
};
RadioGroup.propTypes = {
  selectedValue: PropTypes55.string,
  typographyProps: PropTypes55.object
};
var MemoizedRadioGroup = memo71(RadioGroup);

// src/components/Radio/utils/extendChildrenWithProps.ts
var extendChildrenWithProps = function extendChildrenWithProps(children, additionalProps) {
  var values = [];
  var childrenWithExtendedProps = Children2.map(children, function (child) {
    var _a, _b;
    var childName = getElementName(child);
    var value = (_a = child == null ? void 0 : child.props) == null ? void 0 : _a.value;
    var disabled = (_b = child == null ? void 0 : child.props) == null ? void 0 : _b.disabled;
    if (childName !== RADIO_CLASS_PREFIX) {
      console.error("Only @armor/".concat(RADIO_CLASS_PREFIX, " components can be used as children of ").concat(RADIO_GROUP_CLASS_PREFIX));
      return null;
    }
    if (!value) {
      console.error("Ensure that all @armor/".concat(RADIO_CLASS_PREFIX, " components have 'value' property set"));
      return null;
    }
    values.push(value);
    return React96.cloneElement(child, __spreadProps(__spreadValues({}, additionalProps), {
      disabled: disabled
    }));
  });
  var uniqueValues = Array.from(new Set(values));
  if (uniqueValues.length < Children2.count(children)) {
    console.error("Ensure that all @armor/".concat(RADIO_CLASS_PREFIX, " components have a unique 'value' property set"));
  }
  return childrenWithExtendedProps;
};

// src/components/Radio/utils/useRadioClassName.ts
import { useMemo as useMemo91 } from "react";
import { appendClassName as appendClassName36 } from "@deliveryhero/armor-system";
var useRadioClassName = function useRadioClassName(classPrefix, className, disabled, checked, error) {
  return useMemo91(function () {
    return {
      Root: appendClassName36(selectorClassGeneratorBasedOnComponent({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked,
        error: error
      }), className),
      Input: selectorClassGeneratorBasedOnComponent({
        component: "Input",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked,
        error: error
      }),
      Label: selectorClassGeneratorBasedOnComponent({
        component: "Label",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked,
        error: error
      })
    };
  }, [classPrefix, className, disabled, checked, error]);
};

// src/components/Radio/style.ts
import styled71, { css as css54 } from "styled-components";
import { marginProps as marginProps38, getComponentOverride as getComponentOverride48, propsBlocker as propsBlocker65, mouseCursor as mouseCursor6, getFocusStyle as getFocusStyle3, transition as transition19, token as token47 } from "@deliveryhero/armor-system";
var sizes = {
  container: {
    side: 16
  },
  dot: {
    side: 8,
    offset: 4
  }
};
var getContainerStyle = function getContainerStyle(_ref143) {
  var disabled = _ref143.disabled;
  if (disabled) {
    return css54(_templateObject450 || (_templateObject450 = _taggedTemplateLiteral(["\n            background-color: ", ";\n            border-color: ", ";\n        "])), token47("control.color.secondary.disabled", "color.neutral.02"), token47("control.color.primary.disabled"));
  }
  return css54(_templateObject451 || (_templateObject451 = _taggedTemplateLiteral(["\n        background-color: ", ";\n    "])), token47("control.color.secondary.enabled", "color.neutral.00"));
};
var getDotStyle = function getDotStyle(_ref144) {
  var disabled = _ref144.disabled;
  if (disabled) {
    return css54(_templateObject452 || (_templateObject452 = _taggedTemplateLiteral(["\n            background-color: ", ";\n        "])), token47("control.color.primary.disabled", "color.neutral.03"));
  }
  return css54(_templateObject453 || (_templateObject453 = _taggedTemplateLiteral(["\n        background-color: ", ";\n    "])), token47("control.color.primary.selected", "color.primary.main"));
};
var RadioRoot = styled71.div.withConfig(propsBlocker65)(_templateObject454 || (_templateObject454 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"])), getComponentOverride48("Radio"), marginProps38);
var RadioMark = styled71.label.withConfig(propsBlocker65)(_templateObject455 || (_templateObject455 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    display: inline-flex;\n    padding-left: ", "px;\n    position: relative;\n\n    &:before,\n    &:after {\n        ", "\n    }\n\n    ", ";\n"])), token47("control.sizing.mini", sizes.container.side), transition19({
  all: true
}), mouseCursor6);
var RadioInput = styled71.input.withConfig(propsBlocker65)(_templateObject456 || (_templateObject456 = _taggedTemplateLiteral(["\n    height: 0;\n    margin: 0;\n    opacity: 0;\n    position: absolute;\n    width: 0;\n\n    &:not(:checked) + ", ":before, &:checked + ", ":before {\n        content: '';\n        box-sizing: border-box;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        top: 0;\n        margin: auto;\n        border-style: solid;\n        border-width: ", "px;\n        height: ", "px;\n        width: ", "px;\n        border-radius: ", ";\n        border-color: ", ";\n        ", ";\n    }\n\n    &:not(:checked) + ", ":after, &:checked + ", ":after {\n        bottom: 0;\n        content: '';\n        position: absolute;\n        top: 0;\n        margin: auto;\n        height: ", "px;\n        left: ", "px;\n        width: ", "px;\n        border-radius: ", ";\n        ", ";\n    }\n\n    &:not(:checked) + ", ":after {\n        opacity: 0;\n        transform: scale(0);\n    }\n\n    &:checked + ", ":after {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    &:not(:disabled):checked + ", ":before {\n        border-color: ", ";\n    }\n\n    &:not(:disabled):not(:checked) + ", ":hover:before {\n        border-color: ", ";\n    }\n\n    &:not(:disabled):checked + ", ":hover:before {\n        border-color: ", ";\n    }\n\n    &:not(:disabled):checked + ", ":hover:after {\n        background-color: ", ";\n    }\n\n    &:focus-visible + ", ":before {\n        ", "\n    }\n"])), RadioMark, RadioMark, token47("control.borderWidth.thin", 1), token47("control.sizing.mini", sizes.container.side), token47("control.sizing.mini", sizes.container.side), token47("control.borderRadius.pill", "shape.borderRadius.pill", {
  returnUnit: "px"
}), token47("control.color.primary.enabled", "color.neutral.03"), getContainerStyle, RadioMark, RadioMark, sizes.dot.side, sizes.dot.offset, sizes.dot.side, token47("control.borderRadius.pill", "shape.borderRadius.pill", {
  returnUnit: "px"
}), getDotStyle, RadioMark, RadioMark, RadioMark, token47("control.color.primary.selected", "color.primary.main"), RadioMark, token47("control.color.primary.hover", "color.primary.light"), RadioMark, token47("control.color.primary.selected-hover", "color.primary.light"), RadioMark, token47("control.color.primary.selected-hover", "color.primary.light"), RadioMark, getFocusStyle3({
  useBorder: true
}));

// src/components/Radio/Radio.tsx
var Radio = forwardRef57(function Radio2(_a, ref) {
  var _b = _a,
    checked = _b.checked,
    children = _b.children,
    className = _b.className,
    disabled = _b.disabled,
    error = _b.error,
    propsId = _b.id,
    label = _b.label,
    name = _b.name,
    onChange = _b.onChange,
    selectedValue = _b.selectedValue,
    typographyProps = _b.typographyProps,
    value = _b.value,
    restProps = __objRest(_b, ["checked", "children", "className", "disabled", "error", "id", "label", "name", "onChange", "selectedValue", "typographyProps", "value"]);
  var id = generateId3(propsId, radioIdPrefix);
  var isChecked = checked || value === selectedValue;
  var classOverride = useRadioClassName(RADIO_CLASS_PREFIX, className, disabled, isChecked, error);
  var handleOnChange2 = function handleOnChange2(event) {
    return onChange && onChange(event);
  };
  var _a2 = extractMarginProps(restProps),
    marginProps58 = _a2.marginProps,
    otherProps = __objRest(_a2, ["marginProps"]);
  return /* @__PURE__ */React97.createElement(RadioRoot, __spreadValues({
    className: classOverride.Root,
    "data-testid": radioRoot,
    disabled: disabled
  }, marginProps58), /* @__PURE__ */React97.createElement(RadioInput, __spreadProps(__spreadValues({}, otherProps), {
    checked: isChecked,
    className: classOverride.Input,
    disabled: disabled,
    id: id,
    name: name,
    onChange: handleOnChange2,
    ref: ref,
    type: "radio",
    value: value
  })), /* @__PURE__ */React97.createElement(RadioMark, {
    className: classOverride.Label,
    disabled: disabled,
    htmlFor: id
  }, /* @__PURE__ */React97.createElement(SelectorLabel, {
    disabled: disabled,
    error: error,
    typographyProps: typographyProps
  }, label || children)));
});
Radio.displayName = RADIO_CLASS_PREFIX;
Radio.defaultProps = {
  checked: false,
  disabled: false,
  typographyProps: {
    paragraph: true,
    large: true
  }
};
Radio.propTypes = {
  checked: PropTypes56.bool,
  disabled: PropTypes56.bool,
  error: PropTypes56.bool,
  id: PropTypes56.string,
  /**
   * @deprecated
   * Use children instead
   */
  label: PropTypes56.string,
  onChange: PropTypes56.func,
  selectedValue: PropTypes56.string,
  typographyProps: PropTypes56.object,
  value: PropTypes56.string
};
var MemoizedRadio = memo72(Radio);

// src/components/SideSheet/SideSheet.tsx
import React102, { forwardRef as forwardRef58, memo as memo76 } from "react";
import PropTypes59 from "prop-types";
import { PortalToBody as PortalToBody6 } from "@deliveryhero/armor-system";

// src/components/SideSheet/hooks/useSideSheetClassName.ts
import { useMemo as useMemo92 } from "react";
import { appendClassName as appendClassName37, makeBEM as makeBEM57 } from "@deliveryhero/armor-system";
var sideSheetClassGeneratorBasedOnComponent = function sideSheetClassGeneratorBasedOnComponent(_ref145) {
  var component = _ref145.component,
    classPrefix = _ref145.classPrefix,
    disableOverlay = _ref145.disableOverlay,
    wide = _ref145.wide;
  var baseClassNames = makeBEM57(classPrefix, component);
  var stateClassNames = [];
  if (disableOverlay) {
    stateClassNames.push(makeBEM57(classPrefix, component, "disableOverlay"));
  }
  if (wide) {
    stateClassNames.push(makeBEM57(classPrefix, component, "wide"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useSideSheetClassName = function useSideSheetClassName(classPrefix, className, disableOverlay, wide) {
  return useMemo92(function () {
    return {
      Root: appendClassName37(sideSheetClassGeneratorBasedOnComponent({
        component: "Root",
        classPrefix: classPrefix,
        disableOverlay: disableOverlay,
        wide: wide
      }), className),
      Window: sideSheetClassGeneratorBasedOnComponent({
        component: "Window",
        classPrefix: classPrefix,
        disableOverlay: disableOverlay,
        wide: wide
      }),
      Body: sideSheetClassGeneratorBasedOnComponent({
        component: "Body",
        classPrefix: classPrefix,
        disableOverlay: disableOverlay,
        wide: wide
      }),
      Content: sideSheetClassGeneratorBasedOnComponent({
        component: "Content",
        classPrefix: classPrefix,
        disableOverlay: disableOverlay,
        wide: wide
      }),
      Footer: sideSheetClassGeneratorBasedOnComponent({
        component: "Footer",
        classPrefix: classPrefix,
        disableOverlay: disableOverlay,
        wide: wide
      }),
      Header: sideSheetClassGeneratorBasedOnComponent({
        component: "Header",
        classPrefix: classPrefix,
        disableOverlay: disableOverlay,
        wide: wide
      }),
      HeaderContainer: sideSheetClassGeneratorBasedOnComponent({
        component: "HeaderContainer",
        classPrefix: classPrefix,
        disableOverlay: disableOverlay,
        wide: wide
      }),
      Backdrop: makeBEM57(classPrefix, "Backdrop")
    };
  }, [classPrefix, className, disableOverlay, wide]);
};

// src/components/SideSheet/style.ts
import styled72, { css as css55 } from "styled-components";
import { spacing as spacing53, reset as reset21, zIndex as zIndex5, getComponentOverride as getComponentOverride49, propsBlocker as propsBlocker66, token as token48, color as color34, SCALE_SMALL, durationNormal as durationNormal12, componentSpacing06 as componentSpacing062 } from "@deliveryhero/armor-system";

// src/components/SideSheet/constants.ts
var SIDE_SHEET_CLASS_PREFIX = "SideSheet";
var minWidth = "300px";
var widthWide = "62vw";
var widthDefault = "38vw";
var sideSheetContent = "SideSheetContent";
var sideSheetHeaderContainer = "SideSheetHeaderContainer";
var sideSheetBody = "SideSheetBody";
var sideSheetFooter = "SideSheetFooter";
var sideSheetHeader = "SideSheetHeader";

// src/components/SideSheet/style.ts
var calculateWidth = function calculateWidth(effectToggle, wide, scale) {
  if (effectToggle) {
    if (scale === SCALE_SMALL) {
      return spacing53(100);
    }
    return wide ? "max(".concat(widthWide, ", ").concat(minWidth, ");") : "max(".concat(widthDefault, ", ").concat(minWidth, ");");
  }
  return "0";
};
var getWindowStyle2 = function getWindowStyle2(_ref146) {
  var disableEffects = _ref146.disableEffects,
    effectToggle = _ref146.effectToggle,
    wide = _ref146.wide,
    scale = _ref146.scale;
  return css55(_templateObject457 || (_templateObject457 = _taggedTemplateLiteral(["\n        width: ", ";\n        transition: ", ";\n    "])), calculateWidth(effectToggle, wide, scale), disableEffects ? "none" : "width ".concat(durationNormal12, "ms ease"));
};
var SideSheetRoot = styled72.div.withConfig(propsBlocker66)(_templateObject458 || (_templateObject458 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n"])), reset21, zIndex5, getComponentOverride49("SideSheet"));
var SideSheetWindow = styled72.div.withConfig(propsBlocker66)(_templateObject459 || (_templateObject459 = _taggedTemplateLiteral(["\n    display: flex;\n    height: 100vh;\n    overflow: hidden;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: inherit;\n    background-color: ", ";\n    box-shadow: ", ";\n    ", ";\n"])), color34("neutral.00"), token48("elevation.medium"), getWindowStyle2);
var SideSheetContent = styled72.div.withConfig(propsBlocker66)(_templateObject460 || (_templateObject460 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n"])));
var SideSheetHeaderContainer = styled72.div.withConfig(propsBlocker66)(_templateObject461 || (_templateObject461 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-end;\n    padding: ", ";\n"])), spacing53(componentSpacing062, componentSpacing062, 0));
var SideSheetCloseButton = styled72(CloseButton)(_templateObject462 || (_templateObject462 = _taggedTemplateLiteral(["\n    margin-top: -", ";\n    margin-right: -", ";\n    position: absolute;\n    top: ", ";\n    right: ", ";\n"])), spacing53(1), spacing53(2.5), spacing53(6.5), spacing53(6.5));

// src/components/SideSheet/hooks/useSideSheet.ts
import { useCallback as useCallback26 } from "react";
import { useControlledFlagState as useControlledFlagState4, useOverlay as useOverlay6, useDisplayEffects as useDisplayEffects2, useDocumentKeydown as useDocumentKeydown2, useRootRef as useRootRef25 } from "@deliveryhero/armor-system";
var useSideSheet = function useSideSheet(_a, ref) {
  var _b = _a,
    open = _b.open,
    defaultOpen = _b.defaultOpen,
    onOpenChange = _b.onOpenChange,
    onClose = _b.onClose,
    zIndex6 = _b.zIndex,
    enablePortal = _b.enablePortal,
    enableBackdrop = _b.enableBackdrop,
    disableOverlay = _b.disableOverlay,
    enableCloseButton = _b.enableCloseButton,
    isCloseButtonVisible = _b.isCloseButtonVisible,
    enableCloseByEscape = _b.enableCloseByEscape,
    disableCloseByEscape = _b.disableCloseByEscape,
    enableCloseOnBackdropClick = _b.enableCloseOnBackdropClick,
    enableWindowScrollBlock = _b.enableWindowScrollBlock,
    enableEffects = _b.enableEffects,
    disableEffects = _b.disableEffects,
    isFixed = _b.isFixed,
    wide = _b.wide,
    scale = _b.scale,
    restProps = __objRest(_b, [
    // ComponentBehaviourOpenStateType
    "open", "defaultOpen", "onOpenChange", /** @deprecated @see onOpenChange */
    "onClose",
    // ComponentBehaviourPortalType & ComponentBehaviourOverlayType
    "zIndex", "enablePortal",
    // ComponentBehaviourModalDialogType
    "enableBackdrop", /** @deprecated @see enableBackdrop */
    "disableOverlay", "enableCloseButton", /** @deprecated @see enableCloseButton */
    "isCloseButtonVisible", "enableCloseByEscape", /** @deprecated @see enableCloseByEscape */
    "disableCloseByEscape", "enableCloseOnBackdropClick", "enableWindowScrollBlock", "enableEffects", /** @deprecated @see disableEffects */
    "disableEffects",
    // other
    "isFixed", "wide", "scale"]);
  var reallyEnableCloseButton = enableCloseButton !== void 0 ? enableCloseButton : isCloseButtonVisible;
  var reallyEnableCloseByEscape = enableCloseByEscape !== void 0 ? enableCloseByEscape : !disableCloseByEscape;
  var reallyEnableBackdrop = enableBackdrop !== void 0 ? enableBackdrop : !disableOverlay;
  var reallyEnableEffects = enableEffects !== void 0 ? enableEffects : !disableEffects;
  var _useControlledFlagSta7 = useControlledFlagState4(defaultOpen, open, onOpenChange),
    _useControlledFlagSta8 = _slicedToArray(_useControlledFlagSta7, 4),
    reallyOpen = _useControlledFlagSta8[0],
    setClose = _useControlledFlagSta8[3];
  var _useOverlay6 = useOverlay6(reallyOpen, {
      zIndex: zIndex6,
      blockWindowScroll: enableWindowScrollBlock !== false
    }),
    realZIndex = _useOverlay6.zIndex,
    isTopOverlay = _useOverlay6.isTopOverlay;
  var onCloseInternal = useCallback26(function () {
    if (isTopOverlay()) {
      onClose == null ? void 0 : onClose();
      setClose();
    }
  }, [onClose, setClose, isTopOverlay]);
  var rootRef = useRootRef25(ref);
  var onBackdropClick = useCallback26(function () {
    if (reallyEnableBackdrop && enableCloseOnBackdropClick !== false) {
      onCloseInternal();
    }
  }, [onCloseInternal, enableCloseOnBackdropClick, reallyEnableBackdrop]);
  var _useDisplayEffects2 = useDisplayEffects2(!!reallyOpen),
    display = _useDisplayEffects2.display,
    effectToggle = _useDisplayEffects2.effectToggle;
  var onKeyDown = useCallback26(function (event) {
    if (!reallyEnableCloseByEscape || event.key !== "Escape" || !isTopOverlay()) {
      return;
    }
    onCloseInternal();
  }, [isTopOverlay, onCloseInternal, reallyEnableCloseByEscape]);
  useDocumentKeydown2(onKeyDown);
  return {
    portalProps: {
      enablePortal: enablePortal
    },
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: rootRef,
      zIndex: realZIndex
    }),
    getBackdropProps: function getBackdropProps() {
      return {
        disableEffects: !reallyEnableEffects,
        display: display,
        effectToggle: effectToggle,
        onClick: onBackdropClick
      };
    },
    windowProps: {
      disableEffects: !reallyEnableEffects,
      display: display,
      effectToggle: effectToggle,
      wide: wide,
      scale: scale
    },
    contentProps: {
      "data-testid": sideSheetContent
    },
    headerContainerProps: {
      "data-testid": sideSheetHeaderContainer
    },
    getCloseButtonProps: function getCloseButtonProps() {
      return {
        onClick: onCloseInternal
      };
    },
    isCloseButtonVisible: isCloseButtonVisible,
    wide: wide,
    isFixed: isFixed,
    enableCloseButton: reallyEnableCloseButton,
    enableBackdrop: reallyEnableBackdrop
  };
};

// src/components/SideSheet/utils/extendChildrenWithProps.ts
import React101, { Children as Children3 } from "react";
import { getElementName as getElementName2 } from "@deliveryhero/armor-system";

// src/components/SideSheet/SideSheetHeader/SideSheetHeader.tsx
import React98, { memo as memo73 } from "react";
import PropTypes57 from "prop-types";

// src/components/SideSheet/SideSheetHeader/style.ts
import styled73 from "styled-components";
import { componentSpacing04 as componentSpacing042, componentSpacing08 as componentSpacing082, color as color35, getComponentOverride as getComponentOverride50, propsBlocker as propsBlocker67, reset as reset22, spacing as spacing54, typography as typography35, token as token49 } from "@deliveryhero/armor-system";
var SideSheetHeaderRoot = styled73.div.withConfig(propsBlocker67)(_templateObject463 || (_templateObject463 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    flex-grow: 1;\n    padding-bottom: ", ";\n    padding-right: ", ";\n    ", ";\n"])), reset22, typography35("paragraphMedium"), token49("body.color"), spacing54(componentSpacing082), spacing54(componentSpacing042), getComponentOverride50("SideSheetHeader"));
var SideSheetHeaderTitle = styled73.div(_templateObject464 || (_templateObject464 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    margin-top: 0;\n    margin-bottom: ", ";\n"])), typography35("sectionTitle"), token49("body.color"), spacing54(2));
var SideSheetHeaderDescription = styled73.div.withConfig(propsBlocker67)(_templateObject465 || (_templateObject465 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    margin-bottom: 0;\n    margin-top: 0;\n"])), typography35("paragraphLarge"), color35("neutral.07"));

// src/components/SideSheet/SideSheetHeader/hooks/useSideSheetHeader.ts
var useSideSheetHeader = function useSideSheetHeader(_a) {
  var _b = _a,
    description = _b.description,
    title = _b.title,
    children = _b.children,
    props = __objRest(_b, ["description", "title", "children"]);
  return {
    rootProps: __spreadValues({
      "data-testid": sideSheetHeader
    }, props),
    title: title,
    description: description,
    children: children,
    showTitle: !!title && !children,
    showDescription: !!description && !children
  };
};

// src/components/SideSheet/SideSheetHeader/hooks/useSideSheetHeaderClassNames.ts
import { useMemo as useMemo93 } from "react";
import { makeRootClassName as makeRootClassName41, makeBEM as makeBEM58 } from "@deliveryhero/armor-system";
var useSideSheetHeaderClassNames = function useSideSheetHeaderClassNames(classPrefix, className) {
  return useMemo93(function () {
    return {
      Root: makeRootClassName41(classPrefix, className),
      Title: makeBEM58(classPrefix, "Title"),
      Description: makeBEM58(classPrefix, "Description")
    };
  }, [classPrefix, className]);
};

// src/components/SideSheet/SideSheetHeader/SideSheetHeader.tsx
var SIDE_SHEET_HEADER_CLASS_PREFIX = "SideSheetHeader";
var SideSheetHeader = function SideSheetHeader(_a) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNames = useSideSheetHeaderClassNames(SIDE_SHEET_HEADER_CLASS_PREFIX, className);
  var _useSideSheetHeader = useSideSheetHeader(props),
    rootProps = _useSideSheetHeader.rootProps,
    title = _useSideSheetHeader.title,
    description = _useSideSheetHeader.description,
    children = _useSideSheetHeader.children,
    showTitle = _useSideSheetHeader.showTitle,
    showDescription = _useSideSheetHeader.showDescription;
  return /* @__PURE__ */React98.createElement(SideSheetHeaderRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), children, showTitle && /* @__PURE__ */React98.createElement(SideSheetHeaderTitle, {
    className: classNames.Title
  }, title), showDescription && /* @__PURE__ */React98.createElement(SideSheetHeaderDescription, {
    className: classNames.Description
  }, description));
};
SideSheetHeader.displayName = SIDE_SHEET_HEADER_CLASS_PREFIX;
SideSheetHeader.propTypes = {
  description: PropTypes57.string,
  title: PropTypes57.string
};
var MemoizedSideSheetHeader = memo73(SideSheetHeader);

// src/components/SideSheet/SideSheetBody/SideSheetBody.tsx
import React99, { memo as memo74 } from "react";
import PropTypes58 from "prop-types";
import { makeRootClassName as makeRootClassName42 } from "@deliveryhero/armor-system";

// src/components/SideSheet/SideSheetBody/style.ts
import styled74, { css as css56 } from "styled-components";
import { marginProps as marginProps39, paddingProps as paddingProps15, typography as typography36, spacing as spacing55, token as token50 } from "@deliveryhero/armor-system";
var rootStyle = function rootStyle(_ref147) {
  var isFixed = _ref147.isFixed;
  return css56(_templateObject466 || (_templateObject466 = _taggedTemplateLiteral(["\n    ", "\n"])), isFixed ? "overflow-y: auto;" : "");
};
var SideSheetBodyRoot = styled74.div(_templateObject467 || (_templateObject467 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    display: inline-block;\n    flex-grow: 1;\n    flex-wrap: wrap;\n    margin: 0;\n    padding: 0 ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), typography36("paragraphMedium"), token50("body.color"), spacing55(6), rootStyle, marginProps39, paddingProps15);

// src/components/SideSheet/SideSheetBody/SideSheetBody.tsx
var SIDE_SHEET_BODY_CLASS_PREFIX = "SideSheetBody";
var SideSheetBody = function SideSheetBody(_a) {
  var _b = _a,
    children = _b.children,
    isFixed = _b.isFixed,
    className = _b.className,
    restProps = __objRest(_b, ["children", "isFixed", "className"]);
  return /* @__PURE__ */React99.createElement(SideSheetBodyRoot, __spreadProps(__spreadValues({
    "data-testid": sideSheetBody
  }, restProps), {
    isFixed: isFixed,
    className: makeRootClassName42(SIDE_SHEET_BODY_CLASS_PREFIX, className)
  }), children);
};
SideSheetBody.displayName = SIDE_SHEET_BODY_CLASS_PREFIX;
SideSheetBody.propTypes = {
  isFixed: PropTypes58.bool
};
var MemoizedSideSheetBody = memo74(SideSheetBody);

// src/components/SideSheet/SideSheetFooter/SideSheetFooter.tsx
import React100, { memo as memo75 } from "react";
import { makeRootClassName as makeRootClassName43 } from "@deliveryhero/armor-system";

// src/components/SideSheet/SideSheetFooter/style.ts
import styled75 from "styled-components";
import { color as color36, getComponentOverride as getComponentOverride51, spacing as spacing56, typography as typography37, token as token51 } from "@deliveryhero/armor-system";
var SideSheetFooterRoot = styled75.div(_templateObject468 || (_templateObject468 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    align-items: center;\n    justify-content: flex-end;\n    box-sizing: border-box;\n    display: flex;\n    height: 64px;\n    border-top: 1px solid ", ";\n    padding-top: ", ";\n    margin: ", ";\n    ", ";\n"])), typography37("paragraphMedium"), token51("body.color"), color36("neutral.03"), spacing56(6), spacing56(0, 6, 6), getComponentOverride51("SideSheetFooter"));

// src/components/SideSheet/SideSheetFooter/SideSheetFooter.tsx
var SIDE_SHEET_FOOTER_CLASS_PREFIX = "SideSheetFooter";
var SideSheetFooter = function SideSheetFooter(_a) {
  var _b = _a,
    children = _b.children,
    className = _b.className,
    restProps = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */React100.createElement(SideSheetFooterRoot, __spreadProps(__spreadValues({
    "data-testid": sideSheetFooter
  }, restProps), {
    className: makeRootClassName43(SIDE_SHEET_FOOTER_CLASS_PREFIX, className)
  }), children);
};
SideSheetFooter.displayName = SIDE_SHEET_FOOTER_CLASS_PREFIX;
var MemoizedSideSheetFooter = memo75(SideSheetFooter);

// src/components/SideSheet/utils/extendChildrenWithProps.ts
var extendChildrenWithProps2 = function extendChildrenWithProps2(children, additionalProps) {
  if (!children) {
    return children;
  }
  var classOverride = additionalProps.classOverride,
    isFixed = additionalProps.isFixed,
    theme = additionalProps.theme;
  var className;
  return Children3.map(children, function (child) {
    var childName = getElementName2(child);
    if (childName && ![SIDE_SHEET_HEADER_CLASS_PREFIX, SIDE_SHEET_BODY_CLASS_PREFIX, SIDE_SHEET_FOOTER_CLASS_PREFIX].includes(childName)) {
      console.warn("Only ".concat(SIDE_SHEET_HEADER_CLASS_PREFIX, ", ").concat(SIDE_SHEET_HEADER_CLASS_PREFIX, " or ").concat(SIDE_SHEET_FOOTER_CLASS_PREFIX, " components can be used as children of ").concat(SIDE_SHEET_CLASS_PREFIX));
    }
    if (classOverride) {
      switch (childName) {
        case SIDE_SHEET_HEADER_CLASS_PREFIX:
          className = classOverride.Header;
          break;
        case SIDE_SHEET_BODY_CLASS_PREFIX:
          className = classOverride.Body;
          break;
        case SIDE_SHEET_FOOTER_CLASS_PREFIX:
          className = classOverride.Footer;
          break;
        default:
          className = "";
      }
    }
    return React101.cloneElement(child, {
      isFixed: isFixed,
      theme: theme,
      className: className
    });
  });
};

// src/components/SideSheet/utils/extractContentSections.ts
import { Children as Children4 } from "react";
import { getElementName as getElementName3 } from "@deliveryhero/armor-system";
var extractContentSections = function extractContentSections(children) {
  var sections = {
    header: null,
    body: null,
    footer: null
  };
  if (!children) {
    return sections;
  }
  Children4.forEach(children, function (child) {
    var childName = getElementName3(child);
    if (childName === SIDE_SHEET_HEADER_CLASS_PREFIX) {
      sections.header = child;
    }
    if (childName === SIDE_SHEET_BODY_CLASS_PREFIX) {
      sections.body = child;
    }
    if (childName === SIDE_SHEET_FOOTER_CLASS_PREFIX) {
      sections.footer = child;
    }
  });
  return sections;
};

// src/components/SideSheet/SideSheet.tsx
var SideSheet = forwardRef58(function SideSheet2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var _useSideSheet = useSideSheet(props, ref),
    portalProps = _useSideSheet.portalProps,
    rootProps = _useSideSheet.rootProps,
    getBackdropProps = _useSideSheet.getBackdropProps,
    windowProps = _useSideSheet.windowProps,
    contentProps = _useSideSheet.contentProps,
    headerContainerProps = _useSideSheet.headerContainerProps,
    getCloseButtonProps = _useSideSheet.getCloseButtonProps,
    enableBackdrop = _useSideSheet.enableBackdrop,
    enableCloseButton = _useSideSheet.enableCloseButton,
    wide = _useSideSheet.wide,
    isFixed = _useSideSheet.isFixed;
  var classOverride = useSideSheetClassName(SIDE_SHEET_CLASS_PREFIX, className, !enableBackdrop, wide);
  var childrenWithExtendedProps = extendChildrenWithProps2(children, {
    classOverride: classOverride,
    isFixed: isFixed
  });
  var _extractContentSectio = extractContentSections(childrenWithExtendedProps),
    header = _extractContentSectio.header,
    body = _extractContentSectio.body,
    footer = _extractContentSectio.footer;
  return /* @__PURE__ */React102.createElement(PortalToBody6, __spreadValues({}, portalProps), /* @__PURE__ */React102.createElement(SideSheetRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  }), enableBackdrop && /* @__PURE__ */React102.createElement(Backdrop, __spreadProps(__spreadValues({}, getBackdropProps()), {
    className: classOverride.Backdrop
  })), /* @__PURE__ */React102.createElement(SideSheetWindow, __spreadProps(__spreadValues({}, windowProps), {
    className: classOverride.Window
  }), /* @__PURE__ */React102.createElement(SideSheetContent, __spreadProps(__spreadValues({}, contentProps), {
    className: classOverride.Content
  }), /* @__PURE__ */React102.createElement(SideSheetHeaderContainer, __spreadProps(__spreadValues({}, headerContainerProps), {
    className: classOverride.HeaderContainer
  }), header, enableCloseButton ? /* @__PURE__ */React102.createElement(SideSheetCloseButton, __spreadValues({}, getCloseButtonProps())) : null), body, footer))));
});
SideSheet.displayName = SIDE_SHEET_CLASS_PREFIX;
SideSheet.defaultProps = {
  disableOverlay: false,
  disableEffects: false,
  disableCloseByEscape: false,
  isCloseButtonVisible: true,
  isFixed: true,
  open: false,
  wide: false
};
SideSheet.propTypes = {
  disableEffects: PropTypes59.bool,
  disableOverlay: PropTypes59.bool,
  disableCloseByEscape: PropTypes59.bool,
  isCloseButtonVisible: PropTypes59.bool,
  isFixed: PropTypes59.bool,
  onClose: PropTypes59.func,
  open: PropTypes59.bool,
  /** Tells the dialog to occupy the larger or the smaller line segment according to the ~ of the Golden Ration */
  wide: PropTypes59.bool
};
var MemoizedSideSheet = memo76(SideSheet);

// src/components/Navigation/Navigation.tsx
import React103, { forwardRef as forwardRef59, Fragment as Fragment2, memo as memo77 } from "react";
import PropTypes60 from "prop-types";

// src/components/Navigation/hooks/useNavigationClassNames.ts
import { useMemo as useMemo94 } from "react";
import { makeRootClassName as makeRootClassName44 } from "@deliveryhero/armor-system";
var useNavigationClassNames = function useNavigationClassNames(classPrefix, className) {
  return useMemo94(function () {
    return {
      Root: makeRootClassName44(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/Navigation/hooks/useNavigation.ts
import { useCallback as useCallback27, useMemo as useMemo95 } from "react";
import { consoleWarn as consoleWarn2 } from "@deliveryhero/armor-system";

// src/components/Navigation/constants.ts
var NAVIGATION_CLASS_PREFIX = "Navigation";
var DEFAULT_MAX_DEPTH_LEVEL = 3;

// src/components/Navigation/hooks/useNavigation.ts
var useNavigation = function useNavigation(_a) {
  var _b = _a,
    menuItems = _b.items,
    maxDepthLevel = _b.maxDepthLevel,
    onElementClick = _b.onElementClick,
    restRootProps = __objRest(_b, ["items", "maxDepthLevel", "onElementClick"]);
  var references = useMemo95(function () {
    var result = {};
    if (!menuItems) {
      return result;
    }
    var nestingErrorDisplayed = false;
    var traverse = function traverse(items) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var depthLevel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      if (!items) {
        return;
      }
      if (depthLevel >= (maxDepthLevel || DEFAULT_MAX_DEPTH_LEVEL)) {
        if (!nestingErrorDisplayed) {
          consoleWarn2("Too deep nesting in the SideNavigation.");
        }
        nestingErrorDisplayed = true;
        return;
      }
      for (var i = 0; i < items.length; i += 1) {
        var item = items[i];
        var globalId = "".concat(parentId, ".").concat(item.id);
        result[globalId] = items[i];
        traverse(item.items, path, globalId, depthLevel + 1);
      }
    };
    traverse(menuItems);
    return result;
  }, [menuItems, maxDepthLevel]);
  var onMenuElementClick = useCallback27(function (event) {
    var itemNode = event.currentTarget;
    var itemId = itemNode.getAttribute("data-menuelementid");
    var itemGlobalId = itemNode.getAttribute("data-menuelementglobalid");
    if (!itemId || !itemGlobalId) {
      return;
    }
    var itemReference = references[itemGlobalId];
    if (!itemReference) {
      return;
    }
    if (itemReference.menuElementProps && itemReference.menuElementProps.onClick) {
      itemReference.menuElementProps.onClick(event);
    }
    if (event.isPropagationStopped()) {
      return;
    }
    onElementClick == null ? void 0 : onElementClick(itemId, itemReference);
  }, [onElementClick, references]);
  return {
    onMenuElementClick: onMenuElementClick,
    items: menuItems,
    maxDepthLevel: maxDepthLevel,
    restRootProps: restRootProps
  };
};

// src/components/Navigation/style.ts
import styled76 from "styled-components";
import { marginProps as marginProps40, widthProps as widthProps16, propsBlocker as propsBlocker68, getComponentOverride as getComponentOverride52, typography as typography38 } from "@deliveryhero/armor-system";
var NavigationRoot = styled76.div.withConfig(propsBlocker68)(_templateObject469 || (_templateObject469 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n\n    ", ";\n    ", ";\n    ", ";\n\n    .MenuElement-Content {\n        ", ";\n    }\n"])), getComponentOverride52("Navigation"), marginProps40, widthProps16, typography38("labelLarge"));

// src/components/Navigation/Navigation.tsx
var isElementInState = function isElementInState(element, stateName, elementIds) {
  if (element[stateName] !== void 0) {
    return element[stateName];
  }
  if (elementIds) {
    return elementIds.includes(element.id);
  }
  return false;
};
var renderMenuElement = function renderMenuElement(element, depthLevel) {
  var maxDepthLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MAX_DEPTH_LEVEL;
  var parentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var enableEffects = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var onMenuElementClick = arguments.length > 5 ? arguments[5] : undefined;
  var selectedElementIds = arguments.length > 6 ? arguments[6] : undefined;
  var expandedElementIds = arguments.length > 7 ? arguments[7] : undefined;
  var _a;
  if (depthLevel >= maxDepthLevel) {
    return null;
  }
  var hasChildren = !!(element.items && element.items.length);
  var globalId = "".concat(parentId, ".").concat(element.id);
  var elementExpanded = isElementInState(element, "expanded", expandedElementIds);
  var elementSelected = isElementInState(element, "selected", selectedElementIds);
  return /* @__PURE__ */React103.createElement(Fragment2, {
    key: element.id
  }, /* @__PURE__ */React103.createElement(MenuElement, __spreadProps(__spreadValues({}, element.menuElementProps), {
    enableExpansionHandle: hasChildren,
    secondary: depthLevel === 1,
    tertiary: depthLevel > 1,
    "data-menuelementid": element.id,
    "data-menuelementglobalid": globalId,
    "data-depthlevel": depthLevel,
    depthLevel: depthLevel,
    expanded: elementExpanded,
    "data-expanded": elementExpanded,
    selected: elementSelected,
    onClick: onMenuElementClick
  }), element.label), element.beforeMenu, hasChildren && /* @__PURE__ */React103.createElement(Menu, {
    secondary: depthLevel === 0,
    tertiary: depthLevel > 0,
    expanded: elementExpanded,
    enableEffects: enableEffects
  }, element.beforeItems, (_a = element.items) == null ? void 0 : _a.map(function (subItem) {
    return renderMenuElement(subItem, depthLevel + 1, maxDepthLevel, globalId, enableEffects, onMenuElementClick, selectedElementIds, expandedElementIds);
  }), element.afterItems), element.afterMenu);
};
var Navigation = forwardRef59(function Navigation2(_a, ref) {
  var _b = _a,
    className = _b.className,
    enableBottomSeparator = _b.enableBottomSeparator,
    enableEffects = _b.enableEffects,
    selectedElementIds = _b.selectedElementIds,
    expandedElementIds = _b.expandedElementIds,
    restProps = __objRest(_b, ["className", "enableBottomSeparator", "enableEffects", "selectedElementIds", "expandedElementIds"]);
  var classNameComponents = useNavigationClassNames(NAVIGATION_CLASS_PREFIX, className);
  var _useNavigation = useNavigation(restProps),
    onMenuElementClick = _useNavigation.onMenuElementClick,
    items = _useNavigation.items,
    maxDepthLevel = _useNavigation.maxDepthLevel,
    restRootProps = _useNavigation.restRootProps;
  return /* @__PURE__ */React103.createElement(NavigationRoot, __spreadProps(__spreadValues({}, restRootProps), {
    className: classNameComponents.Root,
    ref: ref
  }), /* @__PURE__ */React103.createElement(Menu, {
    enableBottomSeparator: enableBottomSeparator
  }, !!items && items.map(function (item) {
    return renderMenuElement(item, 0, maxDepthLevel, "", enableEffects, onMenuElementClick, selectedElementIds, expandedElementIds);
  })));
});
Navigation.defaultProps = {
  maxDepthLevel: DEFAULT_MAX_DEPTH_LEVEL,
  enableBottomSeparator: false,
  enableEffects: true,
  items: []
};
Navigation.propTypes = {
  // todo: tighten
  maxDepthLevel: PropTypes60.number,
  enableBottomSeparator: PropTypes60.bool
};
var MemoizedNavigation = memo77(Navigation);

// src/components/Skeleton/Skeleton.tsx
import React104, { forwardRef as forwardRef60, memo as memo78 } from "react";
import PropTypes61 from "prop-types";
import { FileImagePortraitIcon as FileImagePortraitIcon2 } from "@deliveryhero/armor-icons";

// src/components/Skeleton/hooks/useSkeletonClassNames.ts
import { useMemo as useMemo96 } from "react";
import { makeBEM as makeBEM59, makeRootClassName as makeRootClassName45 } from "@deliveryhero/armor-system";
var useSkeletonClassNames = function useSkeletonClassNames(classPrefix, className) {
  return useMemo96(function () {
    return {
      Root: makeRootClassName45(classPrefix, className),
      CoverSheet: makeBEM59(classPrefix, "CoverSheet")
    };
  }, [classPrefix, className]);
};

// src/components/Skeleton/hooks/useSkeleton.ts
import { useRootRef as useRootRef26 } from "@deliveryhero/armor-system";
var useSkeleton = function useSkeleton(_a, ref) {
  var _b = _a,
    baseImagePlaceholder = _b.imagePlaceholder,
    width = _b.width,
    height = _b.height,
    rounded = _b.rounded,
    restProps = __objRest(_b, ["imagePlaceholder", "width", "height", "rounded"]);
  var innerRef = useRootRef26(ref);
  var isImagePlaceholder = Boolean(baseImagePlaceholder);
  var isEqualSize = width === height;
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      rounded: rounded,
      width: width,
      height: height,
      ref: innerRef
    }),
    imagePlaceholder: isImagePlaceholder && isEqualSize ? baseImagePlaceholder : void 0
  };
};

// src/components/Skeleton/style.ts
import { color as color37, getComponentOverride as getComponentOverride53, heightProps as heightProps5, marginProps as marginProps41, paddingProps as paddingProps16, widthProps as widthProps17, propsBlocker as propsBlocker69, reset as reset23, spacing as spacing57, token as token52 } from "@deliveryhero/armor-system";
import styled77, { css as css57, keyframes } from "styled-components";

// src/components/Skeleton/constants.ts
var SKELETON_CLASS_PREFIX = "Skeleton";
var SKELETON_IMAGE_PLACEHOLDER_SIZE_MAP = {
  small: 5,
  // 5 * 4 = 20px
  large: 10
  // 10 * 4 = 40px
};

var SKELETON_DISPLAY_LARGE_IMAGE_PLACEHOLDER_THRESHOLD = 8;

// src/components/Skeleton/utils.ts
var getIconSize = function getIconSize(rootSize) {
  var size = typeof rootSize === "string" ? parseInt(rootSize, 10) : rootSize;
  var large = SKELETON_IMAGE_PLACEHOLDER_SIZE_MAP.large,
    small = SKELETON_IMAGE_PLACEHOLDER_SIZE_MAP.small;
  if (!size || size > SKELETON_DISPLAY_LARGE_IMAGE_PLACEHOLDER_THRESHOLD) {
    return large;
  }
  return small;
};

// src/components/Skeleton/style.ts
var loading = keyframes(_templateObject470 || (_templateObject470 = _taggedTemplateLiteral(["\n  0% {transform: translateX(-100%)}\n  50% {transform: translateX(100%)}\n  100% {transform: translateX(100%)}\n"])));
var getRootStyle18 = function getRootStyle18(_ref148) {
  var animated = _ref148.animated,
    rounded = _ref148.rounded;
  var result = css57(_templateObject471 || (_templateObject471 = _taggedTemplateLiteral(["\n        border-radius: ", ";\n        min-width: ", ";\n        min-height: ", ";\n        mask-image: -webkit-radial-gradient(white, black);\n        -webkit-mask-image: -webkit-radial-gradient(white, black);\n    "])), rounded ? "".concat(token52("control.borderRadius.pill", 9999), "px") : token52("control.borderRadius.medium", "shape.borderRadius.soft", {
    returnUnit: "px"
  }), spacing57(5), spacing57(5));
  if (animated) {
    result = css57(_templateObject472 || (_templateObject472 = _taggedTemplateLiteral(["\n            ", ";\n            &::after {\n                animation: 2s linear 0.5s infinite normal none running\n                    ", ";\n                background: linear-gradient(\n                    90deg,\n                    ", ",\n                    ", ",\n                    ", "\n                );\n                background: ", ";\n                content: '';\n                position: absolute;\n                transform: translateX(-100%);\n                inset: 0;\n            }\n        "])), result, loading, color37("neutral.00", 0), color37("neutral.00"), color37("neutral.00", 0), token52("skeleton.color.animation"));
  }
  return result;
};
var getSkeletonPlaceholderImageStyle = function getSkeletonPlaceholderImageStyle(_ref149) {
  var width = _ref149.width,
    height = _ref149.height;
  var rootSize = typeof width !== "undefined" && width === height ? width : void 0;
  var iconSize = getIconSize(rootSize);
  return css57(_templateObject473 || (_templateObject473 = _taggedTemplateLiteral(["\n        .FileImagePortraitIcon {\n            width: ", ";\n            height: ", ";\n        }\n    "])), spacing57(iconSize), spacing57(iconSize));
};
var SkeletonRoot = styled77.div.withConfig(propsBlocker69)(_templateObject474 || (_templateObject474 = _taggedTemplateLiteral(["\n    ", ";\n\n    margin: ", ";\n    background-color: ", ";\n    color: ", ";\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: progress;\n    overflow: hidden;\n    width: fit-content;\n\n    svg {\n        color: inherit;\n    }\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    ", ";\n\n    ", ";\n"])), reset23, spacing57(2), token52("control.color.secondary.disabled", "color.neutral.02"), token52("base.color.normal", "color.neutral.03"), getRootStyle18, paddingProps16, marginProps41, heightProps5, widthProps17, getSkeletonPlaceholderImageStyle, getComponentOverride53("Skeleton"));

// src/components/Skeleton/Skeleton.tsx
var Skeleton = forwardRef60(function Skeleton2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNames = useSkeletonClassNames(SKELETON_CLASS_PREFIX, className);
  var _useSkeleton = useSkeleton(props, ref),
    imagePlaceholder = _useSkeleton.imagePlaceholder,
    rootProps = _useSkeleton.rootProps;
  return /* @__PURE__ */React104.createElement(SkeletonRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), imagePlaceholder && /* @__PURE__ */React104.createElement(FileImagePortraitIcon2, null));
});
Skeleton.defaultProps = {
  animated: true
};
Skeleton.propTypes = {
  animated: PropTypes61.bool
};
var MemoizedSkeleton = memo78(Skeleton);

// src/components/Switch/Switch.tsx
import React106, { forwardRef as forwardRef61, memo as memo79 } from "react";
import PropTypes62 from "prop-types";

// src/components/Switch/hooks/useSwitchClassName.ts
import { useMemo as useMemo97 } from "react";
import { appendClassName as appendClassName38 } from "@deliveryhero/armor-system";
var useSwitchClassName = function useSwitchClassName(classPrefix, className, disabled, checked) {
  return useMemo97(function () {
    return {
      Root: appendClassName38(selectorClassGeneratorBasedOnComponent({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked
      }), className),
      Label: selectorClassGeneratorBasedOnComponent({
        component: "Label",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked
      }),
      CheckboxInput: selectorClassGeneratorBasedOnComponent({
        component: "CheckboxInput",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked
      }),
      Slider: selectorClassGeneratorBasedOnComponent({
        component: "Slider",
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked
      })
    };
  }, [classPrefix, className, disabled, checked]);
};

// src/components/Switch/hooks/useSwitch.tsx
import { useCallback as useCallback28, useMemo as useMemo98 } from "react";
import { useControlledState as useControlledState6, useRootRef as useRootRef27, generateId as generateId4 } from "@deliveryhero/armor-system";

// src/components/Switch/constants.ts
var SWITCH_CLASS_PREFIX = "Switch";
var switchIdPrefix = "switch-id-";

// src/components/Switch/hooks/useSwitch.tsx
var useSwitch = function useSwitch(_a, ref) {
  var _b = _a,
    checked = _b.checked,
    defaultChecked = _b.defaultChecked,
    disabled = _b.disabled,
    error = _b.error,
    propsId = _b.id,
    label = _b.label,
    onChange = _b.onChange,
    readOnly = _b.readOnly,
    restProps = __objRest(_b, ["checked", "defaultChecked", "disabled", "error", "id", "label", "onChange", "readOnly"]);
  var internalInputRef = useRootRef27(ref);
  var id = generateId4(propsId, switchIdPrefix);
  var _useControlledState13 = useControlledState6(defaultChecked, checked),
    _useControlledState14 = _slicedToArray(_useControlledState13, 2),
    controlledChecked = _useControlledState14[0],
    setControlledChecked = _useControlledState14[1];
  var handleOnChange2 = useCallback28(function (event) {
    onChange == null ? void 0 : onChange(event);
    setControlledChecked(event.target.checked);
  }, [onChange, setControlledChecked]);
  var typographyProps = useMemo98(function () {
    return {
      paragraph: true,
      large: true
    };
  }, []);
  return {
    rootProps: __spreadValues({
      disabled: disabled,
      htmlFor: id
    }, restProps),
    switchInputProps: {
      checked: controlledChecked,
      disabled: disabled,
      id: id,
      onChange: handleOnChange2,
      ref: internalInputRef,
      type: "checkbox",
      readOnly: readOnly
    },
    selectorLabelProps: {
      disabled: disabled,
      error: error,
      typographyProps: typographyProps
    },
    label: label,
    disabled: disabled,
    checked: controlledChecked
  };
};

// src/components/Switch/style.ts
import styled78 from "styled-components";
import { mouseCursor as mouseCursor7, pointerEvents as pointerEvents4, getComponentOverride as getComponentOverride54, propsBlocker as propsBlocker70, getFocusStyle as getFocusStyle4, transition as transition20, marginProps as marginProps42, round as round2, token as token53 } from "@deliveryhero/armor-system";
var sizes2 = {
  dimensions: {
    width: 32,
    height: 18,
    padding: 2
  },
  toggle: {
    side: 14
  }
};
var SwitchRoot = styled78.label.withConfig(propsBlocker70)(_templateObject475 || (_templateObject475 = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    ", ";\n    ", ";\n    ", ";\n"])), getComponentOverride54("Switch"), mouseCursor7, marginProps42);
var SwitchToggle = styled78.span.withConfig(propsBlocker70)(_templateObject476 || (_templateObject476 = _taggedTemplateLiteral(["\n    position: relative;\n    display: inline-flex;\n    ", ";\n    ", ";\n    width: ", "px;\n    height: ", "px;\n    background-color: ", ";\n\n    &::after {\n        content: '';\n        position: absolute;\n        bottom: ", "px;\n        left: ", "px;\n        width: ", "px;\n        height: ", "px;\n        ", ";\n        ", ";\n        background-color: ", ";\n        border-radius: ", "px;\n    }\n\n    ", ";\n    ", ";\n"])), round2, transition20({
  all: true
}), token53("control.sizing.xsmall", sizes2.dimensions.width), sizes2.dimensions.height, token53("switch.color.inactive.enabled", "color.neutral.07"), sizes2.dimensions.padding, sizes2.dimensions.padding, sizes2.toggle.side, sizes2.toggle.side, round2, transition20({
  all: true
}), token53("action.color.inverse.enabled", "color.neutral.00"), token53("control.borderRadius.pill"), pointerEvents4, mouseCursor7);
var SwitchCheckboxInput = styled78.input.withConfig(propsBlocker70)(_templateObject477 || (_templateObject477 = _taggedTemplateLiteral(["\n    opacity: 0;\n    margin: 0;\n    width: 0;\n    height: 0;\n    pointer-events: none;\n    position: absolute;\n\n    &:checked + ", " {\n        background-color: ", ";\n\n        &:after {\n            left: calc(100% - 2px);\n            transform: translateX(-100%);\n        }\n    }\n\n    &:checked + ", ":hover {\n        background-color: ", ";\n    }\n\n    &:not(:checked) + ", ":hover {\n        background-color: ", ";\n    }\n\n    &:disabled + ", " {\n        background-color: ", ";\n\n        &:after {\n            background-color: ", ";\n        }\n    }\n\n    &:disabled:checked + ", " {\n        background-color: ", ";\n\n        &:after {\n            background-color: ", ";\n        }\n    }\n\n    &:focus-visible + ", " {\n        ", "\n    }\n"])), SwitchToggle, token53("control.color.primary.selected", "color.primary.07"), SwitchToggle, token53("switch.color.active.hover", "color.primary.05"), SwitchToggle, token53("switch.color.inactive.hover", "color.neutral.05"), SwitchToggle, token53("switch.color.inactive.disabled", "color.neutral.03"), token53("action.color.inverse.pressed"), SwitchToggle, token53("switch.color.active.disabled", "color.primary.02"), token53("action.color.inverse.pressed", "color.neutral.02"), SwitchToggle, getFocusStyle4({
  inverse: true
}));

// src/components/Switch/Switch.tsx
var Switch = forwardRef61(function Switch2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var _useSwitch = useSwitch(props, ref),
    rootProps = _useSwitch.rootProps,
    switchInputProps = _useSwitch.switchInputProps,
    selectorLabelProps = _useSwitch.selectorLabelProps,
    label = _useSwitch.label,
    disabled = _useSwitch.disabled,
    checked = _useSwitch.checked;
  var classOverride = useSwitchClassName(SWITCH_CLASS_PREFIX, className, disabled, checked);
  return /* @__PURE__ */React106.createElement(SwitchRoot, __spreadValues({
    className: classOverride.Root
  }, rootProps), /* @__PURE__ */React106.createElement(SwitchCheckboxInput, __spreadValues({
    className: classOverride.CheckboxInput
  }, switchInputProps)), /* @__PURE__ */React106.createElement(SwitchToggle, {
    className: classOverride.Label,
    disabled: disabled
  }), !!label && /* @__PURE__ */React106.createElement(SelectorLabel, __spreadValues({}, selectorLabelProps), label));
});
Switch.displayName = SWITCH_CLASS_PREFIX;
Switch.defaultProps = {
  disabled: false
};
Switch.propTypes = {
  checked: PropTypes62.bool,
  disabled: PropTypes62.bool,
  error: PropTypes62.bool,
  id: PropTypes62.string,
  label: PropTypes62.node,
  onChange: PropTypes62.func
};
var MemoizedSwitch = memo79(Switch);

// src/components/Tab/Tab.tsx
import React109, { forwardRef as forwardRef62, memo as memo80 } from "react";
import PropTypes63 from "prop-types";

// src/components/Tab/utils/useTabClassName.ts
import { useMemo as useMemo99 } from "react";
import { appendClassName as appendClassName39, makeBEM as makeBEM60 } from "@deliveryhero/armor-system";
var classGeneratorBasedOnComponent5 = function classGeneratorBasedOnComponent5(_ref150) {
  var component = _ref150.component,
    classPrefix = _ref150.classPrefix,
    disabled = _ref150.disabled,
    isActive = _ref150.isActive;
  var baseClassNames = makeBEM60(classPrefix, component);
  var stateClassNames = [];
  if (isActive) {
    stateClassNames.push(makeBEM60(classPrefix, component, "active"));
  }
  if (disabled) {
    stateClassNames.push(makeBEM60(classPrefix, component, "disabled"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useTabClassName = function useTabClassName(classPrefix, className, disabled, isActive) {
  return useMemo99(function () {
    return {
      Root: appendClassName39(classGeneratorBasedOnComponent5({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled,
        isActive: isActive
      }), className),
      Tag: classGeneratorBasedOnComponent5({
        component: "LabelContainer",
        classPrefix: classPrefix,
        disabled: disabled,
        isActive: isActive
      }),
      Label: classGeneratorBasedOnComponent5({
        component: "Label",
        classPrefix: classPrefix,
        disabled: disabled,
        isActive: isActive
      })
    };
  }, [classPrefix, className, disabled, isActive]);
};
var useTabClassName_default = useTabClassName;

// src/components/Tab/style.ts
import styled79, { css as css58 } from "styled-components";
import { borderRadius as borderRadius7, color as color38, spacing as spacing58, marginProps as marginProps43, getComponentOverride as getComponentOverride55, propsBlocker as propsBlocker71, typography as typography39, textDecorationNone, transition as transition21, mouseCursor as mouseCursor8, durationNormal as durationNormal13, focus as focus8 } from "@deliveryhero/armor-system";
var getTabRootStyle = function getTabRootStyle(_ref151) {
  var isActive = _ref151.isActive,
    wide = _ref151.wide,
    disabled = _ref151.disabled;
  var result = css58(_templateObject478 || (_templateObject478 = _taggedTemplateLiteral([""])));
  if (isActive) {
    result = css58(_templateObject479 || (_templateObject479 = _taggedTemplateLiteral(["\n            ", ";\n            transform: scaleX(1);\n            ", ";\n            &::after {\n                background-color: ", ";\n                transform: scaleX(1);\n            }\n        "])), result, transition21({
      transform: true
    }), color38("primary.07"));
  } else {
    result = css58(_templateObject480 || (_templateObject480 = _taggedTemplateLiteral(["\n            ", ";\n            &::after {\n                position: relative;\n            }\n        "])), result);
  }
  if (wide) {
    result = css58(_templateObject481 || (_templateObject481 = _taggedTemplateLiteral(["\n            ", ";\n            flex-grow: 1;\n        "])), result);
  }
  if (disabled) {
    result = css58(_templateObject482 || (_templateObject482 = _taggedTemplateLiteral(["\n            ", ";\n            &::after {\n                background-color: ", ";\n            }\n        "])), result, color38("neutral.05"));
  }
  return result;
};
var tabLabelStyle = function tabLabelStyle(_ref152) {
  var disabled = _ref152.disabled,
    wide = _ref152.wide;
  var result = css58(_templateObject483 || (_templateObject483 = _taggedTemplateLiteral([""])));
  if (wide) {
    result = css58(_templateObject484 || (_templateObject484 = _taggedTemplateLiteral(["\n            ", ";\n            justify-content: center;\n        "])), result);
  }
  if (disabled) {
    return css58(_templateObject485 || (_templateObject485 = _taggedTemplateLiteral(["\n            ", ";\n            color: ", ";\n            &:hover {\n                color: ", ";\n            }\n        "])), result, color38("neutral.05"), color38("neutral.05"));
  }
  return result;
};
var tabLabelContainerStyle = function tabLabelContainerStyle(_ref153) {
  var disabled = _ref153.disabled;
  return disabled ? css58(_templateObject486 || (_templateObject486 = _taggedTemplateLiteral(["\n              cursor: not-allowed;\n          "]))) : "";
};
var TabRoot = styled79.div.withConfig(propsBlocker71)(_templateObject487 || (_templateObject487 = _taggedTemplateLiteral(["\n    &::after {\n        content: '';\n        height: 2px;\n        border-radius: ", ";\n        position: absolute;\n        transform: scaleX(0);\n        transition: transform ", "ms ease-out;\n        width: auto;\n        right: 0;\n        left: 0;\n    }\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), borderRadius7("sharp"), durationNormal13, getTabRootStyle, getComponentOverride55("Tab"), function (_ref154) {
  var disabled = _ref154.disabled;
  return focus8({
    disabled: disabled
  });
}, marginProps43);
var Wrapper7 = function Wrapper7(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(restProps);
};
var TabTagWrapper = styled79(Wrapper7).withConfig(propsBlocker71)(_templateObject488 || (_templateObject488 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"])), textDecorationNone, tabLabelContainerStyle);
var TabLabel = styled79.div(_templateObject489 || (_templateObject489 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    text-align: center;\n    display: flex;\n    padding: ", ";\n    &:hover {\n        color: ", ";\n    }\n    ", ";\n    ", ";\n    ", ";\n"])), typography39("labelLarge"), color38("neutral.11"), spacing58(1, 0), color38("primary.06"), tabLabelStyle, mouseCursor8, transition21({
  color: true
}));

// src/components/Tab/constants.ts
var TAB_CLASS_PREFIX = "Tab";

// src/components/Tab/hooks/useTab.ts
import { useCallback as useCallback29, useContext as useContext6 } from "react";

// src/components/Tabs/TabsContext.ts
import * as React107 from "react";
var TabsContext = React107.createContext({
  currentlyActiveTab: void 0,
  wide: void 0,
  handleClick: void 0
});
var TabsContext_default = TabsContext;

// src/components/Tab/hooks/useTab.ts
var useTab = function useTab(_a, ref) {
  var _b = _a,
    children = _b.children,
    disabled = _b.disabled,
    label = _b.label,
    tabIndex = _b.tabIndex,
    value = _b.value,
    _b$tag6 = _b.tag,
    Tag3 = _b$tag6 === void 0 ? "div" : _b$tag6,
    to = _b.to,
    href = _b.href,
    target = _b.target,
    rel = _b.rel,
    onClick = _b.onClick,
    restProps = __objRest(_b, ["children", "disabled", "label", "tabIndex", "value", "tag", "to", "href", "target", "rel", "onClick"]);
  var _useContext5 = useContext6(TabsContext_default),
    currentlyActiveTab = _useContext5.currentlyActiveTab,
    wide = _useContext5.wide,
    handleClick = _useContext5.handleClick;
  var matchingContentViewValue = typeof value !== "undefined" ? value : tabIndex;
  var isActive = currentlyActiveTab === tabIndex;
  var handleSelect = useCallback29(function (event) {
    if (!disabled && handleClick && tabIndex !== void 0) {
      handleClick(event, tabIndex, matchingContentViewValue);
    }
    onClick == null ? void 0 : onClick(event);
  }, [disabled, handleClick, tabIndex, onClick, matchingContentViewValue]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: ref,
      wide: wide,
      disabled: disabled,
      isActive: isActive,
      onClick: handleSelect,
      tabIndex: disabled ? -1 : 0
    }),
    tagProps: {
      to: disabled ? void 0 : to,
      href: disabled ? void 0 : href,
      target: disabled ? void 0 : target,
      rel: disabled ? void 0 : rel,
      disabled: disabled
    },
    tabLabelProps: {
      disabled: disabled,
      isActive: isActive,
      wide: wide
    },
    disabled: disabled,
    isActive: isActive,
    Tag: Tag3,
    label: label,
    children: children
  };
};

// src/components/Tab/Tab.tsx
var Tab = forwardRef62(function Tab2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var _useTab = useTab(restProps, ref),
    rootProps = _useTab.rootProps,
    tagProps = _useTab.tagProps,
    tabLabelProps = _useTab.tabLabelProps,
    disabled = _useTab.disabled,
    isActive = _useTab.isActive,
    Tag3 = _useTab.Tag,
    label = _useTab.label,
    children = _useTab.children;
  var classOverride = useTabClassName_default(TAB_CLASS_PREFIX, className, disabled, isActive);
  return /* @__PURE__ */React109.createElement(TabRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  }), /* @__PURE__ */React109.createElement(TabTagWrapper, __spreadProps(__spreadValues({}, tagProps), {
    className: classOverride.Tag
  }), function (forwardedProps) {
    return /* @__PURE__ */React109.createElement(Tag3, __spreadValues({}, forwardedProps), /* @__PURE__ */React109.createElement(TabLabel, __spreadProps(__spreadValues({}, tabLabelProps), {
      className: classOverride.Label
    }), label || children));
  }));
});
Tab.displayName = TAB_CLASS_PREFIX;
Tab.defaultProps = {
  disabled: false
};
Tab.propTypes = {
  disabled: PropTypes63.bool,
  wide: PropTypes63.bool,
  // handleClick: PropTypes.func,
  to: PropTypes63.string,
  tag: PropTypes63.oneOfType([PropTypes63.elementType, PropTypes63.string]),
  href: PropTypes63.string,
  // tabIndex: PropTypes.number, // TODO (nmelnikov 2020-07-21): we need to hide internal props from storybook docs
  value: PropTypes63.number
};
var MemoizedTab = memo80(Tab);

// src/components/Table/Table.tsx
import React111, { forwardRef as forwardRef63, memo as memo81 } from "react";
import PropTypes64 from "prop-types";

// src/components/Table/hooks/useTableClassNames.ts
import { useMemo as useMemo100 } from "react";
import { makeRootClassName as makeRootClassName46 } from "@deliveryhero/armor-system";
var useTableClassNames = function useTableClassNames(classPrefix, className) {
  return useMemo100(function () {
    var rootClassNames = makeRootClassName46(classPrefix, className);
    return {
      Root: rootClassNames
    };
  }, [classPrefix, className]);
};

// src/components/Table/style.ts
import styled80, { css as css59 } from "styled-components";
import { heightProps as heightProps6, marginProps as marginProps44, widthProps as widthProps18, propsBlocker as propsBlocker72, getComponentOverride as getComponentOverride56 } from "@deliveryhero/armor-system";
var getDynamicStyle2 = function getDynamicStyle2(_ref155) {
  var horizontalScroll = _ref155.horizontalScroll,
    enableFixedLayout = _ref155.enableFixedLayout;
  var result = css59(_templateObject490 || (_templateObject490 = _taggedTemplateLiteral([""])));
  if (horizontalScroll) {
    result = css59(_templateObject491 || (_templateObject491 = _taggedTemplateLiteral(["\n            ", ";\n            display: block;\n            overflow-x: auto;\n            white-space: nowrap;\n        "])), result);
  }
  if (enableFixedLayout) {
    result = css59(_templateObject492 || (_templateObject492 = _taggedTemplateLiteral(["\n            ", ";\n            table-layout: fixed;\n        "])), result);
  }
  return result;
};
var TableRoot = styled80.table.withConfig(propsBlocker72)(_templateObject493 || (_templateObject493 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    border-collapse: collapse;\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), getDynamicStyle2, getComponentOverride56("Table"), marginProps44, widthProps18, heightProps6);

// src/components/Table/constants.ts
var TABLE_CLASS_PREFIX = "Table";
var TABLE_THROTTLE_PERIOD = 200;
var TABLE_SORTING_DIRECTION_ASC = "asc";
var TABLE_SORTING_DIRECTION_DESC = "desc";
var tableRootTestId = "TableRoot";

// src/components/Table/utils/TableContext.ts
import React110 from "react";
var TableContext = React110.createContext({
  data: {
    stickyColumns: {}
  },
  update: function update() {}
});

// src/components/Table/hooks/useTable.ts
import { useCallback as useCallback30, useEffect as useEffect17, useMemo as useMemo101, useState as useState13 } from "react";
import { throttle } from "throttle-debounce";
import { useRootRef as useRootRef28, LEFT, RIGHT, getWindow as getWindow5 } from "@deliveryhero/armor-system";
var useTable = function useTable(_ref156, ref) {
  var stickyColumns = _ref156.stickyColumns,
    stickyHead = _ref156.stickyHead;
  var stickyColumnsInternal = useMemo101(function () {
    var result = {};
    if (!stickyColumns) {
      return result;
    }
    var maxLeftOffset = 0;
    var maxRightOffset = 0;
    var leftEdgeItemIndex;
    var rightEdgeItemIndex;
    for (var i = 0; i < stickyColumns.length; i += 1) {
      var index = stickyColumns[i].index;
      var item = __spreadProps(__spreadValues({}, stickyColumns[i]), {
        edge: false,
        offset: stickyColumns[i].offset || 0
      });
      if (item.alignment === LEFT && item.offset >= maxLeftOffset) {
        maxLeftOffset = item.offset;
        leftEdgeItemIndex = index;
      }
      if (item.alignment === RIGHT && item.offset >= maxRightOffset) {
        maxRightOffset = item.offset;
        rightEdgeItemIndex = index;
      }
      result = __spreadProps(__spreadValues({}, result), _defineProperty({}, index, item));
    }
    if (leftEdgeItemIndex !== void 0) {
      result[leftEdgeItemIndex].edge = true;
    }
    if (rightEdgeItemIndex !== void 0) {
      result[rightEdgeItemIndex].edge = true;
    }
    return result;
  }, [stickyColumns]);
  var _useState47 = useState13({
      data: {
        stickyColumns: stickyColumnsInternal,
        stickyHead: stickyHead
      },
      update: function update(data) {
        return setTableContextValue(data);
      }
    }),
    _useState48 = _slicedToArray(_useState47, 2),
    tableContextValue = _useState48[0],
    setTableContextValue = _useState48[1];
  var rootReference = useRootRef28(ref);
  var onLayoutUpdateImmediate = useCallback30(function () {
    if (!stickyColumns || !stickyColumns.length) {
      return;
    }
    if (rootReference.current) {
      var scrollLeft = rootReference.current.scrollLeft;
      var node = rootReference.current;
      var firstChild = node.children[0];
      if (!firstChild) {
        return;
      }
      var tableWidth = node.getBoundingClientRect().width;
      var firstChildWidth = firstChild.getBoundingClientRect().width;
      var differentLevelsLeft = scrollLeft > 0;
      var differentLevelsRight = Math.ceil(tableWidth + scrollLeft) < Math.ceil(firstChildWidth);
      var _tableContextValue$da = tableContextValue.data,
        stickyLeftColumnVisible = _tableContextValue$da.stickyLeftColumnVisible,
        stickyRightColumnVisible = _tableContextValue$da.stickyRightColumnVisible;
      if (stickyRightColumnVisible !== differentLevelsRight || stickyLeftColumnVisible !== differentLevelsLeft) {
        setTableContextValue(__spreadProps(__spreadValues({}, tableContextValue), {
          data: __spreadProps(__spreadValues({}, tableContextValue.data), {
            stickyLeftColumnVisible: differentLevelsLeft,
            stickyRightColumnVisible: differentLevelsRight
          })
        }));
      }
    }
  }, [rootReference, stickyColumns, tableContextValue]);
  var onLayoutUpdate = useCallback30(throttle(TABLE_THROTTLE_PERIOD, false, onLayoutUpdateImmediate), [onLayoutUpdateImmediate]);
  useEffect17(function () {
    onLayoutUpdateImmediate();
    var win2 = getWindow5();
    if (win2) {
      win2.addEventListener("resize", onLayoutUpdate);
    }
    return function () {
      if (win2) {
        win2.removeEventListener("resize", onLayoutUpdate);
      }
    };
  }, [onLayoutUpdate, onLayoutUpdateImmediate]);
  return {
    tableContextValue: tableContextValue,
    rootReference: rootReference,
    onLayoutUpdate: onLayoutUpdate
  };
};

// src/components/Table/Table.tsx
var Table = forwardRef63(function Table2(_a, ref) {
  var _b = _a,
    className = _b.className,
    stickyColumns = _b.stickyColumns,
    stickyHead = _b.stickyHead,
    restProps = __objRest(_b, ["className", "stickyColumns", "stickyHead"]);
  var classNameComponents = useTableClassNames(TABLE_CLASS_PREFIX, className);
  var _useTable = useTable({
      stickyColumns: stickyColumns,
      stickyHead: stickyHead
    }, ref),
    tableContextValue = _useTable.tableContextValue,
    rootReference = _useTable.rootReference,
    onLayoutUpdate = _useTable.onLayoutUpdate;
  return /* @__PURE__ */React111.createElement(TableContext.Provider, {
    value: tableContextValue
  }, /* @__PURE__ */React111.createElement(TableRoot, __spreadProps(__spreadValues({
    "data-testid": tableRootTestId
  }, restProps), {
    className: classNameComponents.Root,
    ref: rootReference,
    cellPadding: "0",
    cellSpacing: "0",
    onScroll: onLayoutUpdate
  })));
});
Table.defaultProps = {
  horizontalScroll: false,
  stickyHead: false,
  enableFixedLayout: true
};
Table.propTypes = {
  horizontalScroll: PropTypes64.bool,
  stickyHead: PropTypes64.bool
};
var MemoizedTable = memo81(Table);

// src/components/Table/TableAction/TableAction.tsx
import React112, { forwardRef as forwardRef64, memo as memo82 } from "react";

// src/components/Table/TableAction/hooks/useTableActionClassNames.ts
import { useMemo as useMemo102 } from "react";
import { makeRootClassName as makeRootClassName47 } from "@deliveryhero/armor-system";
var useTableActionClassNames = function useTableActionClassNames(classPrefix, className) {
  return useMemo102(function () {
    var rootClassNames = makeRootClassName47(classPrefix, className);
    return {
      Root: rootClassNames
    };
  }, [classPrefix, className]);
};

// src/components/Table/TableAction/style.ts
import styled81 from "styled-components";
import { marginProps as marginProps45, paddingProps as paddingProps17, propsBlocker as propsBlocker73, durationNormal as durationNormal14, token as token54, color as color39, getComponentOverride as getComponentOverride57 } from "@deliveryhero/armor-system";
var TableActionRoot = styled81.div.withConfig(propsBlocker73)(_templateObject494 || (_templateObject494 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    transition: color ", "ms ease;\n    cursor: pointer;\n    font-family: ", ";\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n    ", ";\n    ", ";\n    ", ";\n"])), durationNormal14, token54("typography.body.fontFamily"), color39("neutral.07"), color39("primary.main"), getComponentOverride57("TableAction"), marginProps45, paddingProps17);

// src/components/Table/TableAction/constants.ts
var TABLE_ACTION_CLASS_PREFIX = "TableAction";
var tableActionRootTestId = "TableActionRoot";

// src/components/Table/TableAction/TableAction.tsx
var TableAction = forwardRef64(function TableAction2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useTableActionClassNames(TABLE_ACTION_CLASS_PREFIX, className);
  return /* @__PURE__ */React112.createElement(TableActionRoot, __spreadProps(__spreadValues({
    "data-testid": tableActionRootTestId
  }, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }));
});
TableAction.defaultProps = {};
TableAction.propTypes = {};
var MemoizedTableAction = memo82(TableAction);

// src/components/Table/TableBody/TableBody.tsx
import React113, { forwardRef as forwardRef65, memo as memo83 } from "react";

// src/components/Table/TableBody/hooks/useTableBodyClassNames.ts
import { useMemo as useMemo103 } from "react";
import { makeRootClassName as makeRootClassName48 } from "@deliveryhero/armor-system";
var useTableBodyClassNames = function useTableBodyClassNames(classPrefix, className) {
  return useMemo103(function () {
    var rootClassNames = makeRootClassName48(classPrefix, className);
    return {
      Root: rootClassNames
    };
  }, [classPrefix, className]);
};

// src/components/Table/TableBody/style.ts
import styled82 from "styled-components";
import { getComponentOverride as getComponentOverride58, propsBlocker as propsBlocker74 } from "@deliveryhero/armor-system";
var TableBodyRoot = styled82.tbody.withConfig(propsBlocker74)(_templateObject495 || (_templateObject495 = _taggedTemplateLiteral(["\n    ", ";\n"])), getComponentOverride58("TableBody"));

// src/components/Table/TableBody/constants.ts
var TABLE_BODY_CLASS_PREFIX = "TableBody";
var tableBodyRootTestId = "TableBodyRoot";

// src/components/Table/TableBody/TableBody.tsx
var TableBody = forwardRef65(function TableBody2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useTableBodyClassNames(TABLE_BODY_CLASS_PREFIX, className);
  return /* @__PURE__ */React113.createElement(TableBodyRoot, __spreadProps(__spreadValues({
    "data-testid": tableBodyRootTestId
  }, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }));
});
TableBody.defaultProps = {};
TableBody.propTypes = {};
var MemoizedTableBody = memo83(TableBody);

// src/components/Table/TableCell/TableCell.tsx
import React115, { forwardRef as forwardRef67, memo as memo85 } from "react";
import PropTypes65 from "prop-types";

// src/components/Table/TableCell/hooks/useTableCellClassNames.ts
import { useMemo as useMemo104 } from "react";
import { makeRootClassName as makeRootClassName49 } from "@deliveryhero/armor-system";
import capitalize from "lodash/capitalize";
var useTableCellClassNames = function useTableCellClassNames(classPrefix, className, stickyAlignment, stickyVisible, stickyTop) {
  return useMemo104(function () {
    var rootClassNames = makeRootClassName49(classPrefix, className);
    var makeRootModifier = function makeRootModifier(modifier) {
      return "".concat(rootClassNames, "--").concat(modifier);
    };
    return {
      Root: [rootClassNames, stickyAlignment && makeRootModifier("sticky"), stickyAlignment && makeRootModifier("sticky".concat(capitalize(stickyAlignment), "Column")), stickyVisible && makeRootModifier("stickyVisible"), stickyTop && makeRootModifier("stickyTop")].filter(Boolean).join(" ")
    };
  }, [classPrefix, className, stickyAlignment, stickyVisible, stickyTop]);
};

// src/components/Table/TableCell/style.ts
import styled83, { css as css60 } from "styled-components";
import { colorProps as colorProps5, heightProps as heightProps7, paddingProps as paddingProps18, widthProps as widthProps19, color as color40, spacing as spacing59, typography as typography40, propsBlocker as propsBlocker75, getComponentOverride as getComponentOverride59, ellipsis as ellipsisCSS, LEFT as LEFT2, RIGHT as RIGHT2, zIndexTableHeader as zIndexTableHeader2, durationNormal as durationNormal15, token as token55, transition as transition22 } from "@deliveryhero/armor-system";
var getRootStyle19 = function getRootStyle19(_ref157) {
  var isHeader = _ref157.isHeader,
    stickyTop = _ref157.stickyTop,
    stickyVisible = _ref157.stickyVisible,
    stickyAlignment = _ref157.stickyAlignment,
    stickyOffset = _ref157.stickyOffset,
    stickyShadowVisible = _ref157.stickyShadowVisible,
    disabled = _ref157.disabled,
    ellipsis2 = _ref157.ellipsis,
    enableContentWordBreak = _ref157.enableContentWordBreak,
    enableContentWrap = _ref157.enableContentWrap,
    emptyText = _ref157.emptyText,
    withControls = _ref157.withControls;
  var result = {};
  if (isHeader) {
    result = css60(_templateObject496 || (_templateObject496 = _taggedTemplateLiteral(["\n            ", ";\n            vertical-align: middle;\n            ", ";\n            color: ", ";\n            padding: ", ";\n        "])), result, typography40("labelMedium"), token55("body.color"), spacing59(4));
  }
  if (stickyTop) {
    result = css60(_templateObject497 || (_templateObject497 = _taggedTemplateLiteral(["\n            ", ";\n            position: sticky;\n            z-index: ", ";\n            top: 0;\n            background-color: ", ";\n\n            &::after {\n                ", ";\n                position: absolute;\n                bottom: -50px;\n                left: 0;\n                right: 0;\n                height: 50px;\n                background-color: transparent;\n                pointer-events: none;\n                border-top-width: 1px;\n                border-top-style: solid;\n                border-color: transparent;\n                transition: box-shadow ", "ms ease;\n            }\n        "])), result, zIndexTableHeader2, color40("neutral.00"), stickyShadowVisible ? "content: ''" : "", durationNormal15);
    if (stickyVisible) {
      result = css60(_templateObject498 || (_templateObject498 = _taggedTemplateLiteral(["\n                ", ";\n                background-color: ", ";\n\n                &::after {\n                    border-color: ", ";\n                    box-shadow: inset 0 10px 5px -5px rgba(0, 0, 0, 0.08);\n                }\n            "])), result, color40("neutral.00"), color40("neutral.03"));
    }
  }
  if (!stickyTop && stickyAlignment === LEFT2) {
    result = css60(_templateObject499 || (_templateObject499 = _taggedTemplateLiteral(["\n            ", ";\n            position: sticky;\n            ", ": ", "px;\n            background-color: ", ";\n\n            &::after {\n                ", ";\n                position: absolute;\n                right: -50px;\n                top: 0;\n                bottom: 0;\n                width: 50px;\n                background-color: transparent;\n                pointer-events: none;\n                border-left-width: 1px;\n                border-left-style: solid;\n                border-color: transparent;\n                transition: box-shadow ", "ms ease,\n                    border-color ", "ms ease;\n            }\n        "])), result, stickyAlignment, stickyOffset, color40("neutral.00"), stickyShadowVisible ? "content: ''" : "", durationNormal15, durationNormal15);
    if (stickyVisible) {
      result = css60(_templateObject500 || (_templateObject500 = _taggedTemplateLiteral(["\n                ", ";\n                background-color: ", ";\n\n                &::after {\n                    border-color: ", ";\n                    box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);\n                }\n            "])), result, color40("neutral.00"), color40("neutral.03"));
    }
  }
  if (!stickyTop && stickyAlignment === RIGHT2) {
    result = css60(_templateObject501 || (_templateObject501 = _taggedTemplateLiteral(["\n            ", ";\n            position: sticky;\n            ", ": ", "px;\n            background-color: ", ";\n\n            &::after {\n                ", ";\n                position: absolute;\n                left: -50px;\n                top: 0;\n                bottom: 0;\n                width: 50px;\n                background-color: transparent;\n                pointer-events: none;\n                border-right-width: 1px;\n                border-right-style: solid;\n                border-color: transparent;\n                transition: box-shadow ", "ms ease,\n                    border-color ", "ms ease;\n            }\n\n            &::before {\n                content: '';\n                display: none;\n                z-index: -1;\n                position: absolute;\n                left: 0;\n                top: 0;\n                bottom: 0;\n                right: 0;\n                background-color: ", ";\n                transition: background-color ", "ms ease;\n            }\n\n            .TableRow--hovered &:not(th)::before {\n                background-color: ", ";\n            }\n        "])), result, stickyAlignment, stickyOffset, color40("neutral.00"), stickyShadowVisible ? "content: ''" : "", durationNormal15, durationNormal15, color40("neutral.00"), durationNormal15, color40("primary.01"));
    if (stickyVisible) {
      result = css60(_templateObject502 || (_templateObject502 = _taggedTemplateLiteral(["\n                ", ";\n                background-color: ", ";\n\n                &::after {\n                    border-color: ", ";\n                    box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);\n                }\n\n                &::before {\n                    display: block;\n                }\n            "])), result, color40("neutral.00"), color40("neutral.03"));
    }
  }
  if (disabled) {
    result = css60(_templateObject503 || (_templateObject503 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: not-allowed;\n            background-color: ", ";\n            color: ", ";\n\n            &:hover {\n                background-color: ", ";\n            }\n        "])), result, color40("neutral.02"), color40("neutral.05"), color40("neutral.02"));
  }
  if (ellipsis2) {
    result = css60(_templateObject504 || (_templateObject504 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n        "])), result, ellipsisCSS);
  }
  if (enableContentWordBreak) {
    result = css60(_templateObject505 || (_templateObject505 = _taggedTemplateLiteral(["\n            ", ";\n            word-break: break-word;\n            overflow-wrap: break-word;\n        "])), result);
  }
  if (!enableContentWrap) {
    result = css60(_templateObject506 || (_templateObject506 = _taggedTemplateLiteral(["\n            ", ";\n            white-space: nowrap;\n        "])), result);
  }
  if (emptyText) {
    result = css60(_templateObject507 || (_templateObject507 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            color: ", ";\n        "])), result, typography40("paragraphMedium"), color40("neutral.05"));
  }
  if (withControls) {
    result = css60(_templateObject508 || (_templateObject508 = _taggedTemplateLiteral(["\n            ", ";\n            padding: ", ";\n        "])), result, spacing59(3, 4));
  }
  return result;
};
var contentAlignYToVerticalAlign = function contentAlignYToVerticalAlign(align) {
  return align === "center" ? "middle" : align;
};
var tableCellContentAlignment = function tableCellContentAlignment(_ref158) {
  var contentAlignX = _ref158.contentAlignX,
    contentAlignY = _ref158.contentAlignY;
  return css60(_templateObject509 || (_templateObject509 = _taggedTemplateLiteral(["\n        ", "\n        ", "\n    "])), contentAlignX ? "text-align: ".concat(contentAlignX, ";") : "", contentAlignY ? "vertical-align: ".concat(contentAlignYToVerticalAlign(contentAlignY), ";") : "");
};
var Wrapper8 = function Wrapper8(_a) {
  var _b = _a,
    children = _b.children,
    restProps = __objRest(_b, ["children"]);
  return children(__spreadValues({}, restProps));
};
var TableCellRoot = styled83(Wrapper8).withConfig(propsBlocker75)(_templateObject510 || (_templateObject510 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    text-align: left;\n    vertical-align: top;\n    ", ";\n    ", ";\n    color: ", ";\n    padding: ", ";\n    background-clip: padding-box;\n\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), transition22({
  "background-color": true
}), typography40("paragraphLarge"), token55("body.color"), spacing59(5, 4), getRootStyle19, getComponentOverride59("TableCell"), paddingProps18, widthProps19, heightProps7, colorProps5, tableCellContentAlignment);

// src/components/Table/TableCell/constants.ts
var TABLE_CELL_CLASS_PREFIX = "TableCell";
var tableCellRootTestId = "TableCellRoot";

// src/components/Table/TableCell/hooks/useTableCell.ts
var useTableCell = function useTableCell(_a) {
  var _b = _a,
    isHeader = _b.isHeader,
    maxLines = _b.maxLines,
    emptyText = _b.emptyText,
    restProps = __objRest(_b, ["isHeader", "maxLines", "emptyText"]);
  var tagName = isHeader ? "th" : "td";
  return {
    rootProps: __spreadProps(__spreadValues({
      "data-testid": tableCellRootTestId
    }, restProps), {
      isHeader: isHeader,
      emptyText: emptyText
    }),
    Tag: tagName,
    isShowTruncatedText: Boolean(maxLines),
    truncatedTextProps: {
      truncated: true,
      numOfLines: maxLines,
      typographyProps: {
        paragraph: true,
        large: true
      }
    }
  };
};

// src/components/MultilineTruncateParagraph/MultilineTruncateParagraph.tsx
import React114, { forwardRef as forwardRef66, memo as memo84 } from "react";

// src/components/MultilineTruncateParagraph/hooks/useMultilineTruncateParagraphClassNames.ts
import { useMemo as useMemo105 } from "react";
import { makeRootClassName as makeRootClassName50, makeBEM as makeBEM61 } from "@deliveryhero/armor-system";
var useMultilineTruncateParagraphClassNames = function useMultilineTruncateParagraphClassNames(classPrefix, className, truncated) {
  return useMemo105(function () {
    return {
      Root: makeRootClassName50(classPrefix, className),
      TextContent: makeBEM61(classPrefix, "TextContent", truncated ? "truncated" : void 0)
    };
  }, [classPrefix, className, truncated]);
};

// src/components/MultilineTruncateParagraph/hooks/useMultilineTruncateParagraph.ts
import { useState as useState14, useRef as useRef11, useCallback as useCallback31, useEffect as useEffect18 } from "react";
import { useRootRef as useRootRef29, useWindowSize, stripHTMLTagsMemoized as stripHTMLTags5 } from "@deliveryhero/armor-system";

// src/components/MultilineTruncateParagraph/constants.ts
var MULTILINETRUNCATEPARAGRAPH_CLASS_PREFIX = "MultilineTruncateParagraph";
var DEFAULT_NUM_OF_LINES = 3;

// src/components/MultilineTruncateParagraph/hooks/useMultilineTruncateParagraph.ts
var useMultilineTruncateParagraph = function useMultilineTruncateParagraph(_a, ref) {
  var _b = _a,
    _b$typographyProps = _b.typographyProps,
    typographyProps = _b$typographyProps === void 0 ? {
      paragraph: true,
      medium: true
    } : _b$typographyProps,
    _b$numOfLines = _b.numOfLines,
    numOfLines = _b$numOfLines === void 0 ? DEFAULT_NUM_OF_LINES : _b$numOfLines,
    truncated = _b.truncated,
    onChangeOverflow = _b.onChangeOverflow,
    children = _b.children,
    restProps = __objRest(_b, ["typographyProps", "numOfLines", "truncated", "onChangeOverflow", "children"]);
  var innerRef = useRootRef29(ref);
  var _useState49 = useState14(false),
    _useState50 = _slicedToArray(_useState49, 2),
    isOverFlow = _useState50[0],
    setOverflow = _useState50[1];
  var textRef = useRef11(null);
  var windowSize = useWindowSize();
  var processTruncateText = useCallback31(function (node) {
    if (!children || !node) {
      return;
    }
    var rootText = stripHTMLTags5(children);
    var words = rootText.split(" ");
    node.textContent = words[0];
    var maxHeight = node.clientHeight * numOfLines;
    var truncatedStr = "";
    var overflow = words.some(function (word) {
      var prevStr = truncatedStr;
      truncatedStr = truncatedStr ? "".concat(truncatedStr, " ").concat(word) : word;
      node.textContent = truncatedStr;
      if (node.clientHeight > maxHeight) {
        node.textContent = "".concat(prevStr, "...");
        if (node.clientHeight > maxHeight) {
          node.textContent = "".concat(prevStr.substring(0, prevStr.length - 4), "...");
        }
        return true;
      }
      return false;
    });
    setOverflow(function (prevState) {
      return prevState || overflow;
    });
  }, [children, numOfLines]);
  useEffect18(function () {
    onChangeOverflow == null ? void 0 : onChangeOverflow(isOverFlow);
  }, [isOverFlow, onChangeOverflow]);
  useEffect18(function () {
    if (textRef.current && truncated) {
      processTruncateText(textRef.current);
    }
  }, [truncated, windowSize, numOfLines, processTruncateText]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: innerRef
    }),
    typographyProps: typographyProps,
    truncated: truncated,
    textRef: textRef,
    children: children
  };
};

// src/components/MultilineTruncateParagraph/style.ts
import styled84 from "styled-components";
import { marginProps as marginProps46, propsBlocker as propsBlocker76, getComponentOverride as getComponentOverride60, reset as reset24, typography as typography41, token as token56 } from "@deliveryhero/armor-system";
var MultilineTruncateParagraphRoot = styled84.div.withConfig(propsBlocker76)(_templateObject511 || (_templateObject511 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    ", ";\n    ", ";\n"])), reset24, typography41("paragraphMedium"), token56("body.color"), getComponentOverride60("MultilineTruncateParagraph"), marginProps46);

// src/components/MultilineTruncateParagraph/MultilineTruncateParagraph.tsx
var MultilineTruncateParagraph = forwardRef66(function MultilineTruncateParagraph2(props, ref) {
  var _a = props,
    className = _a.className,
    restProps = __objRest(_a, ["className"]);
  var _useMultilineTruncate = useMultilineTruncateParagraph(restProps, ref),
    rootProps = _useMultilineTruncate.rootProps,
    truncated = _useMultilineTruncate.truncated,
    textRef = _useMultilineTruncate.textRef,
    children = _useMultilineTruncate.children,
    typographyProps = _useMultilineTruncate.typographyProps;
  var classNames = useMultilineTruncateParagraphClassNames(MULTILINETRUNCATEPARAGRAPH_CLASS_PREFIX, className, truncated);
  return /* @__PURE__ */React114.createElement(MultilineTruncateParagraphRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), truncated && /* @__PURE__ */React114.createElement(Typography, __spreadProps(__spreadValues({}, typographyProps), {
    ref: textRef,
    className: classNames.TextContent,
    "data-testid": "truncatedTextId",
    margin: 0
  }), children), !truncated && /* @__PURE__ */React114.createElement(Typography, __spreadProps(__spreadValues({}, typographyProps), {
    className: classNames.TextContent,
    margin: 0
  }), children));
});
MultilineTruncateParagraph.displayName = "MultilineTruncateParagraph";
var MemoizedMultilineTruncateParagraph = memo84(MultilineTruncateParagraph);

// src/components/Table/TableCell/TableCell.tsx
var TableCell = forwardRef67(function TableCell2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var stickyAlignment = restProps.stickyAlignment,
    stickyVisible = restProps.stickyVisible,
    stickyTop = restProps.stickyTop;
  var classNameComponents = useTableCellClassNames(TABLE_CELL_CLASS_PREFIX, className, stickyAlignment, stickyVisible, stickyTop);
  var _useTableCell = useTableCell(restProps),
    rootProps = _useTableCell.rootProps,
    Tag3 = _useTableCell.Tag,
    isShowTruncatedText = _useTableCell.isShowTruncatedText,
    truncatedTextProps = _useTableCell.truncatedTextProps;
  var emptyText = rootProps.emptyText;
  return /* @__PURE__ */React115.createElement(TableCellRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root
  }), function (forwardedProps) {
    return /* @__PURE__ */React115.createElement(Tag3, __spreadProps(__spreadValues({}, forwardedProps), {
      ref: ref
    }), isShowTruncatedText ? /* @__PURE__ */React115.createElement(MultilineTruncateParagraph, __spreadValues({}, truncatedTextProps), emptyText || children) : emptyText || children);
  });
});
TableCell.defaultProps = {
  stickyTop: false,
  stickyShadowVisible: true,
  stickyOffset: 0,
  isHeader: false,
  disabled: false,
  ellipsis: false,
  enableContentWordBreak: true,
  enableContentWrap: true,
  withControls: false
};
TableCell.propTypes = {
  isHeader: PropTypes65.bool,
  stickyTop: PropTypes65.bool,
  stickyVisible: PropTypes65.bool,
  stickyShadowVisible: PropTypes65.bool,
  disabled: PropTypes65.bool,
  ellipsis: PropTypes65.bool,
  emptyText: PropTypes65.string,
  withControls: PropTypes65.bool
};
var MemoizedTableCell = memo85(TableCell);

// src/components/Table/TableCellLabel/TableCellLabel.tsx
import React116, { forwardRef as forwardRef68, memo as memo86 } from "react";

// src/components/Table/TableCellLabel/hooks/useTableCellLabelClassNames.ts
import { useMemo as useMemo106 } from "react";
import { makeRootClassName as makeRootClassName51 } from "@deliveryhero/armor-system";
var useTableCellLabelClassNames = function useTableCellLabelClassNames(classPrefix, className) {
  return useMemo106(function () {
    var rootClassNames = makeRootClassName51(classPrefix, className);
    return {
      Root: rootClassNames
    };
  }, [classPrefix, className]);
};

// src/components/Table/TableCellLabel/style.ts
import styled85 from "styled-components";
import { marginProps as marginProps47, propsBlocker as propsBlocker77, token as token57 } from "@deliveryhero/armor-system";
var TableCellLabelRoot = styled85.div.withConfig(propsBlocker77)(_templateObject512 || (_templateObject512 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: inline-flex;\n    justify-content: flex-start;\n    align-items: center;\n    font-family: ", ";\n    ", ";\n"])), token57("typography.body.fontFamily"), marginProps47);

// src/components/Table/TableCellLabel/constants.ts
var TABLE_CELL_LABEL_CLASS_PREFIX = "TableCellLabel";
var tableCellLabelRootTestId = "TableCellLabelRoot";

// src/components/Table/TableCellLabel/TableCellLabel.tsx
var TableCellLabel = forwardRef68(function TableCellLabel2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useTableCellLabelClassNames(TABLE_CELL_LABEL_CLASS_PREFIX, className);
  return /* @__PURE__ */React116.createElement(TableCellLabelRoot, __spreadProps(__spreadValues({
    "data-testid": tableCellLabelRootTestId
  }, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }));
});
TableCellLabel.defaultProps = {};
TableCellLabel.propTypes = {};
var MemoizedTableCellLabel = memo86(TableCellLabel);

// src/components/Table/TableCheckboxCell/TableCheckboxCell.tsx
import React117, { forwardRef as forwardRef69, memo as memo87 } from "react";

// src/components/Table/TableCheckboxCell/hooks/useTableCheckboxCellClassNames.ts
import { useMemo as useMemo107 } from "react";
import { makeRootClassName as makeRootClassName52 } from "@deliveryhero/armor-system";
var useTableCheckboxCellClassNames = function useTableCheckboxCellClassNames(classPrefix, className) {
  return useMemo107(function () {
    var rootClassNames = makeRootClassName52(classPrefix, className);
    return {
      Root: rootClassNames
    };
  }, [classPrefix, className]);
};

// src/components/Table/TableCheckboxCell/style.ts
import styled86 from "styled-components";
import { color as color41, getComponentOverride as getComponentOverride61, spacing as spacing60 } from "@deliveryhero/armor-system";

// src/components/Table/TableCheckboxCell/constants.ts
var TABLE_CHECKBOX_CELL_CLASS_PREFIX = "TableCheckboxCell";
var tableCheckboxCellRootTestId = "TableCheckboxCellRoot";
var TABLE_CHECKBOX_CELL_WIDTH = 48;

// src/components/Table/TableCheckboxCell/style.ts
var TableCheckboxCellRoot = styled86(TableCell)(_templateObject513 || (_templateObject513 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    width: ", "px;\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    & + .TableCell-Root {\n        padding-left: ", ";\n    }\n\n    ", ";\n"])), TABLE_CHECKBOX_CELL_WIDTH, color41("primary.lightest"), spacing60(2), getComponentOverride61("TableCheckboxCell"));
var TableCheckboxCellCheckbox = styled86(Checkbox)(_templateObject514 || (_templateObject514 = _taggedTemplateLiteral(["\n    display: block;\n    margin-top: ", ";\n"])), spacing60(0.5));

// src/components/Table/TableCheckboxCell/hooks/useTableCheckboxCell.ts
import { useCallback as useCallback32 } from "react";
var useTableCheckboxCell = function useTableCheckboxCell(_a, ref) {
  var _b = _a,
    checked = _b.checked,
    checkedIcon = _b.checkedIcon,
    isHeader = _b.isHeader,
    restProps = __objRest(_b, ["checked", "checkedIcon", "isHeader"]);
  var onCheckboxClick = useCallback32(function (e) {
    return e.preventDefault();
  }, []);
  return {
    rootProps: __spreadProps(__spreadValues({
      "data-testid": tableCheckboxCellRootTestId
    }, restProps), {
      contentAlignX: "center",
      ref: ref,
      isHeader: isHeader
    }),
    checkboxProps: {
      checked: checked,
      checkedIcon: checkedIcon,
      onClick: onCheckboxClick
    }
  };
};

// src/components/Table/TableCheckboxCell/TableCheckboxCell.tsx
var TableCheckboxCell = forwardRef69(function TableCheckboxCell2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNameComponents = useTableCheckboxCellClassNames(TABLE_CHECKBOX_CELL_CLASS_PREFIX, className);
  var _useTableCheckboxCell = useTableCheckboxCell(props, ref),
    rootProps = _useTableCheckboxCell.rootProps,
    checkboxProps = _useTableCheckboxCell.checkboxProps;
  return /* @__PURE__ */React117.createElement(TableCheckboxCellRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root
  }), /* @__PURE__ */React117.createElement(TableCheckboxCellCheckbox, __spreadValues({}, checkboxProps)));
});
TableCheckboxCell.defaultProps = {};
TableCheckboxCell.propTypes = {};
var MemoizedTableCheckboxCell = memo87(TableCheckboxCell);

// src/components/Table/TableFoot/TableFoot.tsx
import React119, { forwardRef as forwardRef70, memo as memo88 } from "react";

// src/components/Table/utils/TableSectionContext.ts
import React118 from "react";
var TABLE_HEAD = "thead";
var TABLE_FOOT = "tfoot";
var TableSectionContext = React118.createContext({
  data: {}
});

// src/components/Table/TableFoot/hooks/useTableFoot.ts
import { useState as useState15 } from "react";
var useTableFoot = function useTableFoot() {
  var _useState51 = useState15({
      data: {
        section: TABLE_FOOT
      }
    }),
    _useState52 = _slicedToArray(_useState51, 1),
    tableSectionContextValue = _useState52[0];
  return {
    tableSectionContextValue: tableSectionContextValue
  };
};

// src/components/Table/TableFoot/hooks/useTableFootClassNames.ts
import { useMemo as useMemo108 } from "react";
import { makeRootClassName as makeRootClassName53 } from "@deliveryhero/armor-system";
var useTableFootClassNames = function useTableFootClassNames(classPrefix, className) {
  return useMemo108(function () {
    var rootClassNames = makeRootClassName53(classPrefix, className);
    return {
      Root: rootClassNames
    };
  }, [classPrefix, className]);
};

// src/components/Table/TableFoot/style.ts
import styled87 from "styled-components";
import { getComponentOverride as getComponentOverride62, propsBlocker as propsBlocker78 } from "@deliveryhero/armor-system";
var TableFootRoot = styled87.tfoot.withConfig(propsBlocker78)(_templateObject515 || (_templateObject515 = _taggedTemplateLiteral(["\n    ", ";\n"])), getComponentOverride62("TableFoot"));

// src/components/Table/TableFoot/constants.ts
var TABLE_FOOT_CLASS_PREFIX = "TableFoot";
var tableFootRootTestId = "TableFootRoot";

// src/components/Table/TableFoot/TableFoot.tsx
var TableFoot = forwardRef70(function TableFoot2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useTableFootClassNames(TABLE_FOOT_CLASS_PREFIX, className);
  var _useTableFoot = useTableFoot(),
    tableSectionContextValue = _useTableFoot.tableSectionContextValue;
  return /* @__PURE__ */React119.createElement(TableSectionContext.Provider, {
    value: tableSectionContextValue
  }, /* @__PURE__ */React119.createElement(TableFootRoot, __spreadProps(__spreadValues({
    "data-testid": tableFootRootTestId
  }, restProps), {
    className: classNameComponents.Root,
    ref: ref
  })));
});
TableFoot.defaultProps = {};
TableFoot.propTypes = {};
var MemoizedTableFoot = memo88(TableFoot);

// src/components/Table/TableHead/TableHead.tsx
import React120, { forwardRef as forwardRef71, memo as memo89 } from "react";

// src/components/Table/TableHead/hooks/useTableHeadClassNames.ts
import { useMemo as useMemo109 } from "react";
import { makeRootClassName as makeRootClassName54 } from "@deliveryhero/armor-system";
var useTableHeadClassNames = function useTableHeadClassNames(classPrefix, className) {
  return useMemo109(function () {
    var rootClassNames = makeRootClassName54(classPrefix, className);
    return {
      Root: rootClassNames
    };
  }, [classPrefix, className]);
};

// src/components/Table/TableHead/style.ts
import styled88 from "styled-components";
import { getComponentOverride as getComponentOverride63, propsBlocker as propsBlocker79 } from "@deliveryhero/armor-system";
var TableHeadRoot = styled88.thead.withConfig(propsBlocker79)(_templateObject516 || (_templateObject516 = _taggedTemplateLiteral(["\n    ", ";\n\n    & > tr {\n        border-bottom: none;\n    }\n"])), getComponentOverride63("TableHead"));

// src/components/Table/TableHead/constants.ts
var TABLE_HEAD_CLASS_PREFIX = "TableHead";
var tableHeadRootTestId = "TableHeadRoot";

// src/components/Table/TableHead/hooks/useTableHead.ts
import { useEffect as useEffect19, useState as useState16, useCallback as useCallback33, useContext as useContext7 } from "react";
import { throttle as throttle2 } from "throttle-debounce";
import { useRootRef as useRootRef30, getWindow as getWindow6 } from "@deliveryhero/armor-system";
var useTableHead = function useTableHead(props, ref) {
  var tableContextValue = useContext7(TableContext);
  var stickyHead = tableContextValue.data.stickyHead,
    updateTableContext = tableContextValue.update;
  var _useState53 = useState16({
      data: {
        section: TABLE_HEAD
      }
    }),
    _useState54 = _slicedToArray(_useState53, 1),
    tableSectionContextValue = _useState54[0];
  var rootReference = useRootRef30(ref);
  var onLayoutUpdate = useCallback33(throttle2(TABLE_THROTTLE_PERIOD, false, function () {
    if (!stickyHead) {
      return;
    }
    if (rootReference.current) {
      var firstCell = rootReference.current.querySelector("th");
      if (!firstCell) {
        return;
      }
      var headerTop = rootReference.current.getBoundingClientRect().top;
      var cellTop = firstCell.getBoundingClientRect().top;
      var differentLevels = headerTop !== cellTop;
      if (tableContextValue.data.stickyHeadVisible !== differentLevels) {
        updateTableContext(__spreadProps(__spreadValues({}, tableContextValue), {
          data: __spreadProps(__spreadValues({}, tableContextValue.data), {
            stickyHeadVisible: differentLevels
          })
        }));
      }
    }
  }), [rootReference, stickyHead, tableContextValue, updateTableContext]);
  useEffect19(function () {
    var win2 = getWindow6();
    if (win2) {
      win2.addEventListener("resize", onLayoutUpdate);
      win2.addEventListener("scroll", onLayoutUpdate);
    }
    return function () {
      if (win2) {
        win2.removeEventListener("resize", onLayoutUpdate);
        win2.removeEventListener("scroll", onLayoutUpdate);
      }
    };
  }, [onLayoutUpdate]);
  return {
    tableSectionContextValue: tableSectionContextValue,
    rootReference: rootReference
  };
};

// src/components/Table/TableHead/TableHead.tsx
var TableHead = forwardRef71(function TableHead2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = useTableHeadClassNames(TABLE_HEAD_CLASS_PREFIX, className);
  var _useTableHead = useTableHead({}, ref),
    tableSectionContextValue = _useTableHead.tableSectionContextValue,
    rootReference = _useTableHead.rootReference;
  return /* @__PURE__ */React120.createElement(TableSectionContext.Provider, {
    value: tableSectionContextValue
  }, /* @__PURE__ */React120.createElement(TableHeadRoot, __spreadProps(__spreadValues({
    "data-testid": tableHeadRootTestId
  }, restProps), {
    className: classNameComponents.Root,
    ref: rootReference
  })));
});
TableHead.defaultProps = {};
TableHead.propTypes = {};
var MemoizedTableHead = memo89(TableHead);

// src/components/Table/TableHeadCell/TableHeadCell.tsx
import React121, { forwardRef as forwardRef72, memo as memo90 } from "react";
import { SortAlphabetIcon, SortNumberIcon, ArrowUpTailIcon, ArrowDownTailIcon } from "@deliveryhero/armor-icons";
import PropTypes66 from "prop-types";

// src/components/Table/TableHeadCell/hooks/useTableHeadCellClassNames.ts
import { useMemo as useMemo110 } from "react";
import { makeBEM as makeBEM62, makeRootClassName as makeRootClassName55 } from "@deliveryhero/armor-system";
var useTableHeadCellClassNames = function useTableHeadCellClassNames(classPrefix, className) {
  return useMemo110(function () {
    var rootClassNames = makeRootClassName55(classPrefix, className);
    return {
      Root: rootClassNames,
      AlphabeticalIcon: makeBEM62(classPrefix, "AlphabeticalIcon"),
      NumericalIcon: makeBEM62(classPrefix, "NumericalIcon"),
      ArrowUpIcon: makeBEM62(classPrefix, "ArrowUpIcon"),
      ArrowDownIcon: makeBEM62(classPrefix, "ArrowDownIcon")
    };
  }, [classPrefix, className]);
};

// src/components/Table/TableHeadCell/style.ts
import styled89, { css as css61 } from "styled-components";
import { color as color42, getComponentOverride as getComponentOverride64, makeBEM as makeBEM63, durationNormal as durationNormal16 } from "@deliveryhero/armor-system";

// src/components/Table/TableHeadCell/constants.ts
var TABLE_HEAD_CELL_CLASS_PREFIX = "TableHeadCell";
var TABLE_HEAD_CELL_SORTING_TYPE_NUMERICAL = "numerical";
var TABLE_HEAD_CELL_SORTING_TYPE_ALPHABETICAL = "alphabetical";
var tableHeadCellRootTestId = "TableHeadCellRoot";

// src/components/Table/TableHeadCell/style.ts
var getRootStyle20 = function getRootStyle20(_ref159) {
  var sortingEnabled = _ref159.sortingEnabled;
  var result = {};
  if (sortingEnabled) {
    result = css61(_templateObject517 || (_templateObject517 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: pointer;\n            user-select: none;\n        "])), result);
  }
  return result;
};
var alphabeticalIconClassName = makeBEM63(TABLE_HEAD_CELL_CLASS_PREFIX, "AlphabeticalIcon");
var numericalIconClassName = makeBEM63(TABLE_HEAD_CELL_CLASS_PREFIX, "NumericalIcon");
var TableHeadCellRoot = styled89(TableCell)(_templateObject518 || (_templateObject518 = _taggedTemplateLiteral(["\n    .", ", .", " {\n        opacity: 0;\n        transition: opacity ", "ms ease;\n    }\n    &:hover {\n        .", ", .", " {\n            opacity: 1;\n        }\n        background-color: ", ";\n    }\n\n    ", ";\n    ", ";\n"])), alphabeticalIconClassName, numericalIconClassName, durationNormal16, alphabeticalIconClassName, numericalIconClassName, color42("primary.lightest"), getRootStyle20, getComponentOverride64("TableHeadCell"));

// src/components/Table/TableHeadCell/hooks/useTableHeadCell.ts
import { useMemo as useMemo111 } from "react";
var useTableHeadCell = function useTableHeadCell(_a, ref) {
  var _b = _a,
    sortable = _b.sortable,
    columnId = _b.columnId,
    rowSortType = _b.rowSortType,
    rowSortOrder = _b.rowSortOrder,
    restProps = __objRest(_b, ["sortable", "columnId", "rowSortType", "rowSortOrder"]);
  var sortingEnabled = !!(sortable && columnId);
  var _useMemo6 = useMemo111(function () {
      if (!sortable || !rowSortOrder || !rowSortOrder.length) {
        return [false, false, false];
      }
      var isColumnSelected = rowSortOrder[0][0] === columnId;
      return [isColumnSelected, isColumnSelected && rowSortOrder[0][1] === TABLE_SORTING_DIRECTION_ASC, isColumnSelected && rowSortOrder[0][1] === TABLE_SORTING_DIRECTION_DESC];
    }, [sortable, rowSortOrder, columnId]),
    _useMemo7 = _slicedToArray(_useMemo6, 3),
    isSelected = _useMemo7[0],
    isAscending = _useMemo7[1],
    isDescending = _useMemo7[2];
  var isIconNumerical = !isSelected && rowSortType === TABLE_HEAD_CELL_SORTING_TYPE_NUMERICAL;
  var isIconAlphabetical = !isSelected && rowSortType !== TABLE_HEAD_CELL_SORTING_TYPE_NUMERICAL;
  var sortingIconProps = {
    marginLeft: 2
  };
  return {
    rootProps: __spreadProps(__spreadValues({
      "data-testid": tableHeadCellRootTestId,
      enableContentWrap: false
    }, restProps), {
      columnId: columnId,
      ref: ref,
      sortingEnabled: sortingEnabled,
      "data-sortable": sortingEnabled ? "1" : "0"
    }),
    sortingIconProps: sortingIconProps,
    isSelected: isSelected,
    isIconNumerical: isIconNumerical,
    isIconAlphabetical: isIconAlphabetical,
    isAscending: isAscending,
    isDescending: isDescending
  };
};

// src/components/Table/TableHeadCell/TableHeadCell.tsx
var TableHeadCell = forwardRef72(function TableHeadCell2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var classNameComponents = useTableHeadCellClassNames(TABLE_HEAD_CELL_CLASS_PREFIX, className);
  var _useTableHeadCell = useTableHeadCell(props, ref),
    rootProps = _useTableHeadCell.rootProps,
    sortingIconProps = _useTableHeadCell.sortingIconProps,
    isAscending = _useTableHeadCell.isAscending,
    isDescending = _useTableHeadCell.isDescending,
    isIconAlphabetical = _useTableHeadCell.isIconAlphabetical,
    isIconNumerical = _useTableHeadCell.isIconNumerical;
  return /* @__PURE__ */React121.createElement(TableHeadCellRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root
  }), /* @__PURE__ */React121.createElement(TableCellLabel, null, children, isIconAlphabetical && /* @__PURE__ */React121.createElement(SortAlphabetIcon, __spreadProps(__spreadValues({}, sortingIconProps), {
    medium: true,
    className: classNameComponents.AlphabeticalIcon
  })), isIconNumerical && /* @__PURE__ */React121.createElement(SortNumberIcon, __spreadProps(__spreadValues({}, sortingIconProps), {
    medium: true,
    className: classNameComponents.NumericalIcon
  })), isAscending && /* @__PURE__ */React121.createElement(ArrowUpTailIcon, __spreadProps(__spreadValues({}, sortingIconProps), {
    small: true,
    className: classNameComponents.ArrowUpIcon
  })), isDescending && /* @__PURE__ */React121.createElement(ArrowDownTailIcon, __spreadProps(__spreadValues({}, sortingIconProps), {
    small: true,
    className: classNameComponents.ArrowDownIcon
  }))));
});
TableHeadCell.defaultProps = {
  sortable: false
};
TableHeadCell.propTypes = {
  sortable: PropTypes66.bool,
  columnId: PropTypes66.oneOfType([PropTypes66.number, PropTypes66.string]),
  rowSortType: PropTypes66.oneOf([TABLE_HEAD_CELL_SORTING_TYPE_NUMERICAL, TABLE_HEAD_CELL_SORTING_TYPE_ALPHABETICAL])
};
var MemoizedTableHeadCell = memo90(TableHeadCell);

// src/components/Table/TableRow/TableRow.tsx
import React123, { forwardRef as forwardRef73 } from "react";

// src/components/Table/TableRow/hooks/useTableRowClassNames.ts
import { useMemo as useMemo112 } from "react";
import { makeRootClassName as makeRootClassName56 } from "@deliveryhero/armor-system";

// src/helpers/joinClasses.ts
function joinClasses() {
  var classes = [];
  for (var i = 0; i < arguments.length; ++i) {
    var option = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (!option) continue;
    if (typeof option === "string") {
      classes.push(option);
    } else if (Array.isArray(option)) {
      var strClasses = joinClasses.apply(void 0, _toConsumableArray(option));
      if (strClasses) classes.push(strClasses);
    } else if (typeof option === "object") {
      if (option.toString !== Object.prototype.toString) {
        classes.push(option.toString());
      } else {
        for (var key in option) {
          if (Object.prototype.hasOwnProperty.call(option, key) && option[key]) {
            classes.push(key);
          }
        }
      }
    }
  }
  return classes.join(" ");
}

// src/components/Table/TableRow/hooks/useTableRowClassNames.ts
var useTableRowClassNames = function useTableRowClassNames(classPrefix, className, isHovered) {
  return useMemo112(function () {
    var rootClassNames = makeRootClassName56(classPrefix, className);
    var isHoveredClassName = isHovered ? "TableRow--hovered" : "";
    return {
      Root: joinClasses(rootClassNames, isHoveredClassName)
    };
  }, [classPrefix, className, isHovered]);
};

// src/components/Table/TableRow/style.ts
import styled90, { css as css62 } from "styled-components";
import { color as color43, heightProps as heightProps8, propsBlocker as propsBlocker80, getComponentOverride as getComponentOverride65 } from "@deliveryhero/armor-system";
var getRootDynamicStyle4 = function getRootDynamicStyle4(_ref160) {
  var isHeader = _ref160.isHeader,
    enableRowClick = _ref160.enableRowClick;
  var result = {};
  if (!isHeader) {
    result = css62(_templateObject519 || (_templateObject519 = _taggedTemplateLiteral(["\n            ", ";\n\n            &:hover td {\n                background-color: ", ";\n            }\n        "])), result, color43("primary.01"));
  }
  if (enableRowClick) {
    result = css62(_templateObject520 || (_templateObject520 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: pointer;\n\n            &:active td {\n                background-color: ", ";\n            }\n        "])), result, color43("primary.02"));
  }
  return result;
};
var TableRowRoot = styled90.tr.withConfig(propsBlocker80)(_templateObject521 || (_templateObject521 = _taggedTemplateLiteral(["\n    background-color: ", ";\n\n    &:not(:last-child) {\n        border-bottom: 1px solid ", ";\n    }\n\n    ", ";\n    ", ";\n    ", ";\n"])), color43("neutral.00"), color43("neutral.03"), getRootDynamicStyle4, getComponentOverride65("TableRow"), heightProps8);

// src/components/Table/TableRow/constants.ts
var TABLE_ROW_CLASS_PREFIX = "TableRow";
var tableRowRootTestId = "TableRowRoot";

// src/components/Table/TableRow/hooks/useTableRow.ts
import { useContext as useContext8 } from "react";
import mergeProps from "merge-props";

// src/components/Table/TableRow/hooks/useIsHovered.ts
import { useState as useState17 } from "react";
var useIsHovered = function useIsHovered() {
  var _useState55 = useState17(false),
    _useState56 = _slicedToArray(_useState55, 2),
    isHovered = _useState56[0],
    setIsHovered = _useState56[1];
  var onMouseEnter = function onMouseEnter() {
    setIsHovered(true);
  };
  var onMouseLeave = function onMouseLeave() {
    return setIsHovered(false);
  };
  return {
    isHovered: isHovered,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
};

// src/components/Table/TableRow/hooks/useTableRow.ts
var EMPTY_STICKY_COLUMNS = [];
var useTableRow = function useTableRow(_a) {
  var _b = _a,
    enableStickyTop = _b.enableStickyTop,
    enableStickyColumns = _b.enableStickyColumns,
    onClick = _b.onClick,
    restProps = __objRest(_b, ["enableStickyTop", "enableStickyColumns", "onClick"]);
  var _useContext6 = useContext8(TableContext),
    _useContext6$data = _useContext6.data,
    stickyHead = _useContext6$data.stickyHead,
    stickyHeadVisible = _useContext6$data.stickyHeadVisible,
    stickyColumns = _useContext6$data.stickyColumns,
    stickyLeftColumnVisible = _useContext6$data.stickyLeftColumnVisible,
    stickyRightColumnVisible = _useContext6$data.stickyRightColumnVisible;
  var _useContext7 = useContext8(TableSectionContext),
    section = _useContext7.data.section;
  var _useIsHovered = useIsHovered(),
    onMouseEnter = _useIsHovered.onMouseEnter,
    onMouseLeave = _useIsHovered.onMouseLeave,
    isHovered = _useIsHovered.isHovered;
  var isHeader = section === TABLE_HEAD;
  var isFooter = section === TABLE_FOOT;
  return {
    rootProps: __spreadProps(__spreadValues({}, mergeProps(restProps, {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    })), {
      isHeader: isHeader,
      isFooter: isFooter,
      onClick: onClick,
      enableRowClick: !!onClick
    }),
    cellsProps: {
      isHeader: isHeader,
      isFooter: isFooter,
      stickyTop: enableStickyTop ? !!stickyHead && isHeader : false,
      stickyColumns: enableStickyColumns ? stickyColumns : EMPTY_STICKY_COLUMNS,
      stickyTopVisible: !!stickyHeadVisible && isHeader,
      stickyLeftColumnVisible: stickyLeftColumnVisible,
      stickyRightColumnVisible: stickyRightColumnVisible
    },
    isHovered: isHovered
  };
};

// src/components/Table/TableRow/TableRowCells.tsx
import React122, { Children as Children5, memo as memo91 } from "react";
import { LEFT as LEFT3, RIGHT as RIGHT3 } from "@deliveryhero/armor-system";
var TableRowCells = function TableRowCells(_ref161) {
  var children = _ref161.children,
    stickyColumns = _ref161.stickyColumns,
    stickyTopVisible = _ref161.stickyTopVisible,
    stickyLeftColumnVisible = _ref161.stickyLeftColumnVisible,
    stickyRightColumnVisible = _ref161.stickyRightColumnVisible,
    stickyTop = _ref161.stickyTop,
    isHeader = _ref161.isHeader;
  var index = 0;
  return /* @__PURE__ */React122.createElement(React122.Fragment, null, Children5.map(children, function (child) {
    if (!child) {
      return null;
    }
    var stickyAlignment;
    var stickyOffset;
    var stickyColumnShadowVisible = false;
    if (stickyColumns && index in stickyColumns) {
      stickyAlignment = stickyColumns[index].alignment;
      stickyOffset = stickyColumns[index].offset;
      stickyColumnShadowVisible = stickyColumns[index].edge;
    }
    var stickyVisible = stickyTopVisible || stickyAlignment === LEFT3 && stickyLeftColumnVisible || stickyAlignment === RIGHT3 && stickyRightColumnVisible;
    var stickyShadowVisible = stickyTopVisible || stickyColumnShadowVisible;
    index += 1;
    return React122.cloneElement(child, {
      stickyTop: stickyTop,
      stickyVisible: stickyVisible,
      stickyAlignment: stickyAlignment,
      stickyOffset: stickyOffset,
      stickyShadowVisible: stickyShadowVisible,
      isHeader: isHeader
    });
  }));
};
var MemoizedTableRowCells = memo91(TableRowCells);

// src/components/Table/TableRow/TableRow.tsx
var TableRow = forwardRef73(function TableRow2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var _useTableRow = useTableRow(restProps),
    rootProps = _useTableRow.rootProps,
    cellsProps = _useTableRow.cellsProps,
    isHovered = _useTableRow.isHovered;
  var classNameComponents = useTableRowClassNames(TABLE_ROW_CLASS_PREFIX, className, isHovered);
  return /* @__PURE__ */React123.createElement(TableRowRoot, __spreadProps(__spreadValues({}, rootProps), {
    "data-testid": tableRowRootTestId,
    className: classNameComponents.Root,
    ref: ref
  }), /* @__PURE__ */React123.createElement(TableRowCells, __spreadValues({}, cellsProps), children));
});
TableRow.defaultProps = {
  enableStickyTop: true,
  enableStickyColumns: true
};
TableRow.propTypes = {};

// src/components/Table/TableExpandableSection/TableExpandableSection.tsx
import React124, { forwardRef as forwardRef74, memo as memo92 } from "react";
import PropTypes67 from "prop-types";

// src/components/Table/TableExpandableSection/hooks/useTableExpandableSectionClassNames.ts
import { useMemo as useMemo113 } from "react";
import { makeRootClassName as makeRootClassName57, makeBEM as makeBEM64 } from "@deliveryhero/armor-system";
var useTableExpandableSectionClassNames = function useTableExpandableSectionClassNames(classPrefix, className) {
  return useMemo113(function () {
    return {
      Root: makeRootClassName57(classPrefix, className),
      Cell: makeBEM64(classPrefix, "Cell"),
      Content: makeBEM64(classPrefix, "Content")
    };
  }, [classPrefix, className]);
};

// src/components/Table/TableExpandableSection/hooks/useTableExpandableSection.ts
import { useEffect as useEffect20, useRef as useRef12, useState as useState18 } from "react";
import { RESIZE_OBSERVER_SUPPORTED as RESIZE_OBSERVER_SUPPORTED3 } from "@deliveryhero/armor-system";
var useTableExpandableSection = function useTableExpandableSection(_a) {
  var _b = _a,
    expanded = _b.expanded,
    enableDefaultPadding = _b.enableDefaultPadding,
    colSpan = _b.colSpan,
    offsetLeft = _b.offsetLeft,
    restProps = __objRest(_b, ["expanded", "enableDefaultPadding", "colSpan", "offsetLeft"]);
  var _useState57 = useState18(-1),
    _useState58 = _slicedToArray(_useState57, 2),
    containerHeight = _useState58[0],
    setContainerHeight = _useState58[1];
  var contentRef = useRef12(null);
  useEffect20(function () {
    var observer = null;
    if (RESIZE_OBSERVER_SUPPORTED3 && contentRef.current) {
      observer = new ResizeObserver(function (entries) {
        var contentEntry = entries[0];
        if (!contentEntry) {
          return;
        }
        var contentNodeHeight = contentEntry.target.getBoundingClientRect().height;
        setContainerHeight(contentNodeHeight);
      });
      observer.observe(contentRef.current);
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  var _useState59 = useState18(expanded),
    _useState60 = _slicedToArray(_useState59, 2),
    expandedInternal = _useState60[0],
    setExpandedInternal = _useState60[1];
  useEffect20(function () {
    if (expanded) {
      setTimeout(function () {
        return setExpandedInternal(true);
      }, 0);
    } else {
      setExpandedInternal(false);
    }
  }, [expanded]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      enableStickyTop: false,
      enableStickyColumns: false,
      expanded: expanded
    }),
    cellProps: {
      colSpan: colSpan,
      height: containerHeight
    },
    contentProps: {
      expanded: expandedInternal,
      ref: contentRef,
      enableDefaultPadding: enableDefaultPadding,
      offsetLeft: offsetLeft
    }
  };
};

// src/components/Table/TableExpandableSection/style.ts
import styled91, { css as css63 } from "styled-components";
import { color as color44, spacing as spacing61, propsBlocker as propsBlocker81, getComponentOverride as getComponentOverride66, componentSpacing04 as componentSpacing043, componentSpacing05 as componentSpacing052, RESIZE_OBSERVER_SUPPORTED as RESIZE_OBSERVER_SUPPORTED4, durationNormal as durationNormal17 } from "@deliveryhero/armor-system";
var getRootDynamicStyle5 = function getRootDynamicStyle5(_ref162) {
  var expanded = _ref162.expanded;
  var result = {};
  if (!expanded) {
    result = css63(_templateObject522 || (_templateObject522 = _taggedTemplateLiteral(["\n            ", ";\n            display: none;\n        "])), result);
  }
  return result;
};
var TableExpandableSectionRoot = styled91(TableRow)(_templateObject523 || (_templateObject523 = _taggedTemplateLiteral(["\n    white-space: normal;\n    background-color: ", ";\n    &:hover td {\n        background-color: ", ";\n    }\n\n    ", ";\n    ", ";\n"])), color44("neutral.00"), color44("neutral.00"), getRootDynamicStyle5, getComponentOverride66("TableExpandableSection"));
var getCellStyle = function getCellStyle(_ref163) {
  var height = _ref163.height;
  var result = {};
  if (height && height >= 0 && RESIZE_OBSERVER_SUPPORTED4) {
    result = css63(_templateObject524 || (_templateObject524 = _taggedTemplateLiteral(["\n            ", ";\n            height: ", "px;\n        "])), result, height);
  }
  return result;
};
var TableExpandableSectionCell = styled91(TableCell)(_templateObject525 || (_templateObject525 = _taggedTemplateLiteral(["\n    position: relative;\n    padding: 0;\n    ", ";\n"])), getCellStyle);
var getContentDynamicStyle = function getContentDynamicStyle(_ref164) {
  var expanded = _ref164.expanded,
    enableDefaultPadding = _ref164.enableDefaultPadding,
    offsetLeft = _ref164.offsetLeft;
  var result = {};
  if (RESIZE_OBSERVER_SUPPORTED4) {
    result = css63(_templateObject526 || (_templateObject526 = _taggedTemplateLiteral(["\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n        "])));
  }
  if (expanded) {
    result = css63(_templateObject527 || (_templateObject527 = _taggedTemplateLiteral(["\n            ", ";\n            opacity: 1;\n        "])), result);
  }
  if (enableDefaultPadding) {
    result = css63(_templateObject528 || (_templateObject528 = _taggedTemplateLiteral(["\n            ", ";\n            padding: ", ";\n        "])), result, spacing61(componentSpacing052, componentSpacing043));
  }
  if (offsetLeft !== void 0) {
    result = css63(_templateObject529 || (_templateObject529 = _taggedTemplateLiteral(["\n            ", ";\n            padding-left: ", ";\n        "])), result, spacing61(offsetLeft));
  }
  return result;
};
var TableExpandableSectionContent = styled91.div.withConfig(propsBlocker81)(_templateObject530 || (_templateObject530 = _taggedTemplateLiteral(["\n    opacity: 0;\n    transition: opacity ", "ms ease-in;\n\n    ", ";\n"])), durationNormal17, getContentDynamicStyle);

// src/components/Table/TableExpandableSection/constants.ts
var TABLE_EXPANDABLE_SECTION_CLASS_PREFIX = "TableExpandableSection";

// src/components/Table/TableExpandableSection/TableExpandableSection.tsx
var TableExpandableSection = forwardRef74(function TableExpandableSection2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var classNameComponents = useTableExpandableSectionClassNames(TABLE_EXPANDABLE_SECTION_CLASS_PREFIX, className);
  var _useTableExpandableSe = useTableExpandableSection(restProps),
    rootProps = _useTableExpandableSe.rootProps,
    cellProps = _useTableExpandableSe.cellProps,
    contentProps = _useTableExpandableSe.contentProps;
  return /* @__PURE__ */React124.createElement(TableExpandableSectionRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root,
    ref: ref
  }), /* @__PURE__ */React124.createElement(TableExpandableSectionCell, __spreadProps(__spreadValues({}, cellProps), {
    className: classNameComponents.Cell
  }), /* @__PURE__ */React124.createElement(TableExpandableSectionContent, __spreadProps(__spreadValues({}, contentProps), {
    className: classNameComponents.Content
  }), children)));
});
TableExpandableSection.defaultProps = {
  expanded: false,
  enableDefaultPadding: true
};
TableExpandableSection.propTypes = {
  expanded: PropTypes67.bool,
  offsetLeft: PropTypes67.number
};
var MemoizedTableExpandableSection = memo92(TableExpandableSection);

// src/components/Table/TableControllerCell/TableControllerCell.tsx
import React125, { forwardRef as forwardRef75, memo as memo93 } from "react";
import PropTypes68 from "prop-types";
import { getScalarPropType } from "@deliveryhero/armor-system";

// src/components/Table/TableControllerCell/hooks/useTableControllerCellClassNames.ts
import { useMemo as useMemo114 } from "react";
import { makeRootClassName as makeRootClassName58, makeBEM as makeBEM65 } from "@deliveryhero/armor-system";
var useTableControllerCellClassNames = function useTableControllerCellClassNames(classPrefix, className) {
  return useMemo114(function () {
    return {
      Root: makeRootClassName58(classPrefix, className),
      Container: makeBEM65(classPrefix, "Container"),
      Trigger: makeBEM65(classPrefix, "Trigger"),
      Icon: makeBEM65(classPrefix, "Icon")
    };
  }, [classPrefix, className]);
};

// src/components/Table/TableControllerCell/hooks/useTableControllerCell.ts
var useTableControllerCell = function useTableControllerCell(_a) {
  var _b = _a,
    onTriggerClick = _b.onTriggerClick,
    expanded = _b.expanded,
    rowId = _b.rowId,
    enableTriggerVisibility = _b.enableTriggerVisibility,
    restProps = __objRest(_b, ["onTriggerClick", "expanded", "rowId", "enableTriggerVisibility"]);
  return {
    rootProps: restProps,
    triggerProps: {
      light: true,
      marginRight: 2.5,
      onClick: onTriggerClick,
      visible: enableTriggerVisibility !== false,
      "data-rowid": rowId
    },
    triggerIconProps: {
      small: true,
      expanded: expanded
    }
  };
};

// src/components/Table/TableControllerCell/style.ts
import styled92 from "styled-components";
import { ArrowDownIcon as ArrowDownIcon2 } from "@deliveryhero/armor-icons";
import { color as color45, spacing as spacing62, paddingProps as paddingProps19, propsBlocker as propsBlocker82, transition as transition23, expansion as expansion2, getComponentOverride as getComponentOverride67 } from "@deliveryhero/armor-system";
var TableControllerCellRoot = styled92(TableCell)(_templateObject531 || (_templateObject531 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    padding-left: ", ";\n\n    ", ";\n    ", ";\n"])), spacing62(4), spacing62(4), spacing62(2.5), getComponentOverride67("TableControllerCell"), paddingProps19);
var TableControllerCellContainer = styled92.div.withConfig(propsBlocker82)(_templateObject532 || (_templateObject532 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n"])));
var TableControllerCellTrigger = styled92(IconButton)(_templateObject533 || (_templateObject533 = _taggedTemplateLiteral(["\n    color: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), color45("primary.main"), color45("neutral.00"));
var TableControllerCellIcon = styled92(ArrowDownIcon2)(_templateObject534 || (_templateObject534 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"])), transition23({
  transform: true,
  color: true
}), expansion2(180));

// src/components/Table/TableControllerCell/constants.ts
var TABLE_CONTROLLER_CELL_CLASS_PREFIX = "TableControllerCell";

// src/components/Table/TableControllerCell/TableControllerCell.tsx
var TableControllerCell = forwardRef75(function TableControllerCell2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var classNameComponents = useTableControllerCellClassNames(TABLE_CONTROLLER_CELL_CLASS_PREFIX, className);
  var _useTableControllerCe = useTableControllerCell(restProps),
    rootProps = _useTableControllerCe.rootProps,
    triggerProps = _useTableControllerCe.triggerProps,
    triggerIconProps = _useTableControllerCe.triggerIconProps;
  return /* @__PURE__ */React125.createElement(TableControllerCellRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root,
    ref: ref
  }), /* @__PURE__ */React125.createElement(TableControllerCellContainer, {
    className: classNameComponents.Container
  }, /* @__PURE__ */React125.createElement(TableControllerCellTrigger, __spreadProps(__spreadValues({}, triggerProps), {
    className: classNameComponents.Trigger
  }), /* @__PURE__ */React125.createElement(TableControllerCellIcon, __spreadProps(__spreadValues({}, triggerIconProps), {
    className: classNameComponents.Icon
  }))), children));
});
TableControllerCell.defaultProps = {
  expanded: false
};
TableControllerCell.propTypes = {
  expanded: PropTypes68.bool,
  rowId: getScalarPropType()
  // onExpansionButtonClick: PropTypes.func,
};

var MemoizedTableControllerCell = memo93(TableControllerCell);

// src/components/Table/TableSelectionContextMenu/TableSelectionContextMenu.tsx
import { ArrowDownIcon as ArrowDownIcon3, ArrowUpIcon } from "@deliveryhero/armor-icons";
import React126, { forwardRef as forwardRef76 } from "react";

// src/components/Table/TableSelectionContextMenu/style.ts
import styled93 from "styled-components";
import { color as color46, getComponentOverride as getComponentOverride68, spacing as spacing63 } from "@deliveryhero/armor-system";
var TableCheckboxCellRoot2 = styled93(TableCell)(_templateObject535 || (_templateObject535 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    width: 52px;\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    & + .TableCell-Root {\n        padding-left: ", ";\n    }\n\n    ", ";\n"])), color46("primary.lightest"), spacing63(2), getComponentOverride68("TableCheckboxCell"));
var TableCheckboxCellCheckbox2 = styled93(Checkbox)(_templateObject536 || (_templateObject536 = _taggedTemplateLiteral(["\n    display: block;\n    margin-top: ", ";\n"])), spacing63(0.5));
var TableContextMenuIcon = styled93(IconButton)(_templateObject537 || (_templateObject537 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n"])), spacing63(1));

// src/components/Table/TableSelectionContextMenu/hooks/useTableSelectionContextMenu.ts
import { useState as useState19 } from "react";
var useTableSelectionContextMenu = function useTableSelectionContextMenu(_a, ref) {
  var _b = _a,
    checked = _b.checked,
    checkedIcon = _b.checkedIcon,
    isHeader = _b.isHeader,
    onCheckboxChange = _b.onCheckboxChange,
    selections = _b.selections,
    restProps = __objRest(_b, ["checked", "checkedIcon", "isHeader", "onCheckboxChange", "selections"]);
  var _useState61 = useState19(false),
    _useState62 = _slicedToArray(_useState61, 2),
    open = _useState62[0],
    setOpen = _useState62[1];
  var formatedMenuElements = selections.map(function (_ref165) {
    var key = _ref165.key,
      onSelect = _ref165.onSelect,
      text = _ref165.text;
    return {
      id: key,
      label: text,
      props: {
        onClick: function onClick() {
          onSelect();
          setOpen(false);
        }
      }
    };
  });
  return {
    rootProps: __spreadProps(__spreadValues({
      "data-testid": tableCheckboxCellRootTestId
    }, restProps), {
      contentAlignX: "center",
      ref: ref,
      isHeader: isHeader
    }),
    checkboxProps: {
      checked: checked,
      checkedIcon: checkedIcon,
      onChange: onCheckboxChange
    },
    contextMenuProps: {
      open: open,
      onOpenChange: setOpen,
      menuElements: formatedMenuElements
    }
  };
};

// src/components/Table/TableSelectionContextMenu/TableSelectionContextMenu.tsx
var TableSelectionContextMenu = forwardRef76(function TableSelectionContextMenu2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNameComponents = useTableCheckboxCellClassNames(TABLE_CHECKBOX_CELL_CLASS_PREFIX, className);
  var _useTableSelectionCon = useTableSelectionContextMenu(props, ref),
    rootProps = _useTableSelectionCon.rootProps,
    checkboxProps = _useTableSelectionCon.checkboxProps,
    contextMenuProps = _useTableSelectionCon.contextMenuProps;
  return /* @__PURE__ */React126.createElement(TableCheckboxCellRoot2, __spreadProps(__spreadValues({}, rootProps), {
    className: classNameComponents.Root
  }), /* @__PURE__ */React126.createElement(Flex, {
    direction: "row",
    alignItems: "baseline"
  }, /* @__PURE__ */React126.createElement(TableCheckboxCellCheckbox2, __spreadValues({}, checkboxProps)), /* @__PURE__ */React126.createElement(ContextMenu, __spreadValues({
    align: "bottom-start",
    trigger: /* @__PURE__ */React126.createElement(TableContextMenuIcon, null, contextMenuProps.open ? /* @__PURE__ */React126.createElement(ArrowUpIcon, null) : /* @__PURE__ */React126.createElement(ArrowDownIcon3, null))
  }, contextMenuProps))));
});

// src/components/Tabs/Tabs.tsx
import React129, { forwardRef as forwardRef77, memo as memo94 } from "react";
import PropTypes69 from "prop-types";

// src/components/Tabs/utils/injectTabIndex.ts
import React127, { Children as Children6 } from "react";
var injectTabIndex = function injectTabIndex(children, additionalProps) {
  return Children6.map(children, function (child, tabIndex) {
    return child ? React127.cloneElement(child, __spreadProps(__spreadValues({}, additionalProps), {
      tabIndex: tabIndex
    })) : null;
  });
};

// src/components/Tabs/utils/useTabsClassName.ts
import { useMemo as useMemo115 } from "react";
import { appendClassName as appendClassName40, makeBEM as makeBEM66 } from "@deliveryhero/armor-system";
var classGeneratorBasedOnComponent6 = function classGeneratorBasedOnComponent6(_ref166) {
  var component = _ref166.component,
    classPrefix = _ref166.classPrefix,
    disabled = _ref166.disabled;
  var baseClassNames = makeBEM66(classPrefix, component);
  var stateClassNames = [];
  if (disabled) {
    stateClassNames.push(makeBEM66(classPrefix, component, "disabled"));
  }
  return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
};
var useTabsClassName = function useTabsClassName(classPrefix, className, disabled) {
  return useMemo115(function () {
    return {
      Root: appendClassName40(classGeneratorBasedOnComponent6({
        component: "Root",
        classPrefix: classPrefix,
        disabled: disabled
      }), className)
    };
  }, [classPrefix, className, disabled]);
};

// src/components/Tabs/style.ts
import styled94, { css as css65 } from "styled-components";
import { childrenNotLastChild, marginProps as marginProps48, propsBlocker as propsBlocker83, spacing as spacing64 } from "@deliveryhero/armor-system";
var getRootStyle21 = function getRootStyle21(_ref167) {
  var wide = _ref167.wide;
  var result = css65(_templateObject538 || (_templateObject538 = _taggedTemplateLiteral([""])));
  if (wide) {
    return css65(_templateObject539 || (_templateObject539 = _taggedTemplateLiteral(["\n            ", ";\n            width: 100%;\n            justify-content: space-evenly;\n        "])), result);
  }
  return result;
};
var TabsRoot = styled94.div.withConfig(propsBlocker83)(_templateObject540 || (_templateObject540 = _taggedTemplateLiteral(["\n    align-items: start;\n    display: flex;\n    flex-wrap: wrap;\n    width: fit-content;\n    & ", " {\n        margin-right: ", ";\n    }\n    ", ";\n    ", ";\n"])), childrenNotLastChild, spacing64(9), getRootStyle21, marginProps48);

// src/components/Tabs/constants.ts
var TABS_CLASS_PREFIX = "Tabs";

// src/components/Tabs/hooks/useTabs.ts
import { useCallback as useCallback34, useEffect as useEffect21 } from "react";
import { useControlledState as useControlledState7 } from "@deliveryhero/armor-system";
var useTabs = function useTabs(_a, ref) {
  var _b = _a,
    children = _b.children,
    disabled = _b.disabled,
    onSwitch = _b.onSwitch,
    wide = _b.wide,
    defaultActiveTabIndex = _b.defaultActiveTabIndex,
    activeTabIndex = _b.activeTabIndex,
    onActiveTabIndexChange = _b.onActiveTabIndexChange,
    removePaddingLeft = _b.removePaddingLeft,
    removePaddingRight = _b.removePaddingRight,
    _b$defaultActiveTab = _b.defaultActiveTab,
    defaultActiveTab = _b$defaultActiveTab === void 0 ? 0 : _b$defaultActiveTab,
    restProps = __objRest(_b, ["children", "disabled", "onSwitch", "wide", "defaultActiveTabIndex", "activeTabIndex", "onActiveTabIndexChange", "removePaddingLeft", "removePaddingRight", "defaultActiveTab"]);
  var _useControlledState15 = useControlledState7(defaultActiveTabIndex !== void 0 ? defaultActiveTabIndex : defaultActiveTab, activeTabIndex, onActiveTabIndexChange),
    _useControlledState16 = _slicedToArray(_useControlledState15, 2),
    currentlyActiveTab = _useControlledState16[0],
    setCurrentlyActiveTab = _useControlledState16[1];
  useEffect21(function () {
    if (onSwitch && defaultActiveTab) {
      onSwitch(defaultActiveTab);
    }
  }, [defaultActiveTab, onSwitch]);
  var handleClick = useCallback34(function (event, tabIndex, contentValue) {
    setCurrentlyActiveTab(tabIndex);
    if (onSwitch && contentValue !== void 0) {
      onSwitch(contentValue);
    }
  }, [onSwitch, setCurrentlyActiveTab]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: ref,
      wide: wide,
      disabled: disabled,
      children: injectTabIndex(children),
      // todo: better use context api in Tab, instead of cloning the nodes here
      removePaddingLeft: removePaddingLeft,
      removePaddingRight: removePaddingRight
    }),
    contextValue: {
      currentlyActiveTab: currentlyActiveTab,
      wide: wide,
      handleClick: handleClick
    },
    disabled: disabled
  };
};

// src/components/Tabs/Tabs.tsx
var Tabs = forwardRef77(function Tabs2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var _useTabs = useTabs(restProps, ref),
    rootProps = _useTabs.rootProps,
    contextValue = _useTabs.contextValue,
    disabled = _useTabs.disabled;
  var classOverride = useTabsClassName(TABS_CLASS_PREFIX, className, disabled);
  return /* @__PURE__ */React129.createElement(TabsContext_default.Provider, {
    value: contextValue
  }, /* @__PURE__ */React129.createElement(TabsRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classOverride.Root
  })));
});
Tabs.displayName = TABS_CLASS_PREFIX;
Tabs.propTypes = {
  defaultActiveTab: PropTypes69.number,
  // disabled: PropTypes.bool,
  wide: PropTypes69.bool,
  onSwitch: PropTypes69.func
};
var MemoizedTabs = memo94(Tabs);

// src/components/TabView/TabView.tsx
import React130, { memo as memo95 } from "react";
import PropTypes70 from "prop-types";
import { makeRootClassName as makeRootClassName59 } from "@deliveryhero/armor-system";

// src/components/TabView/style.ts
import styled95 from "styled-components";
import { marginProps as marginProps49, token as token58, typography as typography42 } from "@deliveryhero/armor-system";
var TabViewRoot = styled95.div(_templateObject541 || (_templateObject541 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    ", ";\n"])), typography42("paragraphLarge"), token58("body.color"), marginProps49);

// src/components/TabView/constants.ts
var TAB_VIEW_CLASS_PREFIX = "TabView";

// src/components/TabView/TabView.tsx
var TabView = function TabView(_a) {
  var _b = _a,
    children = _b.children,
    value = _b.value,
    selectedValue = _b.selectedValue,
    className = _b.className,
    restProps = __objRest(_b, ["children", "value", "selectedValue", "className"]);
  if (typeof value === "undefined" || typeof selectedValue === "undefined") {
    return null;
  }
  return value === selectedValue ? /* @__PURE__ */React130.createElement(TabViewRoot, __spreadProps(__spreadValues({}, restProps), {
    className: makeRootClassName59(TAB_VIEW_CLASS_PREFIX, className)
  }), children) : null;
};
TabView.displayName = TAB_VIEW_CLASS_PREFIX;
TabView.propTypes = {
  id: PropTypes70.string,
  selectedValue: PropTypes70.oneOfType([PropTypes70.string, PropTypes70.number]),
  value: PropTypes70.number
};
var MemoizedTabView = memo95(TabView);

// src/components/PageNavigation/PageNavigation.tsx
import React131, { forwardRef as forwardRef78, memo as memo96 } from "react";
import PropTypes71 from "prop-types";
import { ArrowLeftIcon, ArrowRightIcon } from "@deliveryhero/armor-icons";

// src/components/PageNavigation/hooks/usePageNavigationClassNames.ts
import { useMemo as useMemo116 } from "react";
import { makeBEM as makeBEM67, makeRootClassName as makeRootClassName60 } from "@deliveryhero/armor-system";
var usePageNavigationClassNames = function usePageNavigationClassNames(classPrefix, className) {
  return useMemo116(function () {
    var pageButtonClassName = makeBEM67(classPrefix, "PageButton");
    return {
      Root: makeRootClassName60(classPrefix, className),
      PageButton: pageButtonClassName,
      Buttons: makeBEM67(classPrefix, "Buttons"),
      ArrowButton: "".concat(makeBEM67(classPrefix, "ArrowButton"), " ").concat(pageButtonClassName),
      PageSize: makeBEM67(classPrefix, "PageSize"),
      PageSizeSelector: makeBEM67(classPrefix, "PageSizeSelector")
    };
  }, [classPrefix, className]);
};

// src/components/PageNavigation/hooks/usePageNavigation.ts
import { useCallback as useCallback35 } from "react";

// src/components/PageNavigation/utils/getPageNavigation.ts
var getPageNavigation = function getPageNavigation() {
  var itemCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var displayedRadius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var result = {
    displayedRange: [],
    nextPageNumber: 1,
    previousPageNumber: 1,
    currentPageNumber: pageNumber,
    firstPageArrowEnabled: false,
    lastPageArrowEnabled: false,
    nextPageArrowEnabled: false,
    previousPageArrowEnabled: false
  };
  if (!itemCount || itemCount < pageSize) {
    result.displayedRange = [1];
    return result;
  }
  var pageCount = Math.ceil(itemCount / pageSize);
  var displayedRange = [pageNumber - displayedRadius, pageNumber + displayedRadius];
  if (displayedRange[0] < 1) {
    displayedRange[1] += 1 - displayedRange[0];
    displayedRange[0] = 1;
    if (displayedRange[1] > pageCount) {
      displayedRange[1] = pageCount;
    }
  }
  if (displayedRange[1] > pageCount) {
    displayedRange[0] -= displayedRange[1] - pageCount;
    displayedRange[1] = pageCount;
    if (displayedRange[0] < 1) {
      displayedRange[0] = 1;
    }
  }
  for (var i = displayedRange[0]; i <= displayedRange[1]; i += 1) {
    result.displayedRange.push(i);
  }
  result.previousPageNumber = pageNumber - 1;
  result.nextPageNumber = pageNumber + 1;
  result.firstPageArrowEnabled = pageNumber > 1;
  result.lastPageArrowEnabled = pageNumber < pageCount;
  result.previousPageArrowEnabled = pageNumber > 1;
  result.nextPageArrowEnabled = pageNumber < pageCount;
  return result;
};

// src/components/PageNavigation/hooks/usePageNavigation.ts
var usePageNavigation = function usePageNavigation(_ref168) {
  var pageNumber = _ref168.pageNumber,
    pageSize = _ref168.pageSize,
    itemCount = _ref168.itemCount,
    displayRange = _ref168.displayRange,
    onPageSelect = _ref168.onPageSelect,
    onPageNumberChange = _ref168.onPageNumberChange,
    enablePageSizeSelector = _ref168.enablePageSizeSelector,
    onPageSizeChange = _ref168.onPageSizeChange,
    pageSizeList = _ref168.pageSizeList;
  var actualOnPageSelect = onPageSelect != null ? onPageSelect : onPageNumberChange;
  var onPageButtonClick = useCallback35(function (event) {
    if (!actualOnPageSelect) {
      return;
    }
    var button = event.currentTarget;
    var buttonDisabled = !!button.getAttribute("data-disabled");
    if (buttonDisabled) {
      return;
    }
    var currentPageNumber = button.getAttribute("data-pagenumber");
    if (currentPageNumber !== null) {
      var currentPageNumberSafe = parseInt(currentPageNumber, 10);
      if (!Number.isNaN(currentPageNumberSafe)) {
        actualOnPageSelect(currentPageNumberSafe);
      }
    }
  }, [actualOnPageSelect]);
  var onPageSelectorChange = useCallback35(function (event) {
    onPageSizeChange == null ? void 0 : onPageSizeChange(event.target.value);
  }, [onPageSizeChange]);
  return {
    pageSizeSelectorProps: {
      options: pageSizeList,
      onChange: onPageSelectorChange,
      value: pageSize
    },
    structure: getPageNavigation(itemCount, pageNumber, pageSize, displayRange),
    onPageButtonClick: onPageButtonClick,
    enablePageSizeSelector: enablePageSizeSelector
  };
};

// src/components/PageNavigation/style.ts
import styled96, { css as css66 } from "styled-components";
import { color as color47, reset as reset25, spacing as spacing65, typography as typography43, marginProps as marginProps50, getComponentOverride as getComponentOverride69, propsBlocker as propsBlocker84, durationNormal as durationNormal18, borderRadius as borderRadius8, focus as focus9, token as token59 } from "@deliveryhero/armor-system";
var PageNavigationRoot = styled96.div.withConfig(propsBlocker84)(_templateObject542 || (_templateObject542 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    display: inline-flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: ", ";\n    align-items: center;\n    width: 100%;\n    ", ";\n    ", ";\n    ", ";\n"])), reset25(), typography43("paragraphMedium"), token59("body.color"), function (_ref169) {
  var justifyContent = _ref169.justifyContent;
  return justifyContent;
}, getComponentOverride69("PageNavigation"), focus9(), marginProps50);
var getButtonStyle = function getButtonStyle(_ref170) {
  var arrow = _ref170.arrow,
    disabled = _ref170.disabled,
    selected = _ref170.selected;
  var result = css66(_templateObject543 || (_templateObject543 = _taggedTemplateLiteral(["\n        position: relative;\n        &:before {\n            content: '';\n            position: absolute;\n            left: 0;\n            right: 0;\n            bottom: -2px;\n            height: 2px;\n            border-radius: 1px;\n            display: none;\n        }\n    "])));
  if (arrow) {
    result = css66(_templateObject544 || (_templateObject544 = _taggedTemplateLiteral(["\n            ", ";\n            padding-left: ", ";\n            padding-right: ", ";\n            color: ", ";\n        "])), result, spacing65(1), spacing65(1), color47("neutral.07"));
  }
  if (selected) {
    result = css66(_templateObject545 || (_templateObject545 = _taggedTemplateLiteral(["\n            ", ";\n            &:before {\n                display: initial;\n            }\n        "])), result);
  }
  if (disabled) {
    result = css66(_templateObject546 || (_templateObject546 = _taggedTemplateLiteral(["\n            ", ";\n            &:hover {\n                background-color: transparent;\n            }\n            cursor: initial;\n            color: ", ";\n        "])), result, color47("neutral.05"));
  }
  return result;
};
var PageNavigationButtons = styled96.div.withConfig(propsBlocker84)(_templateObject547 || (_templateObject547 = _taggedTemplateLiteral(["\n    ", ";\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n"])), reset25());
var PageNavigationPageButton = styled96.button.withConfig(propsBlocker84)(_templateObject548 || (_templateObject548 = _taggedTemplateLiteral(["\n    ", ";\n    font-family: inherit;\n    font-size: inherit;\n    font-weight: inherit;\n    letter-spacing: inherit;\n    line-height: inherit;\n    color: ", ";\n    user-select: none;\n    appearance: none;\n    border: 0 none;\n    background-color: transparent;\n    cursor: pointer;\n    transition: background-color ", "ms ease-out;\n    display: flex;\n    align-items: center;\n    padding: ", ";\n    border-radius: ", ";\n    min-height: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n    &:not(:last-child) {\n        margin-right: ", ";\n    }\n    &:before {\n        background-color: ", ";\n    }\n    ", ";\n"])), reset25(), color47("neutral.11"), durationNormal18, spacing65(1, 3), borderRadius8("soft"), spacing65(2), color47("primary.lightest"), spacing65(1), color47("primary.main"), getButtonStyle);
var PageNavigationPageSize = styled96.div.withConfig(propsBlocker84)(_templateObject549 || (_templateObject549 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    margin-right: ", ";\n    white-space: nowrap;\n"])), reset25(), color47("neutral.05"), spacing65(10));
var PageNavigationPageSizeSelector = styled96(Dropdown)(_templateObject550 || (_templateObject550 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n\n    .TextInput-Input {\n        padding: ", ";\n        width: ", ";\n\n        &:focus {\n            outline: unset;\n            box-shadow: unset;\n        }\n    }\n\n    .ExpansionIndicator-Content {\n        position: relative;\n        right: -", ";\n        top: -", ";\n    }\n\n    .ExpansionIndicator-Icon {\n        color: ", ";\n    }\n"])), spacing65(3), spacing65(1.5, 0, 1.5, 2), spacing65(9), spacing65(1), spacing65(0.5), color47("primary.07"));

// src/components/PageNavigation/constants.ts
var PAGE_NAVIGATION_CLASS_PREFIX = "PageNavigation";
var pageNavigationRootTestId = "PageNavigationRoot";
var pageNavigationPageButtonTestId = "PageNavigationPageButton";

// src/components/PageNavigation/PageNavigation.tsx
var PageNavigation = forwardRef78(function PageNavigation2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var classNameComponents = usePageNavigationClassNames(PAGE_NAVIGATION_CLASS_PREFIX, className);
  var _usePageNavigation = usePageNavigation(restProps),
    pageSizeSelectorProps = _usePageNavigation.pageSizeSelectorProps,
    _usePageNavigation$st = _usePageNavigation.structure,
    displayedRange = _usePageNavigation$st.displayedRange,
    nextPageNumber = _usePageNavigation$st.nextPageNumber,
    previousPageNumber = _usePageNavigation$st.previousPageNumber,
    currentPageNumber = _usePageNavigation$st.currentPageNumber,
    nextPageArrowEnabled = _usePageNavigation$st.nextPageArrowEnabled,
    previousPageArrowEnabled = _usePageNavigation$st.previousPageArrowEnabled,
    onPageButtonClick = _usePageNavigation.onPageButtonClick,
    enablePageSizeSelector = _usePageNavigation.enablePageSizeSelector;
  var pageButtonType = "button";
  return /* @__PURE__ */React131.createElement(PageNavigationRoot, __spreadProps(__spreadValues({
    "data-testid": pageNavigationRootTestId
  }, restProps), {
    className: classNameComponents.Root,
    ref: ref
  }), enablePageSizeSelector && /* @__PURE__ */React131.createElement(PageNavigationPageSize, {
    className: classNameComponents.PageSize
  }, "Rows per page:", " ", /* @__PURE__ */React131.createElement(PageNavigationPageSizeSelector, __spreadValues({
    className: classNameComponents.PageSizeSelector
  }, pageSizeSelectorProps))), /* @__PURE__ */React131.createElement(PageNavigationButtons, {
    className: classNameComponents.Buttons
  }, /* @__PURE__ */React131.createElement(PageNavigationPageButton, {
    className: classNameComponents.ArrowButton,
    arrow: true,
    disabled: !previousPageArrowEnabled,
    "data-testid": pageNavigationPageButtonTestId,
    "data-disabled": previousPageArrowEnabled ? "" : "1",
    "data-pagenumber": previousPageNumber,
    type: pageButtonType,
    onClick: onPageButtonClick
  }, /* @__PURE__ */React131.createElement(ArrowLeftIcon, {
    small: true
  })), displayedRange.map(function (pageNumber) {
    return /* @__PURE__ */React131.createElement(PageNavigationPageButton, {
      key: pageNumber,
      className: classNameComponents.PageButton,
      selected: pageNumber === currentPageNumber,
      "data-testid": pageNavigationPageButtonTestId,
      "data-disabled": "",
      "data-pagenumber": pageNumber,
      type: pageButtonType,
      onClick: onPageButtonClick
    }, pageNumber);
  }), /* @__PURE__ */React131.createElement(PageNavigationPageButton, {
    className: classNameComponents.ArrowButton,
    arrow: true,
    disabled: !nextPageArrowEnabled,
    "data-testid": pageNavigationPageButtonTestId,
    "data-disabled": nextPageArrowEnabled ? "" : "1",
    "data-pagenumber": nextPageNumber,
    type: pageButtonType,
    onClick: onPageButtonClick
  }, /* @__PURE__ */React131.createElement(ArrowRightIcon, {
    small: true
  }))));
});
PageNavigation.defaultProps = {
  pageNumber: 1,
  itemCount: 0,
  pageSize: 25,
  displayRange: 2,
  pageSizeList: [{
    label: "25",
    value: 25
  }, {
    label: "100",
    value: 100
  }, {
    label: "500",
    value: 500
  }]
};
PageNavigation.propTypes = {
  pageNumber: PropTypes71.number,
  itemCount: PropTypes71.number,
  pageSize: PropTypes71.number,
  displayRange: PropTypes71.number,
  onPageSelect: PropTypes71.func
};
var MemoizedPageNavigation = memo96(PageNavigation);

// src/components/FileUploadButton/FileUploadButton.tsx
import React132, { forwardRef as forwardRef79, memo as memo97 } from "react";
import PropTypes72 from "prop-types";

// src/components/FileUploadButton/hooks/useFileUploadButtonClassNames.ts
import { useMemo as useMemo117 } from "react";
import { makeBEM as makeBEM68, makeRootClassName as makeRootClassName61 } from "@deliveryhero/armor-system";
var useFileUploadButtonClassNames = function useFileUploadButtonClassNames(classPrefix, className) {
  return useMemo117(function () {
    return {
      Root: makeRootClassName61(classPrefix, className),
      Button: makeBEM68(classPrefix, "Button"),
      Input: makeBEM68(classPrefix, "Input")
    };
  }, [classPrefix, className]);
};

// src/components/FileUploadButton/hooks/useFileUploadButton.ts
import { useCallback as useCallback36, useRef as useRef13 } from "react";
import { useRootRef as useRootRef31 } from "@deliveryhero/armor-system";
var useFileUploadButton = function useFileUploadButton(_a, ref) {
  var _b = _a,
    accept = _b.accept,
    children = _b.children,
    onFileSelect = _b.onFileSelect,
    onClick = _b.onClick,
    disabled = _b.disabled,
    small = _b.small,
    wide = _b.wide,
    primary = _b.primary,
    secondary = _b.secondary,
    tertiary = _b.tertiary,
    danger = _b.danger,
    multiple = _b.multiple,
    onFilesSelect = _b.onFilesSelect,
    restProps = __objRest(_b, ["accept", "children", "onFileSelect", "onClick", "disabled", "small", "wide", "primary", "secondary", "tertiary", "danger", "multiple", "onFilesSelect"]);
  var rootRef = useRootRef31(ref);
  var internalInputRef = useRef13(null);
  var handleClick = useCallback36(function (event) {
    if (!internalInputRef.current) {
      return;
    }
    onClick == null ? void 0 : onClick(event);
    var node = internalInputRef.current;
    if (node && !disabled) {
      node.click();
    }
  }, [disabled, onClick]);
  var handleChange = useCallback36(function (event) {
    var target = event.target;
    if (target) {
      var fileList = target.files;
      onFileSelect == null ? void 0 : onFileSelect(fileList[0]);
      onFilesSelect == null ? void 0 : onFilesSelect(Array.from(fileList));
    }
  }, [onFileSelect, onFilesSelect]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: rootRef
    }),
    buttonProps: {
      disabled: disabled,
      small: small,
      wide: wide,
      primary: primary,
      secondary: secondary,
      tertiary: tertiary,
      danger: danger,
      onClick: handleClick
    },
    fileInputProps: {
      accept: accept,
      type: "file",
      hidden: true,
      onChange: handleChange,
      ref: internalInputRef,
      multiple: multiple,
      // set input value to an empty string will allow the onChange event
      // to fire when selecting the same file twice
      value: ""
    },
    children: children
  };
};

// src/components/FileUploadButton/style.ts
import styled97 from "styled-components";
import { marginProps as marginProps51, propsBlocker as propsBlocker85, reset as reset26, token as token60, typography as typography44 } from "@deliveryhero/armor-system";
var FileUploadButtonRoot = styled97.div.withConfig(propsBlocker85)(_templateObject551 || (_templateObject551 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    display: inline-block;\n    ", ";\n"])), reset26, typography44("paragraphMedium"), token60("body.color"), marginProps51);

// src/components/FileUploadButton/constants.ts
var FILE_UPLOAD_BUTTON_CLASS_PREFIX = "FileUploadButton";

// src/components/FileUploadButton/FileUploadButton.tsx
var FileUploadButton = forwardRef79(function FileUploadButton2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNames = useFileUploadButtonClassNames(FILE_UPLOAD_BUTTON_CLASS_PREFIX, className);
  var _useFileUploadButton = useFileUploadButton(props, ref),
    rootProps = _useFileUploadButton.rootProps,
    fileInputProps = _useFileUploadButton.fileInputProps,
    buttonProps = _useFileUploadButton.buttonProps,
    children = _useFileUploadButton.children;
  return (
    // @ts-ignore
    /* @__PURE__ */
    React132.createElement(FileUploadButtonRoot, __spreadProps(__spreadValues({}, rootProps), {
      className: classNames.Root
    }), /* @__PURE__ */React132.createElement(Button, __spreadProps(__spreadValues({}, buttonProps), {
      className: classNames.Button
    }), children), /* @__PURE__ */React132.createElement("input", __spreadProps(__spreadValues({}, fileInputProps), {
      className: classNames.Input,
      "data-testid": classNames.Input
    })))
  );
});
FileUploadButton.defaultProps = {
  accept: "",
  children: "Choose file",
  onFileSelect: function onFileSelect() {},
  onClick: function onClick() {},
  primary: true,
  secondary: false,
  tertiary: false,
  danger: false,
  small: false,
  wide: false,
  disabled: false
};
FileUploadButton.propTypes = {
  /** Accept file types */
  accept: PropTypes72.string,
  onFileSelect: PropTypes72.func,
  /* Button props */
  onClick: PropTypes72.func,
  primary: PropTypes72.bool,
  secondary: PropTypes72.bool,
  tertiary: PropTypes72.bool,
  danger: PropTypes72.bool,
  small: PropTypes72.bool,
  wide: PropTypes72.bool,
  disabled: PropTypes72.bool
};
var MemoizedFileUploadButton = memo97(FileUploadButton);

// src/components/FontLoader/hooks/useFontLoader.ts
import { useEffect as useEffect22, useMemo as useMemo118 } from "react";
import { getWindow as getWindow7, generateId as generateId5 } from "@deliveryhero/armor-system";

// src/components/FontLoader/utils/createElement.ts
var createElement = function createElement(win2, html) {
  var template = document.createElement("template");
  template.innerHTML = html.trim();
  return template.content.firstChild;
};

// src/components/FontLoader/hooks/useFontLoader.ts
var win = getWindow7();
var useFontLoader = function useFontLoader() {
  var linkElementId = useMemo118(function () {
    return generateId5(void 0, "armor_font_");
  }, []);
  useEffect22(function () {
    if (win) {
      var head = win.document.getElementsByTagName("head");
      if (head && head[0]) {
        head[0].appendChild(createElement(win, "<link id=\"".concat(linkElementId, "\" href=\"https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap\" rel=\"stylesheet\" />")));
      }
    }
    return function () {
      if (win) {
        var element = win.document.getElementById(linkElementId);
        if (element && element.parentElement) {
          element.parentElement.removeChild(element);
        }
      }
    };
  }, [linkElementId]);
};

// src/components/FontLoader/FontLoader.tsx
var FontLoader = function FontLoader() {
  useFontLoader();
  return null;
};

// src/components/EmptyState/EmptyState.tsx
import React134, { forwardRef as forwardRef80, memo as memo99 } from "react";
import PropTypes73 from "prop-types";

// src/components/EmptyState/hooks/useEmptyStateClassNames.ts
import { useMemo as useMemo119 } from "react";
import { makeRootClassName as makeRootClassName62, makeBEM as makeBEM69 } from "@deliveryhero/armor-system";
var useEmptyStateClassNames = function useEmptyStateClassNames(classPrefix, className) {
  return useMemo119(function () {
    return {
      Root: makeRootClassName62(classPrefix, className),
      Title: makeBEM69(classPrefix, "Title"),
      Description: makeBEM69(classPrefix, "Description"),
      ActionsContainer: makeBEM69(classPrefix, "Actions"),
      ImageContainer: makeBEM69(classPrefix, "Image"),
      HorizontalLayout: makeBEM69(classPrefix, "Horizontal"),
      VerticalLayout: makeBEM69(classPrefix, "Vertical"),
      EmptyStateContainer: makeBEM69(classPrefix, "Container")
    };
  }, [classPrefix, className]);
};

// src/components/EmptyState/hooks/useEmptyState.ts
var useEmptyState = function useEmptyState(_a, ref) {
  var _b = _a,
    layout = _b.layout,
    small = _b.small,
    enableImage = _b.enableImage,
    enableIndicator = _b.enableIndicator,
    enableTitle = _b.enableTitle,
    enableDescription = _b.enableDescription,
    enableActions = _b.enableActions,
    children = _b.children,
    preset = _b.preset,
    imagePosition = _b.imagePosition,
    titlePosition = _b.titlePosition,
    descriptionPosition = _b.descriptionPosition,
    actionsPosition = _b.actionsPosition,
    image = _b.image,
    title = _b.title,
    actions = _b.actions,
    description = _b.description,
    restProps = __objRest(_b, ["layout", "small", "enableImage", "enableIndicator", "enableTitle", "enableDescription", "enableActions", "children", "preset", "imagePosition", "titlePosition", "descriptionPosition", "actionsPosition", "image", "title", "actions", "description"]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      layout: layout,
      ref: ref
    }),
    horizontalLayoutProps: {
      small: small,
      preset: preset
    },
    verticalLayoutProps: {
      small: small,
      preset: preset
    },
    imageContainerProps: {
      imagePosition: imagePosition,
      small: small
    },
    imageIllustrationProps: {
      small: small
    },
    titleProps: {
      titlePosition: titlePosition,
      layout: layout,
      small: small
    },
    descriptionProps: {
      descriptionPosition: descriptionPosition,
      small: small
    },
    actionsContainerProps: {
      actionsPosition: actionsPosition
    },
    enableDescription: enableDescription,
    enableActions: enableActions,
    enableTitle: enableTitle,
    image: image,
    title: title,
    actions: actions,
    description: description,
    layout: layout,
    children: children,
    renderIndicator: !!enableIndicator,
    renderImage: !!image && !enableIndicator,
    renderDefaultImage: !enableIndicator && !image,
    enableImage: enableImage
  };
};

// src/components/EmptyState/style.ts
import styled98, { css as css67 } from "styled-components";
import { marginProps as marginProps52, propsBlocker as propsBlocker86, getComponentOverride as getComponentOverride70, reset as reset27, typography as typography45, spacing as spacing66, color as color48, pixelToRem as pixelToRem8, sizeProps as sizeProps8, token as token61 } from "@deliveryhero/armor-system";
var sizes3 = {
  default: 160,
  small: 80
};
var getAlignmentStyle = function getAlignmentStyle(_ref171) {
  var preset = _ref171.preset;
  var result = css67(_templateObject552 || (_templateObject552 = _taggedTemplateLiteral([""])));
  if (preset === "left") {
    result = css67(_templateObject553 || (_templateObject553 = _taggedTemplateLiteral(["\n            ", ";\n            justify-content: left;\n            align-items: flex-start;\n        "])), result);
  } else if (preset === "middle") {
    result = css67(_templateObject554 || (_templateObject554 = _taggedTemplateLiteral(["\n            ", ";\n            text-align: center;\n            justify-content: center;\n            align-items: center;\n        "])), result);
  } else if (preset === "right") {
    result = css67(_templateObject555 || (_templateObject555 = _taggedTemplateLiteral(["\n            ", ";\n            justify-content: right;\n            align-items: flex-end;\n            text-align: right;\n        "])), result);
  }
  return result;
};
var getEmptyStateContainerStyle = function getEmptyStateContainerStyle(_ref172) {
  var layout = _ref172.layout;
  var result = {};
  if (layout === "horizontal") {
    result = css67(_templateObject556 || (_templateObject556 = _taggedTemplateLiteral(["\n            ", ";\n            display: flex;\n            flex-direction: column;\n            justify-content: left;\n            width: fit-content;\n        "])), result);
  }
  return result;
};
var getTitleStyle = function getTitleStyle(_ref173) {
  var titlePosition = _ref173.titlePosition,
    layout = _ref173.layout,
    small = _ref173.small;
  var result = css67(_templateObject557 || (_templateObject557 = _taggedTemplateLiteral(["\n        display: flex;\n    "])));
  if (layout === "vertical") {
    result = css67(_templateObject558 || (_templateObject558 = _taggedTemplateLiteral(["\n            ", ";\n            margin-top: ", ";\n        "])), result, spacing66(4.5));
  }
  if (titlePosition === "left") {
    result = css67(_templateObject559 || (_templateObject559 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: flex-start;\n        "])), result);
  } else if (titlePosition === "middle") {
    result = css67(_templateObject560 || (_templateObject560 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: center;\n        "])), result);
  } else if (titlePosition === "right") {
    result = css67(_templateObject561 || (_templateObject561 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: flex-end;\n        "])), result);
  }
  if (small) {
    result = css67(_templateObject562 || (_templateObject562 = _taggedTemplateLiteral(["\n            ", ";\n            font-size: ", ";\n        "])), result, pixelToRem8(20));
  }
  return result;
};
var getDescriptionStyle = function getDescriptionStyle(_ref174) {
  var descriptionPosition = _ref174.descriptionPosition,
    small = _ref174.small;
  var result = {};
  if (small) {
    result = css67(_templateObject563 || (_templateObject563 = _taggedTemplateLiteral(["\n            ", ";\n            font-size: ", ";\n            margin-top: ", ";\n        "])), result, pixelToRem8(14), spacing66(2));
  }
  if (descriptionPosition === "left") {
    result = css67(_templateObject564 || (_templateObject564 = _taggedTemplateLiteral(["\n            ", ";\n            text-align: left;\n        "])), result);
  } else if (descriptionPosition === "middle") {
    result = css67(_templateObject565 || (_templateObject565 = _taggedTemplateLiteral(["\n            ", ";\n            text-align: center;\n        "])), result);
  } else if (descriptionPosition === "right") {
    result = css67(_templateObject566 || (_templateObject566 = _taggedTemplateLiteral(["\n            ", ";\n            text-align: right;\n        "])), result);
  }
  return result;
};
var getImageStyle = function getImageStyle(_ref175) {
  var imagePosition = _ref175.imagePosition;
  var result = {};
  if (imagePosition === "left") {
    result = css67(_templateObject567 || (_templateObject567 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: flex-start;\n        "])), result);
  } else if (imagePosition === "middle") {
    result = css67(_templateObject568 || (_templateObject568 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: center;\n        "])), result);
  } else if (imagePosition === "right") {
    result = css67(_templateObject569 || (_templateObject569 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: flex-end;\n        "])), result);
  }
  return result;
};
var getActionsContainerStyle2 = function getActionsContainerStyle2(_ref176) {
  var actionsPosition = _ref176.actionsPosition,
    small = _ref176.small;
  var result = css67(_templateObject570 || (_templateObject570 = _taggedTemplateLiteral(["\n        display: flex;\n    "])));
  if (actionsPosition === "left") {
    result = css67(_templateObject571 || (_templateObject571 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: flex-start;\n        "])), result);
  } else if (actionsPosition === "middle") {
    result = css67(_templateObject572 || (_templateObject572 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: center;\n        "])), result);
  } else if (actionsPosition === "right") {
    result = css67(_templateObject573 || (_templateObject573 = _taggedTemplateLiteral(["\n            ", ";\n            align-self: flex-end;\n        "])), result);
  }
  if (small) {
    result = css67(_templateObject574 || (_templateObject574 = _taggedTemplateLiteral(["\n            ", ";\n            margin-top: ", ";\n        "])), result, spacing66(4));
  }
  return result;
};
var getSVGStyle = function getSVGStyle(_ref177) {
  var small = _ref177.small;
  var side = small ? sizes3.small : sizes3.default;
  return css67(_templateObject575 || (_templateObject575 = _taggedTemplateLiteral(["\n        width: ", "px;\n        height: ", "px;\n    "])), side, side);
};
var EmptyStateRoot = styled98.div.withConfig(propsBlocker86)(_templateObject576 || (_templateObject576 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    display: flex;\n    flex-direction: column;\n    width: fit-content;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset27, typography45("paragraphMedium"), token61("body.color"), getAlignmentStyle, getComponentOverride70("EmptyState"), marginProps52, sizeProps8);
var EmptyStateTitle = styled98.div.withConfig(propsBlocker86)(_templateObject577 || (_templateObject577 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    font-size: ", ";\n    max-height: ", ";\n    ", ";\n"])), typography45("paragraphMedium"), color48("neutral.11"), pixelToRem8(32), pixelToRem8(48), getTitleStyle);
var EmptyStateDescription = styled98.div.withConfig(propsBlocker86)(_templateObject578 || (_templateObject578 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    font-size: ", ";\n    max-height: ", ";\n    margin-top: ", ";\n    ", ";\n"])), typography45("paragraphMedium"), color48("neutral.11"), pixelToRem8(16), spacing66(60), spacing66(4), getDescriptionStyle);
var EmptyStateActionContainer = styled98.div.withConfig(propsBlocker86)(_templateObject579 || (_templateObject579 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    ", ";\n"])), spacing66(8), getActionsContainerStyle2);
var EmptyStateHorizontalLayout = styled98.div.withConfig(propsBlocker86)(_templateObject580 || (_templateObject580 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    max-width: ", ";\n"])), spacing66(130));
var EmptyStateContainer = styled98.div.withConfig(propsBlocker86)(_templateObject581 || (_templateObject581 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n    ", ";\n"])), spacing66(10),
// @ts-ignore
getEmptyStateContainerStyle);
var EmptyStateVerticalLayout = styled98.div.withConfig(propsBlocker86)(_templateObject582 || (_templateObject582 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    max-width: ", ";\n    width: fit-content;\n    ", ";\n"])), spacing66(80), getAlignmentStyle);
var EmptyStateImageContainer = styled98.div.withConfig(propsBlocker86)(_templateObject583 || (_templateObject583 = _taggedTemplateLiteral(["\n    display: flex;\n    ", ";\n"])), getImageStyle);
var EmptyStateIllustrationSVG = styled98.svg.withConfig(propsBlocker86)(_templateObject584 || (_templateObject584 = _taggedTemplateLiteral(["\n    ", ";\n"])), getSVGStyle);

// src/components/EmptyState/EmptyStateIllustration.tsx
import React133, { memo as memo98 } from "react";
var EmptyStateIllustration = memo98(function (_ref178) {
  var small = _ref178.small;
  return /* @__PURE__ */React133.createElement(EmptyStateIllustrationSVG, {
    small: small,
    viewBox: "0 0 160 160",
    version: "1.1"
  }, /* @__PURE__ */React133.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */React133.createElement("g", {
    id: "Illustration"
  }, /* @__PURE__ */React133.createElement("polygon", {
    id: "shadow",
    fill: "#F4F4F4",
    points: "80 83 160 118.916497 80 160 0 118.916497"
  }), /* @__PURE__ */React133.createElement("polygon", {
    id: "Path",
    fill: "#A3A3A3",
    points: "80 77.0556309 80 139 160 98.1112619 160 36"
  }), /* @__PURE__ */React133.createElement("polygon", {
    id: "Path",
    fill: "#878787",
    points: "80 139 80 77.0556309 40.0835073 56.5278155 0 36 0 98.1112619"
  }), /* @__PURE__ */React133.createElement("polygon", {
    id: "Path",
    fill: "#DBDBDB",
    points: "80 0 160 35.9164969 80 77 0 35.9164969"
  }))));
});
EmptyStateIllustration.displayName = "EmptyStateIllustration";

// src/components/EmptyState/constants.ts
var EMPTY_STATE_CLASS_PREFIX = "EmptyState";

// src/components/EmptyState/EmptyState.tsx
var EmptyState = forwardRef80(function EmptyState2(_a, ref) {
  var _b = _a,
    className = _b.className,
    props = __objRest(_b, ["className"]);
  var classNames = useEmptyStateClassNames(EMPTY_STATE_CLASS_PREFIX, className);
  var _useEmptyState = useEmptyState(props, ref),
    rootProps = _useEmptyState.rootProps,
    horizontalLayoutProps = _useEmptyState.horizontalLayoutProps,
    verticalLayoutProps = _useEmptyState.verticalLayoutProps,
    imageContainerProps = _useEmptyState.imageContainerProps,
    imageIllustrationProps = _useEmptyState.imageIllustrationProps,
    titleProps = _useEmptyState.titleProps,
    actionsContainerProps = _useEmptyState.actionsContainerProps,
    descriptionProps = _useEmptyState.descriptionProps,
    layout = _useEmptyState.layout,
    enableTitle = _useEmptyState.enableTitle,
    enableActions = _useEmptyState.enableActions,
    enableDescription = _useEmptyState.enableDescription,
    enableImage = _useEmptyState.enableImage,
    image = _useEmptyState.image,
    actions = _useEmptyState.actions,
    description = _useEmptyState.description,
    title = _useEmptyState.title,
    renderImage = _useEmptyState.renderImage,
    renderIndicator = _useEmptyState.renderIndicator,
    renderDefaultImage = _useEmptyState.renderDefaultImage,
    children = _useEmptyState.children;
  return /* @__PURE__ */React134.createElement(EmptyStateRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), layout === "horizontal" && /* @__PURE__ */React134.createElement(EmptyStateHorizontalLayout, __spreadProps(__spreadValues({}, horizontalLayoutProps), {
    className: classNames.HorizontalLayout
  }), !!enableImage && /* @__PURE__ */React134.createElement(EmptyStateImageContainer, __spreadProps(__spreadValues({}, imageContainerProps), {
    className: classNames.ImageContainer
  }), renderIndicator && /* @__PURE__ */React134.createElement(Indicator, null), renderImage && image, renderDefaultImage && /* @__PURE__ */React134.createElement(EmptyStateIllustration, __spreadValues({}, imageIllustrationProps))), /* @__PURE__ */React134.createElement(EmptyStateContainer, {
    className: classNames.EmptyStateContainer
  }, !!enableTitle && /* @__PURE__ */React134.createElement(EmptyStateTitle, __spreadProps(__spreadValues({}, titleProps), {
    className: classNames.Title
  }), title), !!enableDescription && /* @__PURE__ */React134.createElement(EmptyStateDescription, __spreadProps(__spreadValues({}, descriptionProps), {
    className: classNames.Description
  }), description), !!enableActions && /* @__PURE__ */React134.createElement(EmptyStateActionContainer, __spreadProps(__spreadValues({}, actionsContainerProps), {
    className: classNames.ActionsContainer
  }), actions))), layout === "vertical" && /* @__PURE__ */React134.createElement(EmptyStateVerticalLayout, __spreadProps(__spreadValues({}, verticalLayoutProps), {
    className: classNames.VerticalLayout
  }), !!enableImage && /* @__PURE__ */React134.createElement(EmptyStateImageContainer, __spreadProps(__spreadValues({}, imageContainerProps), {
    className: classNames.ImageContainer
  }), renderIndicator && /* @__PURE__ */React134.createElement(Indicator, null), renderImage && image, renderDefaultImage && /* @__PURE__ */React134.createElement(EmptyStateIllustration, __spreadValues({}, imageIllustrationProps))), !!enableTitle && /* @__PURE__ */React134.createElement(EmptyStateTitle, __spreadProps(__spreadValues({}, titleProps), {
    className: classNames.Title
  }), title), !!enableDescription && /* @__PURE__ */React134.createElement(EmptyStateDescription, __spreadProps(__spreadValues({}, descriptionProps), {
    className: classNames.Description
  }), description), !!enableActions && /* @__PURE__ */React134.createElement(EmptyStateActionContainer, __spreadProps(__spreadValues({}, actionsContainerProps), {
    className: classNames.ActionsContainer
  }), actions)), children);
});
EmptyState.defaultProps = {
  title: "It's empty",
  description: "There's nothing to show here. Trying going back and updating  your request",
  enableImage: true,
  enableActions: true,
  layout: "vertical",
  enableTitle: true,
  enableDescription: true,
  small: false,
  enableIndicator: false
};
EmptyState.propTypes = {
  title: PropTypes73.string,
  description: PropTypes73.string,
  enableImage: PropTypes73.bool,
  image: PropTypes73.elementType,
  actions: PropTypes73.elementType,
  enableActions: PropTypes73.bool,
  enableTitle: PropTypes73.bool,
  enableDescription: PropTypes73.bool,
  small: PropTypes73.bool,
  enableIndicator: PropTypes73.bool
};
var MemoizedEmptyState = memo99(EmptyState);

// src/components/Stepper/Stepper.tsx
import React137, { forwardRef as forwardRef81, memo as memo100 } from "react";
import PropTypes74 from "prop-types";

// src/components/Stepper/hooks/useStepperClassNames.ts
import { useMemo as useMemo120 } from "react";
import { makeBEM as makeBEM70, makeRootClassName as makeRootClassName63 } from "@deliveryhero/armor-system";
var useStepperClassNames = function useStepperClassNames(classPrefix, className, vertical, minimal) {
  return useMemo120(function () {
    var baseClassNames = makeRootClassName63(classPrefix, className);
    var stateClassNames = [];
    if (vertical) {
      stateClassNames.push(makeBEM70(classPrefix, "Root", "vertical"));
    }
    if (minimal) {
      stateClassNames.push(makeBEM70(classPrefix, "Root", "minimal"));
    }
    return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
  }, [classPrefix, className, vertical, minimal]);
};

// src/components/Stepper/hooks/useStepper.ts
import React135, { useState as useState20, useEffect as useEffect23 } from "react";
var useStepper = function useStepper(_a, ref) {
  var _b = _a,
    children = _b.children,
    _b$activeIndex = _b.activeIndex,
    activeIndex = _b$activeIndex === void 0 ? 0 : _b$activeIndex,
    onActiveIndexChange = _b.onActiveIndexChange,
    vertical = _b.vertical,
    minimal = _b.minimal,
    readOnly = _b.readOnly,
    restProps = __objRest(_b, ["children", "activeIndex", "onActiveIndexChange", "vertical", "minimal", "readOnly"]);
  var _useState63 = useState20(activeIndex),
    _useState64 = _slicedToArray(_useState63, 2),
    currentIndex = _useState64[0],
    setCurrentActiveTab = _useState64[1];
  useEffect23(function () {
    setCurrentActiveTab(activeIndex);
  }, [activeIndex]);
  var handleClick = function handleClick(event, stepIndex) {
    setCurrentActiveTab(stepIndex);
    onActiveIndexChange == null ? void 0 : onActiveIndexChange(stepIndex);
  };
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      vertical: vertical,
      minimal: minimal,
      ref: ref,
      children: React135.Children.toArray(children).filter(React135.isValidElement).map(function (child, index) {
        return React135.cloneElement(child, {
          index: index + 1
        });
      })
    }),
    contextValue: {
      currentIndex: currentIndex,
      vertical: vertical,
      minimal: minimal,
      handleClick: handleClick,
      isActivityLogView: readOnly
    }
  };
};

// src/components/Stepper/constants.ts
var STEPPER_CLASS_PREFIX = "Stepper";
var STEP_CLASS_PREFIX = "Step";
var stepperRoot = "StepperRoot";
var stepRoot = "StepRoot";

// src/components/Stepper/StepperContext.tsx
import * as React136 from "react";
var StepperContext = React136.createContext({
  currentIndex: void 0,
  vertical: void 0,
  minimal: void 0,
  handleClick: void 0,
  isActivityLogView: void 0
});

// src/components/Stepper/style.ts
import styled99, { css as css68 } from "styled-components";
import { makeBEM as makeBEM71, marginProps as marginProps53, sizeProps as sizeProps9, propsBlocker as propsBlocker87, focus as focus10 } from "@deliveryhero/armor-system";
var getStepperRootStyle = function getStepperRootStyle(_ref179) {
  var vertical = _ref179.vertical;
  var result = {};
  if (vertical) {
    result = css68(_templateObject585 || (_templateObject585 = _taggedTemplateLiteral(["\n            flex-direction: column;\n        "])));
  } else {
    result = css68(_templateObject586 || (_templateObject586 = _taggedTemplateLiteral(["\n            .", " {\n                position: relative;\n            }\n        "])), makeBEM71("Step", "Piece"));
  }
  return result;
};
var StepperRoot = styled99.div.withConfig(propsBlocker87)(_templateObject587 || (_templateObject587 = _taggedTemplateLiteral(["\n    display: flex;\n    position: relative;\n\n    ", ";\n    ", "\n    ", ";\n    ", ";\n"])), getStepperRootStyle, focus10(), sizeProps9, marginProps53);

// src/components/Stepper/Stepper.tsx
var Stepper = forwardRef81(function Stepper2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var _useStepper = useStepper(restProps, ref),
    contextValue = _useStepper.contextValue,
    rootProps = _useStepper.rootProps;
  var classNameRoot = useStepperClassNames(STEPPER_CLASS_PREFIX, className, restProps.vertical, restProps.minimal);
  return /* @__PURE__ */React137.createElement(StepperContext.Provider, {
    value: contextValue
  }, /* @__PURE__ */React137.createElement(StepperRoot, __spreadProps(__spreadValues({
    "data-testid": stepperRoot
  }, rootProps), {
    className: classNameRoot
  })));
});
Stepper.propTypes = {
  vertical: PropTypes74.bool,
  minimal: PropTypes74.bool,
  activeIndex: PropTypes74.number,
  onActiveIndexChange: PropTypes74.func,
  className: PropTypes74.string,
  /**
    If set, the activity log (readOnly) view is active
  */
  readOnly: PropTypes74.bool
};
Stepper.defaultProps = {
  vertical: false,
  minimal: false,
  activeIndex: 0,
  readOnly: false
};
var MemoizedStepper = memo100(Stepper);

// src/components/Stepper/Step/Step.tsx
import React139, { isValidElement as isValidElement2, forwardRef as forwardRef82, memo as memo101 } from "react";
import PropTypes75 from "prop-types";
import { TickThickIcon as TickThickIcon2 } from "@deliveryhero/armor-icons";

// src/components/Stepper/Step/hooks/useStep.tsx
import { useCallback as useCallback37, useContext as useContext9, useState as useState21, useEffect as useEffect24 } from "react";

// src/components/Stepper/Step/utils/getStepVariantByStatus.ts
var getStepVariantByStatus = function getStepVariantByStatus(_ref180) {
  var warning = _ref180.warning,
    error = _ref180.error,
    success = _ref180.success,
    info = _ref180.info;
  if (warning) {
    return "warning" /* warning */;
  }

  if (error) {
    return "error" /* error */;
  }

  if (success) {
    return "success" /* success */;
  }

  if (info) {
    return "info" /* info */;
  }

  return "log" /* log */;
};

// src/components/Stepper/Step/hooks/useStep.tsx
var useStep = function useStep(_a, ref) {
  var _b = _a,
    warning = _b.warning,
    error = _b.error,
    success = _b.success,
    info = _b.info,
    index = _b.index,
    icon = _b.icon,
    title = _b.title,
    description = _b.description,
    extraInfo = _b.extraInfo,
    restProps = __objRest(_b, ["warning", "error", "success", "info", "index", "icon", "title", "description", "extraInfo"]);
  var _useState65 = useState21("incomplete" /* incomplete */),
    _useState66 = _slicedToArray(_useState65, 2),
    variant = _useState66[0],
    setVariant = _useState66[1];
  var _useContext8 = useContext9(StepperContext),
    currentIndex = _useContext8.currentIndex,
    handleClick = _useContext8.handleClick,
    vertical = _useContext8.vertical,
    minimal = _useContext8.minimal,
    isActivityLogView = _useContext8.isActivityLogView;
  useEffect24(function () {
    if (isActivityLogView) {
      setVariant(getStepVariantByStatus({
        warning: warning,
        error: error,
        success: success,
        info: info
      }));
      return;
    }
    if (index === void 0 || currentIndex === void 0) {
      console.warn("index: undefined");
      return;
    }
    if (currentIndex === index - 1) {
      setVariant("active" /* active */);
    } else if (currentIndex > index - 1) {
      if (warning) {
        setVariant("warning" /* warning */);
      } else if (error) {
        setVariant("error" /* error */);
      } else {
        setVariant("complete" /* complete */);
      }
    } else {
      setVariant("incomplete" /* incomplete */);
    }
  }, [currentIndex, error, index, info, isActivityLogView, success, warning]);
  var handleSelect = useCallback37(function (event) {
    if (index !== void 0 && currentIndex !== void 0 && currentIndex > index - 1) {
      handleClick == null ? void 0 : handleClick(event, index - 1);
    }
  }, [handleClick, index, currentIndex]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: ref,
      vertical: vertical,
      onClick: handleSelect,
      isActivityLogView: isActivityLogView
    }),
    stepperButtonProps: {
      vertical: vertical
    },
    stepperPieceProps: {
      variant: variant,
      minimal: minimal,
      index: index
    },
    stepperLineProps: {
      vertical: vertical,
      variant: variant
    },
    variant: variant,
    icon: icon,
    isIconShown: !!icon && !minimal,
    title: title,
    description: description,
    extraInfo: extraInfo,
    isExtraInfoShown: vertical && extraInfo,
    vertical: vertical
  };
};

// src/components/Stepper/Step/hooks/useStepClassNames.ts
import { useMemo as useMemo121 } from "react";
import { appendClassName as appendClassName41, makeRootClassName as makeRootClassName64, makeBEM as makeBEM72 } from "@deliveryhero/armor-system";
var useStepClassNames = function useStepClassNames(classPrefix, className, variant) {
  return useMemo121(function () {
    return {
      Root: appendClassName41(makeRootClassName64(classPrefix, className), makeBEM72(classPrefix, "Root", variant)),
      Wrapper: makeBEM72(classPrefix, "Wrapper"),
      Button: makeBEM72(classPrefix, "Button"),
      Icon: makeBEM72(classPrefix, "Icon"),
      Number: makeBEM72(classPrefix, "Number"),
      Content: makeBEM72(classPrefix, "Content"),
      Title: makeBEM72(classPrefix, "Title"),
      ExtraInfo: makeBEM72(classPrefix, "ExtraInfo"),
      Description: makeBEM72(classPrefix, "Description"),
      Line: makeBEM72(classPrefix, "Line"),
      Piece: makeBEM72(classPrefix, "Piece")
    };
  }, [classPrefix, className, variant]);
};

// src/components/Stepper/Step/style.ts
import styled100, { css as css69 } from "styled-components";
import { makeBEM as makeBEM73, propsBlocker as propsBlocker88, color as color49, spacing as spacing67, typography as typography46, transition as transition24, getComponentOverride as getComponentOverride71, token as token62 } from "@deliveryhero/armor-system";
var stepPieceClassName = makeBEM73("Step", "Piece");
var stepIconClassName = makeBEM73("Step", "Icon");
var stepNumberClassName = makeBEM73("Step", "Number");
var stepTitleClassName = makeBEM73("Step", "Title");
var stepDescriptionClassName = makeBEM73("Step", "Description");
var stepPieceWrapperClassName = makeBEM73("Step", "Wrapper");
var stepButtonClassName = makeBEM73("Step", "Button");
var completeClassName = makeBEM73("Step", "Root", "complete");
var incompleteClassName = makeBEM73("Step", "Root", "incomplete");
var activeClassName = makeBEM73("Step", "Root", "active");
var warningClassName = makeBEM73("Step", "Root", "warning");
var errorClassName = makeBEM73("Step", "Root", "error");
var logClassName = makeBEM73("Step", "Root", "log");
var successClassName = makeBEM73("Step", "Root", "success");
var infoClassName = makeBEM73("Step", "Root", "info");
var stepLineClassName = makeBEM73("Step", "Line");
var getStepperPieceWrapperRootStyle = function getStepperPieceWrapperRootStyle(_ref181) {
  var minimal = _ref181.minimal,
    variant = _ref181.variant;
  var size;
  var backgroundAndBorderColor;
  if (variant === "active" /* active */ && minimal) {
    size = css69(_templateObject588 || (_templateObject588 = _taggedTemplateLiteral(["\n            height: ", ";\n            width: ", ";\n            > .", ", .", " {\n                display: none;\n            }\n        "])), spacing67(4), spacing67(4), stepIconClassName, stepNumberClassName);
  } else if (minimal) {
    size = css69(_templateObject589 || (_templateObject589 = _taggedTemplateLiteral(["\n            height: ", ";\n            width: ", ";\n            > .", ", .", " {\n                display: none;\n            }\n        "])), spacing67(2), spacing67(2), stepIconClassName, stepNumberClassName);
  } else {
    size = css69(_templateObject590 || (_templateObject590 = _taggedTemplateLiteral(["\n            height: ", ";\n            width: ", ";\n        "])), spacing67(6), spacing67(6));
  }
  switch (variant) {
    case "incomplete" /* incomplete */:
      backgroundAndBorderColor = css69(_templateObject591 || (_templateObject591 = _taggedTemplateLiteral(["\n                border-color: ", ";\n            "])), color49("neutral.03"));
      break;
    case "active" /* active */:
      backgroundAndBorderColor = css69(_templateObject592 || (_templateObject592 = _taggedTemplateLiteral(["\n                background-color: ", ";\n                .", " {\n                    color: ", ";\n                }\n            "])), color49("primary.07"), stepNumberClassName, color49("neutral.00"));
      break;
    case "complete" /* complete */:
      backgroundAndBorderColor = css69(_templateObject593 || (_templateObject593 = _taggedTemplateLiteral(["\n                background-color: ", ";\n            "])), color49("primary.01"));
      break;
    case "warning" /* warning */:
      backgroundAndBorderColor = css69(_templateObject594 || (_templateObject594 = _taggedTemplateLiteral(["\n                background-color: ", ";\n                .", " {\n                    color: ", ";\n                }\n            "])), color49("warning.02"), stepNumberClassName, color49("neutral.11"));
      break;
    case "error" /* error */:
      backgroundAndBorderColor = css69(_templateObject595 || (_templateObject595 = _taggedTemplateLiteral(["\n                background-color: ", ";\n                .", " {\n                    color: ", ";\n                }\n            "])), color49("error.01"), stepNumberClassName, color49("neutral.11"));
      break;
    case "info" /* info */:
      backgroundAndBorderColor = css69(_templateObject596 || (_templateObject596 = _taggedTemplateLiteral(["\n                background-color: ", ";\n            "])), color49("primary.01"));
      break;
    case "success" /* success */:
      backgroundAndBorderColor = css69(_templateObject597 || (_templateObject597 = _taggedTemplateLiteral(["\n                background-color: ", ";\n            "])), color49("success.02"));
      break;
    default:
      backgroundAndBorderColor = css69(_templateObject598 || (_templateObject598 = _taggedTemplateLiteral(["\n                border-color: ", ";\n            "])), color49("neutral.03"));
      break;
  }
  return css69(_templateObject599 || (_templateObject599 = _taggedTemplateLiteral(["\n        ", ";\n        ", ";\n    "])), size, backgroundAndBorderColor);
};
var getStepButtonRootStyle = function getStepButtonRootStyle(_ref182) {
  var vertical = _ref182.vertical;
  var result = {};
  if (vertical) {
    result = css69(_templateObject600 || (_templateObject600 = _taggedTemplateLiteral(["\n            .", ", .", " {\n                text-align: left;\n            }\n        "])), stepTitleClassName, stepDescriptionClassName);
  } else {
    result = css69(_templateObject601 || (_templateObject601 = _taggedTemplateLiteral(["\n            flex-direction: column;\n            align-items: center;\n            .", " {\n                white-space: nowrap;\n                text-overflow: ellipsis;\n                overflow: hidden;\n\n                @supports (-webkit-line-clamp: 2) {\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: initial;\n                    display: -webkit-box;\n                    -webkit-line-clamp: 2;\n                    -webkit-box-orient: vertical;\n                }\n            }\n        "])), stepDescriptionClassName);
  }
  return result;
};
var getStepRootStyle = function getStepRootStyle(_ref183) {
  var vertical = _ref183.vertical,
    isActivityLogView = _ref183.isActivityLogView;
  var result = css69(_templateObject602 || (_templateObject602 = _taggedTemplateLiteral(["\n        position: relative;\n        margin: 0 ", ";\n\n        :last-child .", " {\n            display: none;\n        }\n        &.", " .", " {\n            background-color: ", ";\n        }\n        &.", " .", " {\n            background-color: ", ";\n        }\n        &.", " .", " {\n            background-color: ", ";\n        }\n        &.", " .", " {\n            background-color: ", ";\n        }\n        &.", " .", " {\n            background-color: ", ";\n        }\n    "])), spacing67(2), stepLineClassName, warningClassName, stepLineClassName, color49("warning.03"), errorClassName, stepLineClassName, color49("error.02"), logClassName, stepLineClassName, color49("neutral.03"), successClassName, stepLineClassName, color49("success.03"), infoClassName, stepLineClassName, color49("primary.03"));
  if (!isActivityLogView) {
    result = css69(_templateObject603 || (_templateObject603 = _taggedTemplateLiteral(["\n            ", "\n            &:not(.", ", .", ") .", " {\n                cursor: pointer;\n                &:hover {\n                    .", " {\n                        color: ", ";\n                    }\n                }\n            }\n            &.", "\n                .", ":hover\n                .", " {\n                border: 1px solid ", ";\n            }\n            &.", "\n                .", ":hover\n                .", " {\n                border: 1px solid ", ";\n            }\n            &.", "\n                .", ":hover\n                .", " {\n                border: 1px solid ", ";\n            }\n        "])), result, incompleteClassName, activeClassName, stepButtonClassName, stepTitleClassName, color49("primary.06"), completeClassName, stepButtonClassName, stepPieceWrapperClassName, color49("primary.06"), warningClassName, stepButtonClassName, stepPieceWrapperClassName, color49("warning.07"), errorClassName, stepButtonClassName, stepPieceWrapperClassName, color49("error.06"));
  }
  if (vertical) {
    result = css69(_templateObject604 || (_templateObject604 = _taggedTemplateLiteral(["\n            ", "\n            min-height: ", ";\n            margin-bottom: ", ";\n            .", " {\n                margin-right: ", ";\n            }\n        "])), result, spacing67(15), spacing67(2), stepPieceClassName, spacing67(2));
  } else {
    result = css69(_templateObject605 || (_templateObject605 = _taggedTemplateLiteral(["\n            ", "\n            width: ", ";\n            .", " {\n                margin-right: ", ";\n                margin-left: ", ";\n            }\n        "])), result, spacing67(31), stepPieceClassName, spacing67(1), spacing67(1));
  }
  return result;
};
var getStepperLineStyle = function getStepperLineStyle(_ref184) {
  var vertical = _ref184.vertical,
    variant = _ref184.variant;
  var result = {};
  var background = css69(_templateObject606 || (_templateObject606 = _taggedTemplateLiteral(["\n        background-color: ", ";\n    "])), variant === "complete" /* complete */ ? color49("primary.07") : color49("neutral.03"));
  if (vertical) {
    result = css69(_templateObject607 || (_templateObject607 = _taggedTemplateLiteral(["\n            top: ", ";\n            /* minus the line 1px width to make it center */\n            left: calc(", " - 1);\n            width: 1px;\n            bottom: 0;\n            ", ";\n        "])), spacing67(8), spacing67(3), background);
  } else {
    result = css69(_templateObject608 || (_templateObject608 = _taggedTemplateLiteral(["\n            top: 50%;\n            /* push to the exterm left and then the 8px for margin */\n            left: calc(100% + ", ");\n            width: ", ";\n            height: 1px;\n            ", ";\n        "])), spacing67(2), spacing67(25), background);
  }
  return result;
};
var StepperLine = styled100.div(_templateObject609 || (_templateObject609 = _taggedTemplateLiteral(["\n    position: absolute;\n\n    ", ";\n"])), getStepperLineStyle);
var StepRoot = styled100.div.withConfig(propsBlocker88)(_templateObject610 || (_templateObject610 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"])), getStepRootStyle, getComponentOverride71("Step"));
var StepButton = styled100.button(_templateObject611 || (_templateObject611 = _taggedTemplateLiteral(["\n    background-color: transparent;\n    border: 0;\n    display: flex;\n    padding: 0;\n    width: 100%;\n\n    ", ";\n"])), getStepButtonRootStyle);
var StepContent = styled100.div(_templateObject612 || (_templateObject612 = _taggedTemplateLiteral(["\n    flex: 1 0;\n"])));
var StepperPieceWrapper = styled100.div.withConfig(propsBlocker88)(_templateObject613 || (_templateObject613 = _taggedTemplateLiteral(["\n    border-radius: 50%;\n    border: 1px solid transparent;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", ";\n\n    ", ";\n"])), transition24({
  border: true
}), getStepperPieceWrapperRootStyle);
var StepperPieceRoot = styled100.div(_templateObject614 || (_templateObject614 = _taggedTemplateLiteral(["\n    height: ", ";\n    width: ", ";\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: ", ";\n"])), spacing67(6), spacing67(6), spacing67(2));
var StepperPieceNumber = styled100.p(_templateObject615 || (_templateObject615 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n"])), typography46("paragraphMedium"), token62("body.color"));

// src/components/Stepper/Step/Step.tsx
var Step = forwardRef82(function Step2(_a, ref) {
  var _b = _a,
    className = _b.className,
    restProps = __objRest(_b, ["className"]);
  var _useStep = useStep(restProps, ref),
    variant = _useStep.variant,
    rootProps = _useStep.rootProps,
    stepperButtonProps = _useStep.stepperButtonProps,
    stepperLineProps = _useStep.stepperLineProps,
    stepperPieceProps = _useStep.stepperPieceProps,
    icon = _useStep.icon,
    isIconShown = _useStep.isIconShown,
    title = _useStep.title,
    description = _useStep.description,
    extraInfo = _useStep.extraInfo,
    isExtraInfoShown = _useStep.isExtraInfoShown,
    vertical = _useStep.vertical;
  var classOverride = useStepClassNames(STEP_CLASS_PREFIX, className, variant);
  return /* @__PURE__ */React139.createElement(StepRoot, __spreadProps(__spreadValues({
    "data-testid": stepRoot
  }, rootProps), {
    className: classOverride.Root
  }), /* @__PURE__ */React139.createElement(StepButton, __spreadValues({
    className: classOverride.Button,
    type: "button"
  }, stepperButtonProps), /* @__PURE__ */React139.createElement(StepperPieceRoot, {
    className: classOverride.Piece
  }, /* @__PURE__ */React139.createElement(StepperPieceWrapper, __spreadProps(__spreadValues({}, stepperPieceProps), {
    className: classOverride.Wrapper
  }), isIconShown && icon, !isIconShown && ("complete" /* complete */ === variant ? /* @__PURE__ */React139.createElement(TickThickIcon2, {
    small: true,
    className: classOverride.Icon,
    color: "primary.07"
  }) : /* @__PURE__ */React139.createElement(StepperPieceNumber, {
    className: classOverride.Number
  }, stepperPieceProps.index))), /* @__PURE__ */React139.createElement(StepperLine, __spreadProps(__spreadValues({}, stepperLineProps), {
    className: classOverride.Line
  }))), /* @__PURE__ */React139.createElement(StepContent, {
    className: classOverride.Content
  }, /* @__PURE__ */React139.createElement(Pack, {
    alignItems: "center",
    justifyContent: vertical ? "space-between" : "center"
  }, /* @__PURE__ */React139.createElement(PackItem, {
    flexGrow: 1,
    flexShrink: 1
  }, /* @__PURE__ */React139.createElement(Typography, {
    className: classOverride.Title,
    paragraph: true,
    medium: true,
    margin: 0
  }, title)), isExtraInfoShown && /* @__PURE__ */React139.createElement(PackItem, {
    alignSelf: "flex-start",
    flexShrink: 0,
    marginLeft: 2,
    marginTop: 0.5
  }, /* @__PURE__ */React139.createElement(Typography, {
    className: classOverride.ExtraInfo,
    paragraph: true,
    small: true,
    margin: 0,
    color: "neutral.05"
  }, extraInfo))), isValidElement2(description) ? description : /* @__PURE__ */React139.createElement(Typography, {
    className: classOverride.Description,
    paragraph: true,
    small: true,
    margin: 0,
    color: "neutral.05"
  }, description))));
});
Step.propTypes = {
  /** The step's title */
  title: PropTypes75.string,
  /** The step's description */
  description: PropTypes75.oneOfType([PropTypes75.string, PropTypes75.element]),
  index: PropTypes75.number,
  /** The step's extra info (only capable in vertical mode) */
  extraInfo: PropTypes75.oneOfType([PropTypes75.string, PropTypes75.element]),
  /** If there is a warning in the step */
  warning: PropTypes75.bool,
  /** If there is a error in the step */
  error: PropTypes75.bool,
  /** If there is a success in the step */
  success: PropTypes75.bool,
  /** If there is a info in the step */
  info: PropTypes75.bool,
  /** Set icon for each step instead of the default number */
  icon: PropTypes75.element
};
Step.defaultProps = {
  index: 0
};
var MemoizedStep = memo101(Step);

// src/components/ContentSwitcher/ContentSwitcher.tsx
import React141, { forwardRef as forwardRef83, memo as memo102 } from "react";
import PropTypes76 from "prop-types";

// src/components/ContentSwitcher/hooks/useContentSwitcherClassNames.ts
import { useMemo as useMemo122 } from "react";
import { makeRootClassName as makeRootClassName65 } from "@deliveryhero/armor-system";
var useContentSwitcherClassNames = function useContentSwitcherClassNames(classPrefix, className) {
  return useMemo122(function () {
    return {
      Root: makeRootClassName65(classPrefix, className)
    };
  }, [classPrefix, className]);
};

// src/components/ContentSwitcher/hooks/useContentSwitcher.ts
import { useMemo as useMemo123, Children as Children7 } from "react";
import { useControlledState as useControlledState8 } from "@deliveryhero/armor-system";
var useContentSwitcher = function useContentSwitcher(_a, ref) {
  var _b = _a,
    onSwitchNameChangeCb = _b.onSwitchNameChange,
    selectedSwitchNameProp = _b.switchName,
    defaultSwitchName = _b.defaultSwitchName,
    children = _b.children,
    restProps = __objRest(_b, ["onSwitchNameChange", "switchName", "defaultSwitchName", "children"]);
  var _useControlledState17 = useControlledState8(defaultSwitchName, selectedSwitchNameProp, onSwitchNameChangeCb),
    _useControlledState18 = _slicedToArray(_useControlledState17, 2),
    selectedSwitchName = _useControlledState18[0],
    setSelectedSwitchName = _useControlledState18[1];
  var contextValue = useMemo123(function () {
    var childrenIndexMap = {};
    Children7.map(children, function (child, index) {
      var _a2;
      childrenIndexMap[(_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.switchName] = index;
    });
    return {
      switchName: selectedSwitchName,
      onSwitchNameChange: setSelectedSwitchName,
      childrenIndexMap: childrenIndexMap
    };
  }, [selectedSwitchName, setSelectedSwitchName, children]);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: ref
    }),
    contextValue: contextValue
  };
};

// src/components/ContentSwitcher/style.ts
import styled101, { css as css70 } from "styled-components";
import { marginProps as marginProps54, propsBlocker as propsBlocker89, getComponentOverride as getComponentOverride72, reset as reset28, typography as typography47, widthProps as widthProps20, token as token63 } from "@deliveryhero/armor-system";
var getRootStyle22 = function getRootStyle22() {
  return css70(_templateObject616 || (_templateObject616 = _taggedTemplateLiteral(["\n        display: inline-flex;\n        background-color: ", ";\n        height: ", "px;\n    "])), token63("control.color.secondary.enabled", "color.neutral.00"), token63("control.sizing.small"));
};
var ContentSwitcherRoot = styled101.div.withConfig(propsBlocker89)(_templateObject617 || (_templateObject617 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    width: fit-content;\n\n    svg {\n        color: inherit;\n    }\n\n    ", ";\n    ", ";\n    ", ";\n    ", "\n"])), reset28, typography47("desktop.bodyMedium", "paragraphMedium"), token63("text.color.primary", "body.color"), getRootStyle22, getComponentOverride72("ContentSwitcher"), marginProps54, widthProps20);

// src/components/ContentSwitcher/constants.ts
var CONTENTSWITCHER_CLASS_PREFIX = "ContentSwitcher";
var ContentSwitcherRootTestId = "ContentSwitcherRoot";

// src/components/ContentSwitcher/ContentSwitcherContext.ts
import * as React140 from "react";
var ContentSwitcherContext = React140.createContext({
  switchName: void 0,
  onSwitchNameChange: void 0,
  childrenIndexMap: void 0
});

// src/components/ContentSwitcher/ContentSwitcher.tsx
var ContentSwitcher = forwardRef83(function ContentSwitcher2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var classNames = useContentSwitcherClassNames(CONTENTSWITCHER_CLASS_PREFIX, className);
  var _a2 = useContentSwitcher(__spreadProps(__spreadValues({}, props), {
      children: children
    }), ref),
    _b2 = _a2.rootProps,
    restProps = __objRest(_b2, []),
    contextValue = _a2.contextValue;
  return /* @__PURE__ */React141.createElement(ContentSwitcherContext.Provider, {
    value: contextValue
  }, /* @__PURE__ */React141.createElement(ContentSwitcherRoot, __spreadProps(__spreadValues({}, restProps), {
    "data-testid": ContentSwitcherRootTestId,
    className: classNames.Root
  }), children));
});
ContentSwitcher.displayName = CONTENTSWITCHER_CLASS_PREFIX;
ContentSwitcher.propTypes = {
  /** For controlled usage: Switch with the name passed here will be shown as selected */
  switchName: PropTypes76.string,
  /** Callback function which will be called after clicking
   * any of the unselected switch controls and receive first
   * argument as object containing name and index of selected switch control
   */
  onSwitchNameChange: PropTypes76.func,
  /**
   * Switch with the name passed here will be shown as selected for first load
   */
  defaultSwitchName: PropTypes76.string
};
var MemoizedContentSwitcher = memo102(ContentSwitcher);

// src/components/ContentSwitcher/ContentSwitcherControl/ContentSwitcherControl.tsx
import React142, { forwardRef as forwardRef84, memo as memo103 } from "react";
import PropTypes77 from "prop-types";

// src/components/ContentSwitcher/ContentSwitcherControl/hooks/useContentSwitcherControlClassNames.ts
import { useMemo as useMemo124 } from "react";
import { makeRootClassName as makeRootClassName66, makeBEM as makeBEM74 } from "@deliveryhero/armor-system";
var useContentSwitcherControlClassNames = function useContentSwitcherControlClassNames(classPrefix, className, selected, disabled) {
  return useMemo124(function () {
    var baseClassNames = makeRootClassName66(classPrefix, className);
    var stateClassNames = [];
    if (selected) {
      stateClassNames.push(makeBEM74(classPrefix, "Root", "selected"));
    }
    if (disabled) {
      stateClassNames.push(makeBEM74(classPrefix, "Root", "disabled"));
    }
    return "".concat(baseClassNames, " ").concat(stateClassNames.join(" ")).trim();
  }, [classPrefix, className, selected, disabled]);
};

// src/components/ContentSwitcher/ContentSwitcherControl/hooks/useContentSwitcherControl.ts
import { useContext as useContext10 } from "react";
import { useRootRef as useRootRef32 } from "@deliveryhero/armor-system";
var useContentSwitcherControl = function useContentSwitcherControl(_a, ref) {
  var _b = _a,
    switchName = _b.switchName,
    disabled = _b.disabled,
    restProps = __objRest(_b, ["switchName", "disabled"]);
  var innerRef = useRootRef32(ref);
  var _useContext9 = useContext10(ContentSwitcherContext),
    onSwitchNameChange = _useContext9.onSwitchNameChange,
    selectedSwitchName = _useContext9.switchName,
    childrenIndexMap = _useContext9.childrenIndexMap;
  var selected = !disabled && !!switchName && !!selectedSwitchName && (childrenIndexMap == null ? void 0 : childrenIndexMap[switchName]) === (childrenIndexMap == null ? void 0 : childrenIndexMap[selectedSwitchName]);
  return {
    rootProps: __spreadValues(__spreadProps(__spreadValues({}, restProps), {
      disabled: disabled,
      ref: innerRef,
      switchName: switchName,
      onClick: function onClick() {
        return !!switchName && (onSwitchNameChange == null ? void 0 : onSwitchNameChange(switchName));
      }
    }), selected && {
      selected: selected,
      "data-selected": selected
    }),
    classNameProps: [selected, disabled]
  };
};

// src/components/ContentSwitcher/ContentSwitcherControl/style.ts
import styled102, { css as css71 } from "styled-components";
import { marginProps as marginProps55, propsBlocker as propsBlocker90, reset as reset29, typography as typography48, spacing as spacing68, mouseCursor as mouseCursor9, transition as transition25, token as token64, focus as focus11 } from "@deliveryhero/armor-system";
var disabledStyle = css71(_templateObject618 || (_templateObject618 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n\n    &:active,\n    &:hover {\n        color: ", ";\n        background-color: ", ";\n    }\n"])), token64("text.color.disabled", "color.neutral.05"), token64("control.color.secondary.enabled", "unset"), token64("text.color.disabled", "color.neutral.05"), token64("control.color.secondary.enabled", "unset"));
var getRootStyle23 = function getRootStyle23() {
  return css71(_templateObject619 || (_templateObject619 = _taggedTemplateLiteral(["\n    padding: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    background-color: ", ";\n    position: relative;\n    display: flex;\n    align-items: center;\n    border: ", "px solid;\n    border-color: ", ";\n    flex-grow: 1;\n    justify-content: center;\n    color: ", ";\n    ", ";\n\n    &:hover {\n        color: ", ";\n        background-color: ", ";\n    }\n\n    &::before {\n        position: absolute;\n        left: -1px;\n        display: block;\n        width: 1px;\n        height: ", ";\n        background-color: ", ";\n        content: '';\n    }\n\n    &:first-child::before,\n    &:focus-visible::before,\n    &:focus-visible + button::before {\n        content: none;\n    }\n\n    &:first-of-type {\n        border-top-left-radius: ", ";\n        border-bottom-left-radius: ", ";\n        border-right-color: transparent;\n    }\n\n    &:last-of-type {\n        border-top-right-radius: ", ";\n        border-bottom-right-radius: ", ";\n        border-left-color: transparent;\n    }\n\n    &:not(:first-of-type):not(:last-of-type) {\n        border-left-color: transparent;\n        border-right-color: transparent;\n    }\n"])), spacing68(2), spacing68("control.spacing.large", [4]), spacing68("control.spacing.large", [4]), token64("control.color.secondary.enabled", "color.neutral.00"), token64("control.borderWidth.thin", 1), token64("border.color.high", "color.neutral.03"), token64("text.color.primary", "color.neutral.11"), transition25({
    all: true
  }), token64("action.color.primary.hover", "color.primary.05"), token64("control.color.secondary.hover"), token64("action.sizing.tiny", "1rem", {
    returnUnit: "px"
  }), token64("border.color.high", "color.neutral.03"), token64("control.borderRadius.small", "shape.borderRadius.soft", {
    returnUnit: "px"
  }), token64("control.borderRadius.small", "shape.borderRadius.soft", {
    returnUnit: "px"
  }), token64("control.borderRadius.small", "shape.borderRadius.soft", {
    returnUnit: "px"
  }), token64("control.borderRadius.small", "shape.borderRadius.soft", {
    returnUnit: "px"
  }));
};
var getDynamicStyle3 = function getDynamicStyle3(props) {
  var result = {};
  var selected = props.selected,
    disabled = props.disabled;
  if (selected) {
    result = css71(_templateObject620 || (_templateObject620 = _taggedTemplateLiteral(["\n            color: ", ";\n            background-color: ", ";\n            border-color: ", ";\n\n            &::before,\n            & + button::before {\n                content: none;\n            }\n\n            &:first-of-type {\n                border-color: ", ";\n            }\n\n            &:last-of-type {\n                border-color: ", ";\n            }\n\n            &:not(:first-of-type):not(:last-of-type) {\n                border-color: ", ";\n            }\n        "])), token64("action.color.primary.enabled", "color.primary.07"), token64("control.color.secondary.selected", "color.primary.01"), token64("action.color.primary.enabled", "color.primary.07"), token64("action.color.primary.enabled", "color.primary.07"), token64("action.color.primary.enabled", "color.primary.07"), token64("action.color.primary.enabled", "color.primary.07"));
  }
  if (disabled) {
    result = css71(_templateObject621 || (_templateObject621 = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "])), result, disabledStyle);
  }
  return result;
};
var ContentSwitcherControlRoot = styled102.button.withConfig(propsBlocker90)(_templateObject622 || (_templateObject622 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset29, typography48("desktop.bodyMedium", "paragraphMedium"), token64("text.color.primary", "body.color"), function (_ref185) {
  var selected = _ref185.selected,
    disabled = _ref185.disabled;
  return focus11({
    disabled: disabled,
    noOutline: selected
  });
}, mouseCursor9, getRootStyle23, getDynamicStyle3, marginProps55);

// src/components/ContentSwitcher/ContentSwitcherControl/constants.ts
var SWITCH_CONTROL_CLASS_PREFIX = "ContentSwitcherControl";
var ContentSwitcherControlRootTestId = "ContentSwitcherControlRoot";

// src/components/ContentSwitcher/ContentSwitcherControl/ContentSwitcherControl.tsx
var ContentSwitcherControl = forwardRef84(function Switch3(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    restProps = __objRest(_b, ["className", "children"]);
  var _useContentSwitcherCo = useContentSwitcherControl(restProps, ref),
    rootProps = _useContentSwitcherCo.rootProps,
    classNameProps = _useContentSwitcherCo.classNameProps;
  var classNames = useContentSwitcherControlClassNames.apply(void 0, [SWITCH_CONTROL_CLASS_PREFIX, className].concat(_toConsumableArray(classNameProps)));
  return /* @__PURE__ */React142.createElement(ContentSwitcherControlRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames,
    "data-testid": ContentSwitcherControlRootTestId
  }), children);
});
ContentSwitcherControl.propTypes = {
  /** String value that will be passed as argument in
   * callback function upon switch change */
  switchName: PropTypes77.string.isRequired,
  /** Reserved - Sets a flag on switch as selected */
  selected: PropTypes77.bool,
  /** Set true for a disabled state */
  disabled: PropTypes77.bool
};
var MemoizedContentSwitcherControl = memo103(ContentSwitcherControl);

// src/components/Toast/Toast.tsx
import React144, { forwardRef as forwardRef85, memo as memo104 } from "react";
import PropTypes78 from "prop-types";

// src/components/Toast/hooks/useToastContainer.ts
import { createElement as createElement2, useEffect as useEffect25 } from "react";
import { render } from "react-dom";
import { getWindow as getWindow8, zIndexToast } from "@deliveryhero/armor-system";
import { useTheme as useTheme4 } from "styled-components";

// src/components/Toast/constants.ts
var TOAST_CLASS_PREFIX = "Toast";
var TOAST_CONTAINER_PREFIX = "ToastContainer";
var DEFAULT_AUTO_CLOSE = true;
var DEFAULT_AUTO_CLOSE_TIME = 5e3;
var DEFAULT_PROGRESS_BAR_SHOW = true;
var DEFAULT_PAUSE_ON_HOVER = true;
var DEFAULT_TOAST_POSITION = "topRight";
var DEFAULT_GAP_SPACING = "12px";
var TOAST_PORTAL_CONTAINER_ID = "ToastPortalContainer";
var ToastLevels = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error"
};
var ToastPositions = {
  TOP_RIGHT: "topRight",
  TOP_LEFT: "topLeft",
  BOTTOM_RIGHT: "bottomRight",
  BOTTOM_LEFT: "bottomLeft"
};
var progressBarRootTestId = "ProgressBarRoot";

// src/components/Toast/ToastStore.ts
import { useState as useState22 } from "react";
import { generateId as generateId6 } from "@deliveryhero/armor-system";
var emptyState = {
  toasts: {
    topRight: [],
    topLeft: [],
    bottomRight: [],
    bottomLeft: []
  },
  isPausedAutoClose: false
};
function createStore(initialState) {
  var state = initialState;
  var listeners = /* @__PURE__ */new Set();
  var setState = function setState(setStateFn) {
    state = setStateFn(state);
    listeners.forEach(function (l) {
      return l();
    });
  };
  var removeToast = function removeToast(id, position) {
    setState(function (prevState) {
      return __spreadProps(__spreadValues({}, prevState), {
        toasts: __spreadProps(__spreadValues({}, prevState.toasts), _defineProperty({}, position, prevState.toasts[position].filter(function (toast) {
          return toast.id !== id;
        })))
      });
    });
  };
  return {
    getState: function getState() {
      return state;
    },
    subscribe: function subscribe(listener) {
      listeners.add(listener);
      return function () {
        setState(function () {
          return initialState;
        });
        listeners.delete(listener);
      };
    },
    clear: function clear() {
      return setState(function () {
        return initialState;
      });
    },
    removeToast: removeToast,
    makeToast: function makeToast(toast) {
      var _toast$autoCloseTime = toast.autoCloseTime,
        autoCloseTime = _toast$autoCloseTime === void 0 ? DEFAULT_AUTO_CLOSE_TIME : _toast$autoCloseTime,
        _toast$showProgressBa = toast.showProgressBar,
        showProgressBar = _toast$showProgressBa === void 0 ? DEFAULT_PROGRESS_BAR_SHOW : _toast$showProgressBa,
        _toast$position = toast.position,
        position = _toast$position === void 0 ? DEFAULT_TOAST_POSITION : _toast$position,
        _toast$autoClose = toast.autoClose,
        autoClose = _toast$autoClose === void 0 ? DEFAULT_AUTO_CLOSE : _toast$autoClose,
        _toast$pauseOnHover = toast.pauseOnHover,
        pauseOnHover = _toast$pauseOnHover === void 0 ? DEFAULT_PAUSE_ON_HOVER : _toast$pauseOnHover;
      var toastId = generateId6();
      var setPauseAutoClose = function setPauseAutoClose(isPaused) {
        if (!autoClose || !pauseOnHover) {
          return;
        }
        setState(function (prevState) {
          return __spreadProps(__spreadValues({}, prevState), {
            isPausedAutoClose: isPaused
          });
        });
      };
      var newToastProps = {
        id: toastId,
        autoCloseTime: autoCloseTime,
        showProgressBar: showProgressBar,
        setPauseAutoClose: setPauseAutoClose,
        onClose: function onClose() {
          var _a;
          removeToast(toastId, position);
          (_a = toast.onClose) == null ? void 0 : _a.call(toast);
        }
      };
      setState(function (prevState) {
        return __spreadProps(__spreadValues({}, prevState), {
          toasts: __spreadProps(__spreadValues({}, prevState.toasts), _defineProperty({}, position, [__spreadValues(__spreadValues({}, toast), newToastProps)].concat(_toConsumableArray(prevState.toasts[position]))))
        });
      });
      return toastId;
    }
  };
}
var toastStore = createStore(emptyState);
var useToastStore = function useToastStore() {
  var _useState67 = useState22(function () {
      return toastStore.getState();
    }),
    _useState68 = _slicedToArray(_useState67, 2),
    toastState = _useState68[0],
    setToastState = _useState68[1];
  toastStore.subscribe(function () {
    return setToastState(toastStore.getState());
  });
  return toastState;
};

// src/components/Toast/ToastContainer.tsx
import React143 from "react";
import { CSSTransition as CSSTransition2, TransitionGroup as TransitionGroup2 } from "react-transition-group";
import { durationNormal as durationNormal19, ThemeProvider, makeDefaultTheme as makeDefaultTheme2 } from "@deliveryhero/armor-system";

// src/components/Toast/style.ts
import styled103, { css as css72 } from "styled-components";
import { marginProps as marginProps56, propsBlocker as propsBlocker91, getComponentOverride as getComponentOverride73, reset as reset30, typography as typography49, spacing as spacing69, color as color50, widthProps as widthProps21, borderRadius as borderRadius9, transition as transition26, focus as focus12, token as token65 } from "@deliveryhero/armor-system";
var getRootStyle24 = function getRootStyle24(_ref186) {
  var level = _ref186.level,
    success = _ref186.success,
    error = _ref186.error,
    warning = _ref186.warning;
  var result = css72(_templateObject623 || (_templateObject623 = _taggedTemplateLiteral(["\n        pointer-events: visible;\n        position: relative;\n        border-radius: ", ";\n        overflow: hidden;\n        min-width: ", ";\n\n        .Message-Root {\n            border: none;\n        }\n        .CloseButton-Root:focus-visible {\n            border-radius: ", ";\n        }\n        .Message-Content {\n            display: flex;\n            align-items: center;\n        }\n    "])), borderRadius9("soft"), spacing69(50), borderRadius9("soft"));
  if (level === ToastLevels.ERROR || error) {
    result = css72(_templateObject624 || (_templateObject624 = _taggedTemplateLiteral(["\n            ", ";\n            .Message-Root {\n                background-color: ", ";\n            }\n            .Message-Icon,\n            .Message-Content,\n            .CloseButton-Root,\n            .MessageAction-Root {\n                color: ", ";\n            }\n            .CloseButton-Root {\n                ", ";\n            }\n            .CloseButton-Root:hover {\n                background-color: ", ";\n            }\n        "])), result, color50("error.06"), color50("neutral.00"), focus12({
      mainColor: "neutral.00"
    }), color50("error.04"));
  } else if (level === ToastLevels.WARNING || warning) {
    result = css72(_templateObject625 || (_templateObject625 = _taggedTemplateLiteral(["\n            ", ";\n            .Message-Root {\n                background-color: ", ";\n            }\n            .Message-Icon,\n            .Message-Content,\n            .CloseButton-Root,\n            .MessageAction-Root {\n                color: ", ";\n            }\n            .CloseButton-Root {\n                ", ";\n            }\n            .CloseButton-Root:hover {\n                background-color: ", ";\n            }\n        "])), result, color50("warning.07"), color50("neutral.11"), focus12({
      mainColor: "neutral.11"
    }), color50("warning.05"));
  } else if (level === ToastLevels.SUCCESS || success) {
    result = css72(_templateObject626 || (_templateObject626 = _taggedTemplateLiteral(["\n            ", ";\n            .Message-Root {\n                background-color: ", ";\n            }\n            .Message-Icon,\n            .Message-Content,\n            .CloseButton-Root,\n            .MessageAction-Root {\n                color: ", ";\n            }\n            .CloseButton-Root {\n                ", ";\n            }\n            .CloseButton-Root:hover {\n                background-color: ", ";\n            }\n        "])), result, color50("success.06"), color50("neutral.11"), focus12({
      mainColor: "neutral.11"
    }), color50("success.04"));
  } else {
    result = css72(_templateObject627 || (_templateObject627 = _taggedTemplateLiteral(["\n            ", ";\n            .Message-Root {\n                background-color: ", ";\n            }\n            .Message-Icon,\n            .Message-Content,\n            .CloseButton-Root,\n            .MessageAction-Root {\n                color: ", ";\n            }\n            .CloseButton-Root {\n                ", ";\n            }\n            .CloseButton-Root:hover {\n                background-color: ", ";\n            }\n        "])), result, color50("primary.04"), color50("neutral.00"), focus12({
      mainColor: "neutral.00"
    }), color50("primary.03"));
  }
  return result;
};
var getContainerStyle2 = function getContainerStyle2(_ref187) {
  var position = _ref187.position,
    gap = _ref187.gap;
  var result = css72(_templateObject628 || (_templateObject628 = _taggedTemplateLiteral(["\n        position: fixed;\n        pointer-events: none;\n        max-width: ", ";\n        width: fit-content;\n\n        .ToastContainer-Group {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-end;\n            gap: ", ";\n        }\n        .ToastContainer-Item {\n            ", ";\n        }\n        .ToastContainer-Item.enter {\n            opacity: 0;\n        }\n        .ToastContainer-Item.enter-active {\n            opacity: 1;\n        }\n        .ToastContainer-Item.exit {\n            opacity: 1;\n        }\n        .ToastContainer-Item.exit-active {\n            opacity: 0;\n            transform: scale(0.85);\n        }\n    "])), spacing69(100), spacing69(gap || DEFAULT_GAP_SPACING), transition26({
    right: true,
    left: true,
    opacity: true,
    transform: true
  }));
  switch (position) {
    case ToastPositions.TOP_RIGHT:
      result = css72(_templateObject629 || (_templateObject629 = _taggedTemplateLiteral(["\n                ", ";\n                top: ", ";\n                right: ", ";\n\n                .ToastContainer-Item.enter {\n                    right: -", ";\n                }\n                .ToastContainer-Item.enter-active {\n                    right: 0;\n                }\n            "])), result, spacing69(6), spacing69(6), spacing69(5));
      break;
    case ToastPositions.TOP_LEFT:
      result = css72(_templateObject630 || (_templateObject630 = _taggedTemplateLiteral(["\n                ", ";\n                top: ", ";\n                left: ", ";\n\n                .ToastContainer-Group {\n                    align-items: flex-start;\n                }\n                .ToastContainer-Item.enter {\n                    left: -", ";\n                }\n                .ToastContainer-Item.enter-active {\n                    left: 0;\n                }\n            "])), result, spacing69(6), spacing69(6), spacing69(5));
      break;
    case ToastPositions.BOTTOM_LEFT:
      result = css72(_templateObject631 || (_templateObject631 = _taggedTemplateLiteral(["\n                ", ";\n                bottom: ", ";\n                left: ", ";\n\n                .ToastContainer-Group {\n                    flex-direction: column-reverse;\n                    align-items: flex-start;\n                }\n                .ToastContainer-Item.enter {\n                    left: -", ";\n                }\n                .ToastContainer-Item.enter-active {\n                    left: 0;\n                }\n            "])), result, spacing69(6), spacing69(6), spacing69(5));
      break;
    case ToastPositions.BOTTOM_RIGHT:
      result = css72(_templateObject632 || (_templateObject632 = _taggedTemplateLiteral(["\n                ", ";\n                bottom: ", ";\n                right: ", ";\n\n                .ToastContainer-Group {\n                    flex-direction: column-reverse;\n                }\n                .ToastContainer-Item.enter {\n                    right: -", ";\n                }\n                .ToastContainer-Item.enter-active {\n                    right: 0;\n                }\n            "])), result, spacing69(6), spacing69(6), spacing69(5));
      break;
    default:
      result = css72(_templateObject633 || (_templateObject633 = _taggedTemplateLiteral(["\n                ", ";\n                top: ", ";\n                right: ", ";\n\n                .ToastContainer-Item.enter {\n                    right: -", ";\n                }\n                .ToastContainer-Item.enter-active {\n                    right: 0;\n                }\n            "])), result, spacing69(6), spacing69(6), spacing69(5));
      break;
  }
  return result;
};
var ToastRoot = styled103.div.withConfig(propsBlocker91)(_templateObject634 || (_templateObject634 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset30, typography49("paragraphMedium"), token65("body.color"), getRootStyle24, getComponentOverride73("Toast"), marginProps56);
var ToastContainerRoot = styled103.div.withConfig(propsBlocker91)(_templateObject635 || (_templateObject635 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n"])), getContainerStyle2, widthProps21, marginProps56);
var ProgressBarContainer = styled103.div(_templateObject636 || (_templateObject636 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    visibility: ", ";\n"])), function (props) {
  return props.isHidden ? "hidden" : "visible";
});

// src/components/Toast/ToastContainer.tsx
var ToastContainer = function ToastContainer(_ref188) {
  var theme = _ref188.theme,
    gap = _ref188.gap;
  var classNames = useToastClassNames(TOAST_CONTAINER_PREFIX);
  var _useToastStore = useToastStore(),
    toasts = _useToastStore.toasts,
    isPausedAutoClose = _useToastStore.isPausedAutoClose;
  var defaultTheme = makeDefaultTheme2();
  return /* @__PURE__ */React143.createElement(ThemeProvider, {
    theme: theme || defaultTheme
  }, Object.keys(toasts).map(function (position) {
    return /* @__PURE__ */React143.createElement(ToastContainerRoot, {
      className: classNames.Root,
      key: position,
      position: position,
      gap: gap
    }, /* @__PURE__ */React143.createElement(TransitionGroup2, {
      className: classNames.Group
    }, toasts[position].map(function (toast) {
      return /* @__PURE__ */React143.createElement(CSSTransition2, {
        key: toast.id,
        timeout: durationNormal19,
        className: classNames.Item
      }, /* @__PURE__ */React143.createElement(Toast, __spreadProps(__spreadValues({}, toast), {
        isPaused: isPausedAutoClose
      }), toast.message));
    })));
  }));
};

// src/components/Toast/hooks/useToastContainer.ts
var renderToastContainer = function renderToastContainer(_ref189) {
  var zIndex6 = _ref189.zIndex,
    gap = _ref189.gap,
    theme = _ref189.theme;
  var portalId = TOAST_PORTAL_CONTAINER_ID;
  var window = getWindow8();
  if (!window) {
    return;
  }
  var toastContainer = document.getElementById(portalId);
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.setAttribute("id", portalId);
    toastContainer.setAttribute("data-testid", portalId);
    document.body.prepend(toastContainer);
    toastContainer.setAttribute("style", "position: fixed; z-index: ".concat(zIndex6 || zIndexToast));
  }
  render(createElement2(ToastContainer, {
    theme: theme,
    gap: gap
  }), toastContainer);
};
var useToastContainer = function useToastContainer(props) {
  var _a = props || {},
    gap = _a.gap,
    zIndex6 = _a.zIndex,
    restProps = __objRest(_a, ["gap", "zIndex"]);
  var theme = useTheme4();
  var makeToast = function makeToast(newToast) {
    toastStore.makeToast(__spreadValues(__spreadValues({}, restProps), newToast));
  };
  useEffect25(function () {
    renderToastContainer({
      zIndex: zIndex6,
      gap: gap,
      theme: theme
    });
  }, [gap, theme, zIndex6]);
  return {
    makeToast: makeToast
  };
};

// src/components/Toast/hooks/useToast.ts
import { useRootRef as useRootRef33 } from "@deliveryhero/armor-system";

// src/components/Toast/utils/getProgressBarPreset.ts
var getProgressBarPreset = function getProgressBarPreset(_ref190) {
  var level = _ref190.level,
    success = _ref190.success,
    info = _ref190.info,
    error = _ref190.error,
    warning = _ref190.warning;
  if (level === "success" || success) {
    return "success";
  }
  if (level === "info" || info) {
    return "info";
  }
  if (level === "error" || error) {
    return "error";
  }
  if (level === "warning" || warning) {
    return "warning";
  }
  return void 0;
};

// src/components/Toast/hooks/useToast.ts
var useToast = function useToast(_a, ref) {
  var _b = _a,
    level = _b.level,
    success = _b.success,
    info = _b.info,
    error = _b.error,
    warning = _b.warning,
    onClose = _b.onClose,
    disableIcon = _b.disableIcon,
    disableCloseButton = _b.disableCloseButton,
    action = _b.action,
    showProgressBar = _b.showProgressBar,
    autoClose = _b.autoClose,
    autoCloseTime = _b.autoCloseTime,
    message = _b.message,
    isPaused = _b.isPaused,
    setPauseAutoClose = _b.setPauseAutoClose,
    restProps = __objRest(_b, ["level", "success", "info", "error", "warning", "onClose", "disableIcon", "disableCloseButton", "action", "showProgressBar", "autoClose", "autoCloseTime", "message", "isPaused", "setPauseAutoClose"]);
  var innerRef = useRootRef33(ref);
  return {
    rootProps: __spreadValues({
      level: level,
      success: success,
      info: info,
      error: error,
      warning: warning,
      ref: innerRef,
      onMouseOver: function onMouseOver() {
        return setPauseAutoClose == null ? void 0 : setPauseAutoClose(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setPauseAutoClose == null ? void 0 : setPauseAutoClose(false);
      }
    }, restProps),
    getMessageProps: function getMessageProps() {
      return {
        level: level,
        success: success,
        info: info,
        error: error,
        warning: warning,
        onClose: onClose,
        disableIcon: disableIcon,
        disableCloseButton: disableCloseButton
      };
    },
    getProgressBarContainerProps: function getProgressBarContainerProps() {
      return {
        isHidden: !showProgressBar
      };
    },
    getProgressBarProps: function getProgressBarProps() {
      return {
        preset: getProgressBarPreset({
          level: level,
          success: success,
          info: info,
          error: error,
          warning: warning
        }),
        duration: autoCloseTime,
        onFinish: onClose,
        isPaused: isPaused
      };
    },
    message: message,
    autoClose: autoClose,
    showAction: !!action,
    getActionProps: function getActionProps() {
      return {
        onClick: action == null ? void 0 : action.onClick
      };
    },
    getActionLabel: function getActionLabel() {
      return action == null ? void 0 : action.label;
    }
  };
};

// src/components/Toast/hooks/useToastClassNames.ts
import { useMemo as useMemo125 } from "react";
import { makeRootClassName as makeRootClassName67, makeBEM as makeBEM75 } from "@deliveryhero/armor-system";
var useToastClassNames = function useToastClassNames(classPrefix, className) {
  return useMemo125(function () {
    return {
      Root: makeRootClassName67(classPrefix, className),
      Group: makeBEM75(classPrefix, "Group"),
      Item: makeBEM75(classPrefix, "Item")
    };
  }, [classPrefix, className]);
};

// src/components/Toast/Toast.tsx
var Toast = forwardRef85(function Toast2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var classNames = useToastClassNames(TOAST_CLASS_PREFIX, className);
  var _useToast = useToast(props, ref),
    rootProps = _useToast.rootProps,
    getMessageProps = _useToast.getMessageProps,
    getProgressBarContainerProps = _useToast.getProgressBarContainerProps,
    getProgressBarProps = _useToast.getProgressBarProps,
    autoClose = _useToast.autoClose,
    message = _useToast.message,
    showAction = _useToast.showAction,
    getActionProps = _useToast.getActionProps,
    getActionLabel = _useToast.getActionLabel;
  return /* @__PURE__ */React144.createElement(ToastRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), /* @__PURE__ */React144.createElement(Message, __spreadProps(__spreadValues({}, getMessageProps()), {
    actions: showAction ? /* @__PURE__ */React144.createElement(MessageAction, __spreadValues({}, getActionProps()), getActionLabel()) : null
  }), message || children), autoClose && /* @__PURE__ */React144.createElement(ProgressBarContainer, __spreadValues({
    "data-testid": progressBarRootTestId
  }, getProgressBarContainerProps()), /* @__PURE__ */React144.createElement(ProgressBar, __spreadValues({}, getProgressBarProps()))));
});
Toast.defaultProps = {
  disableCloseButton: false,
  disableIcon: false,
  error: false,
  warning: false,
  info: false,
  success: false,
  showProgressBar: true,
  autoClose: true
};
Toast.propTypes = {
  /** The id will automatically be generated when adding a new toast */
  id: PropTypes78.string.isRequired,
  /** The toast message */
  message: PropTypes78.string.isRequired,
  /** Toast level */
  level: PropTypes78.oneOf(["error", "warning", "info", "success"]),
  /** Toast level: error */
  error: PropTypes78.bool,
  /** Toast level: warning */
  warning: PropTypes78.bool,
  /** Toast level: info */
  info: PropTypes78.bool,
  /** Toast level: success */
  success: PropTypes78.bool,
  /** Show progress bar when auto close is enable */
  showProgressBar: PropTypes78.bool,
  /** A callback is fired when toast is closed */
  onClose: PropTypes78.func,
  /** Show/hide close button */
  disableCloseButton: PropTypes78.bool,
  /** Show/hide toast level icon */
  disableIcon: PropTypes78.bool,
  /** Enable auto close */
  autoClose: PropTypes78.bool,
  /** Action button */
  action: PropTypes78.shape({
    label: PropTypes78.string.isRequired,
    onClick: PropTypes78.func.isRequired
  }),
  /** Put the progress bar auto run on hold */
  isPaused: PropTypes78.bool,
  /** Set the pause status to the toast container */
  setPauseAutoClose: PropTypes78.func,
  /** Position of the toast */
  position: PropTypes78.oneOf(["topRight", "topLeft", "bottomRight", "bottomLeft"])
};
var MemoizedToast = memo104(Toast);

// src/components/FileUploader/FileUploader.tsx
import React145, { forwardRef as forwardRef86, memo as memo105 } from "react";
import PropTypes79 from "prop-types";
import { UploadIcon } from "@deliveryhero/armor-icons";

// src/components/FileUploader/hooks/useFileUploaderClassNames.ts
import { useMemo as useMemo126 } from "react";
import { makeRootClassName as makeRootClassName68, makeBEM as makeBEM76 } from "@deliveryhero/armor-system";
var useFileUploaderClassNames = function useFileUploaderClassNames(classPrefix, className) {
  return useMemo126(function () {
    return {
      Root: makeRootClassName68(classPrefix, className),
      Title: makeBEM76(classPrefix, "Title"),
      Description: makeBEM76(classPrefix, "Description"),
      UploadButton: makeBEM76(classPrefix, "UploadButton"),
      FileListContainer: makeBEM76(classPrefix, "FileListContainer"),
      FileCard: makeBEM76(classPrefix, "FileCard")
    };
  }, [classPrefix, className]);
};

// src/components/FileUploader/hooks/useFileUploader.ts
import { useRootRef as useRootRef34 } from "@deliveryhero/armor-system";

// src/components/FileUploader/constants.ts
var FILE_UPLOADER_CLASS_PREFIX = "FileUploader";
var DEFAULT_UPLOAD_BUTTON_LABEL = "Select File";

// src/components/FileUploader/hooks/useFileUploader.ts
var useFileUploader = function useFileUploader(_a, ref) {
  var _b = _a,
    title = _b.title,
    description = _b.description,
    uploadButtonParams = _b.uploadButtonParams,
    onFilesSelect = _b.onFilesSelect,
    restProps = __objRest(_b, ["title", "description", "uploadButtonParams", "onFilesSelect"]);
  var innerRef = useRootRef34(ref);
  return {
    rootProps: __spreadProps(__spreadValues({}, restProps), {
      ref: innerRef
    }),
    getUploadButtonProps: function getUploadButtonProps() {
      return __spreadValues({
        onFilesSelect: onFilesSelect
      }, uploadButtonParams);
    },
    uploadButtonLabel: (uploadButtonParams == null ? void 0 : uploadButtonParams.buttonLabel) || DEFAULT_UPLOAD_BUTTON_LABEL,
    title: title,
    description: description
  };
};

// src/components/FileUploader/style.ts
import styled104 from "styled-components";
import { marginProps as marginProps57, propsBlocker as propsBlocker92, getComponentOverride as getComponentOverride74, reset as reset31, typography as typography50, spacing as spacing70, color as color51, token as token66 } from "@deliveryhero/armor-system";
var FileUploaderRoot = styled104.div.withConfig(propsBlocker92)(_templateObject637 || (_templateObject637 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    color: ", ";\n    ", ";\n    ", ";\n"])), reset31, typography50("paragraphMedium"), token66("body.color"), getComponentOverride74("FileUploader"), marginProps57);
var Title = styled104.div.withConfig(propsBlocker92)(_templateObject638 || (_templateObject638 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n"])), typography50("sectionTitle"), token66("body.color"));
var Description = styled104.div.withConfig(propsBlocker92)(_templateObject639 || (_templateObject639 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    margin-top: ", ";\n"])), typography50("paragraphLarge"), color51("neutral.07"), spacing70(2));
var UploadButton = styled104(FileUploadButton)(_templateObject640 || (_templateObject640 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n"])), spacing70(4));

// src/components/FileUploader/FileUploader.tsx
var FileUploader = forwardRef86(function FileUploader2(_a, ref) {
  var _b = _a,
    className = _b.className,
    children = _b.children,
    props = __objRest(_b, ["className", "children"]);
  var classNames = useFileUploaderClassNames(FILE_UPLOADER_CLASS_PREFIX, className);
  var _useFileUploader = useFileUploader(props, ref),
    rootProps = _useFileUploader.rootProps,
    title = _useFileUploader.title,
    description = _useFileUploader.description,
    getUploadButtonProps = _useFileUploader.getUploadButtonProps,
    uploadButtonLabel = _useFileUploader.uploadButtonLabel;
  return /* @__PURE__ */React145.createElement(FileUploaderRoot, __spreadProps(__spreadValues({}, rootProps), {
    className: classNames.Root
  }), /* @__PURE__ */React145.createElement(Title, {
    className: classNames.Title
  }, title), /* @__PURE__ */React145.createElement(Description, {
    className: classNames.Description
  }, description), /* @__PURE__ */React145.createElement(UploadButton, __spreadProps(__spreadValues({}, getUploadButtonProps()), {
    className: classNames.UploadButton
  }), /* @__PURE__ */React145.createElement(UploadIcon, {
    small: true
  }), uploadButtonLabel), /* @__PURE__ */React145.createElement("div", {
    className: classNames.FileListContainer
  }, children));
});
FileUploader.propTypes = {
  /** The title of the file uploader */
  title: PropTypes79.node,
  /** The description of the file uploader */
  description: PropTypes79.node,
  /** The callback invoked when multiple files are selected */
  onFilesSelect: PropTypes79.func,
  /** Input file button params */
  uploadButtonParams: PropTypes79.object
};
var MemoizedFileUploader = memo105(FileUploader);
export { Accordion, AccordionContent, AccordionHeader, AccordionHeaderIcon, ActionSheet, Backdrop, Badge, Box, Button, CHECKBOX_CHECK_TYPE_DASH, CHECKBOX_CHECK_TYPE_TICK, Card, Checkbox, ClearButton, ClearButtonCircleFilledIcon, ClearButtonRoot, ClearButtonThinIcon, CloseButton, ConditionTag, Container, ContentSwitcher, ContentSwitcherControl, ContextMenu, Dialog, DialogActions, DialogContent2 as DialogContent, DialogTitle, Divider, Dropdown, EmptyState, ExpansionIndicator, FileCard, FileUploadButton, FileUploader, Flex, FlexItem, FontLoader, FormField, FormFieldMessage, FormFieldTooltip, Grid, GridItem, HeaderNavigation, HeaderNavigationAction, HeaderNavigationActionItem, HeaderNavigationActionLogisticsSignOutButton, HeaderNavigationItem, HeaderNavigationLink, HeaderNavigationLinks, HeaderNavigationMenu, HeaderNavigationMenuContent, HeaderNavigationMenuContentBody, HeaderNavigationMenuContentBodyOptions, HeaderNavigationMenuContentHeader, HeaderNavigationMenuContentLogistics, HeaderNavigationSearch, HeaderNavigationSelector, HeaderNavigationTitle, IconButton, Indicator, Link, List, ListItem, LoginPage, MemoizedAccordion, MemoizedAccordionContent, MemoizedAccordionHeader, MemoizedAccordionHeaderIcon, MemoizedActionSheet, MemoizedBadge, MemoizedBox, MemoizedButton, MemoizedCard, MemoizedCheckbox, MemoizedClearButton, MemoizedConditionTag, MemoizedContainer, MemoizedContentSwitcher, MemoizedContentSwitcherControl, MemoizedContextMenu, MemoizedDialog, MemoizedDialogActions, MemoizedDialogContent, MemoizedDialogTitle, MemoizedDivider, MemoizedDropdown, MemoizedEmptyState, MemoizedExpansionIndicator, MemoizedFileCard, MemoizedFileUploadButton, MemoizedFileUploader, MemoizedFlex, MemoizedFlexItem, MemoizedFormField, MemoizedFormFieldMessage, MemoizedFormFieldTooltip, MemoizedGrid, MemoizedGridItem, MemoizedHeaderNavigation, MemoizedHeaderNavigationAction, MemoizedHeaderNavigationActionItem, MemoizedHeaderNavigationItem, MemoizedHeaderNavigationLink, MemoizedHeaderNavigationLinks, MemoizedHeaderNavigationMenu, MemoizedHeaderNavigationMenuContent, MemoizedHeaderNavigationMenuContentBody, MemoizedHeaderNavigationMenuContentBodyOptions, MemoizedHeaderNavigationMenuContentHeader, MemoizedHeaderNavigationSearch, MemoizedHeaderNavigationSelector, MemoizedHeaderNavigationTitle, MemoizedIconButton, MemoizedIndicator, MemoizedLink, MemoizedList, MemoizedListItem, MemoizedLoginPage, MemoizedMenu, MemoizedMenuElement, MemoizedMessage, MemoizedMessageAction, MemoizedNavigation, MemoizedPack, MemoizedPackItem, MemoizedPageNavigation, MemoizedProgressBar, MemoizedRadio, MemoizedRadioGroup, MemoizedSearch, MemoizedSideSheet, MemoizedSideSheetBody, MemoizedSideSheetFooter, MemoizedSideSheetHeader, MemoizedSkeleton, MemoizedStack, MemoizedStackItem, MemoizedStep, MemoizedStepper, MemoizedSwitch, MemoizedTab, MemoizedTabView, MemoizedTable, MemoizedTableAction, MemoizedTableBody, MemoizedTableCell, MemoizedTableCellLabel, MemoizedTableCheckboxCell, MemoizedTableControllerCell, MemoizedTableExpandableSection, MemoizedTableFoot, MemoizedTableHead, MemoizedTableHeadCell, MemoizedTabs, MemoizedTag, MemoizedTextInput, MemoizedTextInputAction, MemoizedToast, MemoizedTooltip, MemoizedTypography, Menu, MenuElement, Message, MessageAction, Navigation, OptionList, OptionListItem2 as OptionListItem, Pack, PackItem, PageNavigation, ProgressBar, RADIO_GROUP_CLASS_PREFIX, Radio, RadioGroup, SIDE_SHEET_BODY_CLASS_PREFIX, SIDE_SHEET_FOOTER_CLASS_PREFIX, SIDE_SHEET_HEADER_CLASS_PREFIX, Search, SideSheet, SideSheetBody, SideSheetFooter, SideSheetHeader, Skeleton, Stack, StackItem, Step, Stepper, Switch, Tab, TabView, Table, TableAction, TableBody, TableCell, TableCellLabel, TableCheckboxCell, TableControllerCell, TableExpandableSection, TableFoot, TableHead, TableHeadCell, TableRow, TableSelectionContextMenu, Tabs, Tag, TextInput, TextInputAction, Toast, Tooltip, Typography, borderRadius3 as borderRadius, borderRadius01, borderRadius02, borderRadius04, borderRadiusPill, boxShadowLarge, boxShadowMedium, boxShadowSmall, color20 as color, colorBlue05, colorBlue10, colorBlue20, colorBlue30, colorBlue40, colorBlue50, colorBlue60, colorBlue70, colorBlue80, colorBlue90, colorGreen05, colorGreen10, colorGreen20, colorGreen30, colorGreen40, colorGreen50, colorGreen60, colorGreen70, colorGreen80, colorGreen90, colorGrey002 as colorGrey00, colorGrey01, colorGrey05, colorGrey10, colorGrey20, colorGrey30, colorGrey40, colorGrey50, colorGrey60, colorGrey70, colorGrey80, colorGrey90, colorPurple20, colorPurple50, colorRed05, colorRed10, colorRed20, colorRed30, colorRed40, colorRed50, colorRed60, colorRed70, colorRed80, colorRed90, colorTurquoise05, colorTurquoise10, colorTurquoise20, colorTurquoise30, colorTurquoise40, colorTurquoise50, colorTurquoise60, colorTurquoise70, colorTurquoise80, colorTurquoise90, colorYellow05, colorYellow10, colorYellow20, colorYellow30, colorYellow40, colorYellow50, colorYellow60, colorYellow70, colorYellow80, colorYellow90, componentSpacing01, componentSpacing02, componentSpacing03, componentSpacing04, componentSpacing05, componentSpacing06, componentSpacing07, componentSpacing08, componentSpacing09, css73 as css, durationNormal11 as durationNormal, extractMarginProps, fontFamilyRoboto2 as fontFamilyRoboto, fontSize01, fontSize022 as fontSize02, fontSize03, fontSize04, fontSize05, fontWeightBold, fontWeightMedium, fontWeightRegular2 as fontWeightRegular, keyframes2 as keyframes, layoutSpacing01, layoutSpacing02, layoutSpacing03, layoutSpacing04, layoutSpacing05, letterSpacingLarge, letterSpacingMedium, letterSpacingNone, letterSpacingSmall, lineHeight01, lineHeight02, lineHeight03, lineHeight04, lineHeight05, makeClearButtonIconStyle, makeDefaultTheme, makeTheme, pixelToRem4 as pixelToRem, propsBlocker44 as propsBlocker, selectorClassGeneratorBasedOnComponent, spacing37 as spacing, default2 as styled, typography22 as typography, useToastContainer as useToast, zIndexModal, zIndexSearchSuggestionsList2 as zIndexSearchSuggestionsList, zIndexTableHeader };